(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'satellizer',
                'ngFileUpload',
                'infinite-scroll'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element('#content');
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            })
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            vm.setCurrentStep(vm.currentStepNumber - 1);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            vm.setCurrentStep(vm.currentStepNumber + 1);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        }
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                optionalStep: '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });

                scope.$on('destroy', function() {
                  splashScreenRemoveEvent();
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem           : saveItem,
                deleteItem         : deleteItem,
                sort               : sortByWeight,
                clearNavigation    : clearNavigation,
                setActiveItem      : setActiveItem,
                getActiveItem      : getActiveItem,
                getNavigationObject: getNavigationObject,
                setNavigationScope : setNavigationScope,
                setFolded          : setFolded,
                getFolded          : getFolded,
                setFoldedOpen      : setFoldedOpen,
                getFoldedOpen      : getFoldedOpen,
                toggleFolded       : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }
                }

                return navigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigationObject();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    var onStateChangeStart = scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();

                        // If navigation is folded open, close it
                        if ( msNavigationService.getFolded() )
                        {
                            onFoldCollapserHover();
                        }
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        onStateChangeStart();
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            var onNavigationCollapse = $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            var onStateChange = $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });

            $scope.$on('destroy', function() {
              onStateChange();
              onNavigationCollapse();
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            var onStateMatched = $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            var onClearActive = $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            var onStateChange = $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });

            $scope.$on('destroy', function() {
              onStateChange();
              onClearActive();
              onStateMatched();
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPicker($mdMenu, $mdColorPalette, fuseGenerator)
    {
        return {
            require    : 'ngModel',
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function ($scope, element, attrs, ngModel)
            {
                // Material Color Palette
                $scope.palettes = $mdColorPalette;
                $scope.selectedPalette = false;
                $scope.selectedHues = false;

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                $scope.msModelType = $scope.msModelType || 'class';

                /**
                 * Initialize / Watch model changes
                 */
                $scope.$watch('ngModel', setSelectedColor);

                /**
                 * Activate Hue Selection
                 * @param palette
                 * @param hues
                 */
                $scope.activateHueSelection = function (palette, hues)
                {
                    $scope.selectedPalette = palette;
                    $scope.selectedHues = hues;
                };

                /**
                 * Select Color
                 * @type {selectColor}
                 */
                $scope.selectColor = function (palette, hue)
                {
                    // Update Selected Color
                    updateSelectedColor(palette, hue);

                    // Update Model Value
                    updateModel();

                    // Hide The picker
                    $mdMenu.hide();
                };

                $scope.removeColor = function ()
                {

                    $scope.selectedColor = {
                        palette: '',
                        hue    : '',
                        class  : ''
                    };

                    $scope.activateHueSelection(false, false);

                    updateModel();
                };

                /**
                 * Set SelectedColor by model type
                 */
                function setSelectedColor()
                {
                    if ( !ngModel.$viewValue || ngModel.$viewValue === '' )
                    {
                        return;
                    }

                    var palette, hue;

                    // If ModelType Class
                    if ( $scope.msModelType === 'class' )
                    {
                        var color = ngModel.$viewValue.split('-');
                        if ( color.length >= 5 )
                        {
                            palette = color[1] + '-' + color[2];
                            hue = color[3];
                        }
                        else
                        {
                            palette = color[1];
                            hue = color[2];
                        }
                    }
                    // If ModelType Object
                    else if ( $scope.msModelType === 'obj' )
                    {
                        palette = ngModel.$viewValue.palette;
                        hue = ngModel.$viewValue.hue || 500;
                    }

                    // Update Selected Color
                    updateSelectedColor(palette, hue);
                }


                /**
                 * Update Selected Color
                 * @param palette
                 * @param hue
                 */
                function updateSelectedColor(palette, hue)
                {
                    $scope.selectedColor = {
                        palette     : palette,
                        hue         : hue,
                        class       : 'md-' + palette + '-' + hue + '-bg',
                        bgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].value),
                        fgColorValue: fuseGenerator.rgba($scope.palettes[palette][hue].contrast)
                    };

                    // If Model object not Equals the selectedColor update it
                    // it can be happen when the model only have pallete and hue values
                    if ( $scope.msModelType === 'obj' && !angular.equals($scope.selectedColor, ngModel.$viewValue) )
                    {
                        // Update Model Value
                        updateModel();
                    }

                    $scope.activateHueSelection(palette, $scope.palettes[palette]);
                }

                /**
                 * Update Model Value by model type
                 */
                function updateModel()
                {
                    if ( $scope.msModelType === 'class' )
                    {
                        ngModel.$setViewValue($scope.selectedColor.class);
                    }
                    else if ( $scope.msModelType === 'obj' )
                    {
                        ngModel.$setViewValue($scope.selectedColor);
                    }
                }
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msMembershipcard', msMembershipcardDirective);

    /** @ngInject */
    function msMembershipcardDirective($filter, $browser)
    {
        return {
            require: 'ngModel',
            link: function($scope, $element, $attrs, ngModelCtrl) {

                var listener = function() {
                    var value = $element.val().replace(/ /g, '');
                    $element.val($filter('membershipcardNumber')(value, false))
                }

                // This runs when we update the text field
                ngModelCtrl.$parsers.push(function(viewValue) {
                    return viewValue.replace(/ /g, '');
                })

                // This runs when the model gets updated on the scope directly and keeps our view in sync
                ngModelCtrl.$render = function() {
                    var value = ngModelCtrl.$viewValue;
                    $element.val($filter('membershipcardNumber')(value, false))
                }

                $element.bind('change', listener)
                $element.bind('keydown', function(event) {
                    var key = event.keyCode
                    // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                    // This lets us support copy and paste too
                    if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40))
                        return
                    $browser.defer(listener) // Have to do this or changes don't get picked up properly
                })

                $element.bind('paste cut', function() {
                    $browser.defer(listener)
                })
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        // Default configuration
        var defaultConfiguration = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }
                var offset = moment(val).utcOffset();
                var date = new Date(moment(val).add(offset, 'm'));
                return date;
            }
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            return defaultConfiguration;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.unshift(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.unshift(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.vouchersconfig', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.vouchersconfig', {
            title    : "VOUCHERSWELCOME.TITLE",
            url      : '/vouchersconfig/:category',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/vouchersconfig/vouchersconfig.html',
                    controller : 'VouchersConfigController as vm'
                },
            },
            bodyClass: 'vouchersconfig',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/vouchersconfig');

        // Navigation
        // msNavigationServiceProvider.saveItem('my_shop.welcome_vouchers', {
        //     title : 'Welcome vouchers',
        //     state : 'app.vouchersconfig',
        //     stateParams: {category: 'welcome'},
        //     weight: 5
        // });
        //
        // msNavigationServiceProvider.saveItem('my_shop.reengage_vouchers', {
        //     title : 'Re-engage vouchers',
        //     state : 'app.vouchersconfig',
        //     stateParams: {category: 're-engage'},
        //     weight: 6
        // });

        msNavigationServiceProvider.saveItem('my_shop.points_vouchers', {
            title : 'Points vouchers',
            state : 'app.vouchersconfig',
            stateParams: {category: 'point'},
            weight: 7
        });

        msNavigationServiceProvider.saveItem('my_shop.adhoc_vouchers', {
            title : 'Adhoc vouchers',
            state : 'app.vouchersconfig',
            stateParams: {category: 'ad-hoc'},
            weight: 8
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.vouchersconfig')
        .controller('VouchersConfigController', VouchersConfigController);

    /** @ngInject */
    function VouchersConfigController(api, $mdDialog, $stateParams, $state, $filter, $rootScope, clientSideExceptions) {
        // Data
        var vm = this;
        vm.category = $stateParams.category;
        vm.voucherDef = null;
        vm.activeVouchers = [];
        vm.statusChangeEnabled = true;
        vm.loading = true;
        vm.hasOwnShop = true; // assume true until back-end replies

        // Methods
        vm.updateShopData = updateShopData;
        vm.revokeVoucher = revokeVoucher;
        vm.revokeAll = revokeAll;
        vm.changeVoucherStatus = changeVoucherStatus;
        vm.formatAsCurrency = formatAsCurrency;

        function formatAsCurrency(amount, countryId) {
            amount = amount ? amount : 0;
            countryId = countryId ? countryId : 1;
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function getAllShops() {
            api.getOperatorIndex.save({}, {}).$promise.then(function(response) {
                vm.loading = false;
                if(response.result) {
                    vm.shops = response.data.shops;
                    if(vm.shops.length > 0) {
                        vm.currentShop = vm.shops[0];
                        updateShopData();
                    } else {
                        vm.hasOwnShop = false;

                    }
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetOperatorShops(new Error(), response));
                }
            });
        }

        function getOwnShopData() {
            api.getShop.save({}, {}).$promise.then(function(response) {
                if(response.result) {
                    vm.hasOwnShop = true;
                } else {
                    vm.hasOwnShop = false;
                }
                vm.loading = false;
            });
        }
        getOwnShopData();

        function updateShopData() {
            api.getShopDetails.save({shop: vm.currentShop.id},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;
                    api.getVouchersByShop.save({shop: vm.shop.id}, {voucher_type: vm.category}).$promise.then(function (response) {
                        if (response.result) {
                            vm.statusChangeEnabled = true ;
                            vm.voucherDef = response.data.vouchers;
                            if (vm.voucherDef) {
                                vm.voucherDef.is_active = vm.voucherDef.is_active==1;
                                api.getClientsByVoucher.save({voucher: vm.voucherDef.id}, {limit: 100}).$promise.then(function(response) {
                                    vm.activeVouchers = response.data.membershipcardVouchers;
                                });
                            }
                        } else {
                            if (response.errors[0] == 'Not allowed') {
                                var confirm = $mdDialog.confirm()
                                    .title('This feature is allowed for premium subscriptions only.')
                                    .textContent('Do you want to subscribe?')
                                    .ok('Yes!')
                                    .cancel('No');
                                $mdDialog.show(confirm).then(function() {
                                    $state.go('app.subscription');
                                });
                                $rootScope.throwException(clientSideExceptions.notAllowed(new Error(), response));
                            } else {
                                $rootScope.throwException(clientSideExceptions.cantGetVoucherInfo(new Error(), response));
                            }
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }
        // getActiveVouchers();

        getAllShops();

        function revokeVoucher(voucher) {

            var confirm = $mdDialog.confirm()
                .title('Do you want to revoke voucher?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                api.revokeVoucher.save({}, {membershipcard_vouchers: [voucher.id]}).$promise.then(function (response) {
                    if (response.result) {
                        toastr.success('Voucher successfully revoked.', 'Success!');
                        updateShopData();
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantRevokeVoucher(new Error(), response));
                    }
                });
            });
        }

        function revokeAll() {
            var confirm = $mdDialog.confirm()
                .title('Do you want to revoke all vouchers?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                var vouchersToRevoke = [];

                vm.activeVouchers.forEach(function(item, index) {
                    vouchersToRevoke.push(item.id);
                });

                api.revokeMultipleVouchers.save({}, {membershipcard_vouchers: vouchersToRevoke}).$promise.then(function (response) {
                    if (response.result) {
                        toastr.success('Vouchers successfully revoked.', 'Success!');
                        updateShopData();
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantRevokeVoucher(new Error(), response));
                    }
                });
            });
        }

        function changeVoucherStatus() {
            vm.statusChangeEnabled = false;

            var apiMethod;
            var urlParams;
            if (vm.voucherDef.id) {
                apiMethod = api.updateVoucherDef;
                urlParams = {voucher: vm.voucherDef.id};
            } else {
                vm.voucherDef.type = vm.category;
                vm.voucherDef.expire_days = '30';
                vm.voucherDef.code = '123456789';
                vm.voucherDef.conditions = 'conditions';
                vm.voucherDef.include_active_users = false;

                if (vm.category != "point") {
                    vm.voucherDef.value = 1;
                }

                if (vm.category == "ad-hoc") {
                }

                if (vm.category == "welcome") {
                    vm.voucherDef.min_active_days = 1;
                    vm.voucherDef.min_radius = 1;
                }

                if (vm.category == "re-engage") {
                    vm.voucherDef.min_absence = 1;
                }

                if (vm.category == "point") {
                    vm.voucherDef.min_points = 100;
                    vm.voucherDef.points_to_value_currency = 1;
                    vm.voucherDef.points_to_value_points = 100;
                    vm.voucherDef.value_to_points_currency = 1;
                    vm.voucherDef.value_to_points_points = 1;
                }

                apiMethod = api.storeVoucherDef;
                urlParams = {shop: vm.shop.id};
            }

            apiMethod.save(urlParams, vm.voucherDef).$promise.then(function(response) {
                if (!response.result) {
                    if (response.errors[0] == 'Not allowed') {
                        vm.statusChangeEnabled = true;
                        vm.voucherDef.is_active = false;

                        var confirm = $mdDialog.confirm()
                            .title('This feature is allowed for premium subscriptions only.')
                            .textContent('Do you want to subscribe?')
                            .ok('Yes!')
                            .cancel('No');
                        $mdDialog.show(confirm).then(function() {
                            $state.go('app.subscription');
                        });
                        $rootScope.throwException(clientSideExceptions.notAllowed(new Error(), response));
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantSaveVoucher(new Error(), response));
                    }
                } else {
                    toastr.success('Voucher status updated.', 'Success!');
                    getAllShops();
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.operatorindex', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.operatorindex', {
            title    : "OPERATORINDEX.TITLE",
            url      : '/operator',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/operatorindex/operatorindex.html',
                    controller : 'OperatorIndexController as vm'
                },
            },
            bodyClass: 'operatorindex',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/operatorindex');

        // Navigation
        
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operatorindex')
        .controller('OperatorIndexController', OperatorIndexController);

    /** @ngInject */
    function OperatorIndexController($rootScope, api, $state, clientSideExceptions) {
        var vm = this;
        vm.onShopSelect = onShopSelect;

        // Methods
        api.getOperatorIndex.save({}, {}).$promise.then(function(response) {
            if (response.result) {
                vm.shops = response.data.shops;
                if(vm.shops.length == 1 && vm.shops[0].locations.length == 1) {
                    $state.go('app.operatelocation', {location: vm.shops[0].locations[0].id})
                }
                // } else if (vm.shops.length == 1) {
                    vm.currentShop = vm.shops[0];
                // }
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetOperatorShops(new Error(), response));
            }
        });

        function onShopSelect() {
            if (vm.currentShop.locations.length == 1) {
                $state.go('app.operatelocation', {location: vm.currentShop.locations[0].id})
            }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.stampcards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.stampcards', {
            title    : "STAMPCARDS.TITLE",
            url      : '/stampcards',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/stampcards/stampcards.html',
                    controller : 'StampcardsController as vm'
                },
            },
            bodyClass: 'stampcards',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/stampcards');

        // Navigation
        msNavigationServiceProvider.saveItem('stamp_cards', {
            title : 'My Stamp Cards',
            state: 'app.stampcards',
            icon  : 'icon-credit-card',
            weight: 3
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.stampcards')
        .controller('StampcardsController', StampcardsController);

    /** @ngInject */
    function StampcardsController($rootScope, api, $timeout, clientSideExceptions) {
        var vm = this;
        vm.showCards = true;
        vm.sortOrder = 'shop.closest_location.distance_km';
        vm.loading = true;

        var today = new Date();
        vm.today = today;

        // Methods

        vm.flipCard = flipCard;
        vm.unflipCard = unflipCard;
        vm.setFavorite = setFavorite;
        vm.setOrdering = setOrdering;
        vm.toggleCheckin = toggleCheckin;
        vm.setFavorite = setFavorite;

        $rootScope.$on('notificationsChanged', function(event) {
            getStampcards();
            getArchiveStampcards();
        });

        function getStampcards() {
            api.getStampcards.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.activeStampcards = response.data.stampcardUsers;
                    vm.loading = false

                    var categories = JSON.parse(localStorage.categories);

                    vm.activeStampcards.forEach(function(stampcard) {
                        var markedStamps = stampcard.stamps.length;
                        var remainingStamps = stampcard.stamps_total - markedStamps;

                        stampcard.stamps.forEach(function(stamp, index) {
                            if (stamp.created_at) {
                                var todayUnixTime = moment().unix();
                                var creationUnixTime = moment(stamp.created_at, 'YYYY-MM-DD hh:mm:ss').unix();
                                var hourDiff = (todayUnixTime - creationUnixTime) / 3600;
                                stamp.new = hourDiff <= 24;
                            } else {
                                stamp.new = false;
                            }
                        });

                        for(var i = 0; i < remainingStamps; i++) {
                            stampcard.stamps.push({});
                        }
                        stampcard.shop.category = categories[stampcard.shop.category_id];

                        if(stampcard.shop.closest_location.distance_km > 1.0) {
                            stampcard.rounded_distance = Math.floor(stampcard.shop.closest_location.distance_km) + ' km';
                        } else {
                            stampcard.rounded_distance = Math.floor(stampcard.shop.closest_location.distance_km * 1000) + ' mts';
                        }
                    });

                    vm.setOrdering('active', 'shop.closest_location.distance_km');
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetStampCards(new Error(), response));
                }
            });
        }

        function getArchiveStampcards() {
            api.getArchiveStampcards.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.archiveStampcards = response.data.stampcardUsers;
                    vm.loading = false;

                    var categories = JSON.parse(localStorage.categories);

                    vm.archiveStampcards.forEach(function(stampcard) {
                        var markedStamps = stampcard.stamps.length;
                        var remainingStamps = stampcard.stamps_total - markedStamps;

                        var expireDate = new Date(stampcard.expires_at);
                        var expireTimeDiff = Math.abs(today.getTime() - expireDate.getTime());
                        stampcard.timeDiff = (expireTimeDiff / (1000 * 3600));
                        stampcard.expired = Math.ceil(expireTimeDiff / (1000 * 3600)) > 0;

                        stampcard.stamps.forEach(function(stamp, index) {
                            var createDate = new Date(stamp.created_at);
                            var timeDiff = Math.abs(today.getTime() - createDate.getTime());
                            stamp.new = Math.ceil(timeDiff / (1000 * 3600)) <= 24;
                        });

                        for(var i = 0; i < remainingStamps; i++) {
                            stampcard.stamps.push({});
                        }
                        stampcard.shop.category = categories[stampcard.shop.category_id];

                        if(stampcard.shop.closest_location.distance_km > 1.0) {
                            stampcard.rounded_distance = Math.floor(stampcard.shop.closest_location.distance_km) + ' km';
                        } else {
                            stampcard.rounded_distance = Math.floor(stampcard.shop.closest_location.distance_km * 1000) + ' mts';
                        }
                    });

                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetStampCards(new Error(), response));
                }
            });
        }

        function flipCard (stampcard, index, showConditions) {

            stampcard.showConditions = showConditions;

            var latLng = new google.maps.LatLng(stampcard.shop.closest_location.latitude, stampcard.shop.closest_location.longitude);

            if(!vm.openMapObj) {
                var mapOptions = {
                  center: latLng,
                  zoom: 15,
                  mapTypeId: google.maps.MapTypeId.ROADMAP,
                  streetViewControl: false,
                  zoomControl: false,
                  mapTypeControl: false
                };

                var map = new google.maps.Map(document.getElementById('fixedMapDiv'), mapOptions);
                vm.openMapObj = {
                    'stampcard': stampcard,
                    'map': map
                }

            } else {
                vm.openMapObj.stampcard.flipped = false;
                vm.openMapObj.stampcard = stampcard;
                vm.openMapObj.stampcard.flipped = false;
                vm.openMapObj.marker.setMap(null);
                vm.openMapObj.map.setCenter(latLng);
            }

            vm.openMapObj.stampcard.flipped = true;
            var mapDiv = angular.element(document.getElementById(index + '-map'));
            mapDiv.append(vm.openMapObj.map.getDiv());
            vm.openMapObj.location = stampcard.shop.closest_location;

            // Put marker
            google.maps.event.addListenerOnce(vm.openMapObj.map, 'idle', function(){

                $timeout(function () { //TODO: FIX, Safari is too slow loading map and/or on map re-center messes things up
                    var marker = new google.maps.Marker({
                        map: vm.openMapObj.map,
                        animation: google.maps.Animation.DROP,
                        position: latLng
                    });

                    vm.openMapObj.marker = marker;
                    vm.openMapObj.map.setCenter(latLng);
                }, 1000);
                vm.openMapObj.firstMarker = true;

                google.maps.event.trigger(vm.openMapObj.map, 'resize');

            }, function(error){
                $rootScope.throwException(clientSideExceptions.googleMapError(new Error(), error));
            });
        };

        function unflipCard(stampcard) {
            vm.openMapObj.stampcard = stampcard;
            vm.openMapObj.stampcard.flipped = false;
        };

        function setFavorite(stampcard, state) {
            var apiMethod;
            if (state) {
                apiMethod = api.setFavorite;
            } else {
                apiMethod = api.clearFavorite;
            }

            apiMethod.save({shop: stampcard.shop.id}, {}).$promise.then(function(response) {
                if (response.result) {
                    stampcard.shop.is_favorite = state;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantFavoriteShop(new Error(), response));
                }
            });
        };

        function setOrdering(stampcardSet, orderValue) {
            if (stampcardSet == 'active') {
                vm.stampcards = vm.activeStampcards;
            } else {
                vm.stampcards = vm.archiveStampcards;
            }
            vm.sortOrder = orderValue;
        };

        function toggleCheckin(stampcard) {
            var location = stampcard.shop.closest_location;
            if (location.id) {
                var locationId = location.id;
                // md-switch changes model, se we use optimistic loading by default
                if(location.is_checked_in) { // must check-out costumer to location
                    api.checkOutOfLocation.save({location: locationId}, {}).$promise.then(function(response) {
                        if(response.result) {
                            toastr.success('You successfully checked out.', 'Success!');
                        } else {
                            toastr.warning('Can\'t check you out.', 'Warning!');
                            location.is_checked_in = true;
                            $rootScope.throwException(clientSideExceptions.cantCheckOutUser(new Error(), response));
                        }
                    });
                } else { // must check-in costumer to location
                    api.checkInToLocation.save({location: locationId}, {}).$promise.then(function(response) {
                        if(response.result) {
                            toastr.success('You successfully checked in.', 'Success!');
                        } else {
                            toastr.warning('Can\'t check you in.', 'Warning!');
                            location.is_checked_in = false;
                            $rootScope.throwException(clientSideExceptions.cantCheckInUser(new Error(), response));
                        }
                    });
                }
            } else {
                toastr.warning('Can\'t check you in/out.', 'Warning!');
            }
        };
        getStampcards();
        getArchiveStampcards();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.verifyemail', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_verify_email', {
            url      : '/verifyemail?user&code',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_verify_email': {
                    templateUrl: 'app/main/verifyemail/verifyemail.html',
                    controller : 'VerifyEmailController as vm'
                }
            },
            bodyClass: 'login',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already registered and logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/verifyemail');

        // Navigation
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.verifyemail')
        .controller('VerifyEmailController', VerifyEmailController);

    /** @ngInject */
    function VerifyEmailController($rootScope, $location, $auth, api, $window, clientSideExceptions) {

        // Data
        var vm = this;

        vm.verificationSuccess = null;

        vm.isMobile = $window.navigator.userAgent.match(/iPhone|iPad|iPod|Android/i);

        var credentials = $location.search();
        verifyEmail();

        // Methods
        vm.openMobileApp = openMobileApp;

        function verifyEmail() {
          api.verifyEmail.save({user: credentials.user}, {verification_code: credentials.code}).$promise.then(function(response) {

              if (response.result) {

                  if(response.data.user)
                  {
                      // Stringify the retured data
                      var user = JSON.stringify(response.data.user);
                      // Set the stringified user data into local storage
                      localStorage.setItem('user', user);
                      localStorage.setItem('api_token', response.data.api_token);
                      vm.authToken = response.data.api_token;
                      $auth.setToken(response.data.api_token);
                      vm.verificationSuccess = true;
                  } else {
                      var errorMsg = '';
                      for (var i in response.errors) {
                          if ( response.errors[i] instanceof Array) {
                              for ( var j in response.errors[i]) {
                                  errorMsg += (i.toString() + ': ' + response.errors[i][j].toString() + '. ');
                              }
                          } else {
                              errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                          }
                      }
                      form.email.$setValidity('serverSideValidation', false);
                      if (errorMsg != '') {
                          $rootScope.throwException(clientSideExceptions.cantVerifyEmail(new Error(), response, errorMsg));
                      }
                  }
              } else {
                  vm.verificationSuccess = false;
              }
          });
        }

        function openMobileApp() {
          $window.location = 'shoplocalmobile://logged?token=' + vm.authToken;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.userprofile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.userprofile', {
            title    : "PROFILE.GENERAL_INFORMATION",
            url      : '/userprofile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/userprofile/userprofile.html',
                    controller : 'UserProfileController as vm'
                },
            },
            bodyClass: 'user-profile',
            needAuth: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/userprofile');

        // Navigation
        msNavigationServiceProvider.saveItem('profile', {
            title : 'My Profile',
            state : 'app.userprofile',
            icon  : 'icon-account',
            weight: 5
        });


    }

})();

(function ()
{
    'use strict';

    angular
    .module('app.userprofile')
    .controller('UserProfileController', UserProfileController);

    /** @ngInject */
    function UserProfileController($rootScope, api, $auth, Upload, $mdDialog, clientSideExceptions)
    {
        // Data
        var vm = this;

        vm.form = {}; // User data
        vm.checkins = [];

        vm.showSuccessMessage = false;
        vm.serverSideValidationMsg = {};
        vm.avatarChanged = false;

        var locationDetected = false;
        var location = {
            latitude: 0.0,
            longitude:0.0
        };

        vm.editMode = false;
        var shadowCopy = {}; // Meant to store temporal user data when edit mode it triggered
        vm.updateSuccess = null;

        vm.countryList = {};

        // Methods

        vm.enableEditMode = enableEditMode;
        vm.cancelEditMode = cancelEditMode;
        vm.setAvatarChanged = setAvatarChanged;
        vm.saveUserProfile = saveUserProfile;
        vm.changePassword = changePassword;
        vm.upload = upload;
        vm.toggleCheckinStatus = toggleCheckinStatus;
        vm.striptags = striptags;
        
        vm.qrCode = null;

        api.getMembershipQRCode.save({}, {}).$promise.then(function (response) {
            if (response.result) {
                vm.qrCode = response.data.qr;
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetQrCode(new Error(), response));
            }
        });

        api.getCountryList.save({}, {}).$promise.then(function(response){
            for (var i in response.data.countries) {
                vm.countryList[response.data.countries[i].id] = {
                    id:  response.data.countries[i].id,
                    name: response.data.countries[i].name
                };
            }
        });

        function enableEditMode() {
            shadowCopy = angular.copy(vm.form);
            vm.editMode = true;
        }

        function cancelEditMode() {
            if(vm.editMode) {
                vm.form = shadowCopy;
                vm.editMode = false;
                vm.avatarChanged = false;
            }
        }

        function setAvatarChanged() {
            vm.avatarChanged = true;
        }

        // upload on file select or drop
        function upload(model, form) {
            Upload.upload({
                url: api.baseUrl + '/user/profile_save',
                data: model
            }).then(function (resp) {
                if (!resp.data.result) {
                    var errorMsg = '';
                    for (var i in resp.data.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in resp.data.errors[i]) {
                                vm.serverSideValidationMsg[i] += resp.data.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + resp.data.errors[i].toString() + '. ');
                        }
                    }
                    vm.updateSuccess = false;
                    vm.editMode = true;
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantUploadUserProfile(new Error(), resp.data, errorMsg));
                    }
                } else {
                    toastr.success('Profile successfully updated.', 'Success!');
                    vm.avatarChanged = false;
                    $rootScope.fetchedLocation = false;
                    getProfile();

                    vm.editMode = false;
                }
            }, function (resp) {
                $rootScope.throwException(clientSideExceptions.cantUploadUserProfile(new Error(), resp.data));
            }, function (evt) {
                // TODO: show progress
                // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                // console.log('progress: ' + progressPercentage + '% ' + evt.config.data.avatar.name);
            });
        };

        function saveUserProfile(form, model) {

            var profileData = jQuery.extend(true, {}, model);;
            if (profileData.latitude == null || profileData.longitude == null) {
                delete profileData.latitude;
                delete profileData.longitude;
            }

            if (form.avatar.$valid && profileData.avatar && vm.avatarChanged) {
                vm.upload(profileData, form);
            } else {
                profileData.avatar = null;
                profileData.avatar_full_url = null;
                api.saveUserProfile.save({}, profileData).$promise.then(function(response) {
                    if (!response.result) {
                        var errorMsg = '';
                        for (var i in response.errors) {
                            if (form[i]) {
                                form[i].$setValidity('serverSideValidation', false);
                                vm.serverSideValidationMsg[i] = '';
                                for (var j in response.errors[i]) {
                                    vm.serverSideValidationMsg[i] += response.errors[i][j];
                                }
                            } else {
                                errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                            }
                        }
                        vm.updateSuccess = false;
                        vm.editMode = true;
                        if (errorMsg != '') {
                            $rootScope.throwException(clientSideExceptions.cantSaveUserProfile(new Error(), response));
                        }
                    } else {
                        toastr.success('Profile successfully updated.', 'Success!');
                        // $state.go($state.current, {}, {reload: true}) //Trying this change
                        $rootScope.fetchedLocation = false;
                        getProfile();

                        vm.editMode = false;
                    }
                });
            }
        }

        function getProfile() {
            api.getUserProfile.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.form = response.data.user;
                    var user = JSON.stringify(response.data.user);
                    if (vm.form.avatar_full_url) {
                        vm.form.avatar_full_url = vm.form.avatar_full_url + '?' + new Date().getTime();
                        $rootScope.$broadcast('profileUpdated', response.data.user);
                    }
                    localStorage.setItem('user', user);
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetUserProfile(new Error(), response));
                }
            });
        }

        function changePassword() {
            var alert = $mdDialog.confirm({
              title: 'Attention',
              textContent: 'You will be logged out.\nWe will send a password reset link to you by e-mail.\nDo you want to continue?',
              ok: 'Ok',
              cancel: 'Cancel'
            });

            var alertPromise = $mdDialog
                .show( alert )
                .finally(function() {
                    alert = undefined;
                });

            alertPromise.then(function(result) {
                var user = JSON.parse(localStorage.getItem('user'));
                    api.sendPasswordResetEmail.save({}, {email: user.email}).$promise.then(function(response)
                    {
                        if (response.result) {
                            api.logout.save({}, {}).$promise.then(function(response)
                                {
                                    $auth.removeToken();
                                    document.location.reload();
                                    // $state.go('app.auth_login');
                                },
                                function(){
                                    $auth.removeToken();
                                    document.location.reload();
                                    // $state.go('app.auth_login');
                                });

                        } else {
                            $rootScope.throwException(clientSideExceptions.cantSendPwResetLink(new Error(), response));
                        }
                    });
            }, function(err) {
                $rootScope.throwException(clientSideExceptions.cantDismissDialog(new Error(), response));
            });
        }

        function getUserCheckins() {
            api.getUserCheckins.save({},{}).$promise.then(function(response) {
                if(response.result) {
                    vm.checkins = response.data.checkIns;
                    vm.checkins.forEach(function(checkin) {
                        checkin.checked = true;
                        var splitTime = checkin.created_at.split(' ')[1].split(':');
                        checkin.checkinTime = splitTime[0] + ':' + splitTime[1];
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetCheckIns(new Error(), response));
                }
            });
        }

        function toggleCheckinStatus(checkin) {
            var locationId = checkin.location_id;
            // md-switch changes model, se we use optimistic loading by default
            if(checkin.checked) { // must check-out costumer to location
                api.checkOutOfLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        toastr.success('Successfully checked-out user.', 'Success!');
                    } else {
                        checkin.checked = true;
                        $rootScope.throwException(clientSideExceptions.cantCheckOutUser(new Error(), response));
                    }
                });
            } else { // must check-in costumer to location
                api.checkInToLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        toastr.success('Successfully checked-in user.', 'Success!');
                    } else {
                        checkin.checked = false;
                        $rootScope.throwException(clientSideExceptions.cantCheckInUser(new Error(), response));
                    }
                });
            }
        }

        // Initialization
        getProfile();
        getUserCheckins();
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.thankyou', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.thankyou', {
            title    : "THANKYOU.TITLE",
            url      : '/thankyou',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/thankyou/thankyou.html',
                    controller : 'ThankyouController as vm'
                },
            },
            bodyClass: 'shop-thankyou',
            needAuth: true,
            params: {orderDetails: null},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/thankyou');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.thankyou')
        .controller('ThankyouController', ThankyouController);

    /** @ngInject */
    function ThankyouController($state, $stateParams, $timeout) {
        var vm = this;

        // console.log($stateParams);
        vm.params = $stateParams.orderDetails;

        $timeout(function() {
          $state.go('app.shopconfig');
        }, 5000);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.subscription', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.subscription', {
            title    : "SUBSCRIPTION.TITLE",
            url      : '/subscription',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/subscription/subscription.html',
                    controller : 'ShopSubscriptionController as vm'
                },
            },
            bodyClass: 'shop-subscription',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true, orderDetails: null},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                api.getShop.save({},{}).$promise.then(function(response) {
                    if (!response.result) {
                        toastr.warning('Please configure your shop first', 'Warning!');
                        state.go('app.createshop');
                    } else {
                        toParams.enableOnStateChangeStartHandler = false;
                        return state.go(that.name, toParams);
                    }
                });
                return;
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/subscription');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop.subscription', {
            title : 'Subscription',
            state : 'app.subscription',
            weight: 3
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.subscription')
        .controller('ShopSubscriptionController', ShopSubscriptionController);

    /** @ngInject */
    function ShopSubscriptionController(api, $state, $filter, $mdDialog, $rootScope, clientSideExceptions)
    {
        var vm = this;
        vm.currentSubscription = {};
        vm.hasSubscription = false;
        vm.formatAsCurrency = formatAsCurrency;
        vm.basicPlanIsAvailable = false;
        vm.standardPlanIsAvailable = false;
        vm.premiumPlanIsAvailable = false;

        vm.previousOrderDetails = $state.params.orderDetails;

        if(vm.previousOrderDetails !== null) {
            var parentEl = angular.element(document.body);
            $mdDialog.show({
                parent: parentEl,
                template:
                '<md-dialog aria-label="List dialog">' +
                '  <md-dialog-content>'+
                '<h3 translate="PRODUCT.PREVIOUS_ORDER">Thanks for your order</h3>' +
                '<p>{{ previousOrderDetails.braintree_plan }} subscription</p>' +
                '<p>Quantity: {{ previousOrderDetails.quantity }}</p>' +
                '<p>Order number: {{ previousOrderDetails.id }}</p>' +
                '<p ng-bind-html="formatedCurrency"></p>' +
                '  </md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Dismiss' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                locals: {
                    previousOrderDetails: vm.previousOrderDetails,
                    formatedCurrency: vm.formatAsCurrency(vm.previousOrderDetails.amount, 1)
                },
                controller: DialogController
            });

            function DialogController($scope, $mdDialog, previousOrderDetails, formatedCurrency) {
                $scope.previousOrderDetails = previousOrderDetails;
                $scope.formatedCurrency = formatedCurrency;
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                    vm.previousOrderDetails = null;
                }
            }
        }

        function formatAsCurrency(amount, countryId) {
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        api.getShop.save({},{}).$promise.then(function(response) {
            if (response.result) {
                vm.shop = response.data.shop;
                api.getShopStats.save({shopId: vm.shop.id},{}).$promise.then(function(response) {
                    if(response.result) {
                        vm.stats = response.data.stats;
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantGetShopStats(new Error(), response));
                    }
                })
            }
        });

        vm.buySubscription = function(subscriptionId) {
            // if (subscriptionId == vm.currentSubscription.plan) {
            //     return;
            // }
            for (var index in vm.plans) {
                var plan = vm.plans[index];
                if (plan.id == subscriptionId) {
                    plan.type = 'subscription';
                    plan.description = '1 Year ' + plan.id + ' subscription';
                    plan.hasSubscription = vm.hasSubscription; //user has subscription for cart page
                    plan.apiCallback = (vm.hasSubscription && vm.currentSubscription.status != 'trial') ? api.updateSubscription : api.storeSubscription;
                    plan.showCoupon = true;
                    $state.go('app.cart', {order: plan});
                }
            }
        };

        // Methods

        // api.getSubscriptionPlans.save({}, {}).$promise.then(function(response) {
        //     if (response.result) {
        //         vm.plans = {}
        //         response.data.plans.forEach(function(plan) {
        //             vm.plans[plan.id] = plan;
        //         });
        //     } else {
        //         $rootScope.throwException(clientSideExceptions.cantGetPlanList(new Error(), response));
        //     }
        // });

        api.showSubscription.save({}, {}).$promise.then(function(response) {
            if (response.result) {
                vm.currentSubscription.plan = response.data.subscription.plan;
                vm.currentSubscription.status = response.data.subscription.status;
                vm.currentSubscription.expires_at = response.data.subscription.expires_at;
                vm.hasSubscription = true;

                if (vm.currentSubscription.status == 'trial') {
                    vm.basicPlanIsAvailable = true;
                    vm.standardPlanIsAvailable = true;
                    vm.premiumPlanIsAvailable = true;
                } else {
                    vm.basicPlanIsAvailable = (vm.currentSubscription.plan != 'Basic'
                    && vm.currentSubscription.plan != 'Standard'
                    && vm.currentSubscription.plan != 'Premium');
                    vm.standardPlanIsAvailable = (vm.currentSubscription.plan != 'Standard'
                    && vm.currentSubscription.plan != 'Premium');
                    vm.premiumPlanIsAvailable = (vm.currentSubscription.plan != 'Premium');
                }

            } else {
                vm.currentSubscription.plan = "Free";
                vm.basicPlanIsAvailable = true;
                vm.standardPlanIsAvailable = true;
                vm.premiumPlanIsAvailable = true;
            }
        });

        vm.cancelSubscription = function() {
            var alert = $mdDialog.confirm({
              title: 'Attention',
              textContent: 'Are yu sure you want cancel your subscription?',
              ok: 'Accept',
              cancel: 'Cancel'
            });

            var alertPromise = $mdDialog
                .show( alert )
                .finally(function() {
                    alert = undefined;
                });

            alertPromise.then(function(result) {
                api.destroySubscription.save({}, {}).$promise.then(function(response) {
                    if (response.result) {
                        toastr.success('Subscription cancelled.', 'Success!');
                        $state.go($state.current, {}, {reload: true})
                    } else {
                        toastr.warning(response.errors.subscription, 'Warning!');
                        $state.go($state.current, {}, {reload: true})
                    }
                });
            }, function(err) {
            });
        };

        function checkForWizard() {
          try {
            var user = JSON.parse(localStorage.getItem('user'))
            var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
            if(!wizardInfo.wizardFinished && wizardInfo.step == 4) {
              var alert = $mdDialog.alert()
                  .title('Thank you for setting up your shop. You can always visit My Shop -> General Settings to change your settings at any time. You are currently on a Trial Subscription')
                  .textContent('Please use the feedback button to let us know if you have any problems')
                  .ok('Ok');

              $mdDialog.show(alert).then(function() { // User is following wizard
                wizardInfo.step = 5;
                localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
              });
              return;
            }
          } catch(err) {

          }
        }
        checkForWizard();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.resendverification', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_resend_verification', {
            url      : '/resendverification',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_resend_verification': {
                    templateUrl: 'app/main/resendverification/resendverification.html',
                    controller : 'ResendVerificationController as vm'
                }
            },
            bodyClass: 'login',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/resendverification');

        // Navigation
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.resendverification')
        .controller('ResendVerificationController', ResendVerificationController);

    /** @ngInject */
    function ResendVerificationController($rootScope, api) {
        var pageRoot = angular.element(document.getElementById('resend-verification'));
        pageRoot.css("background", 'url(\'/assets/images/backgrounds/login' + $rootScope.wallpaperIndex + '.jpg\') no-repeat')
        pageRoot.css("background-size", "cover");

        // Data
        var vm = this;

        vm.serverSideValidationMsg = {};
        vm.resendSuccess = null;

        // Methods
        vm.checkEmail = checkEmail;
        vm.resend = resend;

        function checkEmail(form, credentials) {
            $rootScope.resetServerSideValidation(form);
            api.checkEmail.save({}, credentials).$promise.then(function(response)
            {
                if (!response.data.user) {
                    form.email.$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg.email = 'No registered user with this email';
                } else {
                    $rootScope.resetServerSideValidation(form);
                }
            });
        }

        function resend(form, credentials) {
            api.resendVerificationEmail.save({}, credentials).$promise.then(function(response)
            {
                if (response.result) {
                    vm.resendSuccess = true;
                    toastr.success('Verification e-mail had been re-sent.', 'Success!');
                } else {
                    vm.resendSuccess = false;
                    form.email.$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg.email = response.errors[0];
                }
            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.shops', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.shops', {
            title    : "SHOPS.TITLE",
            url      : '/shops',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/shops/shops.html',
                    controller : 'ShopsController as vm'
                },
            },
            bodyClass: 'shops',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: false},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/shops');

        msNavigationServiceProvider.saveItem('shops', {
            title : 'Local Shops',
            state : 'app.shops',
            icon  : 'icon-cart',
            weight: 2
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.shops')
        .controller('ShopsController', ShopsController);

    /** @ngInject */
    function ShopsController($scope, api, $timeout, $rootScope, $filter, $mdDialog, $state, clientSideExceptions) {
        // Data
        var vm = this;

        vm.showCards = true;
        vm.locations = [];
        vm.searchCriteria = {
            latitude: 0,
            longitude: 0,
            limit: 10,
            offset: 0,
            order: 'distance',
            favorite: false
        };
        vm.sortOrder = 'distance';
        vm.loading = true;
        vm.page = 1;
        vm.totalItems;

        // Methods
        vm.openMap = openMap;
        vm.closeMap = closeMap;
        vm.toggleCheckin = toggleCheckin;
        vm.setOrdering = setOrdering;
        vm.myPagingFunction = myPagingFunction;
        vm.formatAsCurrency = formatAsCurrency;
        vm.striptags = striptags;
        vm.setFavorite = setFavorite

        function setFavorite(location, state) {
            var apiMethod;
            if (state) {
                apiMethod = api.setFavorite;
            } else {
                apiMethod = api.clearFavorite;
            }

            apiMethod.save({shop: location.shop.id}, {}).$promise.then(function(response) {
                if (response.result) {
                    location.is_favorite = state;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantFavoriteShop(new Error(), response));
                }
            });
        };

        function formatAsCurrency(amount, location) {
            return $filter('currency')(amount, location.currencySymbol, 2);
        }

        function myPagingFunction() {
            if (!vm.loading) {
                searchLocations(false);
            }
        }

        function setOrdering(orderValue, isFavorite) {
            vm.showCards = false;
            vm.page = 1;
            vm.searchCriteria.offset = 0;
            vm.searchCriteria.order = orderValue;
            vm.searchCriteria.favorite = isFavorite;
            searchLocations(true);
        }

        function toggleCheckin(location) {
            var locationId = location.id;
            // md-switch changes model, se we use optimistic loading by default
            if(location.is_checked_in) { // must check-out costumer to location
                api.checkOutOfLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        // do nothing
                    } else {
                        location.is_checked_in = true;
                        $rootScope.throwException(clientSideExceptions.cantCheckOutUser(new Error(), response));
                    }
                });
            } else { // must check-in costumer to location
                api.checkInToLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        // do nothing
                    } else {
                        location.is_checked_in = false;
                        $rootScope.throwException(clientSideExceptions.cantCheckInUser(new Error(), response));
                    }
                });
            }
        }

        function openMap (location, index) {
            var latLng = new google.maps.LatLng(location.latitude, location.longitude);

            if(!vm.openMapObj) {
                var mapOptions = {
                  center: latLng,
                  zoom: 15,
                  mapTypeId: google.maps.MapTypeId.ROADMAP,
                  streetViewControl: false,
                  zoomControl: false,
                  mapTypeControl: false
                };

                var map = new google.maps.Map(document.getElementById('fixedMapDiv'), mapOptions);
                vm.openMapObj = {
                    'location': location,
                    'map': map
                }

            } else {
                vm.openMapObj.location.flipped = false;
                vm.openMapObj.marker.setMap(null);
                vm.openMapObj.map.setCenter(latLng);
            }

            location.flipped = true;
            var mapDiv = angular.element(document.getElementById(index + '-map'));
            mapDiv.append(vm.openMapObj.map.getDiv());
            vm.openMapObj.location = location;

            // Put marker
            google.maps.event.addListenerOnce(vm.openMapObj.map, 'idle', function(){

                    $timeout(function () { //TODO: FIX, Safari is too slow loading map and/or on map re-center messes things up
                        var marker = new google.maps.Marker({
                            map: vm.openMapObj.map,
                            animation: google.maps.Animation.DROP,
                            position: latLng
                        });

                        vm.openMapObj.marker = marker;
                        vm.openMapObj.map.setCenter(latLng);
                    }, 1000);
                    vm.openMapObj.firstMarker = true;

                google.maps.event.trigger(vm.openMapObj.map, 'resize');

            }, function(error){
                $rootScope.throwException(clientSideExceptions.googleMapError(new Error(), error));
            });
        };

        function closeMap() {
            vm.openMapObj.location.flipped = false;
        };

        function getUserProfile() {
            $rootScope.getLocation(function(position) {
                vm.searchCriteria.latitude = position.latitude;
                vm.searchCriteria.longitude = position.longitude;
                searchLocations(true);
            }, function(error) {
                vm.loading = false;
                vm.error = 'locationError';
                // $rootScope.throwException({code: '0103', msg: 'Error: Could not get location.', persistent: false, debug: error});
            });
        }

        function searchLocations(resetLocations) {

            if (resetLocations) {
                vm.page = 1;
            }

            if (vm.totalItems != undefined) {
                var offset = (vm.page -1) * vm.searchCriteria.limit;
                if (offset <= vm.totalItems) {
                    vm.searchCriteria.offset = offset;
                } else {
                    return;
                }
            }

            vm.loading = true;
            api.getShopsNearby.save({}, vm.searchCriteria).$promise.then(function(response) {
                if (response.result) {
                    response.data.locations.forEach(function(location) {
                        if(location.distance_km > 1.0) {
                            location.rounded_distance = Math.floor(location.distance_km) + ' km';
                        } else {
                            location.rounded_distance = Math.floor(location.distance_km * 1000) + ' mts';
                        }

                        location.currencySymbol = $rootScope.getCurrencyByCountry(location.shop.country_id);
                    });

                    if (resetLocations) {
                        vm.locations = response.data.locations;
                    } else {
                        response.data.locations.forEach(function(item) {
                            vm.locations.push(item);
                        });
                    }

                    vm.loading = false;
                    vm.showCards = true;
                    vm.page++;
                    vm.totalItems = response.data.meta.total;

                    $scope.$$postDigest(function(){ // Meant to re-size the labels after the scope digest cycle has ended
                        // TODO: a lot of values are hardcoded for convinience, change to queries and real values
                        for(var i = 0; i < vm.locations.length; i++) {
                            var valueSpan = angular.element(document.getElementById(i + '-voucher-value'));
                            valueSpan.css("font-size", 14);
                            var sizeRatio = valueSpan.width()/50;
                            if(sizeRatio > 1) { // this means: voucher value is overflowing
                                var newFontSize = 14 / sizeRatio;
                                valueSpan.css("font-size", newFontSize);
                            }
                            valueSpan = null;
                        }
                    });
                } else {
                    $scope.searchSuccess = false;
                    $rootScope.throwException(clientSideExceptions.cantGetLocationsNearby(new Error(), response));
                }
            });
        }

        // Functions ran at start of controller
        getUserProfile();

        // Prompt user to add webapp to homescreen
        var addtohome = addToHomescreen({
            maxDisplayCount: 1
        });

        // Shop creation wizard
        function checkForWizard() {
          api.getShop.save({}, {}).$promise.then(function(response) {
            if(!response.result) {
              try {
                var user = JSON.parse(localStorage.getItem('user'))
                var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
                if(!wizardInfo.wizardFinished && wizardInfo.step == 0) {
                  var confirm = $mdDialog.confirm()
                      .title('Are you a shop owner? If so please click \'Yes\' to set up your Shop')
                      .textContent('')
                      .ok('Yes!')
                      .cancel('No');

                  $mdDialog.show(confirm).then(function() { // User is following wizard
                    $state.go('app.createshop');
                  }, function() { // User denied wizard
                    wizardInfo.wizardFinished = true;
                    localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                  });
                }
              } catch(err) {
                  wizardInfo = {
                      'wizardFinished': false,
                      'step': 0
                  };
                  var user = JSON.parse(localStorage.getItem('user'))
                  localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                  checkForWizard();
                  // $rootScope.throwException({code: '0105', msg: 'Error: Can\'t get locations nearby.', persistent: false, debug: err});
              }
            }
          });
        }
        // checkForWizard();

        $scope.$on('destroy', function() {
          vm.openMapObj = null;
          vm = null;
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.shoplocation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.shoplocation', {
            title    : "SHOPLOCATION.TITLE",
            url      : '/shoplocation',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/shoplocation/shoplocation.html',
                    controller : 'ShopLocationController as vm'
                },
            },
            bodyClass: 'shop-location',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                api.getShop.save({},{}).$promise.then(function(response) {
                    if (!response.result) {
                        toastr.warning('Please configure your shop first', 'Warning!');
                        return state.go('app.createshop');
                    } else {
                        toParams.enableOnStateChangeStartHandler = false;
                        return state.go(that.name, toParams);
                    }
                });
                return;
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/shoplocation');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop.locations', {
            title : 'Locations',
            state : 'app.shoplocation',
            weight: 1
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.shoplocation')
        .controller('ShopLocationController', ShopLocationController);

    /** @ngInject */
    function ShopLocationController($rootScope, api, $state, clientSideExceptions)
    {
        // Data
        var vm = this;

        // Methods
        vm.deleteLocation = deleteLocation;

        api.getShop.save({},{}, function(response) {
            if (response.result) {
                vm.shop = response.data.shop;
                vm.shop.is_payoff_cancelable = vm.shop.is_payoff_cancelable == 1;

                api.getLocationList.save({shop: vm.shop.id}, {}).$promise.then(function(response)
                {
                    if (response.result) {
                        vm.locations = response.data.locations;
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantGetLocations(new Error(), response));
                    }
                });
            }
        });

        function deleteLocation(event, location) {
            event.preventDefault();
            if (confirm('Are you sure you want to delete this location?') ) {
                api.deleteShopLocation.save({location: location},{}).$promise.then(function(response) {
                    if (response.result) {
                        toastr.success('Location successfully deleted.', 'Success!');
                        $state.go($state.current, {}, {reload: true});
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantDeleteLocation(new Error(), response));
                    }
                });
            }
        };

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.shopconfig', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.shopconfig', {
            title    : "SHOPCONFIG.TITLE",
            url      : '/shopconfig',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/shopconfig/shopconfig.html',
                    controller : 'ShopConfigController as vm'
                },
            },
            bodyClass: 'shop-config',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                event.preventDefault();
                var that = this;
                // api.getOperatorIndex.save({}, {}, function(response) {
                //     if(response.result) {
                //         if(response.data.shops.length == 0) {
                //             toParams.enableOnStateChangeStartHandler = false
                //             return state.go('app.createshop', toParams);
                //         } else {
                            toParams.enableOnStateChangeStartHandler = false;
                            return state.go(that.name, toParams);
                //         }
                //     } else {
                //         console.log('error getting operator locations');
                //     }
                // });
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/shopconfig');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop', {
            title : 'My Business',
            icon  : 'icon-store',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('my_shop.general_settings', {
            title : 'General Settings',
            state : 'app.shopconfig',
            weight: 1
        });

    }

})();

(function () {
    'use strict';

    angular
    .module('app.shopconfig')
    .controller('ShopConfigController', ShopConfigController);

    /** @ngInject */
    function ShopConfigController($rootScope, api, $state, $resource, Upload, $scope, $mdDialog, clientSideExceptions) {
        var vm = this;
        // Data
        vm.verificationSuccess = null;
        vm.serverSideValidationMsg = {};

        vm.logoChanged = false;
        vm.hasOwnShop = true; // assume true until back-end replies
        vm.loading = true;

        // Methods
        vm.enableEditMode = enableEditMode;
        vm.cancelEditMode = cancelEditMode;
        vm.setLogoChanged = setLogoChanged;
        vm.upload = upload;
        vm.saveShopConfiguration = saveShopConfiguration; // this is meant for the information edits, this executes on save button click
        vm.changeShopConfiguration = changeShopConfiguration; // this is meant for toggles and other configuration changes, this executes on change of value
        vm.updateShopData = updateShopData;
        vm.startWizard = startWizard;
        vm.updateOperator = updateOperator;

        function enableEditMode() {
            vm.editMode = true;
            vm.logoChanged = false;
            vm.shadowCopy = angular.copy(vm.shop);
        }

        function cancelEditMode() {
            vm.editMode = false;
            vm.logoChanged = false;
            vm.shop = vm.shadowCopy;
        }

        function setLogoChanged() {
            vm.logoChanged = true;
        }

        function getAllShops() {
            api.getOperatorIndex.save({}, {}).$promise.then(function(response) {
                if(response.result) {
                    vm.shops = response.data.shops;
                    if(vm.shops.length > 0) {
                        vm.currentShop = vm.shops[0];
                        updateShopData();
                    } else {
                        vm.hasOwnShop = false;
                        vm.loading = false;
                    }
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetOperatorShops(new Error(), response));
                }
            });
        }

        function getOwnShopData() {
            api.getShop.save({}, {}).$promise.then(function(response) {
                vm.loading = false;
                if(response.result) {
                    vm.hasOwnShop = true;
                } else {
                    vm.hasOwnShop = false;
                }
            });
        }

        function updateShopData() {
            api.updateShopConfig = $resource(api.baseUrl + '/shop/update/' + vm.currentShop.id);
            api.getShopDetails.save({shop: vm.currentShop.id},{}).$promise.then(function(response) {
                vm.loading = false;
                if (response.result) {
                    vm.shop = response.data.shop;
                    vm.shop.is_payoff_cancelable = vm.shop.is_payoff_cancelable == 1;
                    vm.shop.is_active = vm.shop.is_active == 1;

                    // add date so browser reloads source always
                    if (vm.shop.logo_full_url) {
                        vm.shop.logo_full_url = vm.shop.logo_full_url + '?' + new Date().getTime();
                    }

                    // watch for categories
                    if(vm.categories) {
                        vm.categories.forEach(function(cat) {
                            if(cat.id == vm.shop.category_id) {
                                vm.shop.category_title = cat.title;
                            }
                        });
                    } else {
                        $scope.$watch('vm.categories', function() {
                            if(vm.categories) {
                                vm.categories.forEach(function (cat) {
                                    if (cat.id == vm.shop.category_id) {
                                        vm.shop.category_title = cat.title;
                                    }
                                });
                            }
                        })
                    }

                    // watch for countries
                    if(vm.countryList) {
                        vm.countryList.forEach(function(country) {
                            if(country.id == vm.shop.country_id) {
                                vm.shop.country_name = country.name;
                            }
                        });
                    } else {
                        $scope.$watch('vm.countryList', function() {
                            if (vm.countryList) {
                                vm.countryList.forEach(function(country) {
                                    if(country.id == vm.shop.country_id) {
                                        vm.shop.country_name = country.name;
                                    }
                                });
                            }
                        })
                    }

                    // Get operators
                    api.getOperators.save({shop: vm.shop.id}, {}).$promise.then(function(response) {
                        if (response.result) {
                            vm.operators = response.data.operators;
                            for (var i in vm.operators) {
                                vm.operators[i].has_edit_rights = (vm.operators[i].has_edit_rights == 1);
                                vm.operators[i].is_active = (vm.operators[i].is_active == 1);
                                vm.operators[i].is_owner = (vm.operators[i].user_id == vm.shop.user_id);
                            }
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetOperatorList(new Error(), response));
                        }
                    });

                    // get subscription
                    api.showSubscription.save({}, {}).$promise.then(function(response) {
                        if (response.result) {
                            vm.currentSubscription = response.data.subscription.plan;
                        } else {
                            vm.currentSubscription = "Free";
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }

        function getCountryList() {
            api.getCountryList.save({}, {}).$promise.then(function(response)
            {
                if (response.result) {
                    vm.countryList = response.data.countries;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetCountryList(new Error(), response));
                }
            });
        }


        function getCategoryList() {
            api.getCategoryList.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.categories = response.data.categories;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetCategoryList(new Error(), response));
                }
            });
        }

        // upload on file select or drop
        function upload(model, form) {
            Upload.upload({
                url: api.baseUrl + '/shop/update/' + vm.shop.id,
                data: model
            }).then(function (resp) {
                vm.logoChanged = false;
                if (!resp.data.result) {
                    var errorMsg = '';
                    for (var i in resp.data.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in resp.data.errors[i]) {
                                vm.serverSideValidationMsg[i] += resp.data.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + resp.data.errors[i].toString() + '. ');
                        }
                    }
                    vm.updateSuccess = false;
                    vm.editMode = true;
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantUploadShopData(new Error(), resp.data, errorMsg));
                    }
                } else {
                    toastr.success('Shop config successfully updated.', 'Success!');

                    vm.editMode = false;
                    updateShopData();
                }
            }, function (resp) {
                $rootScope.throwException(clientSideExceptions.cantUploadShopData(new Error(), resp.data));
            }, function (evt) {
                // TODO: show progress
                // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                // console.log('progress: ' + progressPercentage + '% ' + evt.config.data.logo.name);
            });
        };


        function saveShopConfiguration(form, shopData) {

            var model = jQuery.extend(true, {}, shopData);

            if (!model.hasOwnProperty('is_payoff_cancelable')) {
                model.is_payoff_cancelable = 0;
            }
            model.is_payoff_cancelable = model.is_payoff_cancelable ? 1 : 0;

            if (model.website.indexOf('http://') == -1 && model.website.indexOf('https://') == -1) {
                model.website = 'http://' + model.website;
                shopData.website = model.website;
            }

            if (form.logo.$valid && model.logo && vm.logoChanged) {
                vm.upload(model, form);
            } else {
                model.logo = null;

                api.updateShopConfig.save({}, model).$promise.then(function(response) {
                    if (!response.result) {
                        var errorMsg = '';
                        for (var i in response.errors) {
                            if (form[i]) {
                                form[i].$setValidity('serverSideValidation', false);
                                vm.serverSideValidationMsg[i] = '';
                                for (var j in response.errors[i]) {
                                    vm.serverSideValidationMsg[i] += response.errors[i][j];
                                }
                            } else {
                                errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                            }
                            vm.registrationSuccess = false;
                        }
                        if (errorMsg != '') {
                            $rootScope.throwException(clientSideExceptions.cantSaveShopData(new Error(), response, errorMsg));
                        }
                     } else {
                        toastr.success('Shop configuration successfully saved.', 'Success!');
                        vm.successMsg = response.message;
                        vm.registrationSuccess = true;
                        vm.editMode = false;
                        updateShopData();
                    }

                });
            }
        }

        function changeShopConfiguration() {
            if(vm.editMode) {
                cancelEditMode(); // cancel edit mode to conserve data integrity
            }

            // change format from boolean, to a truthy value for back-end
            if(vm.shop.is_payoff_cancelable) {
                vm.shop.is_payoff_cancelable = 0;
            } else {
                vm.shop.is_payoff_cancelable = 1;
            }

            vm.shop.logo = null;

            api.updateShopConfig.save({}, vm.shop).$promise.then(function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveShopData(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Shop configuration successfully saved.', 'Success!');
                    vm.successMsg = response.message;
                    vm.registrationSuccess = true;
                    getShopData();
                }

            });

        }

        //////////

        getCountryList();
        getCategoryList();
        getOwnShopData();
        getAllShops();

        // Shop creation wizard
        function checkForWizard() {
          try {
            var user = JSON.parse(localStorage.getItem('user'));
            var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
            if(wizardInfo.wizardFinished) {
              return;
            }

            switch (wizardInfo.step) {
              case 1:
                wizardInfo.step = 2;
                localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                $state.go('app.editshoplocation', {shop: null});
                break;

              case 2:
                wizardInfo.step = 3;
                localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                $state.go('app.editstampcard', {shop: null});
                break;

              case 5:
                var confirm = $mdDialog.alert()
                    .title('Thank you for creating your shop and stampcard offering, you will be notified by email once your shop has been activated!')
                    .textContent('')
                    .ok('Done');

                $mdDialog.show(confirm).then(function() { // User is following wizard
                  wizardInfo.wizardFinished = true;
                  localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                });
                break;

              default:
            }

          } catch(err) {
              // $rootScope.throwException({code: '0132', msg: 'Error happened.', persistent: false, debug: err});
          }
        }
        checkForWizard();

        // Shop creation wizard
        function startWizard() {
          try {
            var user = JSON.parse(localStorage.getItem('user'));
            var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
            wizardInfo.wizardFinished = false;
            localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
          } catch(err) {
              wizardInfo = {
                  'wizardFinished': false,
                  'step': 0
              };
              var user = JSON.parse(localStorage.getItem('user'))
              localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
              // $rootScope.throwException({code: '0047', msg: 'Error happened.', persistent: false, debug: err});
          }
          $state.go('app.createshop', {enableOnStateChangeStartHandler: false});
        }

        function updateOperator(operator) {
            var model = angular.copy(operator);
            if(operator.is_active) {
                model.is_active = 1;
            } else {
                model.is_active = 0;
            }

            api.updateOperator.save({operator: operator.id}, model).$promise.then(function(response) {
                if(response.result) {
                    toastr.success('Operator info successfully updated.', 'Success!');
                } else {
                    $rootScope.throwException(clientSideExceptions.cantSaveOperatorData(new Error(), response));
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.resetpassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_resetpassword', {
            url      : '/resetpassword?token',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_resetpassword': {
                    templateUrl: 'app/main/resetpassword/resetpassword.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'login',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/resetpassword');

        // Navigation
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.resetpassword')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($rootScope, $location, $state, api, clientSideExceptions)
    {
        // Data
        var vm = this;

        vm.serverSideValidationMsg = {};
        vm.resetSuccess = null;

        // Methods
        vm.reset = reset;

        function reset(form, credentials) {
            var param = $location.search();
            credentials.token = param.token;

            api.resetPassword.save({}, credentials).$promise.then(function(response) {
                if (response.result) {
                    vm.resetSuccess = true;
                    toastr.success('Password successfully changed.', 'Success!');
                    $state.go('app.auth_login');
                } else {
                    vm.resetSuccess = false;

                    var errorMsg = '';
                    for (var i in response.errors) {
                        var k = i;
                        if (i == 'user') {
                            i = 'email';
                        }

                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[k]) {
                                vm.serverSideValidationMsg[i] += response.errors[k][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[k].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantResetPassword(new Error(), response, errorMsg));
                    }
                }
            });

        }

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_register', {
            url      : '/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_register': {
                    templateUrl: 'app/main/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already registered and logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/register');

        // Navigation
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController($rootScope, api, $auth, $state, clientSideExceptions) {
        // place random background
        var pageRoot = angular.element(document.getElementById('register'));
        pageRoot.css("background", 'url(\'/assets/images/backgrounds/login' + $rootScope.wallpaperIndex + '.jpg\') no-repeat')
        pageRoot.css("background-size", "cover");
        // Data
        var vm = this;
        vm.form = {};
        vm.serverSideValidationMsg = {};
        vm.registrationSuccess = null;

        // Methods
        vm.checkEmail = checkEmail;
        vm.register = register;

        api.getCountryList.save({}, {}).$promise.then(function(response)
        {
            if (response.result) {
                vm.countries = response.data.countries;

                api.getLocationByIp.getIp({}, {}).$promise.then(function(response) {
                    // DEBUG
                    response.country_code = response.country_code == 'HU' ? 'GB' : response.country_code;
                   vm.countries.forEach(function(item, index) {
                        if (item.code == response.country_code) {
                            vm.form.country_id = item.id;
                        }
                    });
                });

            } else {
                $rootScope.throwException(clientSideExceptions.cantGetCountryList(new Error(), response));
            }
        });

        function checkEmail(form, credentials) {
            api.checkEmail.save({}, credentials).$promise.then(function(response)
            {
                if (response.data.user) {
                    form.email.$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg.email = 'Email address is already taken';
                } else {
                    $rootScope.resetServerSideValidation(form);
                }
            });
        }

        function register(form, credentials) {
            api.register.save({}, credentials).$promise.then(function(response)
            {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    vm.registrationSuccess = false;
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveRegistrationData(new Error(), response));
                    }
                } else {
                    // vm.successMsg = response.message;
                    // vm.registrationSuccess = true;


                    // Stringify the retured data
                    var user = JSON.stringify(response.data.user);
                    // Set the stringified user data into local storage
                    localStorage.setItem('user', user);
                    localStorage.setItem('api_token', response.data.api_token);
                    $auth.setToken(response.data.api_token);
                    // Getting current user data from local storage
                    // setCurrentUser(response.data.user);

                    localStorage.setItem('notifications', '[]');

                    // TODO: move it to cacheing
                    api.getCategoryList.save({}, {}).$promise.then(function(response)
                    {
                        if (response.result) {
                            var categories = response.data.categories;

                            var categoryMap = {};
                            for (var i in categories) {
                                categoryMap[categories[i].id] = categories[i];
                            }

                            localStorage.setItem('categories', JSON.stringify(categoryMap));
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetCategoryList(new Error(), response));
                        }
                    });

                    // TODO: move it to cacheing
                    api.getCountryList.save({}, {}).$promise.then(function(response)
                    {
                        if (response.result) {
                            var countries = response.data.countries;

                            var countryMap = {};
                            for (var i in countries) {
                                countryMap[countries[i].id] = countries[i];
                            }

                            localStorage.setItem('countries', JSON.stringify(countryMap));

                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetCountryList(new Error(), response));
                        }
                    });

                    api.getNotifications.save({}, {}).$promise.then(function(response) {
                        if (response.result) {
                            localStorage.notifications = JSON.stringify(response.data.notifications);
                            $rootScope.notifications = response.data.notifications;
                            $rootScope.$broadcast('notificationsChanged');
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetNotifications(new Error(), response));
                        }
                    });

                    $state.go('app.dashboard');
                }

            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.product', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.product', {
            title    : "PRODUCT.TITLE",
            url      : '/product',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/product/product.html',
                    controller : 'ProductController as vm'
                },
            },
            bodyClass: 'product',
            needAuth: true,
            params: {orderDetails: null}
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/product');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop.product', {
            title : 'Order Cards',
            state : 'app.product',
            weight: 4
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.product')
        .controller('ProductController', ProductController);

    /** @ngInject */
    function ProductController(api, $state, $filter, $rootScope, $mdDialog, clientSideExceptions) {

        // Data
        var vm = this;
        vm.serverSideValidationMsg = {};
        vm.loading = true;

        // Methods
        vm.buyProduct = buyProduct;
        vm.placeOrder = placeOrder;
        vm.formatAsCurrency = formatAsCurrency;

        vm.previousOrderDetails = $state.params.orderDetails;

        if(vm.previousOrderDetails !== null) {
          var parentEl = angular.element(document.body);
          $mdDialog.show({
             parent: parentEl,
             template:
               '<md-dialog aria-label="List dialog">' +
               '  <md-dialog-content>'+
               '<h3 translate="PRODUCT.PREVIOUS_ORDER">Thanks for your order</h3>' +
               '<p>{{ previousOrderDetails.product.name }}</p>' +
               '<p>Quantity: {{ previousOrderDetails.quantity }}</p>' +
               '<p>{{ previousOrderDetails.address }}</p>' +
               '<p ng-if="previousOrderDetails.comments">Shipping instructions: {{ previousOrderDetails.comments }}</p>' +
               '<p>Order number: {{ previousOrderDetails.id }}</p>' +
               '<p ng-bind-html="formatedCurrency"></p>' +
               '  </md-dialog-content>' +
               '  <md-dialog-actions>' +
               '    <md-button ng-click="closeDialog()" class="md-primary">' +
               '      Dismiss' +
               '    </md-button>' +
               '  </md-dialog-actions>' +
               '</md-dialog>',
             locals: {
               previousOrderDetails: vm.previousOrderDetails,
               formatedCurrency: vm.formatAsCurrency(vm.previousOrderDetails.amount, 1)
             },
             controller: DialogController
          });

          function DialogController($scope, $mdDialog, previousOrderDetails, formatedCurrency) {
            $scope.previousOrderDetails = previousOrderDetails;
            $scope.formatedCurrency = formatedCurrency;
            $scope.closeDialog = function() {
              $mdDialog.hide();
              vm.previousOrderDetails = null;
            }
          }
        }

        function formatAsCurrency(amount, countryId) {
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function resetOrder () {
            vm.order = {
                quantity: 1,
                product: null
            };
        }
        resetOrder();

        function getProducts() {
            api.getProducts.save({}, {}).$promise.then(function(response) {
                vm.loading = false;
                if (response.result) {
                    vm.products = response.data.products;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetProducts(new Error(), response));
                }
            });
        }

        function buyProduct(product) {
            vm.order.product = product;
        }

        function placeOrder(form) {
            vm.order.type = 'product';
            vm.order.description = vm.order.product.name;
            vm.order.price = vm.order.product.price * vm.order.quantity;
            vm.order.currency = vm.order.product.currency;
            vm.order.apiCallback = api.placeOrder;
            vm.order.showCoupon = false;

            $state.go('app.cart', {order: vm.order});
        }

        (function getShopData() {
            api.getShop.save({},{}).$promise.then(function(response) {
                if (response.result) {
                    var location = response.data.shop.locations[0];
                    if (location) {
                        vm.order.address = location.zipcode + "\n" + location.address;
                    }
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        })();

        //////////

        getProducts();

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.operators', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.operators', {
            title    : "SHOPOPERATORS.TITLE",
            url      : '/operators',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/operators/operators.html',
                    controller : 'OperatorsController as vm'
                },
            },
            bodyClass: 'operators',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                event.preventDefault();
                var that = this;
                api.getShop.save({},{}).$promise.then(function(response) {
                    if (!response.result) {
                        toastr.warning('Please configure your shop first', 'Warning!');
                        state.go('app.createshop');
                    } else {
                        toParams.enableOnStateChangeStartHandler = false;
                        return state.go(that.name, toParams);
                    }
                });
                return;
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/operators');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop.operators', {
            title : 'Operators',
            state : 'app.operators',
            weight: 1
        });


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.operators')
        .controller('OperatorsController', OperatorsController);

    /** @ngInject */
    function OperatorsController($rootScope, api, $state, clientSideExceptions)
    {
        // Data
        var vm = this;
        vm.serverSideValidationMsg = {};
        vm.newOperator = {
            email: '',
            is_active: 0,
            has_edit_rights: false
        };

        // Methods
        vm.saveOperator = saveOperator;
        vm.showAddOperatorForm = showAddOperatorForm;
        vm.addOperator = addOperator;
        vm.deleteoperator = deleteoperator;

        api.getShop.save({},{}).$promise.then(function(response) {
            if (response.result) {
                vm.shop = response.data.shop;

                api.getOperators.save({shop: vm.shop.id}, {}).$promise.then(function(response)
                {
                    if (response.result) {
                        vm.operators = response.data.operators;
                        for (var i in vm.operators) {
                            vm.operators[i].has_edit_rights = (vm.operators[i].has_edit_rights == 1);
                            vm.operators[i].is_active = (vm.operators[i].is_active == 1);
                        }
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantGetOperatorList(new Error(), response));
                    }
                });

            }
        });

        function saveOperator(form, operatorData) {

            var model = jQuery.extend(true, {}, operatorData);

            if (!model.hasOwnProperty('has_edit_rights')) {
                model.has_edit_rights = 0;
            }
            model.has_edit_rights = model.has_edit_rights ? 1 : 0;

            var apiMethod;
            var routeParam;
            if (model.id) {
                apiMethod = api.updateOperator;
                routeParam = {operator: operatorData.id};
            } else {
                apiMethod = api.addOperator;
                routeParam = {shop: vm.shop.id};
            }

            apiMethod.save(routeParam, model).$promise.then(function (response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        var k = (i == 'operator' ? 'email' : i); 

                        if (form[k]) {
                            form[k].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[k] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[k] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveOperator(new Error(), response));
                    }
                } else {
                    toastr.success('Operator successfully updated.', 'Success!');
                    $state.go('app.operators');
                }
            });
        };

        vm._showAddOperatorForm = false;
        function showAddOperatorForm(show) {
            if (show !== undefined) {
                vm._showAddOperatorForm = show;
            }
            return vm._showAddOperatorForm;
        };

        function addOperator(form, operatorData) {

            var model = jQuery.extend(true, {}, operatorData);

            if (!model.hasOwnProperty('has_edit_rights')) {
                model.has_edit_rights = 0;
            }
            model.has_edit_rights = model.has_edit_rights ? 1 : 0;

            var apiMethod;
            var routeParam;
            if (model.id) {
                apiMethod = api.updateOperator;
                routeParam = {operator: vm.operator.id};
            } else {
                apiMethod = api.addOperator;
                routeParam = {shop: vm.shop.id};
            }

            apiMethod.save(routeParam, model).$promise.then(function (response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        var k = (i == 'operator' ? 'email' : i); 

                        if (form[k]) {
                            form[k].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[k] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[k] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantAddOperator(new Error(), response));
                    }
                } else {
                    toastr.success('Operator successfully updated.', 'Success!');

                    showAddOperatorForm(false);
                    api.getOperators.save({shop: vm.shop.id}, {}).$promise.then(function(response)
                    {
                        if (response.result) {
                            vm.operators = response.data.operators;
                            for (var i in vm.operators) {
                                vm.operators[i].has_edit_rights = (vm.operators[i].has_edit_rights == 1);
                                vm.operators[i].is_active = (vm.operators[i].is_active == 1);
                            }
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetOperatorList(new Error(), response));
                        }
                    });

                    vm.newOperator = {
                        email: '',
                        is_active: 0,
                        has_edit_rights: false
                    };
                }
            });
        };

        function deleteoperator(operatorId) {
            if (confirm('Are you sure?')) {

                api.destroyOperator.save({operator: operatorId}, {}).$promise.then(function (response) {
                    if (!response.result) {
                        var serverSideValidationMsg = '';
                        for (var i in response.errors) {
                            for (var j in response.errors[i]) {
                                serverSideValidationMsg += response.errors[i][j];
                            }
                        }
                        // $rootScope.throwException({code: '0094', msg: 'Error: ' + serverSideValidationMsg, persistent: false, debug: response});
                        toastr.warning(serverSideValidationMsg, 'Warning!');
                    } else {
                        toastr.success('Operator successfully deleted.', 'Success!');

                        api.getOperators.save({shop: vm.shop.id}, {}).$promise.then(function(response)
                        {
                            if (response.result) {
                                vm.operators = response.data.operators;
                                for (var i in vm.operators) {
                                    vm.operators[i].has_edit_rights = (vm.operators[i].has_edit_rights == 1);
                                    vm.operators[i].is_active = (vm.operators[i].is_active == 1);
                                }
                            } else {
                                $rootScope.throwException(clientSideExceptions.cantGetOperatorList(new Error(), response));
                            }
                        });
                    }
                });
            }
        };

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.operateuser', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.operateuser', {
            title    : "OPERATEUSER.TITLE",
            url      : '/operateuser/:location/user/:user/membercard/:membercard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/operateuser/operateuser.html',
                    controller : 'OperateUserController as vm'
                },
            },
            bodyClass: 'operate-user',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: false}
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/operateuser');

        // Navigation
    }

})();

(function () {
    'use strict';

    angular
        .module('app.operateuser')
        .controller('OperateUserController', OperateUserController);

    /** @ngInject */
    function OperateUserController($filter, api, $state, $mdDialog, $rootScope, clientSideExceptions) {
        // Data
        var vm = this;

        vm.serverSideValidationMsg = {};
        vm.categoryMap = JSON.parse(localStorage.categories);

        vm.membershipcard = {};
        vm.location = {};
        vm.stamps = [];

        vm.numberOfStamps = 1;
        vm.totalVoucherValue = 0;
        vm.originalSalesValue = null;
        vm.newSalesValue = null;
        vm.transactions = [];

        vm.loading = false;

        // Methods
        vm.getRange = getRange;
        vm.removeLastStamp = removeLastStamp;
        vm.updateTotalVoucherValue = updateTotalVoucherValue;
        vm.getRoundedNewSalesValue = getRoundedNewSalesValue;
        vm.processAndCheckout = processAndCheckout;
        vm.currencySymbol = null;
        vm.formatAsCurrency = formatAsCurrency;
        vm.addStamp = addStamp;

        function formatAsCurrency(amount) {
            return $filter('currency')(amount, vm.currencySymbol, 2);
        }

        api.operatorOperate.save({location: $state.params.location}, {}).$promise.then(function (response) {
            if (response.result) {
                getLocation();
            } else {
                $rootScope.throwException(clientSideExceptions.cantOperateLocation(new Error(), response));
            }
        });

        function getTransactions() {

            api.getOperatorIndex.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.shops = response.data.shops;
                    var locations = [];
                    vm.shops.forEach(function (shop) {
                        shop.locations.forEach(function (location) {
                            locations.push(location.id);
                        });
                    });

                    api.getTransactions.save({card: vm.membershipcard.id}, {locations: locations, limit: 50}).$promise.then(function (response) {
                        if (response.result) {
                            vm.transactions = response.data.transactions;
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetTransactions(new Error(), response));
                        }
                    });

                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetOperatorShops(new Error(), response));
                }
            });

        }

        function getCard() {

            var params;
            if ($state.params.user) {
                params = {user_id: $state.params.user};
            } else if ($state.params.membercard){
                params = {membercard: $state.params.membercard};
            }
            api.searchByCard.save({}, params).$promise.then(function(response) {
                if (response.result) {
                    vm.membershipcard = response.data.membershipcard;

                    if (vm.location.shop.stampcard && vm.location.shop.stampcard.is_active) {
                        if (!vm.membershipcard.stampcardUserShop) {
                            issueStampCard();
                        } else {

                            if (vm.membershipcard.stampcardUserShop.stamps_total == vm.membershipcard.total_stamps) {
                                api.payOffStampcard.save({stampcardUser: vm.membershipcard.stampcardUserShop.id}, {}).$promise.then(function(response) {

                                    var alert = $mdDialog.alert({
                                        title: 'Stamp card is complete',
                                        textContent: 'Please reward your customer!',
                                        ok: 'OK'
                                    });
                                    $mdDialog
                                        .show( alert )
                                        .finally(function() {
                                            alert = undefined;
                                            issueStampCard();
                                        });
                                });
                            } else {
                                prepareStampsAndVouchers();
                            }

                        }
                    }
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetMembershipCardData(new Error(), response));
                }
            });
        }

        function prepareStampsAndVouchers() {
            if (vm.membershipcard.stampcardUserShop) {
                vm.stamps = vm.membershipcard.stampcardUserShop.stamps;
            } else {
                vm.stamps = [];
            }
            for (var i = vm.stamps.length; i<vm.membershipcard.stampcardUserShop.stamps_total; i++) {
                vm.stamps.push({});
            }

            var today = new Date();
            vm.stamps.forEach(function(stamp, index) {
                if (stamp.created_at) {
                  // var stamp = stampcard.stamps[i];
                    var todayUnixTime = moment().unix();
                    var creationUnixTime = moment(stamp.created_at, 'YYYY-MM-DD hh:mm:ss').unix();
                    var hourDiff = (todayUnixTime - creationUnixTime) / 3600;
                    stamp.new = hourDiff <= 24;
                    // var createDate = new Date(stamp.created_at.substr(0,10) + "T" + stamp.created_at.substr(11));
                    // var timeDiff = Math.abs(today.getTime() - createDate.getTime());
                    // stamp.new = Math.ceil(timeDiff / (1000 * 3600)) <= 24;
                } else {
                    stamp.new = false;
                }
            });

            vm.membershipcard.active_vouchers.forEach(function(voucher, index) {
                voucher.selected = false;
            });

            getTransactions();
        }

        function getLocation() {
            api.getShopLocation.save({location: $state.params.location}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.location = response.data.location;
                    vm.currencySymbol = $rootScope.getCurrencyByCountry(vm.location.shop.country_id);
                    getCard();
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopLocation(new Error(), response));
                }
            });
        }

        function removeLastStamp(stampcardUser) {

            var confirm = $mdDialog.confirm()
                .title('Do you want to remove a stamp?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                var stamps = stampcardUser.stamps;
                stamps.sort(function(a, b) {
                    var dateA = a.created_at == undefined ? 0 : new Date(a.created_at).getTime();
                    var dateB = b.created_at == undefined ? 0 : new Date(b.created_at).getTime();
                    if (dateA == dateB) {
                        return 0;
                    }
                    return (dateA > dateB) ? -1 : 1;
                });

                if (stamps[0].created_at != undefined) {
                    api.removeStamp.save({stamp: stamps[0].id}, {}).$promise.then(function(response) {
                        if (response.result) {
                            toastr.success('You successfully removed stamp.', 'Success!');
                        } else {
                            toastr.warning('Removing stamp failed: ' + response.errors[0], 'Warning!');
                        }
                        getCard();
                    });
                }
            });
        }

        function getRange(count) {
            return Array.apply(null, Array(count)).map(function (i, j) {return j+1;});
        }

        function updateTotalVoucherValue() {
            var totalVoucherValue = 0;
            vm.membershipcard.active_vouchers.forEach(function(voucher, index) {
                totalVoucherValue += (voucher.selected ? voucher.value : 0);
            });
            vm.totalVoucherValue = totalVoucherValue;
        }

        function getRoundedNewSalesValue() {
            var originalSalesValue = vm.originalSalesValue == undefined ? 0 : vm.originalSalesValue;
            return Math.round((originalSalesValue - vm.totalVoucherValue) * 100) / 100;
        }

        function processAndCheckout() {
            var confirm = $mdDialog.confirm()
                .title('Do you want to process this sale?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                 addSale();
            });
        }

        function checkout() {
            if (vm.membershipcard.stampcardUserShop) {
                api.finishStampcard.save({stampcardUser: vm.membershipcard.stampcardUserShop.id}, {}).$promise.then(function (response) {
                    toastr.success('You finished with previous user.', 'Success!');
                    $state.go('app.operatelocation', {location: vm.location.id})
                });
            }
        }

        function payOffVouchers() {
            var selectedVouchers = 0;
            var paidVouchers = 0;
            vm.membershipcard.active_vouchers.forEach(function(voucher, index) {
                if (voucher.selected) {
                    selectedVouchers++;
                    api.payOffVoucher.save({membershipcardVoucher: voucher.id}, {}).$promise.then(function (response) {
                        if (response.result) {
                            paidVouchers++;
                            if (selectedVouchers == paidVouchers) {
                                checkout();
                            }
                            toastr.success('You successfully paid off voucher ' + voucher.code + '.', 'Success!');
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantPayOffVoucher(new Error(), response));
                        }
                    });
                }
            });
            if (selectedVouchers == 0) {
                checkout();
            }
        }

        function addSale() {
            vm.loading = true;
            if (vm.originalSalesValue > 0) {
                api.addSale.save({shop: vm.location.shop.id}, {membershipcard_id: vm.membershipcard.id, value: getRoundedNewSalesValue()}).$promise.then(function(response) {
                    if (response.result) {
                        toastr.success('Sales value successfully added.', 'Success!');
                        payOffVouchers();
                    } else {
                        vm.loading = false;
                        $rootScope.throwException(clientSideExceptions.cantAddSaleValue(new Error(), response));
                    }
                });
            } else {
                checkout();
            }
        }

        function issueStampCard() {
            api.issueStampCardForUser.save({stampcard: vm.location.shop.stampcard.id, membershipcard: vm.membershipcard.id}, {}).$promise.then(function(response) {
                if (response.result) {
                    getCard();
                } else {

                    var alert = $mdDialog.alert({
                        title: 'Warning!',
                        textContent: response.errors[0],
                        ok: 'OK'
                    });
                    $mdDialog
                        .show( alert )
                        .finally(function() {
                            alert = undefined;
                            $state.go('app.operatelocation', {location: vm.location.id})
                        });
                    // $rootScope.throwException({code: '0088', msg: response.errors[0], persistent: false, debug: response});
                }
            });
        }

        function addStamp() {
            var confirm = $mdDialog.confirm()
                .title('Are you sure you would like to stamp the card?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                api.addStamp.save({stampcardUser: vm.membershipcard.stampcardUserShop.id}, {count: vm.numberOfStamps}).$promise.then(function(response) {
                    if (response.result) {
                        toastr.success('You successfully added ' + vm.numberOfStamps.toString() + 'stamp(s).', 'Success!');
                        getCard();
                    } else {
                        toastr.warning(response.errors.count[0], 'Warning!');
                    }
                });
            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.operatelocation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.operatelocation', {
            title    : "OPERATELOCATION.TITLE",
            url      : '/operatelocation/:location',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/operatelocation/operatelocation.html',
                    controller : 'OperateLocationController as vm'
                },
            },
            bodyClass: 'operate-location',
            needAuth: true,
            // params: {enableOnStateChangeStartHandler: true},
            // onStateChangeStart: function(event, state, auth, api, toParams) {
            //     event.preventDefault();
            //     var that = this;
            //     api.getShop.save({},{}, function(response) {
            //         if (!response.result) {
            //             toastr.warning('Please configure your shop first', 'Warning!');
            //             return state.go('app.createshop');
            //         } else {
            //             toParams.enableOnStateChangeStartHandler = false;
            //             return state.go(that.name, toParams);
            //         }
            //     });
            //     return;
            // }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/operatelocation');

        // Navigation
    }

})();

(function() {
  'use strict';

  angular
    .module('app.operatelocation')
    .controller('OperateLocationController', OperateLocationController);

  /** @ngInject */
  function OperateLocationController(api, $state, $mdDialog, $timeout, $scope, $window, $rootScope, clientSideExceptions) {
    // Data

    var vm = this;
    vm.serverSideValidationMsg = {};
    vm.qrScanDialog;

    vm.locationId = $state.params.location;
    vm.location = {};
    vm.location.selectedUser = null;
    vm.stampTotalArray = [];
    vm.selectedUser = null;
    vm.selectedUserIndex = null;
    vm.sale_amount = 0;
    vm.usersAround = [];

    vm.searchQuery = '';
    vm.isIOS = $window.navigator.userAgent.match(/iPhone|iPad|iPod/i);

    // Methods
    vm.issueCard = issueCard;
    vm.search = search;
    vm.searchScannedData = searchScannedData;
    vm.showScanDialog = showScanDialog;
    vm.initDialog = initDialog;

    vm.refreshing = false;

    function searchScannedData(data) {
      vm.searchQuery = data;
      $timeout(function() {
        angular.element('#goSearch').trigger('click');
      }, 100);
    }

    function getLocationData() {
      api.getShopLocation.save({ location: vm.locationId }, {}).$promise.then(function(response) {
        if (response.result) {
          vm.location = response.data.location
          vm.shopDoesNotHaveSubscription = !vm.location.subscription;
          api.getLocationClientsCheckIn.save({ location: vm.locationId }, {}).$promise.then(function(response) {
            if (response.result) {
              vm.usersAround = response.data.checkIns;
            } else {
              $rootScope.throwException(clientSideExceptions.cantGetClientsAround(new Error(), response));
            }
          });
        } else {
          $rootScope.throwException(clientSideExceptions.cantGetShopLocation(new Error(), response));
        }
      });
    }

    api.operatorOperate.save({ location: vm.locationId }, {}).$promise.then(function(response) {
      if (response.result) {
        getLocationData();
      } else {
        alert = $mdDialog.alert({
          title: 'Error',
          textContent: 'Can\'t operate location.',
          ok: 'Close'
        });
        $mdDialog
          .show(alert)
          .finally(function() {
            alert = undefined;
            $state.go('app.shopconfig', {});
          });
      }
    });

    function issueCard() {
      var confirm = $mdDialog.confirm()
        .title('Do you want to issue a new membership card?')
        .textContent('Remember to give the new membership number to your customer')
        .ok('Yes!')
        .cancel('Cancel');
      $mdDialog.show(confirm).then(function() {

        api.issueCard.save({ shop: vm.location.shop.id }, {}).$promise.then(function(response) {
          if (response.result) {
            toastr.success('Card #' + response.data.membershipcard.code + ' successfully issued.', 'Success!');
            $state.go('app.operateuser', { location: vm.locationId, membercard: response.data.membershipcard.code });
          } else {
            $rootScope.throwException(clientSideExceptions.cantIssueMembershipCard(new Error(), response));
          }
        });
      });
    }

    function showScanDialog() {
      // evt.preventDefault();
      var parentEl = angular.element(document.body);
      vm.qrScanDialog = $mdDialog.show({
        parent: parentEl,
        templateUrl: 'app/main/operatelocation/scandialog.html',
        clickOutsideToClose: true,
        onComplete: initDialog(),
        scope: $scope, // use parent scope in template
        preserveScope: true
      });
    }

    $scope.closeDialog = function() {
      $('#reader').html5_qrcode_stop();
      $mdDialog.hide(vm.qrScanDialog, "finished");
      vm.qrScanDialog = undefined;
    }

    function search(form) {
      if ((vm.searchQuery == "" || !vm.searchQuery) && !vm.isIOS) {
        showScanDialog();
        return;
      }
      api.searchByCard.save({}, { membercard: vm.searchQuery }).$promise.then(function(response) {
        if (response.result) {
          $state.go('app.operateuser', { location: vm.locationId, membercard: response.data.membershipcard.code });
        } else {
          var errorMsg = '';
          for (var i in response.errors) {
            var k = i;
            if (i == 'membershipcard') {
              k = 'membercard';
            }
            if (form[k]) {
              form[k].$setValidity('serverSideValidation', false);
              vm.serverSideValidationMsg[k] = '';
              for (var j in response.errors[i]) {
                vm.serverSideValidationMsg[k] += response.errors[i][j];
              }
            } else {
              errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
            }
          }
          if (errorMsg != '') {
            $rootScope.throwException(clientSideExceptions.cantSearchByCard(new Error(), response, errorMsg));
          }
        }
      });
    }

    function initDialog() {

      initGridSampler();

      $timeout(function() {
        $('#reader').html5_qrcode(function(data) {
            $('#reader').html5_qrcode_stop();
            $mdDialog.hide();
            searchScannedData(data);
          },
          function(error) {
            $rootScope.throwException(clientSideExceptions.cantInitialiseQrReader(new Error(), error));
          },
          function(videoError) {
            $rootScope.throwException(clientSideExceptions.cantInitialiseQrReader(new Error(), videoError));
          });
      }, 1000);

    }
    //////////

    $scope.refresh = function() {
      vm.refreshing = true;
      api.getLocationClientsCheckIn.save({ location: vm.locationId }, {}).$promise
        .then(function(response) {
          if (response.result && response.data && response.data.checkIns) {
            vm.usersAround = response.data.checkIns;
          } else {
            $rootScope.throwException(clientSideExceptions.cantGetClientsAround(new Error(), response));
          }
        })
        .catch(function(error) {
          console.log('error', error);
        })
        .finally(function() {
          $timeout(function() {
            vm.refreshing = false;
          }, 500);
        });
    };
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notifications', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.notifications', {
            title    : "NOTIFICATIONS.TITLE",
            url      : '/notifications',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/notifications/notifications.html',
                    controller : 'NotificationsController as vm'
                },
            },
            bodyClass: 'notifications',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/notifications');

        // Navigation
        // msNavigationServiceProvider.saveItem('notifications', {
        //     title : 'Notifications',
        //     state : 'app.notifications',
        //     icon  : 'icon-email',
        //     weight: 2
        // });


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notifications')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController(api, $rootScope, clientSideExceptions)
    {
        // Data
        var vm = this;
        vm.notifications = JSON.parse(localStorage.notifications);
        vm.setToSeen = setToSeen;
        vm.setAllToSeen = setAllToSeen;
        vm.user = JSON.parse(localStorage.user);
        vm.showNotifications = true;

        // Methods
        function setToSeen(notification) {
            api.setNotificationSeen.save({notification: notification.id}, {}).$promise.then(function(response) {
                if (response.result) {
                    vm.showNotifications = false;
                    api.getNotifications.save({}, {}).$promise.then(function(response) {
                        if (response.result) {
                            localStorage.notifications = JSON.stringify(response.data.notifications);
                            vm.notifications = response.data.notifications;
                            toastr.success('Notification dissmised', 'Success!');
                            $rootScope.$broadcast('notificationsChanged');
                            vm.showNotifications = true;
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetNotifications(new Error(), response));
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantSetNotificationToSeen(new Error(), response));
                }
            });
        }

        function setAllToSeen(notification) {
            // TODO: optimize it, should create and API endpoint for multiple notifications
            vm.notifications.forEach(function (item) {
                api.setNotificationSeen.save({notification: item.id}, {}).$promise.then(function(response) {
                    if (response.result) {
                        vm.showNotifications = false;
                        api.getNotifications.save({}, {}).$promise.then(function(response) {
                            if (response.result) {
                                localStorage.notifications = JSON.stringify(response.data.notifications);
                                vm.notifications = response.data.notifications;
                                $rootScope.$broadcast('notificationsChanged');
                                vm.showNotifications = true;
                            } else {
                                $rootScope.throwException(clientSideExceptions.cantGetNotifications(new Error(), response));
                            }
                        });
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantSetNotificationToSeen(new Error(), response));
                    }
                });
            });
            toastr.success('You have seen all notification.', 'Success!');
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.notfound', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.notfound', {
            title    : "NOTFOUND.TITLE",
            url      : '/notfound',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/notfound/notfound.html',
                    controller : 'NotfoundController as vm'
                },
            },
            bodyClass: 'notfound',
            needAuth: true,
            params: {orderDetails: null},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/notfound');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notfound')
        .controller('NotfoundController', NotfoundController);

    /** @ngInject */
    function NotfoundController($rootScope) {
        var vm = this;

        vm.goToPreviousState = $rootScope.goToPreviousState();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.error', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.error', {
            title    : "ERROR.TITLE",
            url      : '/error',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/error/error.html',
                    controller : 'ErrorController as vm'
                },
            },
            bodyClass: 'error',
            needAuth: false,
            params: {orderDetails: null, exceptionObject: null},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/error');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.error')
        .controller('ErrorController', ErrorController);

    /** @ngInject */
    function ErrorController($rootScope, $state, api) {
        var vm = this;

        vm.goToPreviousState = $rootScope.goToPreviousState;
        vm.exceptionObject = $state.params.exceptionObject;

        if (vm.exceptionObject) {
            api.sendExceptionLog.save({}, {exceptionObject: vm.exceptionObject}).$promise.then(function(response) {
                console.log('response', response);
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.myvouchers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.myvouchers', {
            title    : "MYVOUCHERS.TITLE",
            url      : '/myvouchers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/myvouchers/myvouchers.html',
                    controller : 'MyVouchersController as vm'
                },
            },
            bodyClass: 'myvouchers',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/myvouchers');

        // Navigation
        msNavigationServiceProvider.saveItem('vouchers', {
            title : 'My Vouchers',
            state: 'app.myvouchers',
            icon  : 'icon-cash-100',
            weight: 4
        });


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.myvouchers')
        .controller('MyVouchersController', MyVouchersController);

    /** @ngInject */
    function MyVouchersController($scope, $filter, api, $timeout, $rootScope, clientSideExceptions)
    {
        // Data
        var vm = this;
        vm.showCards = true;

        vm.vouchers = [];
        vm.sortOrder = 'shop.closest_location.distance_km';
        vm.loading = true;

        // Methods

        vm.flipCard = flipCard;
        vm.unflipCard = unflipCard;
        vm.toggleCheckin = toggleCheckin;
        vm.setOrdering = setOrdering;
        vm.formatAsCurrency = formatAsCurrency;
        vm.setFavorite = setFavorite

        function setFavorite(voucher, state) {
            var apiMethod;
            if (state) {
                apiMethod = api.setFavorite;
            } else {
                apiMethod = api.clearFavorite;
            }

            apiMethod.save({shop: voucher.shop.id}, {}).$promise.then(function(response) {
                if (response.result) {
                    voucher.is_favorite = state;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantFavoriteShop(new Error(), response));
                }
            });
        };

        
        function formatAsCurrency(amount, countryId) {
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        api.getMyVouchers.save({}, {}).$promise.then(function(response) {
            var today = new Date();

            if (response.result) {
                vm.activeVouchers = response.data.membershipcardVouchers;
                vm.loading = false;
                var categoryMap = JSON.parse(localStorage.categories);
                vm.activeVouchers.forEach(function(voucher, index){
                    voucher.shop.category = categoryMap[voucher.shop.category_id];
                    // voucher.type = voucher.type[0]

                    var expireDate = new Date(voucher.expires_at);
                    var timeDiff = Math.abs(expireDate.getTime() - today.getTime());
                    voucher.expires_in_days = Math.ceil(timeDiff / (1000 * 3600 * 24));

                    if(voucher.shop.closest_location.distance_km > 1.0) {
                        voucher.rounded_distance = Math.floor(voucher.shop.closest_location.distance_km) + ' km';
                    } else {
                        voucher.rounded_distance = Math.floor(voucher.shop.closest_location.distance_km * 1000) + ' mts';
                    }

                });

                $scope.$$postDigest(function(){ // Meant to re-size the labels after the scope digest cycle has ended
                    // TODO: a lot of values are hardcoded for convinience, change to queries and real values
                    for(var i = 0; i < vm.activeVouchers.length; i++) {
                        var valueSpan = angular.element(document.getElementById(i + '-voucher-value'));
                        var sizeRatio = valueSpan.width()/90;
                        if(sizeRatio > 1) { // this means: voucher value is overflowing
                            var newFontSize = 38 / sizeRatio;
                            valueSpan.css("font-size", newFontSize);
                            valueSpan.css("top",135 - valueSpan.height()/2);
                        }
                    }
                });
                setOrdering('active', 'created_at');
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetVouchers(new Error(), response));
            }
        });

        api.getMyArchiveVouchers.save({}, {}).$promise.then(function(response) {
            var today = new Date();

            if (response.result) {
                vm.archiveVouchers = response.data.membershipcardVouchers;
                vm.loading = false;
                var categoryMap = JSON.parse(localStorage.categories);
                vm.archiveVouchers.forEach(function(voucher, index){
                    voucher.shop.category = categoryMap[voucher.shop.category_id];

                    var expireDate = new Date(voucher.expires_at);
                    var timeDiff = expireDate.getTime() - today.getTime();
                    voucher.expires_in_days = Math.ceil(timeDiff / (1000 * 3600 * 24));
                    voucher.expired = (voucher.expires_in_days <= 0);

                    if(voucher.shop.closest_location.distance_km > 1.0) {
                        voucher.rounded_distance = Math.floor(voucher.shop.closest_location.distance_km) + ' km';
                    } else {
                        voucher.rounded_distance = Math.floor(voucher.shop.closest_location.distance_km * 1000) + ' mts';
                    }

                });

                $scope.$$postDigest(function(){ // Meant to re-size the labels after the scope digest cycle has ended
                    // TODO: a lot of values are hardcoded for convinience, change to queries and real values
                    for(var i = 0; i < vm.archiveVouchers.length; i++) {
                        var valueSpan = angular.element(document.getElementById(i + '-voucher-value'));
                        var sizeRatio = valueSpan.width()/90;
                        if(sizeRatio > 1) { // this means: voucher value is overflowing
                            var newFontSize = 38 / sizeRatio;
                            valueSpan.css("font-size", newFontSize);
                            valueSpan.css("top",135 - valueSpan.height()/2);
                        }
                    }
                });
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetArchiveVouchers(new Error(), response));
            }
        });

        function flipCard (voucher, index, showConditions) {

            voucher.showConditions = showConditions;

            var latLng = new google.maps.LatLng(voucher.shop.closest_location.latitude, voucher.shop.closest_location.longitude);

            if(!vm.openMapObj) {
                var mapOptions = {
                    center: latLng,
                    zoom: 15,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    streetViewControl: false,
                    zoomControl: false,
                    mapTypeControl: false
                };

                var map = new google.maps.Map(document.getElementById('fixedMapDiv'), mapOptions);
                vm.openMapObj = {
                    'voucher': voucher,
                    'map': map
                }

            } else {
                vm.openMapObj.voucher.flipped = false;
                vm.openMapObj.voucher = voucher;
                vm.openMapObj.voucher.flipped = false;
                vm.openMapObj.marker.setMap(null);
                vm.openMapObj.map.setCenter(latLng);
            }

            vm.openMapObj.voucher.flipped = true;
            var mapDiv = angular.element(document.getElementById(index + '-map'));
            mapDiv.append(vm.openMapObj.map.getDiv());
            vm.openMapObj.location = voucher.shop.closest_location;

            // Put marker
            google.maps.event.addListenerOnce(vm.openMapObj.map, 'idle', function(){

                $timeout(function () { //TODO: FIX, Safari is too slow loading map and/or on map re-center messes things up
                    var marker = new google.maps.Marker({
                        map: vm.openMapObj.map,
                        animation: google.maps.Animation.DROP,
                        position: latLng
                    });

                    vm.openMapObj.marker = marker;
                    vm.openMapObj.map.setCenter(latLng);
                }, 1000);
                vm.openMapObj.firstMarker = true;

                google.maps.event.trigger(vm.openMapObj.map, 'resize');

            }, function(error){
                $rootScope.throwException(clientSideExceptions.googleMapError(new Error(), error));
            });
        };

        function unflipCard(voucher) {
            vm.openMapObj.voucher = voucher;
            vm.openMapObj.voucher.flipped = false;
        };

        function toggleCheckin(voucher) {
            var location = voucher.shop.closest_location;
            var locationId = location.id;
            // md-switch changes model, se we use optimistic loading by default
            if(location.is_checked_in) { // must check-out costumer to location
                api.checkOutOfLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        // do nothing
                    } else {
                        location.is_checked_in = true;
                        $rootScope.throwException(clientSideExceptions.cantCheckOutUser(new Error(), response));
                    }
                });
            } else { // must check-in costumer to location
                api.checkInToLocation.save({location: locationId}, {}).$promise.then(function(response) {
                    if(response.result) {
                        // do nothing
                    } else {
                        location.is_checked_in = false;
                        $rootScope.throwException(clientSideExceptions.cantCheckInUser(new Error(), response));
                    }
                });
            }
        }

        function setOrdering(voucherSet, orderValue) {

            if (voucherSet == 'active') {
                vm.vouchers = vm.activeVouchers;
                vm.archived = false;
            } else {
                vm.vouchers = vm.archiveVouchers;
                vm.archived = true;
            }
            vm.sortOrder = orderValue;
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login');

        // Navigation
    }

})();

(function ()
{
  'use strict';

  angular
  .module('app.auth.login')
  .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($rootScope, api, $auth, $state, clientSideExceptions)
  {
    // Data
    var vm = this;
    vm.loading = false;
    vm.serverSideValidationMsg = '';

    var currentUser;

    // Methods
    vm.login = login;

    // place random background
    var pageRoot = angular.element(document.getElementById('login'));
    pageRoot.css("background", 'url(\'/assets/images/backgrounds/login' + $rootScope.wallpaperIndex + '.jpg\') no-repeat')
    pageRoot.css("background-size", "cover");

    function setCurrentUser(user) {
      currentUser = user;
    };

    // function getCurrentUser() {
    //   if (!currentUser) {
    //     setCurrentUser(JSON.parse(localStorage.getItem('user')));
    //   }
    //   return currentUser;
    // };

    // function isAuthenticated() {
    //   return $auth.isAuthenticated();
    // };

    function login(form, credentials) {
      vm.loading = true;

      api.login.save({}, credentials).$promise.then(function(response)
      {
        if(response.data.user) {
          // Stringify the retured data
          var user = JSON.stringify(response.data.user);
          // Set the stringified user data into local storage
          localStorage.setItem('user', user);
          localStorage.setItem('api_token', response.data.api_token);
          $auth.setToken(response.data.api_token);
          // Getting current user data from local storage
          setCurrentUser(response.data.user);

          localStorage.setItem('notifications', '[]');

          // TODO: move it to cacheing
          api.getCategoryList.save({}, {}).$promise.then(function(response)
          {
            if (response.result) {
              var categories = response.data.categories;

              var categoryMap = {};
              for (var i in categories) {
                categoryMap[categories[i].id] = categories[i];
              }

              localStorage.setItem('categories', JSON.stringify(categoryMap));
            } else {
              $rootScope.throwException(clientSideExceptions.cantGetCategoryList(new Error(), response));
            }
          });

          // TODO: move it to cacheing
          api.getCountryList.save({}, {}).$promise.then(function(response)
          {
            if (response.result) {
              var countries = response.data.countries;

              var countryMap = {};
              for (var i in countries) {
                countryMap[countries[i].id] = countries[i];
              }

              localStorage.setItem('countries', JSON.stringify(countryMap));

            } else {
              $rootScope.throwException(clientSideExceptions.cantGetCountryList(new Error(), response));
            }
          });

          api.getNotifications.save({}, {}).$promise.then(function(response) {
            if (response.result) {
              localStorage.notifications = JSON.stringify(response.data.notifications);
              $rootScope.notifications = response.data.notifications;
              $rootScope.$broadcast('notificationsChanged');
            } else {
              $rootScope.throwException(clientSideExceptions.cantGetNotifications(new Error(), response));
            }
          });

          $state.go('app.dashboard');
        } else {
          vm.loading = false;
          var msg = '';
          for (var i in response.errors) {
            if ( response.errors[i] instanceof Array) {
              for ( var j in response.errors[i]) {
                msg += response.errors[i][j];
              }
            } else {
              msg = response.errors[i];
            }
          }

          form.email.$setValidity('serverSideValidation', false);
          vm.serverSideValidationMsg = msg;
        }
      });
    }

    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgotpassword', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.auth_forgotpassword', {
            url      : '/forgotpassword',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_forgotpassword': {
                    templateUrl: 'app/main/forgotpassword/forgotpassword.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'login',
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // Redirect to dashboard if user is logged in
                event.preventDefault();
                var that = this;
                if (auth.isAuthenticated()) {
                    toastr.warning('You are already logged in.', 'Warning!');
                    return state.go('app.shops');
                } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/forgotpassword');

        // Navigation
    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.forgotpassword')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($rootScope, api) {
        // place random background
        var pageRoot = angular.element(document.getElementById('forgot-password'));
        pageRoot.css("background", 'url(\'/assets/images/backgrounds/login' + $rootScope.wallpaperIndex + '.jpg\') no-repeat')
        pageRoot.css("background-size", "cover");

        var vm = this;

        // Data
        vm.serverSideValidationMsg = {};
        vm.resendSuccess = null;

        // Methods
        vm.checkEmail = checkEmail;
        vm.resend = resend;

        function checkEmail(form, credentials) {
            api.checkEmail.save({}, credentials).$promise.then(function(response)
            {
                if (!response.data.user) {
                    form.email.$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg.email = 'No registered user with this email';
                } else {
                    $rootScope.resetServerSideValidation(form);
                }
            });
        };

        function resend(form, credentials) {
            api.sendPasswordResetEmail.save({}, credentials).$promise.then(function(response)
            {
                if (response.result) {
                    vm.resendSuccess = true;
                } else {
                    vm.resendSuccess = false;
                    form.email.$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg.email = response.errors[0];
                }
            });
        };

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createpointvoucher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.createpointvoucher', {
            title    : "VOUCHERSWELCOME.TITLE",
            url      : '/createpointvoucher/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createpointvoucher/createpointvoucher.html',
                    controller : 'CreatePointVoucherController as vm'
                },
            },
            bodyClass: 'createpointvoucher',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/createpointvoucher');

        // Navigation
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.createpointvoucher')
        .controller('CreatePointVoucherController', CreatePointVoucherController);

    /** @ngInject */
    function CreatePointVoucherController($rootScope, api, $filter, $scope, $state, $mdDialog, clientSideExceptions) {
        // Data
        var vm = this;
        vm.voucherDef = {
            is_active: false,
            // TODO: use real code
            code: '123456789',
            type: 'point',
            min_points: 1,
            expire_days: 7,
            points_to_value_points: 100
        };
        vm.category = 'point';
        vm.serverSideValidationMsg = {};
        vm.validUsers = [];
        vm.loading = false;

        vm.adjustValueSize = adjustValueSize;
        vm.formatAsCurrency = formatAsCurrency;
        vm.searchValidUsers = searchValidUsers;
        vm.createVouchers = createVouchers;
        vm.updateTotalValue = updateTotalValue;
        vm.selectAllValidUsers = selectAllValidUsers;
        vm.deselectAllValidUsers = deselectAllValidUsers;
        vm.getCurrencyByCountry = $rootScope.getCurrencyByCountry;
        vm.saveVoucherDef = saveVoucherDef;

        // subroutine to float voucher representation
        var parent = angular.element(document.getElementById('content'));
        var cardparent = angular.element(document.getElementById('card-parent'));
        var cardparentHeight = cardparent.height();
        var card = angular.element(document.getElementById('voucher-card'));

        parent.bind('scroll', function(event) {
          if(card.css('position') === 'relative') {
            card.css('top', 'auto');
            return;
          }

          card.css('top', event.currentTarget.scrollTop + 200);
          if(event.currentTarget.scrollTop > cardparentHeight) {
            card.css('top', cardparentHeight + 200);
          }
        });


        function formatAsCurrency(amount, countryId) {
            amount = amount ? amount : 0;
            countryId = countryId ? countryId : 1;
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function adjustValueSize() {
            var valueSpan = angular.element(document.getElementById('voucher-value'));
            // restore original font-size first to adjust accordingly
            valueSpan.css("font-size", 38);
            var sizeRatio = valueSpan.width()/50;
            if(sizeRatio > 1) { // this means: voucher value is overflowing
                var newFontSize = 38 / sizeRatio;
                valueSpan.css("font-size", newFontSize);
                valueSpan.css("top",135 - valueSpan.height()/2);
            }
        }

        function getVoucherDef() {
            api.getShop.save({},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;
                    api.getVouchersByShop.save({shop: vm.shop.id}, {voucher_type: 'point'}).$promise.then(function (response) {
                        if (response.result) {
                            if (response.data.vouchers) {
                                vm.voucherDef = response.data.vouchers;
                            }
                            // if (vm.voucherDef) {
                            //     vm.voucherDef.points_to_value_points = vm.voucherDef.points_to_value_points == 0 ? 100 : vm.voucherDef.points_to_value_points;
                            // }
                            searchValidUsers();
                        } else {
                            // $rootScope.throwException({code: '0011', msg: 'Error can\'t get voucher info.', persistent: false, debug: response});
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }
        getVoucherDef();

        $scope.$watch('vm.voucherDef.expire_days', function() {
            if (vm.voucherDef) {
                var expireDate = moment();
                expireDate.add(vm.voucherDef.expire_days, 'day');
                vm.expires_at = expireDate.format('YYYY-MM-DD');
            }
        });

        function searchValidUsers() {
            if (vm.voucherDef) {
                api.getValidClientsByVoucher.save({voucher: vm.voucherDef.id}, {limit: 10}).$promise.then(function(response) {
                    if (response.result) {
                        vm.validUsers = response.data.membershipcards;
                    } else {
                        // $rootScope.throwException({code: '0013', msg: 'Error can\'t find valid users for voucher.', persistent: false, debug: response});
                    }
                });
            }
        }

        function createVouchers() {
            if(vm.loading) {
              return;
            }
            vm.loading = true;

            var selectedMembershipcards = [];
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    selectedMembershipcards.push(membershipcard.id);
                }
            });

            api.issueMultipleVouchers.save({voucher: vm.voucherDef.id}, {membershipcards: selectedMembershipcards}).$promise.then(function(response) {
                vm.loading = false;
                if (response.result) {
                    toastr.success('Vouchers successfully issued.', 'Success!');
                    $state.go('app.vouchersconfig', {category: 'point'});
                } else {
                    var alert = $mdDialog.alert({
                        title: 'Error, can\'t issue vouchers!',
                        textContent: response.errors[0],
                        ok: 'OK'
                    });
                    $mdDialog
                        .show( alert )
                        .finally(function() {
                            alert = undefined;
                        });
                }

            });
        }

        function updateTotalValue() {
            var totalValue = 0;
            var numberOfSelectedUsers = 0;
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    totalValue += membershipcard.voucher_value;
                    numberOfSelectedUsers++;
                }
            });
            vm.totalValue = totalValue;
            vm.numberOfSelectedUsers = numberOfSelectedUsers;
        }

        function selectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = true;
            });
            vm.numberOfSelectedUsers = vm.validUsers.length;
            vm.totalValue = vm.voucherDef.value * vm.numberOfSelectedUsers;
        }

        function deselectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = false;
            });
            vm.numberOfSelectedUsers = 0;
            vm.totalValue = 0;
        }

        function saveVoucherDef(form, model) {
            var apiMethod;
            var urlParams;
            if (model.id) {
                apiMethod = api.updateVoucherDef;
                urlParams = {voucher: model.id};
            } else {
                apiMethod = api.storeVoucherDef;
                urlParams = {shop: vm.shop.id};
            }

            apiMethod.save(urlParams, model).$promise.then(function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSavePointVoucherDef(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Voucher successfully updated.', 'Success!');
                    getVoucherDef();
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.editstampcard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.editstampcard', {
            title    : "EDITSTAMPCARD.TITLE",
            url      : '/editstampcard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/editstampcard/editstampcard.html',
                    controller : 'EditStampcardController as vm'
                },
            },
            bodyClass: 'edit-stampcard',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                event.preventDefault();
                var that = this;
                // api.getShop.save({},{}, function(response) {
                //     if (!response.result) {
                //         toastr.warning('Please configure your shop first', 'Warning!');
                //         return state.go('app.createshop');
                //     } else {
                        toParams.enableOnStateChangeStartHandler = false;
                        return state.go(that.name, toParams);
                //     }
                // });
                // return;
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/editstampcard');

        // Navigation
        msNavigationServiceProvider.saveItem('my_shop.editstampcard', {
            title : 'Stamp Card',
            state : 'app.editstampcard',
            weight: 2
        });


    }

})();

(function () {
    'use strict';

    angular
        .module('app.editstampcard')
        .controller('EditStampcardController', EditStampcardController);

    /** @ngInject */
    function EditStampcardController($scope, api, $state, $rootScope, clientSideExceptions) {

        var vm = this;
        vm.serverSideValidationMsg = {};

        vm.enableEditMode = enableEditMode;
        vm.cancelEditMode = cancelEditMode;
        vm.createStampTotalArray = createStampTotalArray;
        vm.saveStampCardForm = saveStampCardForm;
        vm.changeStampcardConfiguration = changeStampcardConfiguration;
        vm.updateShopData = updateShopData;
        // vm.getShopInfo = getShopInfo;
        vm.loading = true;
        vm.hasOwnShop = true; // assume true until back-end replies

        function createStampTotalArray() {
            vm.totalStamps = [];
            if(vm.shop.stampcard){
                for(var i = 0; i < vm.shop.stampcard.stamps_total-1; i++) {
                    vm.totalStamps.push({});
                }
            }
        }

        function enableEditMode() {
            vm.editMode = true;
            vm.shadowCopy = angular.copy(vm.shop);
        }

        function cancelEditMode() {
            if(vm.editMode) {
                vm.editMode = false;
                vm.shop = vm.shadowCopy;
            }
        }

        function getAllShops() {
            api.getOperatorIndex.save({}, {}).$promise.then(function(response) {
                if(response.result) {
                    vm.shops = response.data.shops;
                    if(vm.shops.length > 0) {
                        vm.currentShop = vm.shops[0];
                        updateShopData();
                    } else {
                        vm.hasOwnShop = false;
                        vm.loading = false;
                    }
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetOperatorShops(new Error(), response));
                }
            });
        }

        function getOwnShopData() {
            api.getShop.save({}, {}).$promise.then(function(response) {
                if(response.result) {
                    vm.hasOwnShop = true;
                    vm.loading = false;
                }
            });
        }

        function updateShopData() {
            api.getShopDetails.save({shop: vm.currentShop.id},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;
                    if (vm.shop.stampcard) {
                        vm.shop.stampcard.is_active = vm.shop.stampcard.is_active == 1;
                    }
                    vm.loading = false;
                    createStampTotalArray();

                    // Meant to re-size container
                    // also handles stamp card automatic scrolling
                    // I suggest you do you not touch this unless you want to deal with some nasty math
                    // not really spaghetti code, just couldn't find a better way to do it
                    $scope.$$postDigest(function(){
                      var container = angular.element(document.getElementById('card-parent'));
                      var card = angular.element(document.getElementById('stamp-card'));
                      container.css('min-height', card.height() + 25);

                      var originalTop = card.css('top');
                      var parent = angular.element(document.getElementById('content'));

                      parent.bind('scroll', function(event) {
                        if(card.css('position') === 'relative') {
                          card.css('top', 'auto');
                          return;
                        }
                        card.css('top', parseInt(originalTop.split('px')[0]) - event.currentTarget.scrollTop);
                        if(vm.editMode) {
                          var newPos = parseInt(originalTop.split('px')[0]) - event.currentTarget.scrollTop * 0.25;
                          if(newPos < container.height()) {
                            card.css('top', newPos);
                          }
                        }
                      });
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopDetails(new Error(), response));
                }
            }, function(err) {
                $rootScope.throwException(clientSideExceptions.cantGetShopDetails(new Error(), err));
            });
        }


        function saveStampCardForm(form, model) {

            var apiMethod, apiParams;

            if (model.is_active) {
                model.is_active = 1;
            } else {
                model.is_active = 0;
            }

            if(vm.shouldActivateStampcard) {
              model.is_active = 1;
              vm.shouldActivateStampcard = false;
            }

            if (model.id) {
                apiMethod = api.updateStampcard;
                apiParams = {stampcard: model.id};
            } else {
                apiMethod = api.storeStampcard;
                apiParams = {shop: vm.shop.id};
            }
            apiMethod.save(apiParams, model).$promise.then(function(response) {
                if (response.result) {
                    vm.shop.stampcard = response.data.stampcard;
                    toastr.success('Stampcard successfully saved.', 'Success!');
                    vm.editMode = false;
                    updateWizard();
                } else {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveStampCard(new Error(), response, errorMsg));
                    }
                }
            });
        }

        function changeStampcardConfiguration(form, skipCheck) {
            // shop does not have a valid stampcard, cannot change configuration
            if(!vm.shop.stampcard) {
              return;
            }

            cancelEditMode(); // cancel edit mode to prevent non valid data
            var apiMethod, apiParams;
            var model = angular.copy(vm.shop.stampcard);

            if(!model) {
                return;
            }

            if (!model.is_active) {
                model.is_active = 1;
            } else {
                model.is_active = 0;
            }

            if (model.id) {
                apiMethod = api.updateStampcard;
                apiParams = {stampcard: model.id};
            } else {
                apiMethod = api.storeStampcard;
                apiParams = {shop: vm.shop.id};
            }
            apiMethod.save(apiParams, model).$promise.then(function(response) {
                if (response.result) {
                    vm.shop.stampcard = response.data.stampcard;
                    vm.shop.stampcard.is_active = vm.shop.stampcard.is_active == 1;
                    toastr.success('Stampcard successfully saved.', 'Success!');
                    if(!skipCheck) {
                      updateWizard();
                    }
                } else {
                    var errorMsg ='';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantChangeStampCard(new Error(), response));
                    }
                }
            });
        }

        function checkWizard() {
            try {
                var user = JSON.parse(localStorage.getItem('user'));
                var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
                if(!wizardInfo.wizardFinished && wizardInfo.step == 3) {
                    vm.shouldActivateStampcard = true;
                    vm.editMode = true;
                }
            } catch(err) {
                // $rootScope.throwException({code: '0064', msg: err, persistent: false, debug: err});
            }
        }

        function updateWizard() {
            try {
              var user = JSON.parse(localStorage.getItem('user'));
              var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
                  wizardInfo.step = 4;
                  localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                  $state.go('app.subscription');
            } catch(err) {
                // $rootScope.throwException({code: '0065', msg: err, persistent: false, debug: err});
            }
        }

        getOwnShopData();
        getAllShops();
        checkWizard();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.editshoplocation', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.editshoplocation', {
            title    : "EDITSHOPLOCATION.TITLE",
            url      : '/editshoplocation/{location}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/editshoplocation/editshoplocation.html',
                    controller : 'EditShopLocationController as vm'
                },
            },
            bodyClass: 'edit-shop-location',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: false},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                // event.preventDefault();
                // var that = this;
                // api.getShop.save({},{}, function(response) {
                //     if (!response.result) {
                //         toastr.warning('Please configure your shop first', 'Warning!');
                //         return state.go('app.createshop');
                //     } else {
                //         toParams.enableOnStateChangeStartHandler = false;
                //         return state.go(that.name, toParams);
                //     }
                // });
                // return;
            }

        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/editshoplocation');

        // Navigation

    }

})();

(function() {
  'use strict';

  angular
    .module('app.editshoplocation')
    .controller('EditShopLocationController', EditShopLocationController);

  /** @ngInject */
  function EditShopLocationController(
    $http,
    $mdDialog,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $timeout,
    api,
    clientSideExceptions
  ) {
    var vm = this;
    // Data
    vm.verificationSuccess = null;
    vm.serverSideValidationMsg = {};

    vm.saveLocation = saveLocation;
    vm.removeLocation = removeLocation

    vm.isNewLocation = !($stateParams.location != undefined || $stateParams.location != '');

    var timeoutPromise,
      delayInMs = 700,
      addressChangeCallback = function(newAddress, oldAddress) {
        if (angular.equals(newAddress, oldAddress)) return;
        $timeout.cancel(timeoutPromise);
        timeoutPromise = $timeout(function() {
          var address = '';
          if (vm.location.name) {
            address += vm.location.name + ' ';
          }
          if (vm.location.address) {
            address += vm.location.address + ' ';
          }
          if (vm.location.zipcode) {
            address += vm.location.zipcode + ' ';
          }
          if (!address) return;

          var url = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&sensor=false';
          $http.get(url, {skipAuthorization: true})
            .then(function(res) {
              if ("OK" !== res.data.status) return;
              vm.location.latitude = res.data.results[0].geometry.location.lat;
              vm.location.longitude = res.data.results[0].geometry.location.lng;
              openMap({ latitude: vm.location.latitude, longitude: vm.location.longitude });
            })
            .catch(function(err) {
              console.error(err);
            });
        }, delayInMs);
      };

    // watch user input for changes and react with 1sec delay
    $scope.$watch('[vm.location.name, vm.location.zipcode ,vm.location.address]', addressChangeCallback, true);

    // Methods
    function removeLocation() {
      api.deleteShopLocation.save({ location: $stateParams.location }, {}).$promise.then(function(response) {
        if (response.result) {
          $state.go('app.shopconfig');
        } else {
          alert = $mdDialog.alert({
            title: 'Error deleting location',
            textContent: 'Could not delete shop location',
            ok: 'Close'
          });
          $mdDialog
            .show(alert)
            .finally(function() {
              alert = undefined;
            });
        }
      })
    }

    function getShopInfo() {
      api.getShop.save({}, {}).$promise.then(function(response) {
        if (response.result) {
          vm.shop = response.data.shop;
        }
      });


      if ($stateParams.location) {
        api.getShopLocation.save({ location: $stateParams.location }, {}).$promise.then(function(response) {
          if (response.result) {
            vm.location = response.data.location
            openMap({ latitude: vm.location.latitude, longitude: vm.location.longitude });
          } else {
            $rootScope.throwException(clientSideExceptions.cantGetShopLocation(new Error(), response));
          }
        });
      } else {
        vm.location = {
          id: null,
        };
        centerMapAtUserLocation();
      };
    }

    function openMap(location) {
      var latLng = new google.maps.LatLng(location.latitude, location.longitude);

      var mapOptions = {
        center: latLng,
        zoom: 15,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        zoomControl: false,
        mapTypeControl: false
      };

      vm.map = new google.maps.Map(document.getElementById('locationMap'), mapOptions);

      google.maps.event.addListenerOnce(vm.map, 'idle', function() {
        vm.marker = new google.maps.Marker({
          map: vm.map,
          animation: google.maps.Animation.DROP,
          position: latLng
        });
      }, function(error) {
        $rootScope.throwException(clientSideExceptions.googleMapError(new Error(), response));
      });

      vm.map.addListener('click', function(event) {
        vm.marker.setMap(null);
        vm.location.latitude = event.latLng.lat();
        vm.location.longitude = event.latLng.lng();
        $scope.$apply();

        vm.marker = new google.maps.Marker({
          map: vm.map,
          animation: google.maps.Animation.DROP,
          position: event.latLng
        })
      });
    }

    function centerMapAtUserLocation() {
      $rootScope.getLocation(function(position) {
        var userLocation = { latitude: position.latitude, longitude: position.longitude };
        vm.location.latitude = userLocation.latitude;
        vm.location.longitude = userLocation.longitude;
        openMap(userLocation);
      }, function(error) {
        var defaultLocation = {
          latitude: 51.508530,
          longitude: -0.076132
        }; // London
        vm.location.latitude = defaultLocation.latitude;
        vm.location.longitude = defaultLocation.longitude;

        openMap(defaultLocation);
        toastr.warning('Error getting user location, opening map at default position.', 'Warning!');
        // $rootScope.throwException({code: '0055', msg: 'Error getting user location, opening map at default position.', persistent: false, debug: error});
      });
    }

    function saveLocation(form, locationData) {
      var apiMethod;
      var routeParam;
      if (locationData.id) {
        apiMethod = api.updateShopLocation;
        routeParam = { location: vm.location.id };
      } else {
        apiMethod = api.addShopLocation;
        routeParam = { shop: vm.shop.id };
      }

      apiMethod.save(routeParam, locationData).$promise.then(function(response) {
        if (!response.result) {
          var errorMsg = '';
          for (var i in response.errors) {
            if (form[i]) {
              form[i].$setValidity('serverSideValidation', false);
              vm.serverSideValidationMsg[i] = '';
              for (var j in response.errors[i]) {
                vm.serverSideValidationMsg[i] += response.errors[i][j];
              }
            } else {
              errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
            }
          }
          vm.updateSuccess = false;
          if (errorMsg != '') {
            $rootScope.throwException(clientSideExceptions.cantSaveLocation(new Error(), response, errorMsg));
          }
        } else {
          updateWizard();
          toastr.success('Location successfully updated.', 'Success!');
          $state.go('app.shopconfig');
        }
      });
    }

    getShopInfo();

    function updateWizard() {
      try {
        var user = JSON.parse(localStorage.getItem('user'))
        var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
        wizardInfo.step = 2;
        localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
      } catch (err) {
        // $rootScope.throwException({code: '0057', msg: err, persistent: false, debug: err});
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.editoperator', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.editoperator', {
            title    : "EDITOPERATOR.TITLE",
            url      : '/editoperator/{shopId}/operator/{operatorId}',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/editoperator/editoperator.html',
                    controller : 'EditOperatorController as vm'
                },
            },
            bodyClass: 'edit-shop-operator',
            needAuth: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/editoperator');

        // Navigation

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.editoperator')
        .controller('EditOperatorController', EditOperatorController);

    /** @ngInject */
    function EditOperatorController(api, $state, $stateParams, $mdDialog, $rootScope, clientSideExceptions) {

        var vm = this;
        vm.operator = {
            is_active: false,
            has_edit_rights: false,
            shop: {},
            email: null
        };
        vm.serverSideValidationMsg = {};
        vm.operatorIsOwner = false;

        vm.saveOperator = saveOperator;
        vm.deleteOperator = deleteOperator;

        api.getShop.save({},{}).$promise.then(function(response) {
            if (response.result) {

                var currentShop = response.data.shop

                if($stateParams.operatorId) {
                    api.getOperator.save({shop: $stateParams.shopId, operator: $stateParams.operatorId}, {}).$promise.then(function(operatorResponse) {
                        if (response.result) {
                            vm.operator = operatorResponse.data.operator;
                            vm.operator.is_active = vm.operator.is_active == 1;
                            vm.operator.has_edit_rights = vm.operator.has_edit_rights == 1;
                            vm.operator.email = vm.operator.user.email;
                            vm.operatorIsOwner = (vm.operator.user_id == currentShop.user_id);

                            // flag to disable UI editing, back-end is not saving edits to operator
                            vm.cannotEdit = true;
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetOperatorInfo(new Error(), response));
                        }
                    });
                } else {
                    vm.operator.shop = currentShop;
                    vm.operatorIsOwner = (vm.operator.user_id == currentShop.user_id);
                }

            } else {
                $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
            }
        });

        function saveOperator(form, model) {
            var apiMethod;
            var urlParams;
            if (model.id) {
                apiMethod = api.updateOperator;
                urlParams = {operator: model.id};
            } else {
                apiMethod = api.addOperator;
                urlParams = {shop: model.shop.id};
            }
            apiMethod.save(urlParams, model, function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        var k = i;
                        if (k == 'operator') {
                            k = 'email';
                        }
                        if (form[k]) {
                            form[k].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[k] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[k] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveOperatorData(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Operator successfully ' + (model.id ? 'updated' : 'added') + '.', 'Success!');
                    $state.go('app.shopconfig');
                }
            });
        }

        function deleteOperator(operator) {

            var confirm = $mdDialog.confirm()
                .title('Do you want to delete operator?')
                .textContent('')
                .ok('Yes!')
                .cancel('Cancel');
            $mdDialog.show(confirm).then(function() {

                api.destroyOperator.save({operator: operator.id}, {}).$promise.then(function(response) {
                    if (response.result) {
                        toastr.success('Operator successfully deleted.', 'Success!');
                        $state.go('app.shopconfig');
                    } else {
                        $rootScope.throwException(clientSideExceptions.cantDeleteOperator(new Error(), response));
                    }
                });
            });
        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.dashboard', {
            title    : "DASHBOARD.TITLE",
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                },
            },
            bodyClass: 'dashboard',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api) {
                event.preventDefault();
                return state.go('app.shops');
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');

        // Navigation
        // msNavigationServiceProvider.saveItem('dashboard', {
        //     title : 'Dashboard',
        //     state : 'app.dashboard',
        //     icon  : 'icon-speedometer',
        //     weight: 1
        // });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController($rootScope)
    {
        // Data
        var vm = this;

        vm.dashboardData = {
            "widget1": {
                "data": {
                    "label": "Number of stamp cards",
                    "count": "24",
                }
            },
            "widget2": {
                "data": {
                    "label": "Total voucher value",
                    "count": "£24",
                }
            },
            "widget3": {
                "data": {
                    "label": "About to expire",
                    "count": "2!",
                }
            },
            "widget4": {
                "data": {
                    "label": "Number of visits this week",
                    "count": "4",
                }
            },
        };

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createwelcomevoucher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.createwelcomevoucher', {
            title    : "VOUCHERSWELCOME.TITLE",
            url      : '/createwelcomevoucher/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createwelcomevoucher/createwelcomevoucher.html',
                    controller : 'CreateWelcomeVoucherController as vm'
                },
            },
            bodyClass: 'createwelcomevoucher',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/createwelcomevoucher');

        // Navigation
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.createwelcomevoucher')
        .controller('CreateWelcomeVoucherController', CreateWelcomeVoucherController);

    /** @ngInject */
    function CreateWelcomeVoucherController(api, $filter, $rootScope, $scope, $state, clientSideExceptions) {
        // Data
        var vm = this;
        vm.voucherDef = {
            is_active: false,
            // TODO: use real code
            code: '123456789',
            type: 'welcome',
            min_transactions: 1
        };
        vm.category = 'welcome';

        vm.validUsers = [];
        vm.totalValue = 0;
        vm.numberOfSelectedUsers = 0;
        vm.serverSideValidationMsg = {};


        vm.adjustValueSize = adjustValueSize;
        vm.formatAsCurrency = formatAsCurrency;
        vm.getCurrencyByCountry = $rootScope.getCurrencyByCountry;
        vm.searchValidUsers = searchValidUsers;
        vm.createVouchers = createVouchers;
        vm.updateTotalValue = updateTotalValue;
        vm.selectAllValidUsers = selectAllValidUsers;
        vm.deselectAllValidUsers = deselectAllValidUsers;
        vm.saveVoucherDef = saveVoucherDef;

        function formatAsCurrency(amount, countryId) {
            amount = amount ? amount : 0;
            countryId = countryId ? countryId : 1;
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function adjustValueSize() {
            var valueSpan = angular.element(document.getElementById('voucher-value'));
            // restore original font-size first to adjust accordingly
            valueSpan.css("font-size", 38);
            var sizeRatio = valueSpan.width()/50;
            if(sizeRatio > 1) { // this means: voucher value is overflowing
                var newFontSize = 38 / sizeRatio;
                valueSpan.css("font-size", newFontSize);
                valueSpan.css("top",135 - valueSpan.height()/2);
            }
        }

        function getVoucherDef() {
            var min_transactions_copy = vm.voucherDef.min_transactions;
            api.getShop.save({},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;
                    api.getVouchersByShop.save({shop: vm.shop.id}, {voucher_type: 'welcome'}).$promise.then(function (response) {
                        if (response.result) {
                            vm.voucherDef = response.data.vouchers;
                            vm.voucherDef.min_transactions = min_transactions_copy;
                            vm.voucherDef.include_active_users = (vm.voucherDef.include_active_users == 1);
                            searchValidUsers();
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetVoucherInfo(new Error(), response));
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }
        getVoucherDef();

        $scope.$watch('vm.voucherDef.expire_days', function() {
          var expireDate = moment();
          expireDate.add(vm.voucherDef.expire_days, 'day');
          vm.expires_at = expireDate.format('YYYY-MM-DD');
        });

        function searchValidUsers() {
            api.getValidClientsByVoucher.save({voucher: vm.voucherDef.id}, {
                limit: 10,
                min_transactions: vm.voucherDef.min_transactions
            }).$promise.then(function(response) {
                if (response.result) {
                    vm.validUsers = response.data.membershipcards;
                } else {
                    if (response.errors[0] == 'Shop has no locations') {
                        // $rootScope.throwException({code: '0134', msg: 'Shop has no locations.', persistent: false, debug: response});
                    }
                    console.log(response);
                    // $rootScope.throwException({code: '0022', msg: 'Error can\'t find valid users for voucher.', persistent: false, debug: response});
                }
            });
        }

        function saveVoucherDef(form, model) {
            var apiMethod;
            var urlParams;
            if (model.id) {
                apiMethod = api.updateVoucherDef;
                urlParams = {voucher: model.id};
            } else {
                apiMethod = api.storeVoucherDef;
                urlParams = {shop: vm.shop.id};
            }

            apiMethod.save(urlParams, model).$promise.then(function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveWelcomeVoucherDef(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Voucher successfully updated.', 'Success!');
                    getVoucherDef();
                }
            });
        }

        function createVouchers() {
            var selectedMembershipcards = [];
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    selectedMembershipcards.push(membershipcard.id);
                }
            });

            api.issueMultipleVouchers.save({voucher: vm.voucherDef.id}, {membershipcards: selectedMembershipcards}).$promise.then(function(response) {
                if (response.result) {
                    toastr.success('Vouchers successfully issued.', 'Success!');
                    $state.go('app.vouchersconfig', {category: 'welcome'});
                } else {
                    $rootScope.throwException(clientSideExceptions.cantIssueWelcomeVouchers(new Error(), response));
                }
            });
        }

        function updateTotalValue() {
            var totalValue = 0;
            var numberOfSelectedUsers = 0;
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    totalValue += vm.voucherDef.value;
                    numberOfSelectedUsers++;
                }
            });
            vm.totalValue = totalValue;
            vm.numberOfSelectedUsers = numberOfSelectedUsers;
        }

        function selectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = true;
            });
            vm.numberOfSelectedUsers = vm.validUsers.length;
            vm.totalValue = vm.voucherDef.value * vm.numberOfSelectedUsers;
        }

        function deselectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = false;
            });
            vm.numberOfSelectedUsers = 0;
            vm.totalValue = 0;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createshop', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.createshop', {
            title    : "CREATE_SHOP.TITLE",
            url      : '/createshop',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createshop/createshop.html',
                    controller : 'CreateShopController as vm'
                },
            },
            bodyClass: 'create-shop',
            needAuth: true,
            params: {enableOnStateChangeStartHandler: true},
            onStateChangeStart: function(event, state, auth, api, toParams) {
                event.preventDefault();
                var that = this;
                api.getShop.save({}, {}).$promise.then(function(response) {
                    if(response.result) {
                      // UPDATE WIZARD CONFIG
                      try {
                          var user = JSON.parse(localStorage.getItem('user'))
                          var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
                          if (wizardInfo != null) {
                              wizardInfo.step = 1;
                              localStorage.setItem('wizardConfig', JSON.stringify(wizardInfo));
                          }
                      } catch(err) {
                          // do nothing
                      }
                    return state.go('app.shopconfig');
                  } else {
                    toParams.enableOnStateChangeStartHandler = false;
                    return state.go(that.name, toParams);
                  }
                });
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/createshop');

        // Navigation

    }

})();

(function () {
    'use strict';

    angular
        .module('app.createshop')
        .controller('CreateShopController', CreateShopController);

    /** @ngInject */
    function CreateShopController(api, $state, Upload, $rootScope, clientSideExceptions) {
        var vm = this;
        // Data
        vm.serverSideValidationMsg = {};
        vm.logoChanged = false;

        vm.form = {
            country_id: JSON.parse(localStorage.user).country_id
        };

        // Methods
        vm.saveShopConfiguration = saveShopConfiguration;

        api.getCountryList.save({}, {}).$promise.then(function(response)
        {
            if (response.result) {
                vm.countries = response.data.countries;
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetCountryList(new Error(), response));
            }
        });

        api.getCategoryList.save({}, {}).$promise.then(function(response)
        {
            if (response.result) {
                vm.categories = response.data.categories;
            } else {
                $rootScope.throwException(clientSideExceptions.cantGetCategoryList(new Error(), response));
            }
        });

        vm.setLogoChanged = function() {
            vm.logoChanged = true;
        }

        // upload on file select or drop
        function upload(model, form) {
            Upload.upload({
                url: api.baseUrl + '/shop/store',
                data: model
            }).then(function (resp) {

                if (!resp.data.result) {
                    var errorMsg = '';
                    for (var i in resp.data.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in resp.data.errors[i]) {
                                vm.serverSideValidationMsg[i] += resp.data.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + resp.data.errors[i].toString() + '. ');
                        }
                    }
                    vm.editMode = true;
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveShopData(new Error(), resp.data, errorMsg));
                    }
                } else {
                    toastr.success('Shop config successfully updated.', 'Success!');
                    updateWizard();
                    $state.go('app.shopconfig');
                }
            }, function (resp) {
                $rootScope.throwException(clientSideExceptions.cantUploadShopData(new Error(), resp.data, 'Error status: ' + resp.status));
            }, function (evt) {
                // TODO: show progress
                // var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                // console.log('progress: ' + progressPercentage + '% ' + evt.config.data.logo.name);
            });
        };

        function saveShopConfiguration(form, shopData) {

            var model = jQuery.extend(true, {}, shopData);

            if (!model.hasOwnProperty('is_payoff_cancelable')) {
                model.is_payoff_cancelable = 0;
            }
            model.is_payoff_cancelable = model.is_payoff_cancelable ? 1 : 0;

            if (model.website.indexOf('http://') == -1 && model.website.indexOf('https://') == -1) {
                model.website = 'http://' + model.website;
                shopData.website = model.website;
            }

            if (form.logo.$valid && model.logo && vm.logoChanged) {
                upload(model, form);
            } else {
                model.logo = null;

                api.storeShopConfig.save({}, model).$promise.then(function(response)
                {
                    if (!response.result) {
                        var errorMsg = '';
                        for (var i in response.errors) {
                            if (form[i]) {
                                form[i].$setValidity('serverSideValidation', false);
                                vm.serverSideValidationMsg[i] = '';
                                for (var j in response.errors[i]) {
                                    vm.serverSideValidationMsg[i] += response.errors[i][j];
                                }
                            } else {
                                errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                            }
                        }
                        if (errorMsg != '') {
                            $rootScope.throwException(clientSideExceptions.cantSaveShopConfig(new Error(), response, errorMsg));
                        }
                    } else {
                        updateWizard();
                        toastr.success('Shop successfully created.', 'Success!');
                        $state.go('app.shopconfig');
                    }
                });
            }
        }

        function updateWizard() {
            try {
                var user = JSON.parse(localStorage.getItem('user'));
                var wizardInfo = JSON.parse(localStorage.getItem('wizardConfig' + user.id));
                if (wizardInfo != null) {
                    wizardInfo.step = 1;
                    localStorage.setItem('wizardConfig' + user.id, JSON.stringify(wizardInfo));
                }
          } catch(err) {
                // $rootScope.throwException({code: '0037', msg: err, persistent: false, debug: err});
          }
        }
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createreengagevoucher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.createreengagevoucher', {
            title    : "VOUCHERSREENGAGE.TITLE",
            url      : '/createreengagevoucher/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createreengagevoucher/createreengagevoucher.html',
                    controller : 'CreateReengageVoucherController as vm'
                },
            },
            bodyClass: 'createreengagevoucher',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/createreengagevoucher');

        // Navigation
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.createreengagevoucher')
        .controller('CreateReengageVoucherController', CreateReengageVoucherController);

    /** @ngInject */
    function CreateReengageVoucherController(api, $filter, $rootScope, $scope, $state, clientSideExceptions) {
        // Data
        var vm = this;
        vm.voucherDef = {
            is_active: false,
            // TODO: use real code
            code: '123456789',
            type: 're-engage'
        };
        vm.category = 're-engage';
        vm.serverSideValidationMsg = {};

        vm.validUsers = [];

        vm.adjustValueSize = adjustValueSize;
        vm.formatAsCurrency = formatAsCurrency;
        vm.searchValidUsers = searchValidUsers;
        vm.createVouchers = createVouchers;
        vm.updateTotalValue = updateTotalValue;
        vm.selectAllValidUsers = selectAllValidUsers;
        vm.deselectAllValidUsers = deselectAllValidUsers;
        vm.saveVoucherDef = saveVoucherDef;


        function formatAsCurrency(amount, countryId) {
            amount = amount ? amount : 0;
            countryId = countryId ? countryId : 1;
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function adjustValueSize() {
            var valueSpan = angular.element(document.getElementById('voucher-value'));
            // restore original font-size first to adjust accordingly
            valueSpan.css("font-size", 38);
            var sizeRatio = valueSpan.width()/50;
            if(sizeRatio > 1) { // this means: voucher value is overflowing
                var newFontSize = 38 / sizeRatio;
                valueSpan.css("font-size", newFontSize);
                valueSpan.css("top",135 - valueSpan.height()/2);
            }
        }

        function getVoucherDef() {
            api.getShop.save({},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;
                    api.getVouchersByShop.save({shop: vm.shop.id}, {voucher_type: 're-engage'}).$promise.then(function (response) {
                        if (response.result) {
                            vm.voucherDef = response.data.vouchers;
                            searchValidUsers();
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetVoucherInfo(new Error(), response));
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }
        getVoucherDef();

        $scope.$watch('vm.voucherDef.expire_days', function() {
          var expireDate = moment();
          expireDate.add(vm.voucherDef.expire_days, 'day');
          vm.expires_at = expireDate.format('YYYY-MM-DD');
        });

        function searchValidUsers() {
            api.getValidClientsByVoucher.save({voucher: vm.voucherDef.id}, {limit: 10}).$promise.then(function(response) {
                if (response.result) {
                    vm.validUsers = response.data.membershipcards;
                } else {
                    // $rootScope.throwException({code: '0017', msg: 'Error can\'t find valid users for voucher.', persistent: false, debug: response});
                }
            });
        }

        function createVouchers() {
            var selectedMembershipcards = [];
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    selectedMembershipcards.push(membershipcard.id);
                }
            });

            api.issueMultipleVouchers.save({voucher: vm.voucherDef.id}, {membershipcards: selectedMembershipcards}).$promise.then(function(response) {
                if (response.result) {
                    toastr.success('Vouchers successfully issued.', 'Success!');
                    $state.go('app.vouchersconfig', {category: 're-engage'});
                } else {
                    $rootScope.throwException(clientSideExceptions.cantIssueReengageVouchers(new Error(), response));
                }
            });
        }

        function updateTotalValue() {
            var totalValue = 0;
            var numberOfSelectedUsers = 0;
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    totalValue += vm.voucherDef.value;
                    numberOfSelectedUsers++;
                }
            });
            vm.totalValue = totalValue;
            vm.numberOfSelectedUsers = numberOfSelectedUsers;
        }

        function selectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = true;
            });
            vm.numberOfSelectedUsers = vm.validUsers.length;
            vm.totalValue = vm.voucherDef.value * vm.numberOfSelectedUsers;
        }

        function deselectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = false;
            });
            vm.numberOfSelectedUsers = 0;
            vm.totalValue = 0;
        }

        function saveVoucherDef(form, model) {
            var apiMethod;
            var urlParams;
            if (model.id) {
                apiMethod = api.updateVoucherDef;
                urlParams = {voucher: model.id};
            } else {
                apiMethod = api.storeVoucherDef;
                urlParams = {shop: vm.shop.id};
            }

            apiMethod.save(urlParams, model).$promise.then(function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveReengageVoucherDef(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Voucher successfully updated.', 'Success!');
                    getVoucherDef();
                }
            });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.createadhocvoucher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.createadhocvoucher', {
            title    : "VOUCHERSWELCOME.TITLE",
            url      : '/createadhocvoucher/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/createadhocvoucher/createadhocvoucher.html',
                    controller : 'CreateAdhocVoucherController as vm'
                },
            },
            bodyClass: 'createadhocvoucher',
            needAuth: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/createadhocvoucher');

        // Navigation
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.createadhocvoucher')
        .controller('CreateAdhocVoucherController', CreateAdhocVoucherController);

    /** @ngInject */
    function CreateAdhocVoucherController(api, $filter, $rootScope, $scope, $mdDialog, $timeout, $window, $state, clientSideExceptions) {
        // Data
        var scannerDialog;

        var vm = this;
        vm.voucherDef = {
            is_active: false,
            // TODO: use real code
            code: '123456789',
            type: 'ad-hoc'
        };
        vm.category = 'ad-hoc';

        vm.validUsers = [];
        vm.totalValue = 0;
        vm.numberOfSelectedUsers = 0;
        vm.serverSideValidationMsg = {};
        vm.membercard = '';
        vm.selectedMembercard = null;

        // Search dialog necessary
        vm.searchQuery = '';
        vm.isIOS = $window.navigator.userAgent.match(/iPhone|iPad|iPod/i);

        vm.searchScannedData = searchScannedData;
        vm.showScanDialog = showScanDialog;
        vm.initDialog = initDialog;
        vm.usersAround = [];


        //Methods

        vm.adjustValueSize = adjustValueSize;
        vm.formatAsCurrency = formatAsCurrency;
        vm.saveVoucherDef = saveVoucherDef;
        // vm.searchValidUsers = searchValidUsers;
        // vm.createVouchers = createVouchers;
        vm.updateTotalValue = updateTotalValue;
        vm.selectAllValidUsers = selectAllValidUsers;
        vm.deselectAllValidUsers = deselectAllValidUsers;
        vm.search = search;
        vm.createVoucher = createVoucher;

        // subroutine to float voucher representation
        var parent = angular.element(document.getElementById('content'));
        var cardparent = angular.element(document.getElementById('card-parent'));
        var cardparentHeight = cardparent.height();
        var card = angular.element(document.getElementById('voucher-card'));

        parent.bind('scroll', function(event) {
          if(card.css('position') === 'relative') {
            card.css('top', 'auto');
            return;
          }

          card.css('top', event.currentTarget.scrollTop + 200);
          if(event.currentTarget.scrollTop > cardparentHeight) {
            card.css('top', cardparentHeight + 200);
          }
        });

        function formatAsCurrency(amount, countryId) {
            return $filter('currency')(amount, $rootScope.getCurrencyByCountry(countryId), 2);
        }

        function adjustValueSize() {
            var valueSpan = angular.element(document.getElementById('voucher-value'));
            // restore original font-size first to adjust accordingly
            valueSpan.css("font-size", 38);
            var sizeRatio = valueSpan.width()/50;
            if(sizeRatio > 1) { // this means: voucher value is overflowing
                var newFontSize = 38 / sizeRatio;
                valueSpan.css("font-size", newFontSize);
                valueSpan.css("top",135 - valueSpan.height()/2);
            }
        }

        function getVoucherDef() {
            api.getShop.save({},{}).$promise.then(function(response) {
                if (response.result) {
                    vm.shop = response.data.shop;

                    var firstLocation = vm.shop.locations[0];
                    if (!firstLocation || false) {
                        $rootScope.throwException(clientSideExceptions.cantGetLocationToOperate(new Error(), response));
                    }
                    api.operatorOperate.save({location: firstLocation.id}, {}).$promise.then(function (response) {
                        if (!response.result) {
                            $rootScope.throwException(clientSideExceptions.cantOperateLocation(new Error(), response));
                        }
                    });

                    api.getVouchersByShop.save({shop: vm.shop.id}, {voucher_type: 'ad-hoc'}).$promise.then(function (response) {
                        if (response.result) {
                            vm.voucherDef = response.data.vouchers;
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetVoucherInfo(new Error(), response));
                        }
                    });

                    api.getLocationClientsCheckIn.save({location: firstLocation.id}, {}).$promise.then(function(response) {
                        if (response.result) {
                            vm.usersAround = response.data.checkIns;
                        } else {
                            $rootScope.throwException(clientSideExceptions.cantGetClientsAround(new Error(), response));
                        }
                    });


                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetShopInfo(new Error(), response));
                }
            });
        }

        $scope.$watch('vm.voucherDef.expire_days', function() {
          var expireDate = moment();
          expireDate.add(vm.voucherDef.expire_days, 'day');
          vm.expires_at = expireDate.format('YYYY-MM-DD');
        });

        function searchScannedData(data) {
            vm.searchQuery = data;
            $timeout(function() {
                vm.search(vm.voucherDefForm, vm.voucherDef)
            }, 100);
        }

        function showScanDialog() {
            var parentEl = angular.element(document.body);
            vm.qrScanDialog = $mdDialog.show({
                parent: parentEl,
                templateUrl: 'app/main/operatelocation/scandialog.html',
                clickOutsideToClose: true,
                onComplete: initDialog(),
                scope: $scope,        // use parent scope in template
                preserveScope: true
            });
        }

        $scope.closeDialog = function() {
            $('#reader').html5_qrcode_stop();
            $mdDialog.hide(vm.qrScanDialog, 'finished');
            vm.qrScanDialog = undefined;
        }

        function initDialog() {

            initGridSampler();

            $timeout(function() {
                $('#reader').html5_qrcode(function(data){
                        $('#reader').html5_qrcode_stop();
                        $mdDialog.hide();
                        searchScannedData(data);
                    },
                    function(error){
                        // console.log('error', error);
                    }, function(videoError){
                        // console.log('video error', videoError);
                    });
            }, 1000);

        }

        function search (form, voucherDef) {
            if((vm.searchQuery == "" || !vm.searchQuery) && !vm.isIOS) {
                showScanDialog();
                return;
            }

            api.searchByCard.save({}, {membercard: vm.searchQuery}).$promise.then(function (response) {
                if (response.result) {
                    vm.selectedMembercard = response.data.membershipcard;
                    vm.usersAround = [vm.selectedMembercard];
                    // createVoucher();
                    // saveVoucherDef(form, voucherDef);
                } else {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        var k=i;
                        if (i=='membershipcard') {
                            k = 'membercard';
                        }
                        if (form[k]) {
                            form[k].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[k] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[k] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                            // toastr.warning(response.errors[i], 'Warning!');
                        }
                    }
                    if (errorMsg !== '') {
                        $rootScope.throwException(clientSideExceptions.cantSearchByCard(new Error(), response, errorMsg));
                    }
                }
            });
        }

        function saveVoucherDef(form, model) {

            var apiMethod;
            var urlParams;
            if (model.id) {
                apiMethod = api.updateVoucherDef;
                urlParams = {voucher: model.id};
            } else {
                apiMethod = api.storeVoucherDef;
                urlParams = {shop: vm.shop.id};
            }

            apiMethod.save(urlParams, model).$promise.then(function(response) {
                if (!response.result) {
                    var errorMsg = '';
                    for (var i in response.errors) {
                        if (form[i]) {
                            form[i].$setValidity('serverSideValidation', false);
                            vm.serverSideValidationMsg[i] = '';
                            for (var j in response.errors[i]) {
                                vm.serverSideValidationMsg[i] += response.errors[i][j];
                            }
                        } else {
                            errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                        }
                    }
                    if (errorMsg != '') {
                        $rootScope.throwException(clientSideExceptions.cantSaveAdhocVoucherDef(new Error(), response, errorMsg));
                    }
                } else {
                    toastr.success('Voucher successfully updated.', 'Success!');
                    // createVoucher();
                }
            });
        }

        function createVoucher() {
            api.issueMultipleVouchers.save({voucher: vm.voucherDef.id}, {membershipcards: [vm.selectedMembercard.id]}).$promise.then(function(response) {
                if (response.result) {
                    toastr.success('Voucher successfully issued.', 'Success!');
                    $state.go('app.vouchersconfig', {category: 'ad-hoc'});
                } else {
                    $rootScope.throwException(clientSideExceptions.cantIssueAdhocVouchers(new Error(), response));
                }

            });
        }

        function updateTotalValue() {
            var totalValue = 0;
            var numberOfSelectedUsers = 0;
            vm.validUsers.forEach(function (membershipcard) {
                if(membershipcard.selected) {
                    totalValue += vm.voucherDef.value;
                    numberOfSelectedUsers++;
                }
            });
            vm.totalValue = totalValue;
            vm.numberOfSelectedUsers = numberOfSelectedUsers;
        }

        function selectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = true;
            });
            vm.numberOfSelectedUsers = vm.validUsers.length;
            vm.totalValue = vm.voucherDef.value * vm.numberOfSelectedUsers;
        }

        function deselectAllValidUsers() {
            vm.validUsers.forEach(function (membershipcard) {
                membershipcard.selected = false;
            });
            vm.numberOfSelectedUsers = 0;
            vm.totalValue = 0;
        }

        getVoucherDef();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.claimcard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.claimcard', {
            url      : '/claimcard',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.claimcard': {
                    templateUrl: 'app/main/claimcard/claimcard.html',
                    controller : 'ClaimCardController as vm'
                }
            },
            bodyClass: 'claim-card',
            needAuth: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/claimcard');

        // Navigation
    }

})();
(function () {
    'use strict';

    angular
        .module('app.claimcard')
        .controller('ClaimCardController', ClaimCardController);

    /** @ngInject */
    function ClaimCardController(api, $timeout, $rootScope, clientSideExceptions) {
        var pageRoot = angular.element(document.getElementById('claim-card'));
        pageRoot.css("background", 'url(\'/assets/images/backgrounds/login' + $rootScope.wallpaperIndex + '.jpg\') no-repeat')
        pageRoot.css("background-size", "cover");

        // Data
        var vm = this;

        vm.claimSuccess = false;
        vm.makeSuccess = false;
        vm.claimCardFormData = {};

        // Methods
        vm.getProfile = getProfile;
        vm.claimCard = claimCard;
        vm.createCard = createCard;
        vm.triggerClaimCard = triggerClaimCard;

        function getProfile() {
            api.getUserProfile.save({}, {}).$promise.then(function(response)
            {
                if (response.result) {
                    vm.user = response.data.user;
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetUserProfile(new Error(), response));
                }
            });
        };
        getProfile();

        function claimCard(form, data) {

            if (data == undefined) {
                data = {code: ''};
            }

            if ( form.submitType == 'claim' ) {
                api.claimCard.save({}, data).$promise.then(function(response){
                    if (response.result) {
                        vm.claimSuccess = true;
                        vm.successMsg = "Card successfully claimed.";
                        $rootScope.hasCard = true;
                        $('.card').toggleClass('flipped');
                    } else {
                        var msg = '';
                        for (var i in response.errors) {
                            if ( response.errors[i] instanceof Array) {
                                for ( var j in response.errors[i]) {
                                    msg += response.errors[i][j];
                                }
                            } else {
                                msg = response.errors[i];
                            }
                        }
                        form.membership_number.$setValidity('serverSideValidation', false);
                        vm.serverSideValidationMsg = msg;
                        vm.claimSuccess = false;
                    }
                });
            } else {
                api.makeCard.save({}, data).$promise.then(function(response){
                    if (response.result) {
                        vm.makeSuccess = true;
                        vm.successMsg = "Card successfully created.";
                        vm.claimCardFormData.code = response.data.membershipcard.code;
                        $rootScope.hasCard = true;
                        $('.card').toggleClass('flipped');
                    } else {
                        var msg = '';
                        var errorMsg = '';
                        for (var i in response.errors) {
                            if ( response.errors[i] instanceof Array) {
                                for ( var j in response.errors[i]) {
                                    msg += response.errors[i][j];
                                }
                            } else {
                                msg = response.errors[i];
                            }
                        }
                        form.membership_number.$setValidity('serverSideValidation', false);
                        vm.serverSideValidationMsg = msg;
                        vm.makeSuccess = false;
                        if (errorMsg != '') {
                            $rootScope.throwException(clientSideExceptions.cantCreateMembershipCard(new Error(), response));
                        }
                    }
                });
            }
        }

        function createCard() {
            $timeout(function() {
                angular.element('#submit-create-form').trigger('click');
            }, 0, false);
        }

        function triggerClaimCard() {
            $timeout(function() {
                angular.element('#submit-claim-form').trigger('click');
            }, 0, false);

        }

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.cart', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.cart', {
            title    : "CART.TITLE",
            url      : '/cart',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/cart/cart.html',
                    controller : 'CartController as vm'
                },
            },
            bodyClass: 'cart',
            needAuth: true,
            params: {order: null},
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/cart');

        // Navigation
        // msNavigationServiceProvider.saveItem('my_shop.subscription', {
        //     title : 'Subscription',
        //     state : 'app.subscription',
        //     weight: 1
        // });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.cart')
        .controller('CartController', CartController);

    /** @ngInject */
    function CartController(api, $state, $stateParams, $rootScope, $timeout, clientSideExceptions) {
        var vm = this;
        vm.goToPreviousState = $rootScope.goToPreviousState;
        vm.paymentConfigured = false;
        vm.serverSideValidationMsg = {};
        vm.order = $stateParams.order;

        if (vm.order == null) {
            $state.go('app.shops');
        }

        vm.totalPrice = vm.order != null && vm.order.hasOwnProperty('price') ? vm.order.price : 0;
        vm.calculateDiscount = calculateDiscount;

        if (vm.order) {
            vm.order.coupon = null;
        }
        vm.hasCoupon = false;

        vm.enableCoupon = enableCoupon;
        function enableCoupon() {
            vm.hasCoupon = true;
        }

        function calculateDiscount() {
            if (vm.order.type == 'product') {
                api.calculateProductDiscount.save({product: vm.order.product.id}, {
                    coupon: vm.order.coupon,
                    quantity: vm.order.quantity
                }).$promise.then(function (response) {
                    if (response.result) {
                        vm.totalPrice = response.data.discounted_price >= 0 ? response.data.discounted_price : 0;
                    } else {
                        vm.totalPrice = vm.order.price;
                    }
                });
            }

            if (vm.order.type == 'subscription') {
                api.calculateSubscriptionDiscount.save({}, {
                    plan: vm.order.id,
                    coupon: vm.order.coupon
                }).$promise.then(function (response) {
                    if (response.result) {
                        vm.totalPrice = response.data.discounted_price >= 0 ? response.data.discounted_price : 0;
                    } else {
                        vm.totalPrice = vm.order.price;
                    }
                });
            }
        }

        function setUpBraintree() {
            api.getSubscriptionToken.save({}, {}).$promise.then(function(response) {
                if (response.result) {
                    var clientToken = response.data.token;

                    braintree.setup(clientToken, "dropin", {
                        container: "payment-form",
                        paymentMethodNonceReceived: function (event, nonce) {
                            vm.paymentInProcess = true;

                            // nonce = 'fake-processor-declined-visa-nonce';
                            // nonce = 'fake-gateway-rejected-fraud-nonce';

                            var params;
                            if (vm.order.type == 'product') {
                                params = {
                                    nonce: nonce,
                                    coupon: vm.order.coupon,
                                    address: vm.order.address,
                                    quantity: vm.order.quantity,
                                    comments: vm.order.comments
                                };
                            }
                            if (vm.order.type == 'subscription') {
                                params = {
                                    nonce: nonce,
                                    plan: vm.order.id,
                                    coupon: vm.order.coupon
                                };
                            }

                            var urlParams = {};
                            if (vm.order.type == 'product') {
                                urlParams = {product: vm.order.product.id};
                            }

                            vm.order.apiCallback.save(urlParams, params, function(response){
                                vm.paymentInProcess = false;
                                if (response.result) {
                                    if (vm.order.type == 'product') {
                                        toastr.success('Sold product ' + response.data.product_sale.product.name, 'Success!');
                                        var orderDetails = response.data.product_sale;
                                        $rootScope.previousStateParams = {orderDetails: orderDetails};
                                    }
                                    if (vm.order.type == 'subscription') {
                                        toastr.success('Subscription saved', 'Success!');
                                        var orderDetails = response.data.subscription;
                                        $state.go('app.thankyou', {orderDetails: orderDetails});
                                        return;
                                        // $rootScope.previousStateParams = {orderDetails: orderDetails};
                                    }
                                    vm.goToPreviousState();
                                } else {
                                    if (response.errors.subscription) {
                                        toastr.warning(response.errors.subscription, 'Warning!');
                                    }
                                    if (response.errors.coupon) {
                                        vm.serverSideValidationMsg['coupon'] = '';
                                        vm.couponForm.coupon.$setValidity('serverSideValidation', false);
                                        for (var i in response.errors['coupon']) {
                                            vm.serverSideValidationMsg['coupon'] += response.errors['coupon'][i];
                                        }
                                    }
                                    if (response.errors.product_sale) {
                                        if (vm.couponForm) {
                                            vm.serverSideValidationMsg['coupon'] = '';
                                            vm.couponForm.coupon.$setValidity('serverSideValidation', false);
                                            for (var i in response.errors['product_sale']) {
                                                vm.serverSideValidationMsg['coupon'] += response.errors['product_sale'][i];
                                            }
                                        } else {
                                            toastr.warning(response.errors['product_sale'], 'Warning!');
                                        }
                                    }
                                    // vm.goToPreviousState();
                                }
                            });
                        },
                        onReady: function() {
                            $timeout(function() {
                                vm.paymentConfigured = true;
                            }, 0);
                        }
                    });
                } else {
                    $rootScope.throwException(clientSideExceptions.cantGetSubscriptionToken(new Error(), response));
                }
            });
        }

        setUpBraintree();
        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '=?'
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        'default'  : {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'shoplocal-colors',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'red'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'pink': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'blue'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        },
        'teal'     : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {name: 'deep-orange'},
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : '100',
                    'hue-2'  : '50',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0, color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject required services
        var $log = angular.injector(['ng']).get('$log'),
            $resource = angular.injector(['ngResource']).get('$resource');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Prepare the resource object
            var resourceObj = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };

            // Assign the resource
            api[key] = $resource(resourceObj.url, resourceObj.paramDefaults, resourceObj.actions, resourceObj.options);
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($q, $log)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    apiObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('membershipcardNumber', membershipcardNumberFilter)
        .filter('voucherNumber', voucherNumberFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function membershipcardNumberFilter()
    {
        return function (value)
        {
            if (!value) {
                return '';
            }
            var formattedValue = '';
            for (var i = 0; i<value.length; i++) {
                if (i % 4 == 0 && i >0) {
                    formattedValue += ' ';
                }
                formattedValue += value[i];
            }
            return formattedValue;
        };
    }

    /** @ngInject */
    function voucherNumberFilter()
    {
        return function (value)
        {
            if (!value) {
                return '';
            }
            var formattedValue = '';
            for (var i = 0; i<value.length; i++) {
                if (i % 4 == 0 && i >0) {
                    formattedValue += ' ';
                }
                formattedValue += value[i];
            }
            return formattedValue;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // angular rich text editor
            'textAngular',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Login
            'app.auth.login',

            // Register
            'app.auth.register',

            // Verify e-mail
            'app.auth.verifyemail',

            // Resend verification
            'app.auth.resendverification',

            // Forgot password
            'app.auth.forgotpassword',

            // Reset password
            'app.auth.resetpassword',

            // Claim card
            'app.claimcard',

            // Shop creation
            'app.createshop',

            // Shop configuration
            'app.shopconfig',

            // Shop location
            // 'app.shoplocation',

            // Shop edit location
            'app.editshoplocation',

            // Shop edit operator
            'app.editoperator',

            // Edit stampcard
            'app.editstampcard',

            // Shop subscription
            'app.subscription',

            // Shop operators
            // 'app.operators',

            // Operator index
            'app.operatorindex',

            // Operate location
            'app.operatelocation',

            // Operate user
            'app.operateuser',

            // Dashboard
            'app.dashboard',

            // shops
            'app.shops',

            // User Profile
            'app.userprofile',

            // Stampcards
            'app.stampcards',

            // My vouchers
            'app.myvouchers',

            // Cart
            'app.cart',

            // Shop vouchers configuration
            'app.vouchersconfig',

            // Shop create welcome vouchers
            'app.createwelcomevoucher',

            // Shop create re-engage vouchers
            'app.createreengagevoucher',

            // Shop create point vouchers
            'app.createpointvoucher',

            // Shop create adhoc vouchers
            'app.createadhocvoucher',

            // Show notifications
            'app.notifications',

            // Products
            'app.product',

            // Thank you landing page
            'app.thankyou',

            // Not found landing page
            'app.notfound',

            // Error landing page
            'app.error'

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($rootScope)
    {
        // Data

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($scope, $rootScope, $mdSidenav, $translate, $mdToast, api, $auth)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.user = JSON.parse(localStorage.getItem('user'));
        vm.latestNotifications = $rootScope.notifications.slice(0, 5);

        var onProfileChanged = $scope.$on('profileUpdated', function(event, newUserInfo) {
            vm.user = JSON.parse(localStorage.getItem('user'));
        });

        var onNotificationsChanged = $scope.$on('notificationsChanged', function(event) {
            $rootScope.notifications = JSON.parse(localStorage.notifications);
            vm.latestNotifications = $rootScope.notifications.slice(0, 5);
        });

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            api.logout.save({}, {}, function(response)
            {
                $auth.removeToken();
                localStorage.removeItem('notifications');
                location.reload();
                // $state.go('app.auth_login');
            },
            function(){
                $auth.removeToken();
                localStorage.removeItem('notifications');
                location.reload();
                // $state.go('app.auth_login');
            });
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        $scope.$on('destroy', function() {
          onProfileChanged();
          onNotificationsChanged();
        });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
        })
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $auth, api, $translate, msNavigationService, config, $log) {
        $rootScope.previousState = null;
        $rootScope.wallpaperIndex = Math.floor(Math.random() * (7 - 1 + 1)) + 1;

        $rootScope.notifications = localStorage.notifications ? JSON.parse(localStorage.notifications) : [];

        $rootScope.goToPreviousState = function() {
            if($rootScope.previousState && !$rootScope.previousState.abstract) {
                if($rootScope.previousStateParams) {
                    $state.go($rootScope.previousState, $rootScope.previousStateParams); // if state is not valid this throws its own error
                } else {
                    $state.go($rootScope.previousState); // if state is not valid this throws its own error
                }
            }
        };

        $rootScope.cardInfoFetched = false;
        $rootScope.hasCard;

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $rootScope.changeStateEvent = event;
            $rootScope.previousState = fromState;
            $rootScope.previousStateParams = fromParams;
            // check if authentication needed
            if (toState.needAuth && !$auth.isAuthenticated()) {
                // redirect to login page
                event.preventDefault();
                $state.go('app.auth_login', {}, {});
            } else {
                if ($auth.isAuthenticated() && toState.name != "app.claimcard" &&toState.name != "app.error" && !$rootScope.cardInfoFetched) {
                    event.preventDefault();

                    var user = JSON.parse(localStorage.getItem('user'));
                    $rootScope.initNotificationListener(user.id);

                    $rootScope.savedToState = toState;
                    $rootScope.savedToparams = toParams;

                    api.getUserCard.save({}, {}).$promise.then(function (response){

                        $rootScope.cardInfoFetched = true;
                        $rootScope.hasCard = response.result;

                        if ($rootScope.hasCard) {
                            if (toState.onStateChangeStart && toParams.enableOnStateChangeStartHandler) {
                                return $rootScope.savedToState.onStateChangeStart(event, $state, $auth, api, $rootScope.savedToparams, $rootScope);
                            } else {
                                return $state.go($rootScope.savedToState, $rootScope.savedToparams);
                            }
                        } else {
                            return $state.go('app.claimcard');
                        }

                    });

                    return;
                } else {
                    if (toState.onStateChangeStart && toParams.enableOnStateChangeStartHandler) {
                        return toState.onStateChangeStart(event, $state, $auth, api, toParams, $rootScope);
                    }
                }
            }

            // TODO: move this into onExit
            if ((fromState.name == 'app.createadhocvoucher' || fromState.name == 'app.operatelocation' || fromState.name == 'app.operateuser') &&
                (toState.name != 'app.createadhocvoucher' && toState.name != 'app.operatelocation' && toState.name != 'app.operateuser')
            ) {
                api.operatorUnoperate.save({}, {});
            }

            $rootScope.loadingProgress = true;

            if (toState.hasOwnProperty('title')) {
                $translate(toState.title).then(function (title) {
                    $rootScope.stateTitle = title;
                });
            } else {
                $rootScope.stateTitle = "";
            }

            if ($auth.isAuthenticated()) {
                checkProcessingAllowed();
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            $timeout(function () {
                $rootScope.loadingProgress = false;
                if(ga) {
                    ga('set', 'page', document.location.pathname);
                    ga('send', 'pageview');
                }
            });

            $rootScope.state = $state;
        });

        $rootScope.resetServerSideValidation = function(form) {
            angular.forEach(form, function(value, key) {
                if (typeof value === 'object' && value.hasOwnProperty('$modelValue')) {
                    value.$setValidity('serverSideValidation', null);
                }
            });
        }

        function checkProcessingAllowed() {
            if ($auth.isAuthenticated()) {
                api.getOperatorIndex.save({}, {}).$promise.then(function (response) {
                    var hasOperatedLocation = false;

                    if (response.result) {
                        var shops = response.data.shops;
                        for (var i in shops) {
                            if (shops[i].locations && shops[i].locations.length) {
                                hasOperatedLocation = true;
                            }
                        }
                    } else {
                        console.log('Can\'t get operator shops');
                    }

                    if (hasOperatedLocation) {
                        // Navigation
                        msNavigationService.saveItem('operatorindex', {
                            title: 'Process Cards',
                            state: 'app.operatorindex',
                            icon: 'icon-cog',
                            weight: 4
                        });
                        msNavigationService.sort();
                    } else {
                        msNavigationService.deleteItem('operatorindex');
                    }

                });
            }
        }

        $rootScope.getCurrencyByCountry = function (countryId) {
            countryId = countryId ? countryId : 1;
            var countryMap = JSON.parse(localStorage.countries);
            return countryMap[countryId].currency_symbol;
        }

        // Get location function
        // TODO: Clean this up a little bit
        $rootScope.fetchedLocation = false;
        var currentGeoCallback; // TODO: VERY UGLY, properly use $q to handle this
        $rootScope.getLocation = function(successCallback, errorCallback) {
            currentGeoCallback = successCallback;
            if($rootScope.fetchedLocation) {
                if($rootScope.position.latitude == null || $rootScope.position.longitude == null) {
                    errorCallback('Position is null');
                } else {
                    successCallback($rootScope.position);
                }
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        $rootScope.position = {
                            latitude:  position.coords.latitude,
                            longitude: position.coords.longitude
                        };
                        $rootScope.fetchedLocation = true;

                        currentGeoCallback($rootScope.position);
                    }, function(){
                        $log.debug('Warning: cannot get browser geolocation, querying back-end for last known data');
                        api.getUserProfile.save({}, {}).$promise.then(function(response) {
                            if (response.result) {
                                $rootScope.position = {
                                    latitude: response.data.user.latitude,
                                    longitude: response.data.user.longitude,
                                };
                                $rootScope.fetchedLocation = true;
                                if($rootScope.position.latitude == null || $rootScope.position.longitude == null) {
                                    errorCallback('Position is null');
                                } else {
                                    successCallback($rootScope.position);
                                }

                            } else {
                                errorCallback('Error querying profile:', response);
                            }
                        });
                    });
                } else {
                    console.log('Warning: browser does not support geolocation, querying back-end for last known data');
                    api.getUserProfile.save({}, {}).$promise.then(function(response) {
                        if (response.result) {
                            $rootScope.position = {
                                latitude: response.data.user.latitude,
                                longitude: response.data.user.longitude,
                            };
                            $rootScope.fetchedLocation = true;
                            if($rootScope.position.latitude == null || $rootScope.position.longitude == null) {
                                errorCallback('Position is null');
                            } else {
                                successCallback($rootScope.position);
                            }

                        } else {
                            errorCallback('Error querying profile:', response);
                        }
                    });
                }
            }
        }
        // Open socket.io for notifications
        var listeningForNotifications = false;
        var socketUrl = config.socketURL;
        var socket = null;
        $rootScope.initNotificationListener = function(userId) {
            if(listeningForNotifications) {
                return;
            }

            try {
              var notifications = localStorage.getItem('notifications');
              if(!notifications) {
                localStorage.setItem('notifications', '[]');
              }
            } catch(err) {
              localStorage.setItem('notifications', '[]');
            }

            listeningForNotifications = true;
            $(function(){
                socket = io(socketUrl);
                socket.on("user." + userId.toString() + ":App\\Events\\CriticalNotification", function(message) {
                    $rootScope.$apply(function(){
                        var notifications = JSON.parse(localStorage.notifications);
                        notifications.push(message.notification);
                        localStorage.notifications = JSON.stringify(notifications);
                        $rootScope.notifications = notifications;
                        toastr.success(message.notification.message, 'New notification!');
                        $rootScope.$broadcast('notificationsChanged');
                    })
                });
            })
        }

        $rootScope.displayError = function(errorMsg, persistant) {
          $rootScope.globalError = errorMsg;

          if(!persistant) {
              $timeout(function () {
                $rootScope.globalError = null;
                return;
              }, 3000);
          }
        }

        $rootScope.clearError = function() {
          $rootScope.globalError = null;
        }

        $rootScope.throwException = function(exceptionObject) {
            if (exceptionObject.severity == 'critical') {
                $rootScope.changeStateEvent.preventDefault();
                throw JSON.stringify(exceptionObject);
            } else {
                if (exceptionObject !== null && typeof(exceptionObject) == 'object' && exceptionObject.hasOwnProperty('msg')) {
                    var persistent = exceptionObject.hasOwnProperty('persistent') ? !!exceptionObject.persistent : false;
                    $rootScope.displayError(exceptionObject.msg, persistent);
                } else {
                    $rootScope.displayError('Exception happened! Please make sure you have an active internet connection', true);
                }
                api.sendExceptionLog.save({}, {exceptionObject: exceptionObject});
            }
        }

        $rootScope.handleErrors = function(response, form, errorObject) {
            var errorMsg = '';
            for (var i in response.errors) {
                if (form[i]) {
                    form[i].$setValidity('serverSideValidation', false);
                    vm.serverSideValidationMsg[i] = '';
                    for (var j in response.errors[i]) {
                        vm.serverSideValidationMsg[i] += response.errors[i][j];
                    }
                } else {
                    errorMsg += (i.toString() + ': ' + response.errors[i].toString() + '. ');
                }
            }
            if (errorMsg != '') {
                errorObject.msg = errorMsg;
                $rootScope.throwException(errorObject);
            }
        };

        // sample call from create adhoc voucher
        // $rootScope.apiCall(apiMethod, urlParams, model,
        //     function (response) {
        //         createVoucher();
        //     },
        //     {type: 'toastr', msg: 'Voucher successfully updated.'},
        //     null,
        //     {code: '0009', msg: errorMsg, persistent: false, debug: response}
        // );
        // TODO: implement disable overlay
        $rootScope.apiCall = function(apiMethod, urlParams, payload, successCallback, successObject, failureCallback, errorObject) {
            apiMethod.save(urlParams, payload).$promise.then(function(response) {
                if (!response.result) {
                    if (failureCallback === null) {
                        vm.serverSideValidationMsg = $rootScope.handleErrors(response, form, errorObject);
                    } else {
                        failureCallback(response, form, errorObject);
                    }
                } else {
                    if (successObject !== null) {
                        switch (successObject.type) {
                            case 'toastr':
                                toastr.success(successObject.msg, 'Success!');
                                break;
                            case 'alert':
                                // show alert popup
                                break;
                        }
                    }
                    if (successCallback === null) {
                        // do nothing
                    } else {
                        successCallback(response);
                    }
                }
            });
        }

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();

            socket.disconnect();
            socket = null;

            $rootScope.previousState = null;
        });
    }
})();

// TODO: find a better place for that code
var GridSampler;
function initGridSampler() {

    function ECB(e,t){this.count=e,this.dataCodewords=t,this.__defineGetter__("Count",function(){return this.count}),this.__defineGetter__("DataCodewords",function(){return this.dataCodewords})}function ECBlocks(e,t,n){this.ecCodewordsPerBlock=e,this.ecBlocks=n?[t,n]:Array(t),this.__defineGetter__("ECCodewordsPerBlock",function(){return this.ecCodewordsPerBlock}),this.__defineGetter__("TotalECCodewords",function(){return this.ecCodewordsPerBlock*this.NumBlocks}),this.__defineGetter__("NumBlocks",function(){for(var e=0,t=0;t<this.ecBlocks.length;t++)e+=this.ecBlocks[t].length;return e}),this.getECBlocks=function(){return this.ecBlocks}}function Version(e,t,n,i,r,o){for(this.versionNumber=e,this.alignmentPatternCenters=t,this.ecBlocks=[n,i,r,o],e=0,t=n.ECCodewordsPerBlock,n=n.getECBlocks(),i=0;i<n.length;i++)r=n[i],e+=r.Count*(r.DataCodewords+t);this.totalCodewords=e,this.__defineGetter__("VersionNumber",function(){return this.versionNumber}),this.__defineGetter__("AlignmentPatternCenters",function(){return this.alignmentPatternCenters}),this.__defineGetter__("TotalCodewords",function(){return this.totalCodewords}),this.__defineGetter__("DimensionForVersion",function(){return 17+4*this.versionNumber}),this.buildFunctionPattern=function(){var e=this.DimensionForVersion,t=new BitMatrix(e);t.setRegion(0,0,9,9),t.setRegion(e-8,0,8,9),t.setRegion(0,e-8,9,8);for(var n=this.alignmentPatternCenters.length,i=0;n>i;i++)for(var r=this.alignmentPatternCenters[i]-2,o=0;n>o;o++)0==i&&(0==o||o==n-1)||i==n-1&&0==o||t.setRegion(this.alignmentPatternCenters[o]-2,r,5,5);return t.setRegion(6,9,1,e-17),t.setRegion(9,6,e-17,1),6<this.versionNumber&&(t.setRegion(e-11,0,3,6),t.setRegion(0,e-11,6,3)),t},this.getECBlocksForLevel=function(e){return this.ecBlocks[e.ordinal()]}}function buildVersions(){return[new Version(1,[],new ECBlocks(7,new ECB(1,19)),new ECBlocks(10,new ECB(1,16)),new ECBlocks(13,new ECB(1,13)),new ECBlocks(17,new ECB(1,9))),new Version(2,[6,18],new ECBlocks(10,new ECB(1,34)),new ECBlocks(16,new ECB(1,28)),new ECBlocks(22,new ECB(1,22)),new ECBlocks(28,new ECB(1,16))),new Version(3,[6,22],new ECBlocks(15,new ECB(1,55)),new ECBlocks(26,new ECB(1,44)),new ECBlocks(18,new ECB(2,17)),new ECBlocks(22,new ECB(2,13))),new Version(4,[6,26],new ECBlocks(20,new ECB(1,80)),new ECBlocks(18,new ECB(2,32)),new ECBlocks(26,new ECB(2,24)),new ECBlocks(16,new ECB(4,9))),new Version(5,[6,30],new ECBlocks(26,new ECB(1,108)),new ECBlocks(24,new ECB(2,43)),new ECBlocks(18,new ECB(2,15),new ECB(2,16)),new ECBlocks(22,new ECB(2,11),new ECB(2,12))),new Version(6,[6,34],new ECBlocks(18,new ECB(2,68)),new ECBlocks(16,new ECB(4,27)),new ECBlocks(24,new ECB(4,19)),new ECBlocks(28,new ECB(4,15))),new Version(7,[6,22,38],new ECBlocks(20,new ECB(2,78)),new ECBlocks(18,new ECB(4,31)),new ECBlocks(18,new ECB(2,14),new ECB(4,15)),new ECBlocks(26,new ECB(4,13),new ECB(1,14))),new Version(8,[6,24,42],new ECBlocks(24,new ECB(2,97)),new ECBlocks(22,new ECB(2,38),new ECB(2,39)),new ECBlocks(22,new ECB(4,18),new ECB(2,19)),new ECBlocks(26,new ECB(4,14),new ECB(2,15))),new Version(9,[6,26,46],new ECBlocks(30,new ECB(2,116)),new ECBlocks(22,new ECB(3,36),new ECB(2,37)),new ECBlocks(20,new ECB(4,16),new ECB(4,17)),new ECBlocks(24,new ECB(4,12),new ECB(4,13))),new Version(10,[6,28,50],new ECBlocks(18,new ECB(2,68),new ECB(2,69)),new ECBlocks(26,new ECB(4,43),new ECB(1,44)),new ECBlocks(24,new ECB(6,19),new ECB(2,20)),new ECBlocks(28,new ECB(6,15),new ECB(2,16))),new Version(11,[6,30,54],new ECBlocks(20,new ECB(4,81)),new ECBlocks(30,new ECB(1,50),new ECB(4,51)),new ECBlocks(28,new ECB(4,22),new ECB(4,23)),new ECBlocks(24,new ECB(3,12),new ECB(8,13))),new Version(12,[6,32,58],new ECBlocks(24,new ECB(2,92),new ECB(2,93)),new ECBlocks(22,new ECB(6,36),new ECB(2,37)),new ECBlocks(26,new ECB(4,20),new ECB(6,21)),new ECBlocks(28,new ECB(7,14),new ECB(4,15))),new Version(13,[6,34,62],new ECBlocks(26,new ECB(4,107)),new ECBlocks(22,new ECB(8,37),new ECB(1,38)),new ECBlocks(24,new ECB(8,20),new ECB(4,21)),new ECBlocks(22,new ECB(12,11),new ECB(4,12))),new Version(14,[6,26,46,66],new ECBlocks(30,new ECB(3,115),new ECB(1,116)),new ECBlocks(24,new ECB(4,40),new ECB(5,41)),new ECBlocks(20,new ECB(11,16),new ECB(5,17)),new ECBlocks(24,new ECB(11,12),new ECB(5,13))),new Version(15,[6,26,48,70],new ECBlocks(22,new ECB(5,87),new ECB(1,88)),new ECBlocks(24,new ECB(5,41),new ECB(5,42)),new ECBlocks(30,new ECB(5,24),new ECB(7,25)),new ECBlocks(24,new ECB(11,12),new ECB(7,13))),new Version(16,[6,26,50,74],new ECBlocks(24,new ECB(5,98),new ECB(1,99)),new ECBlocks(28,new ECB(7,45),new ECB(3,46)),new ECBlocks(24,new ECB(15,19),new ECB(2,20)),new ECBlocks(30,new ECB(3,15),new ECB(13,16))),new Version(17,[6,30,54,78],new ECBlocks(28,new ECB(1,107),new ECB(5,108)),new ECBlocks(28,new ECB(10,46),new ECB(1,47)),new ECBlocks(28,new ECB(1,22),new ECB(15,23)),new ECBlocks(28,new ECB(2,14),new ECB(17,15))),new Version(18,[6,30,56,82],new ECBlocks(30,new ECB(5,120),new ECB(1,121)),new ECBlocks(26,new ECB(9,43),new ECB(4,44)),new ECBlocks(28,new ECB(17,22),new ECB(1,23)),new ECBlocks(28,new ECB(2,14),new ECB(19,15))),new Version(19,[6,30,58,86],new ECBlocks(28,new ECB(3,113),new ECB(4,114)),new ECBlocks(26,new ECB(3,44),new ECB(11,45)),new ECBlocks(26,new ECB(17,21),new ECB(4,22)),new ECBlocks(26,new ECB(9,13),new ECB(16,14))),new Version(20,[6,34,62,90],new ECBlocks(28,new ECB(3,107),new ECB(5,108)),new ECBlocks(26,new ECB(3,41),new ECB(13,42)),new ECBlocks(30,new ECB(15,24),new ECB(5,25)),new ECBlocks(28,new ECB(15,15),new ECB(10,16))),new Version(21,[6,28,50,72,94],new ECBlocks(28,new ECB(4,116),new ECB(4,117)),new ECBlocks(26,new ECB(17,42)),new ECBlocks(28,new ECB(17,22),new ECB(6,23)),new ECBlocks(30,new ECB(19,16),new ECB(6,17))),new Version(22,[6,26,50,74,98],new ECBlocks(28,new ECB(2,111),new ECB(7,112)),new ECBlocks(28,new ECB(17,46)),new ECBlocks(30,new ECB(7,24),new ECB(16,25)),new ECBlocks(24,new ECB(34,13))),new Version(23,[6,30,54,74,102],new ECBlocks(30,new ECB(4,121),new ECB(5,122)),new ECBlocks(28,new ECB(4,47),new ECB(14,48)),new ECBlocks(30,new ECB(11,24),new ECB(14,25)),new ECBlocks(30,new ECB(16,15),new ECB(14,16))),new Version(24,[6,28,54,80,106],new ECBlocks(30,new ECB(6,117),new ECB(4,118)),new ECBlocks(28,new ECB(6,45),new ECB(14,46)),new ECBlocks(30,new ECB(11,24),new ECB(16,25)),new ECBlocks(30,new ECB(30,16),new ECB(2,17))),new Version(25,[6,32,58,84,110],new ECBlocks(26,new ECB(8,106),new ECB(4,107)),new ECBlocks(28,new ECB(8,47),new ECB(13,48)),new ECBlocks(30,new ECB(7,24),new ECB(22,25)),new ECBlocks(30,new ECB(22,15),new ECB(13,16))),new Version(26,[6,30,58,86,114],new ECBlocks(28,new ECB(10,114),new ECB(2,115)),new ECBlocks(28,new ECB(19,46),new ECB(4,47)),new ECBlocks(28,new ECB(28,22),new ECB(6,23)),new ECBlocks(30,new ECB(33,16),new ECB(4,17))),new Version(27,[6,34,62,90,118],new ECBlocks(30,new ECB(8,122),new ECB(4,123)),new ECBlocks(28,new ECB(22,45),new ECB(3,46)),new ECBlocks(30,new ECB(8,23),new ECB(26,24)),new ECBlocks(30,new ECB(12,15),new ECB(28,16))),new Version(28,[6,26,50,74,98,122],new ECBlocks(30,new ECB(3,117),new ECB(10,118)),new ECBlocks(28,new ECB(3,45),new ECB(23,46)),new ECBlocks(30,new ECB(4,24),new ECB(31,25)),new ECBlocks(30,new ECB(11,15),new ECB(31,16))),new Version(29,[6,30,54,78,102,126],new ECBlocks(30,new ECB(7,116),new ECB(7,117)),new ECBlocks(28,new ECB(21,45),new ECB(7,46)),new ECBlocks(30,new ECB(1,23),new ECB(37,24)),new ECBlocks(30,new ECB(19,15),new ECB(26,16))),new Version(30,[6,26,52,78,104,130],new ECBlocks(30,new ECB(5,115),new ECB(10,116)),new ECBlocks(28,new ECB(19,47),new ECB(10,48)),new ECBlocks(30,new ECB(15,24),new ECB(25,25)),new ECBlocks(30,new ECB(23,15),new ECB(25,16))),new Version(31,[6,30,56,82,108,134],new ECBlocks(30,new ECB(13,115),new ECB(3,116)),new ECBlocks(28,new ECB(2,46),new ECB(29,47)),new ECBlocks(30,new ECB(42,24),new ECB(1,25)),new ECBlocks(30,new ECB(23,15),new ECB(28,16))),new Version(32,[6,34,60,86,112,138],new ECBlocks(30,new ECB(17,115)),new ECBlocks(28,new ECB(10,46),new ECB(23,47)),new ECBlocks(30,new ECB(10,24),new ECB(35,25)),new ECBlocks(30,new ECB(19,15),new ECB(35,16))),new Version(33,[6,30,58,86,114,142],new ECBlocks(30,new ECB(17,115),new ECB(1,116)),new ECBlocks(28,new ECB(14,46),new ECB(21,47)),new ECBlocks(30,new ECB(29,24),new ECB(19,25)),new ECBlocks(30,new ECB(11,15),new ECB(46,16))),new Version(34,[6,34,62,90,118,146],new ECBlocks(30,new ECB(13,115),new ECB(6,116)),new ECBlocks(28,new ECB(14,46),new ECB(23,47)),new ECBlocks(30,new ECB(44,24),new ECB(7,25)),new ECBlocks(30,new ECB(59,16),new ECB(1,17))),new Version(35,[6,30,54,78,102,126,150],new ECBlocks(30,new ECB(12,121),new ECB(7,122)),new ECBlocks(28,new ECB(12,47),new ECB(26,48)),new ECBlocks(30,new ECB(39,24),new ECB(14,25)),new ECBlocks(30,new ECB(22,15),new ECB(41,16))),new Version(36,[6,24,50,76,102,128,154],new ECBlocks(30,new ECB(6,121),new ECB(14,122)),new ECBlocks(28,new ECB(6,47),new ECB(34,48)),new ECBlocks(30,new ECB(46,24),new ECB(10,25)),new ECBlocks(30,new ECB(2,15),new ECB(64,16))),new Version(37,[6,28,54,80,106,132,158],new ECBlocks(30,new ECB(17,122),new ECB(4,123)),new ECBlocks(28,new ECB(29,46),new ECB(14,47)),new ECBlocks(30,new ECB(49,24),new ECB(10,25)),new ECBlocks(30,new ECB(24,15),new ECB(46,16))),new Version(38,[6,32,58,84,110,136,162],new ECBlocks(30,new ECB(4,122),new ECB(18,123)),new ECBlocks(28,new ECB(13,46),new ECB(32,47)),new ECBlocks(30,new ECB(48,24),new ECB(14,25)),new ECBlocks(30,new ECB(42,15),new ECB(32,16))),new Version(39,[6,26,54,82,110,138,166],new ECBlocks(30,new ECB(20,117),new ECB(4,118)),new ECBlocks(28,new ECB(40,47),new ECB(7,48)),new ECBlocks(30,new ECB(43,24),new ECB(22,25)),new ECBlocks(30,new ECB(10,15),new ECB(67,16))),new Version(40,[6,30,58,86,114,142,170],new ECBlocks(30,new ECB(19,118),new ECB(6,119)),new ECBlocks(28,new ECB(18,47),new ECB(31,48)),new ECBlocks(30,new ECB(34,24),new ECB(34,25)),new ECBlocks(30,new ECB(20,15),new ECB(61,16)))]}function PerspectiveTransform(e,t,n,i,r,o,s,a,h){this.a11=e,this.a12=i,this.a13=s,this.a21=t,this.a22=r,this.a23=a,this.a31=n,this.a32=o,this.a33=h,this.transformPoints1=function(e){for(var t=e.length,n=this.a11,i=this.a12,r=this.a13,o=this.a21,s=this.a22,a=this.a23,h=this.a31,c=this.a32,l=this.a33,f=0;t>f;f+=2){var d=e[f],w=e[f+1],u=r*d+a*w+l;e[f]=(n*d+o*w+h)/u,e[f+1]=(i*d+s*w+c)/u}},this.transformPoints2=function(e,t){for(var n=e.length,i=0;n>i;i++){var r=e[i],o=t[i],s=this.a13*r+this.a23*o+this.a33;e[i]=(this.a11*r+this.a21*o+this.a31)/s,t[i]=(this.a12*r+this.a22*o+this.a32)/s}},this.buildAdjoint=function(){return new PerspectiveTransform(this.a22*this.a33-this.a23*this.a32,this.a23*this.a31-this.a21*this.a33,this.a21*this.a32-this.a22*this.a31,this.a13*this.a32-this.a12*this.a33,this.a11*this.a33-this.a13*this.a31,this.a12*this.a31-this.a11*this.a32,this.a12*this.a23-this.a13*this.a22,this.a13*this.a21-this.a11*this.a23,this.a11*this.a22-this.a12*this.a21)},this.times=function(e){return new PerspectiveTransform(this.a11*e.a11+this.a21*e.a12+this.a31*e.a13,this.a11*e.a21+this.a21*e.a22+this.a31*e.a23,this.a11*e.a31+this.a21*e.a32+this.a31*e.a33,this.a12*e.a11+this.a22*e.a12+this.a32*e.a13,this.a12*e.a21+this.a22*e.a22+this.a32*e.a23,this.a12*e.a31+this.a22*e.a32+this.a32*e.a33,this.a13*e.a11+this.a23*e.a12+this.a33*e.a13,this.a13*e.a21+this.a23*e.a22+this.a33*e.a23,this.a13*e.a31+this.a23*e.a32+this.a33*e.a33)}}function DetectorResult(e,t){this.bits=e,this.points=t}function Detector(e){this.image=e,this.resultPointCallback=null,this.sizeOfBlackWhiteBlackRun=function(e,t,n,i){var r=Math.abs(i-t)>Math.abs(n-e);if(r){var o=e;e=t,t=o,o=n,n=i,i=o}for(var s=Math.abs(n-e),a=Math.abs(i-t),h=-s>>1,c=i>t?1:-1,l=n>e?1:-1,f=0,d=e,o=t;d!=n;d+=l){var w=r?o:d,u=r?d:o;if(1==f?this.image[w+u*qrcode.width]&&f++:this.image[w+u*qrcode.width]||f++,3==f)return i=d-e,t=o-t,Math.sqrt(i*i+t*t);if(h+=a,h>0){if(o==i)break;o+=c,h-=s}}return e=n-e,t=i-t,Math.sqrt(e*e+t*t)},this.sizeOfBlackWhiteBlackRunBothWays=function(e,t,n,i){var r=this.sizeOfBlackWhiteBlackRun(e,t,n,i),o=1;return n=e-(n-e),0>n?(o=e/(e-n),n=0):n>=qrcode.width&&(o=(qrcode.width-1-e)/(n-e),n=qrcode.width-1),i=Math.floor(t-(i-t)*o),o=1,0>i?(o=t/(t-i),i=0):i>=qrcode.height&&(o=(qrcode.height-1-t)/(i-t),i=qrcode.height-1),n=Math.floor(e+(n-e)*o),r+=this.sizeOfBlackWhiteBlackRun(e,t,n,i),r-1},this.calculateModuleSizeOneWay=function(e,t){var n=this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(e.X),Math.floor(e.Y),Math.floor(t.X),Math.floor(t.Y)),i=this.sizeOfBlackWhiteBlackRunBothWays(Math.floor(t.X),Math.floor(t.Y),Math.floor(e.X),Math.floor(e.Y));return isNaN(n)?i/7:isNaN(i)?n/7:(n+i)/14},this.calculateModuleSize=function(e,t,n){return(this.calculateModuleSizeOneWay(e,t)+this.calculateModuleSizeOneWay(e,n))/2},this.distance=function(e,t){return xDiff=e.X-t.X,yDiff=e.Y-t.Y,Math.sqrt(xDiff*xDiff+yDiff*yDiff)},this.computeDimension=function(e,t,n,i){switch(t=Math.round(this.distance(e,t)/i),e=Math.round(this.distance(e,n)/i),e=(t+e>>1)+7,3&e){case 0:e++;break;case 2:e--;break;case 3:throw"Error"}return e},this.findAlignmentInRegion=function(e,t,n,i){var r=Math.floor(i*e);if(i=Math.max(0,t-r),t=Math.min(qrcode.width-1,t+r),3*e>t-i)throw"Error";var o=Math.max(0,n-r);return n=Math.min(qrcode.height-1,n+r),new AlignmentPatternFinder(this.image,i,o,t-i,n-o,e,this.resultPointCallback).find()},this.createTransform=function(e,t,n,i,r){r-=3.5;var o,s,a;return null!=i?(o=i.X,i=i.Y,s=a=r-3):(o=t.X-e.X+n.X,i=t.Y-e.Y+n.Y,s=a=r),PerspectiveTransform.quadrilateralToQuadrilateral(3.5,3.5,r,3.5,s,a,3.5,r,e.X,e.Y,t.X,t.Y,o,i,n.X,n.Y)},this.sampleGrid=function(e,t,n){return GridSampler.sampleGrid3(e,n,t)},this.processFinderPatternInfo=function(e){var t=e.TopLeft,n=e.TopRight;e=e.BottomLeft;var i=this.calculateModuleSize(t,n,e);if(1>i)throw"Error";var r=this.computeDimension(t,n,e,i),o=Version.getProvisionalVersionForDimension(r),s=o.DimensionForVersion-7,a=null;if(0<o.AlignmentPatternCenters.length)for(s=1-3/s,o=Math.floor(t.X+s*(n.X-t.X+e.X-t.X)),s=Math.floor(t.Y+s*(n.Y-t.Y+e.Y-t.Y));;){a=this.findAlignmentInRegion(i,o,s,4);break}return i=this.createTransform(t,n,e,a,r),r=this.sampleGrid(this.image,i,r),new DetectorResult(r,null==a?[e,t,n]:[e,t,n,a])},this.detect=function(){var e=(new FinderPatternFinder).findFinderPattern(this.image);return this.processFinderPatternInfo(e)}}function FormatInformation(e){this.errorCorrectionLevel=ErrorCorrectionLevel.forBits(e>>3&3),this.dataMask=7&e,this.__defineGetter__("ErrorCorrectionLevel",function(){return this.errorCorrectionLevel}),this.__defineGetter__("DataMask",function(){return this.dataMask}),this.GetHashCode=function(){return this.errorCorrectionLevel.ordinal()<<3|dataMask},this.Equals=function(e){return this.errorCorrectionLevel==e.errorCorrectionLevel&&this.dataMask==e.dataMask}}function ErrorCorrectionLevel(e,t,n){this.ordinal_Renamed_Field=e,this.bits=t,this.name=n,this.__defineGetter__("Bits",function(){return this.bits}),this.__defineGetter__("Name",function(){return this.name}),this.ordinal=function(){return this.ordinal_Renamed_Field}}function BitMatrix(e,t){if(t||(t=e),1>e||1>t)throw"Both dimensions must be greater than 0";this.width=e,this.height=t;var n=e>>5;for(0!=(31&e)&&n++,this.rowSize=n,this.bits=Array(n*t),n=0;n<this.bits.length;n++)this.bits[n]=0;this.__defineGetter__("Width",function(){return this.width}),this.__defineGetter__("Height",function(){return this.height}),this.__defineGetter__("Dimension",function(){if(this.width!=this.height)throw"Can't call getDimension() on a non-square matrix";return this.width}),this.get_Renamed=function(e,t){return 0!=(1&URShift(this.bits[t*this.rowSize+(e>>5)],31&e))},this.set_Renamed=function(e,t){this.bits[t*this.rowSize+(e>>5)]|=1<<(31&e)},this.flip=function(e,t){this.bits[t*this.rowSize+(e>>5)]^=1<<(31&e)},this.clear=function(){for(var e=this.bits.length,t=0;e>t;t++)this.bits[t]=0},this.setRegion=function(e,t,n,i){if(0>t||0>e)throw"Left and top must be nonnegative";if(1>i||1>n)throw"Height and width must be at least 1";if(n=e+n,i=t+i,i>this.height||n>this.width)throw"The region must fit inside the matrix";for(;i>t;t++)for(var r=t*this.rowSize,o=e;n>o;o++)this.bits[r+(o>>5)]|=1<<(31&o)}}function DataBlock(e,t){this.numDataCodewords=e,this.codewords=t,this.__defineGetter__("NumDataCodewords",function(){return this.numDataCodewords}),this.__defineGetter__("Codewords",function(){return this.codewords})}function BitMatrixParser(e){var t=e.Dimension;if(21>t||1!=(3&t))throw"Error BitMatrixParser";this.bitMatrix=e,this.parsedFormatInfo=this.parsedVersion=null,this.copyBit=function(e,t,n){return this.bitMatrix.get_Renamed(e,t)?n<<1|1:n<<1},this.readFormatInformation=function(){if(null!=this.parsedFormatInfo)return this.parsedFormatInfo;for(var e=0,t=0;6>t;t++)e=this.copyBit(t,8,e);for(e=this.copyBit(7,8,e),e=this.copyBit(8,8,e),e=this.copyBit(8,7,e),t=5;t>=0;t--)e=this.copyBit(8,t,e);if(this.parsedFormatInfo=FormatInformation.decodeFormatInformation(e),null!=this.parsedFormatInfo)return this.parsedFormatInfo;for(var n=this.bitMatrix.Dimension,e=0,i=n-8,t=n-1;t>=i;t--)e=this.copyBit(t,8,e);for(t=n-7;n>t;t++)e=this.copyBit(8,t,e);if(this.parsedFormatInfo=FormatInformation.decodeFormatInformation(e),null!=this.parsedFormatInfo)return this.parsedFormatInfo;throw"Error readFormatInformation"},this.readVersion=function(){if(null!=this.parsedVersion)return this.parsedVersion;var e=this.bitMatrix.Dimension,t=e-17>>2;if(6>=t)return Version.getVersionForNumber(t);for(var t=0,n=e-11,i=5;i>=0;i--)for(var r=e-9;r>=n;r--)t=this.copyBit(r,i,t);if(this.parsedVersion=Version.decodeVersionInformation(t),null!=this.parsedVersion&&this.parsedVersion.DimensionForVersion==e)return this.parsedVersion;for(t=0,r=5;r>=0;r--)for(i=e-9;i>=n;i--)t=this.copyBit(r,i,t);if(this.parsedVersion=Version.decodeVersionInformation(t),null!=this.parsedVersion&&this.parsedVersion.DimensionForVersion==e)return this.parsedVersion;throw"Error readVersion"},this.readCodewords=function(){var e=this.readFormatInformation(),t=this.readVersion(),n=DataMask.forReference(e.DataMask),e=this.bitMatrix.Dimension;n.unmaskBitMatrix(this.bitMatrix,e);for(var n=t.buildFunctionPattern(),i=!0,r=Array(t.TotalCodewords),o=0,s=0,a=0,h=e-1;h>0;h-=2){6==h&&h--;for(var c=0;e>c;c++)for(var l=i?e-1-c:c,f=0;2>f;f++)n.get_Renamed(h-f,l)||(a++,s<<=1,this.bitMatrix.get_Renamed(h-f,l)&&(s|=1),8==a&&(r[o++]=s,s=a=0));i^=1}if(o!=t.TotalCodewords)throw"Error readCodewords";return r}}function DataMask000(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){return 0==(e+t&1)}}function DataMask001(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e){return 0==(1&e)}}function DataMask010(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){return 0==t%3}}function DataMask011(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){return 0==(e+t)%3}}function DataMask100(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){return 0==(URShift(e,1)+t/3&1)}}function DataMask101(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){var n=e*t;return 0==(1&n)+n%3}}function DataMask110(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){var n=e*t;return 0==((1&n)+n%3&1)}}function DataMask111(){this.unmaskBitMatrix=function(e,t){for(var n=0;t>n;n++)for(var i=0;t>i;i++)this.isMasked(n,i)&&e.flip(i,n)},this.isMasked=function(e,t){return 0==((e+t&1)+e*t%3&1)}}function ReedSolomonDecoder(e){this.field=e,this.decode=function(e,t){for(var n=new GF256Poly(this.field,e),i=Array(t),r=0;r<i.length;r++)i[r]=0;for(var o=!0,r=0;t>r;r++){var s=n.evaluateAt(this.field.exp(r));i[i.length-1-r]=s,0!=s&&(o=!1)}if(!o)for(r=new GF256Poly(this.field,i),n=this.runEuclideanAlgorithm(this.field.buildMonomial(t,1),r,t),r=n[1],n=this.findErrorLocations(n[0]),i=this.findErrorMagnitudes(r,n,!1),r=0;r<n.length;r++){if(o=e.length-1-this.field.log(n[r]),0>o)throw"ReedSolomonException Bad error location";e[o]=GF256.addOrSubtract(e[o],i[r])}},this.runEuclideanAlgorithm=function(e,t,n){if(e.Degree<t.Degree){var i=e;e=t,t=i}for(var i=this.field.One,r=this.field.Zero,o=this.field.Zero,s=this.field.One;t.Degree>=Math.floor(n/2);){var a=e,h=i,c=o;if(e=t,i=r,o=s,e.Zero)throw"r_{i-1} was zero";for(t=a,s=this.field.Zero,r=e.getCoefficient(e.Degree),r=this.field.inverse(r);t.Degree>=e.Degree&&!t.Zero;){var a=t.Degree-e.Degree,l=this.field.multiply(t.getCoefficient(t.Degree),r),s=s.addOrSubtract(this.field.buildMonomial(a,l));t=t.addOrSubtract(e.multiplyByMonomial(a,l))}r=s.multiply1(i).addOrSubtract(h),s=s.multiply1(o).addOrSubtract(c)}if(n=s.getCoefficient(0),0==n)throw"ReedSolomonException sigmaTilde(0) was zero";return n=this.field.inverse(n),e=s.multiply2(n),n=t.multiply2(n),[e,n]},this.findErrorLocations=function(e){var t=e.Degree;if(1==t)return Array(e.getCoefficient(1));for(var n=Array(t),i=0,r=1;256>r&&t>i;r++)0==e.evaluateAt(r)&&(n[i]=this.field.inverse(r),i++);if(i!=t)throw"Error locator degree does not match number of roots";return n},this.findErrorMagnitudes=function(e,t,n){for(var i=t.length,r=Array(i),o=0;i>o;o++){for(var s=this.field.inverse(t[o]),a=1,h=0;i>h;h++)o!=h&&(a=this.field.multiply(a,GF256.addOrSubtract(1,this.field.multiply(t[h],s))));r[o]=this.field.multiply(e.evaluateAt(s),this.field.inverse(a)),n&&(r[o]=this.field.multiply(r[o],s))}return r}}function GF256Poly(e,t){if(null==t||0==t.length)throw"System.ArgumentException";this.field=e;var n=t.length;if(n>1&&0==t[0]){for(var i=1;n>i&&0==t[i];)i++;if(i==n)this.coefficients=e.Zero.coefficients;else{for(this.coefficients=Array(n-i),n=0;n<this.coefficients.length;n++)this.coefficients[n]=0;for(n=0;n<this.coefficients.length;n++)this.coefficients[n]=t[i+n]}}else this.coefficients=t;this.__defineGetter__("Zero",function(){return 0==this.coefficients[0]}),this.__defineGetter__("Degree",function(){return this.coefficients.length-1}),this.__defineGetter__("Coefficients",function(){return this.coefficients}),this.getCoefficient=function(e){return this.coefficients[this.coefficients.length-1-e]},this.evaluateAt=function(e){if(0==e)return this.getCoefficient(0);var t=this.coefficients.length;if(1==e){for(var n=e=0;t>n;n++)e=GF256.addOrSubtract(e,this.coefficients[n]);return e}for(var i=this.coefficients[0],n=1;t>n;n++)i=GF256.addOrSubtract(this.field.multiply(e,i),this.coefficients[n]);return i},this.addOrSubtract=function(t){if(this.field!=t.field)throw"GF256Polys do not have same GF256 field";if(this.Zero)return t;if(t.Zero)return this;var n=this.coefficients;if(t=t.coefficients,n.length>t.length){var i=n,n=t;t=i}for(var i=Array(t.length),r=t.length-n.length,o=0;r>o;o++)i[o]=t[o];for(o=r;o<t.length;o++)i[o]=GF256.addOrSubtract(n[o-r],t[o]);return new GF256Poly(e,i)},this.multiply1=function(e){if(this.field!=e.field)throw"GF256Polys do not have same GF256 field";if(this.Zero||e.Zero)return this.field.Zero;var t=this.coefficients,n=t.length;e=e.coefficients;for(var i=e.length,r=Array(n+i-1),o=0;n>o;o++)for(var s=t[o],a=0;i>a;a++)r[o+a]=GF256.addOrSubtract(r[o+a],this.field.multiply(s,e[a]));return new GF256Poly(this.field,r)},this.multiply2=function(e){if(0==e)return this.field.Zero;if(1==e)return this;for(var t=this.coefficients.length,n=Array(t),i=0;t>i;i++)n[i]=this.field.multiply(this.coefficients[i],e);return new GF256Poly(this.field,n)},this.multiplyByMonomial=function(e,t){if(0>e)throw"System.ArgumentException";if(0==t)return this.field.Zero;for(var n=this.coefficients.length,i=Array(n+e),r=0;r<i.length;r++)i[r]=0;for(r=0;n>r;r++)i[r]=this.field.multiply(this.coefficients[r],t);return new GF256Poly(this.field,i)},this.divide=function(e){if(this.field!=e.field)throw"GF256Polys do not have same GF256 field";if(e.Zero)throw"Divide by 0";for(var t=this.field.Zero,n=this,i=e.getCoefficient(e.Degree),i=this.field.inverse(i);n.Degree>=e.Degree&&!n.Zero;)var r=n.Degree-e.Degree,o=this.field.multiply(n.getCoefficient(n.Degree),i),s=e.multiplyByMonomial(r,o),r=this.field.buildMonomial(r,o),t=t.addOrSubtract(r),n=n.addOrSubtract(s);return[t,n]}}function GF256(e){this.expTable=Array(256),this.logTable=Array(256);for(var t=1,n=0;256>n;n++)this.expTable[n]=t,t<<=1,t>=256&&(t^=e);for(n=0;255>n;n++)this.logTable[this.expTable[n]]=n;e=Array(1),e[0]=0,this.zero=new GF256Poly(this,Array(e)),e=Array(1),e[0]=1,this.one=new GF256Poly(this,Array(e)),this.__defineGetter__("Zero",function(){return this.zero}),this.__defineGetter__("One",function(){return this.one}),this.buildMonomial=function(e,t){if(0>e)throw"System.ArgumentException";if(0==t)return zero;for(var n=Array(e+1),i=0;i<n.length;i++)n[i]=0;return n[0]=t,new GF256Poly(this,n)},this.exp=function(e){return this.expTable[e]},this.log=function(e){if(0==e)throw"System.ArgumentException";return this.logTable[e]},this.inverse=function(e){if(0==e)throw"System.ArithmeticException";return this.expTable[255-this.logTable[e]]},this.multiply=function(e,t){return 0==e||0==t?0:1==e?t:1==t?e:this.expTable[(this.logTable[e]+this.logTable[t])%255]}}function URShift(e,t){return e>=0?e>>t:(e>>t)+(2<<~t)}function FinderPattern(e,t,n){this.x=e,this.y=t,this.count=1,this.estimatedModuleSize=n,this.__defineGetter__("EstimatedModuleSize",function(){return this.estimatedModuleSize}),this.__defineGetter__("Count",function(){return this.count}),this.__defineGetter__("X",function(){return this.x}),this.__defineGetter__("Y",function(){return this.y}),this.incrementCount=function(){this.count++},this.aboutEquals=function(e,t,n){return Math.abs(t-this.y)<=e&&Math.abs(n-this.x)<=e?(e=Math.abs(e-this.estimatedModuleSize),1>=e||1>=e/this.estimatedModuleSize):!1}}function FinderPatternInfo(e){this.bottomLeft=e[0],this.topLeft=e[1],this.topRight=e[2],this.__defineGetter__("BottomLeft",function(){return this.bottomLeft}),this.__defineGetter__("TopLeft",function(){return this.topLeft}),this.__defineGetter__("TopRight",function(){return this.topRight})}function FinderPatternFinder(){this.image=null,this.possibleCenters=[],this.hasSkipped=!1,this.crossCheckStateCount=[0,0,0,0,0],this.resultPointCallback=null,this.__defineGetter__("CrossCheckStateCount",function(){return this.crossCheckStateCount[0]=0,this.crossCheckStateCount[1]=0,this.crossCheckStateCount[2]=0,this.crossCheckStateCount[3]=0,this.crossCheckStateCount[4]=0,this.crossCheckStateCount}),this.foundPatternCross=function(e){for(var t=0,n=0;5>n;n++){var i=e[n];if(0==i)return!1;t+=i}return 7>t?!1:(t=Math.floor((t<<INTEGER_MATH_SHIFT)/7),n=Math.floor(t/2),Math.abs(t-(e[0]<<INTEGER_MATH_SHIFT))<n&&Math.abs(t-(e[1]<<INTEGER_MATH_SHIFT))<n&&Math.abs(3*t-(e[2]<<INTEGER_MATH_SHIFT))<3*n&&Math.abs(t-(e[3]<<INTEGER_MATH_SHIFT))<n&&Math.abs(t-(e[4]<<INTEGER_MATH_SHIFT))<n)},this.centerFromEnd=function(e,t){return t-e[4]-e[3]-e[2]/2},this.crossCheckVertical=function(e,t,n,i){for(var r=this.image,o=qrcode.height,s=this.CrossCheckStateCount,a=e;a>=0&&r[t+a*qrcode.width];)s[2]++,a--;if(0>a)return 0/0;for(;a>=0&&!r[t+a*qrcode.width]&&s[1]<=n;)s[1]++,a--;if(0>a||s[1]>n)return 0/0;for(;a>=0&&r[t+a*qrcode.width]&&s[0]<=n;)s[0]++,a--;if(s[0]>n)return 0/0;for(a=e+1;o>a&&r[t+a*qrcode.width];)s[2]++,a++;if(a==o)return 0/0;for(;o>a&&!r[t+a*qrcode.width]&&s[3]<n;)s[3]++,a++;if(a==o||s[3]>=n)return 0/0;for(;o>a&&r[t+a*qrcode.width]&&s[4]<n;)s[4]++,a++;return s[4]>=n||5*Math.abs(s[0]+s[1]+s[2]+s[3]+s[4]-i)>=2*i?0/0:this.foundPatternCross(s)?this.centerFromEnd(s,a):0/0},this.crossCheckHorizontal=function(e,t,n,i){for(var r=this.image,o=qrcode.width,s=this.CrossCheckStateCount,a=e;a>=0&&r[a+t*qrcode.width];)s[2]++,a--;if(0>a)return 0/0;for(;a>=0&&!r[a+t*qrcode.width]&&s[1]<=n;)s[1]++,a--;if(0>a||s[1]>n)return 0/0;for(;a>=0&&r[a+t*qrcode.width]&&s[0]<=n;)s[0]++,a--;if(s[0]>n)return 0/0;for(a=e+1;o>a&&r[a+t*qrcode.width];)s[2]++,a++;if(a==o)return 0/0;for(;o>a&&!r[a+t*qrcode.width]&&s[3]<n;)s[3]++,a++;if(a==o||s[3]>=n)return 0/0;for(;o>a&&r[a+t*qrcode.width]&&s[4]<n;)s[4]++,a++;return s[4]>=n||5*Math.abs(s[0]+s[1]+s[2]+s[3]+s[4]-i)>=i?0/0:this.foundPatternCross(s)?this.centerFromEnd(s,a):0/0},this.handlePossibleCenter=function(e,t,n){var i=e[0]+e[1]+e[2]+e[3]+e[4];if(n=this.centerFromEnd(e,n),t=this.crossCheckVertical(t,Math.floor(n),e[2],i),!isNaN(t)&&(n=this.crossCheckHorizontal(Math.floor(n),Math.floor(t),e[2],i),!isNaN(n))){e=i/7;for(var i=!1,r=this.possibleCenters.length,o=0;r>o;o++){var s=this.possibleCenters[o];if(s.aboutEquals(e,t,n)){s.incrementCount(),i=!0;break}}return i||(n=new FinderPattern(n,t,e),this.possibleCenters.push(n),null!=this.resultPointCallback&&this.resultPointCallback.foundPossibleResultPoint(n)),!0}return!1},this.selectBestPatterns=function(){var e=this.possibleCenters.length;if(3>e)throw"Couldn't find enough finder patterns";if(e>3){for(var t=0,n=0;e>n;n++)t+=this.possibleCenters[n].EstimatedModuleSize;for(e=t/e,n=0;n<this.possibleCenters.length&&3<this.possibleCenters.length;n++)Math.abs(this.possibleCenters[n].EstimatedModuleSize-e)>.2*e&&(this.possibleCenters.remove(n),n--)}return[this.possibleCenters[0],this.possibleCenters[1],this.possibleCenters[2]]},this.findRowSkip=function(){var e=this.possibleCenters.length;if(1>=e)return 0;for(var t=null,n=0;e>n;n++){var i=this.possibleCenters[n];if(i.Count>=CENTER_QUORUM){if(null!=t)return this.hasSkipped=!0,Math.floor((Math.abs(t.X-i.X)-Math.abs(t.Y-i.Y))/2);t=i}}return 0},this.haveMultiplyConfirmedCenters=function(){for(var e=0,t=0,n=this.possibleCenters.length,i=0;n>i;i++){var r=this.possibleCenters[i];r.Count>=CENTER_QUORUM&&(e++,t+=r.EstimatedModuleSize)}if(3>e)return!1;for(var e=t/n,o=0,i=0;n>i;i++)r=this.possibleCenters[i],o+=Math.abs(r.EstimatedModuleSize-e);return.05*t>=o},this.findFinderPattern=function(e){this.image=e;var t=qrcode.height,n=qrcode.width,i=Math.floor(3*t/(4*MAX_MODULES));MIN_SKIP>i&&(i=MIN_SKIP);for(var r=!1,o=Array(5),s=i-1;t>s&&!r;s+=i){o[0]=0,o[1]=0,o[2]=0,o[3]=0;for(var a=o[4]=0,h=0;n>h;h++)if(e[h+s*qrcode.width])1==(1&a)&&a++,o[a]++;else if(0==(1&a))if(4==a)if(this.foundPatternCross(o)){if(a=this.handlePossibleCenter(o,s,h))i=2,this.hasSkipped?r=this.haveMultiplyConfirmedCenters():(a=this.findRowSkip(),a>o[2]&&(s+=a-o[2]-i,h=n-1));else{do h++;while(n>h&&!e[h+s*qrcode.width]);h--}a=0,o[0]=0,o[1]=0,o[2]=0,o[3]=0,o[4]=0}else o[0]=o[2],o[1]=o[3],o[2]=o[4],o[3]=1,o[4]=0,a=3;else o[++a]++;else o[a]++;this.foundPatternCross(o)&&this.handlePossibleCenter(o,s,n)&&(i=o[0],this.hasSkipped&&(r=haveMultiplyConfirmedCenters()))}return e=this.selectBestPatterns(),qrcode.orderBestPatterns(e),new FinderPatternInfo(e)}}function AlignmentPattern(e,t,n){this.x=e,this.y=t,this.count=1,this.estimatedModuleSize=n,this.__defineGetter__("EstimatedModuleSize",function(){return this.estimatedModuleSize}),this.__defineGetter__("Count",function(){return this.count}),this.__defineGetter__("X",function(){return Math.floor(this.x)}),this.__defineGetter__("Y",function(){return Math.floor(this.y)}),this.incrementCount=function(){this.count++},this.aboutEquals=function(e,t,n){return Math.abs(t-this.y)<=e&&Math.abs(n-this.x)<=e?(e=Math.abs(e-this.estimatedModuleSize),1>=e||1>=e/this.estimatedModuleSize):!1}}function AlignmentPatternFinder(e,t,n,i,r,o,s){this.image=e,this.possibleCenters=[],this.startX=t,this.startY=n,this.width=i,this.height=r,this.moduleSize=o,this.crossCheckStateCount=[0,0,0],this.resultPointCallback=s,this.centerFromEnd=function(e,t){return t-e[2]-e[1]/2},this.foundPatternCross=function(e){for(var t=this.moduleSize,n=t/2,i=0;3>i;i++)if(Math.abs(t-e[i])>=n)return!1;return!0},this.crossCheckVertical=function(e,t,n,i){var r=this.image,o=qrcode.height,s=this.crossCheckStateCount;s[0]=0,s[1]=0,s[2]=0;for(var a=e;a>=0&&r[t+a*qrcode.width]&&s[1]<=n;)s[1]++,a--;if(0>a||s[1]>n)return 0/0;for(;a>=0&&!r[t+a*qrcode.width]&&s[0]<=n;)s[0]++,a--;if(s[0]>n)return 0/0;for(a=e+1;o>a&&r[t+a*qrcode.width]&&s[1]<=n;)s[1]++,a++;if(a==o||s[1]>n)return 0/0;for(;o>a&&!r[t+a*qrcode.width]&&s[2]<=n;)s[2]++,a++;return s[2]>n||5*Math.abs(s[0]+s[1]+s[2]-i)>=2*i?0/0:this.foundPatternCross(s)?this.centerFromEnd(s,a):0/0},this.handlePossibleCenter=function(e,t,n){var i=e[0]+e[1]+e[2];if(n=this.centerFromEnd(e,n),t=this.crossCheckVertical(t,Math.floor(n),2*e[1],i),!isNaN(t)){e=(e[0]+e[1]+e[2])/3;for(var i=this.possibleCenters.length,r=0;i>r;r++)if(this.possibleCenters[r].aboutEquals(e,t,n))return new AlignmentPattern(n,t,e);n=new AlignmentPattern(n,t,e),this.possibleCenters.push(n),null!=this.resultPointCallback&&this.resultPointCallback.foundPossibleResultPoint(n)}return null},this.find=function(){for(var t=this.startX,r=this.height,o=t+i,s=n+(r>>1),a=[0,0,0],h=0;r>h;h++){var c=s+(0==(1&h)?h+1>>1:-(h+1>>1));a[0]=0,a[1]=0,a[2]=0;for(var l=t;o>l&&!e[l+qrcode.width*c];)l++;for(var f=0;o>l;){if(e[l+c*qrcode.width])if(1==f)a[f]++;else if(2==f){if(this.foundPatternCross(a)&&(f=this.handlePossibleCenter(a,c,l),null!=f))return f;a[0]=a[2],a[1]=1,a[2]=0,f=1}else a[++f]++;else 1==f&&f++,a[f]++;l++}if(this.foundPatternCross(a)&&(f=this.handlePossibleCenter(a,c,o),null!=f))return f}if(0!=this.possibleCenters.length)return this.possibleCenters[0];throw"Couldn't find enough alignment patterns"}}function QRCodeDataBlockReader(e,t,n){this.blockPointer=0,this.bitPointer=7,this.dataLength=0,this.blocks=e,this.numErrorCorrectionCode=n,9>=t?this.dataLengthMode=0:t>=10&&26>=t?this.dataLengthMode=1:t>=27&&40>=t&&(this.dataLengthMode=2),this.getNextBits=function(e){var t=0;if(e<this.bitPointer+1){for(var n=0,t=0;e>t;t++)n+=1<<t;return n<<=this.bitPointer-e+1,t=(this.blocks[this.blockPointer]&n)>>this.bitPointer-e+1,this.bitPointer-=e,t}if(e<this.bitPointer+1+8){for(var i=0,t=0;t<this.bitPointer+1;t++)i+=1<<t;return t=(this.blocks[this.blockPointer]&i)<<e-(this.bitPointer+1),this.blockPointer++,t+=this.blocks[this.blockPointer]>>8-(e-(this.bitPointer+1)),this.bitPointer-=e%8,0>this.bitPointer&&(this.bitPointer=8+this.bitPointer),t}if(e<this.bitPointer+1+16){for(t=n=i=0;t<this.bitPointer+1;t++)i+=1<<t;i=(this.blocks[this.blockPointer]&i)<<e-(this.bitPointer+1),this.blockPointer++;var r=this.blocks[this.blockPointer]<<e-(this.bitPointer+1+8);for(this.blockPointer++,t=0;t<e-(this.bitPointer+1+8);t++)n+=1<<t;return n<<=8-(e-(this.bitPointer+1+8)),t=i+r+((this.blocks[this.blockPointer]&n)>>8-(e-(this.bitPointer+1+8))),this.bitPointer-=(e-8)%8,0>this.bitPointer&&(this.bitPointer=8+this.bitPointer),t}return 0},this.NextMode=function(){return this.blockPointer>this.blocks.length-this.numErrorCorrectionCode-2?0:this.getNextBits(4)},this.getDataLength=function(e){for(var t=0;1!=e>>t;)t++;return this.getNextBits(qrcode.sizeOfDataLengthInfo[this.dataLengthMode][t])},this.getRomanAndFigureString=function(e){var t=0,n="",i="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:".split("");do if(e>1){var t=this.getNextBits(11),r=t%45,n=n+i[Math.floor(t/45)],n=n+i[r];e-=2}else 1==e&&(t=this.getNextBits(6),n+=i[t],e-=1);while(e>0);return n},this.getFigureString=function(e){var t=0,n="";do e>=3?(t=this.getNextBits(10),100>t&&(n+="0"),10>t&&(n+="0"),e-=3):2==e?(t=this.getNextBits(7),10>t&&(n+="0"),e-=2):1==e&&(t=this.getNextBits(4),e-=1),n+=t;while(e>0);return n},this.get8bitByteArray=function(e){var t=0,n=[];do t=this.getNextBits(8),n.push(t),e--;while(e>0);return n},this.getKanjiString=function(e){var t=0,n="";do{var t=getNextBits(13),t=(t/192<<8)+t%192,i=0,i=40956>=t+33088?t+33088:t+49472,n=n+String.fromCharCode(i);e--}while(e>0);return n},this.__defineGetter__("DataByte",function(){for(var e=[];;){var t=this.NextMode();if(0==t){if(0<e.length)break;throw"Empty data block"}if(1!=t&&2!=t&&4!=t&&8!=t)throw"Invalid mode: "+t+" in (block:"+this.blockPointer+" bit:"+this.bitPointer+")";if(dataLength=this.getDataLength(t),1>dataLength)throw"Invalid data length: "+dataLength;switch(t){case 1:for(var t=this.getFigureString(dataLength),n=Array(t.length),i=0;i<t.length;i++)n[i]=t.charCodeAt(i);e.push(n);break;case 2:for(t=this.getRomanAndFigureString(dataLength),n=Array(t.length),i=0;i<t.length;i++)n[i]=t.charCodeAt(i);e.push(n);break;case 4:t=this.get8bitByteArray(dataLength),e.push(t);break;case 8:t=this.getKanjiString(dataLength),e.push(t)}}return e})}GridSampler={checkAndNudgePoints:function(e,t){for(var n=qrcode.width,i=qrcode.height,r=!0,o=0;o<t.Length&&r;o+=2){var s=Math.floor(t[o]),a=Math.floor(t[o+1]);if(-1>s||s>n||-1>a||a>i)throw"Error.checkAndNudgePoints ";r=!1,-1==s?(t[o]=0,r=!0):s==n&&(t[o]=n-1,r=!0),-1==a?(t[o+1]=0,r=!0):a==i&&(t[o+1]=i-1,r=!0)}for(r=!0,o=t.Length-2;o>=0&&r;o-=2){if(s=Math.floor(t[o]),a=Math.floor(t[o+1]),-1>s||s>n||-1>a||a>i)throw"Error.checkAndNudgePoints ";r=!1,-1==s?(t[o]=0,r=!0):s==n&&(t[o]=n-1,r=!0),-1==a?(t[o+1]=0,r=!0):a==i&&(t[o+1]=i-1,r=!0)}},sampleGrid3:function(e,t,n){for(var i=new BitMatrix(t),r=Array(t<<1),o=0;t>o;o++){for(var s=r.length,a=o+.5,h=0;s>h;h+=2)r[h]=(h>>1)+.5,r[h+1]=a;n.transformPoints1(r),GridSampler.checkAndNudgePoints(e,r);try{for(h=0;s>h;h+=2){var c=4*Math.floor(r[h])+4*Math.floor(r[h+1])*qrcode.width,l=e[Math.floor(r[h])+qrcode.width*Math.floor(r[h+1])];qrcode.imagedata.data[c]=l?255:0,qrcode.imagedata.data[c+1]=l?255:0,qrcode.imagedata.data[c+2]=0,qrcode.imagedata.data[c+3]=255,l&&i.set_Renamed(h>>1,o)}}catch(f){throw"Error.checkAndNudgePoints"}}return i},sampleGridx:function(e,t,n,i,r,o,s,a,h,c,l,f,d,w,u,C,E,B){return n=PerspectiveTransform.quadrilateralToQuadrilateral(n,i,r,o,s,a,h,c,l,f,d,w,u,C,E,B),GridSampler.sampleGrid3(e,t,n)}},Version.VERSION_DECODE_INFO=[31892,34236,39577,42195,48118,51042,55367,58893,63784,68472,70749,76311,79154,84390,87683,92361,96236,102084,102881,110507,110734,117786,119615,126325,127568,133589,136944,141498,145311,150283,152622,158308,161089,167017],Version.VERSIONS=buildVersions(),Version.getVersionForNumber=function(e){if(1>e||e>40)throw"ArgumentException";return Version.VERSIONS[e-1]},Version.getProvisionalVersionForDimension=function(e){if(1!=e%4)throw"Error getProvisionalVersionForDimension";try{return Version.getVersionForNumber(e-17>>2)}catch(t){throw"Error getVersionForNumber"}},Version.decodeVersionInformation=function(e){for(var t=4294967295,n=0,i=0;i<Version.VERSION_DECODE_INFO.length;i++){var r=Version.VERSION_DECODE_INFO[i];if(r==e)return this.getVersionForNumber(i+7);r=FormatInformation.numBitsDiffering(e,r),t>r&&(n=i+7,t=r)}return 3>=t?this.getVersionForNumber(n):null},PerspectiveTransform.quadrilateralToQuadrilateral=function(e,t,n,i,r,o,s,a,h,c,l,f,d,w,u,C){return e=this.quadrilateralToSquare(e,t,n,i,r,o,s,a),this.squareToQuadrilateral(h,c,l,f,d,w,u,C).times(e)},PerspectiveTransform.squareToQuadrilateral=function(e,t,n,i,r,o,s,a){return dy2=a-o,dy3=t-i+o-a,0==dy2&&0==dy3?new PerspectiveTransform(n-e,r-n,e,i-t,o-i,t,0,0,1):(dx1=n-r,dx2=s-r,dx3=e-n+r-s,dy1=i-o,denominator=dx1*dy2-dx2*dy1,a13=(dx3*dy2-dx2*dy3)/denominator,a23=(dx1*dy3-dx3*dy1)/denominator,new PerspectiveTransform(n-e+a13*n,s-e+a23*s,e,i-t+a13*i,a-t+a23*a,t,a13,a23,1))},PerspectiveTransform.quadrilateralToSquare=function(e,t,n,i,r,o,s,a){return this.squareToQuadrilateral(e,t,n,i,r,o,s,a).buildAdjoint()};var FORMAT_INFO_MASK_QR=21522,FORMAT_INFO_DECODE_LOOKUP=[[21522,0],[20773,1],[24188,2],[23371,3],[17913,4],[16590,5],[20375,6],[19104,7],[30660,8],[29427,9],[32170,10],[30877,11],[26159,12],[25368,13],[27713,14],[26998,15],[5769,16],[5054,17],[7399,18],[6608,19],[1890,20],[597,21],[3340,22],[2107,23],[13663,24],[12392,25],[16177,26],[14854,27],[9396,28],[8579,29],[11994,30],[11245,31]],BITS_SET_IN_HALF_BYTE=[0,1,1,2,1,2,2,3,1,2,2,3,2,3,3,4];FormatInformation.numBitsDiffering=function(e,t){return e^=t,BITS_SET_IN_HALF_BYTE[15&e]+BITS_SET_IN_HALF_BYTE[15&URShift(e,4)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,8)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,12)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,16)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,20)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,24)]+BITS_SET_IN_HALF_BYTE[15&URShift(e,28)]},FormatInformation.decodeFormatInformation=function(e){var t=FormatInformation.doDecodeFormatInformation(e);return null!=t?t:FormatInformation.doDecodeFormatInformation(e^FORMAT_INFO_MASK_QR)},FormatInformation.doDecodeFormatInformation=function(e){for(var t=4294967295,n=0,i=0;i<FORMAT_INFO_DECODE_LOOKUP.length;i++){var r=FORMAT_INFO_DECODE_LOOKUP[i],o=r[0];if(o==e)return new FormatInformation(r[1]);o=this.numBitsDiffering(e,o),t>o&&(n=r[1],t=o)}return 3>=t?new FormatInformation(n):null},ErrorCorrectionLevel.forBits=function(e){if(0>e||e>=FOR_BITS.Length)throw"ArgumentException";return FOR_BITS[e]};var L=new ErrorCorrectionLevel(0,1,"L"),M=new ErrorCorrectionLevel(1,0,"M"),Q=new ErrorCorrectionLevel(2,3,"Q"),H=new ErrorCorrectionLevel(3,2,"H"),FOR_BITS=[M,L,H,Q];DataBlock.getDataBlocks=function(e,t,n){if(e.length!=t.TotalCodewords)throw"ArgumentException";var i=t.getECBlocksForLevel(n);n=0;var r=i.getECBlocks();for(t=0;t<r.length;t++)n+=r[t].Count;n=Array(n);for(var o=0,s=0;s<r.length;s++){var a=r[s];for(t=0;t<a.Count;t++){var h=a.DataCodewords,c=i.ECCodewordsPerBlock+h;n[o++]=new DataBlock(h,Array(c))}}for(t=n[0].codewords.length,r=n.length-1;r>=0&&n[r].codewords.length!=t;)r--;for(r++,i=t-i.ECCodewordsPerBlock,t=a=0;i>t;t++)for(s=0;o>s;s++)n[s].codewords[t]=e[a++];for(s=r;o>s;s++)n[s].codewords[i]=e[a++];for(h=n[0].codewords.length,t=i;h>t;t++)for(s=0;o>s;s++)n[s].codewords[r>s?t:t+1]=e[a++];return n},DataMask={forReference:function(e){if(0>e||e>7)throw"System.ArgumentException";return DataMask.DATA_MASKS[e]}},DataMask.DATA_MASKS=[new DataMask000,new DataMask001,new DataMask010,new DataMask011,new DataMask100,new DataMask101,new DataMask110,new DataMask111],GF256.QR_CODE_FIELD=new GF256(285),GF256.DATA_MATRIX_FIELD=new GF256(301),GF256.addOrSubtract=function(e,t){return e^t},Decoder={},Decoder.rsDecoder=new ReedSolomonDecoder(GF256.QR_CODE_FIELD),Decoder.correctErrors=function(e,t){for(var n=e.length,i=Array(n),r=0;n>r;r++)i[r]=255&e[r];n=e.length-t;try{Decoder.rsDecoder.decode(i,n)}catch(o){throw o}for(r=0;t>r;r++)e[r]=i[r]},Decoder.decode=function(e){var t=new BitMatrixParser(e);e=t.readVersion();for(var n=t.readFormatInformation().ErrorCorrectionLevel,t=t.readCodewords(),t=DataBlock.getDataBlocks(t,e,n),i=0,r=0;r<t.Length;r++)i+=t[r].NumDataCodewords;for(var i=Array(i),o=0,s=0;s<t.length;s++){var r=t[s],a=r.Codewords,h=r.NumDataCodewords;for(Decoder.correctErrors(a,h),r=0;h>r;r++)i[o++]=a[r]}return new QRCodeDataBlockReader(i,e.VersionNumber,n.Bits)},qrcode={imagedata:null,width:0,height:0,qrCodeSymbol:null,debug:!1,sizeOfDataLengthInfo:[[10,9,8,8],[12,11,16,10],[14,13,16,12]],callback:null,decode:function(e){if(0==arguments.length){var t=document.getElementById("qr-canvas"),n=t.getContext("2d");return qrcode.width=t.width,qrcode.height=t.height,qrcode.imagedata=n.getImageData(0,0,qrcode.width,qrcode.height),qrcode.result=qrcode.process(n),null!=qrcode.callback&&qrcode.callback(qrcode.result),qrcode.result}var i=new Image;i.onload=function(){var e=document.createElement("canvas"),t=e.getContext("2d"),n=document.getElementById("out-canvas");null!=n&&(n=n.getContext("2d"),n.clearRect(0,0,320,240),n.drawImage(i,0,0,320,240)),e.width=i.width,e.height=i.height,t.drawImage(i,0,0),qrcode.width=i.width,qrcode.height=i.height;try{qrcode.imagedata=t.getImageData(0,0,i.width,i.height)}catch(r){return qrcode.result="Cross domain image reading not supported in your browser! Save it to your computer then drag and drop the file!",void(null!=qrcode.callback&&qrcode.callback(qrcode.result))}try{qrcode.result=qrcode.process(t)}catch(o){console.log(o),qrcode.result="error decoding QR Code"}null!=qrcode.callback&&qrcode.callback(qrcode.result)},i.src=e},decode_utf8:function(e){return decodeURIComponent(escape(e))},process:function(e){var t=(new Date).getTime(),n=qrcode.grayScaleToBitmap(qrcode.grayscale());if(qrcode.debug){for(var i=0;i<qrcode.height;i++)for(var r=0;r<qrcode.width;r++){var o=4*r+4*i*qrcode.width;qrcode.imagedata.data[o]=0,qrcode.imagedata.data[o+1]=0,qrcode.imagedata.data[o+2]=n[r+i*qrcode.width]?255:0}e.putImageData(qrcode.imagedata,0,0)}for(n=new Detector(n).detect(),qrcode.debug&&e.putImageData(qrcode.imagedata,0,0),n=Decoder.decode(n.bits).DataByte,e="",i=0;i<n.length;i++)for(r=0;r<n[i].length;r++)e+=String.fromCharCode(n[i][r]);return t=(new Date).getTime()-t,console.log(t),qrcode.decode_utf8(e)},getPixel:function(e,t){if(qrcode.width<e)throw"point error";if(qrcode.height<t)throw"point error";return point=4*e+4*t*qrcode.width,p=(33*qrcode.imagedata.data[point]+34*qrcode.imagedata.data[point+1]+33*qrcode.imagedata.data[point+2])/100},binarize:function(e){for(var t=Array(qrcode.width*qrcode.height),n=0;n<qrcode.height;n++)for(var i=0;i<qrcode.width;i++){var r=qrcode.getPixel(i,n);t[i+n*qrcode.width]=e>=r?!0:!1}return t},getMiddleBrightnessPerArea:function(e){for(var t=Math.floor(qrcode.width/4),n=Math.floor(qrcode.height/4),i=Array(4),r=0;4>r;r++){i[r]=Array(4);for(var o=0;4>o;o++)i[r][o]=[0,0]}for(r=0;4>r;r++)for(o=0;4>o;o++){i[o][r][0]=255;for(var s=0;n>s;s++)for(var a=0;t>a;a++){var h=e[t*o+a+(n*r+s)*qrcode.width];h<i[o][r][0]&&(i[o][r][0]=h),h>i[o][r][1]&&(i[o][r][1]=h)}}for(e=Array(4),t=0;4>t;t++)e[t]=Array(4);for(r=0;4>r;r++)for(o=0;4>o;o++)e[o][r]=Math.floor((i[o][r][0]+i[o][r][1])/2);return e},grayScaleToBitmap:function(e){for(var t=qrcode.getMiddleBrightnessPerArea(e),n=t.length,i=Math.floor(qrcode.width/n),r=Math.floor(qrcode.height/n),o=Array(qrcode.height*qrcode.width),s=0;n>s;s++)for(var a=0;n>a;a++)for(var h=0;r>h;h++)for(var c=0;i>c;c++)o[i*a+c+(r*s+h)*qrcode.width]=e[i*a+c+(r*s+h)*qrcode.width]<t[a][s]?!0:!1;return o},grayscale:function(){for(var e=Array(qrcode.width*qrcode.height),t=0;t<qrcode.height;t++)for(var n=0;n<qrcode.width;n++){var i=qrcode.getPixel(n,t);e[n+t*qrcode.width]=i}return e}},Array.prototype.remove=function(e,t){var n=this.slice((t||e)+1||this.length);return this.length=0>e?this.length+e:e,this.push.apply(this,n)};var MIN_SKIP=3,MAX_MODULES=57,INTEGER_MATH_SHIFT=8,CENTER_QUORUM=2;qrcode.orderBestPatterns=function(e){function t(e,t){return xDiff=e.X-t.X,yDiff=e.Y-t.Y,Math.sqrt(xDiff*xDiff+yDiff*yDiff)}var n=t(e[0],e[1]),i=t(e[1],e[2]),r=t(e[0],e[2]);i>=n&&i>=r?(i=e[0],n=e[1],r=e[2]):r>=i&&r>=n?(i=e[1],n=e[0],r=e[2]):(i=e[2],n=e[0],r=e[1]);var o=i.x,s=i.y;0>(r.x-o)*(n.y-s)-(r.y-s)*(n.x-o)&&(o=n,n=r,r=o),e[0]=n,e[1]=i,e[2]=r};

    (function($) {
        var cameraIds = [];

        /**
         * Code to initialise the cameraIds field
         */
        function gotSources(sourceInfos) {
            for (var i = 0; i !== sourceInfos.length; ++i) {
                var sourceInfo = sourceInfos[i];
                if (sourceInfo.kind === 'video') {
                    cameraIds.push(sourceInfo.id);
                }
            }
        }

        if (typeof MediaStreamTrack === 'undefined' ||
            typeof MediaStreamTrack.getSources === 'undefined') {
            console.log('This browser does not support MediaStreamTrack.\n\nTry Chrome.');
        } else {
            MediaStreamTrack.getSources(gotSources);
        }

        jQuery.fn.extend({
            /**
             * jQuery method,
             * @param: qrcodeSuccess (function) - callback on success
             * @param: qrcodeError (function) - callback on qr error
             * @param: videoError (function) - callback on video error
             * @param: camera (int) - which camera to use
             */
            html5_qrcode: function(qrcodeSuccess, qrcodeError, videoError, camera) {
                return this.each(function() {

                    var currentElem = $(this);

                    $.data(currentElem[0], "qrcodeSuccess", qrcodeSuccess);
                    $.data(currentElem[0], "qrcodeError", qrcodeError);
                    $.data(currentElem[0], "videoError", videoError);

                    if (typeof camera != 'undefined' && typeof cameraIds[camera] != 'undefined')
                        $.data(currentElem[0], "sourceId", camera);
                    else $.data(currentElem[0], "sourceId", 0);

                    if (typeof cameraIds[currentElem.data('sourceId')] != 'undefined')
                        $.data(currentElem[0], "cameraId", cameraIds[currentElem.data('sourceId')] );

                    var height = currentElem.height();
                    var width = currentElem.width();

                    if (height == null) {
                        height = 250;
                    }

                    if (width == null) {
                        width = 300;
                    }

                    var vidElem = $('<video width="' + width + 'px" height="' + height + 'px"></video>').appendTo(currentElem);
                    var canvasElem = $('<canvas id="qr-canvas" width="' + (width - 2) + 'px" height="' + (height - 2) + 'px" style="display:none;"></canvas>').appendTo(currentElem);

                    var video = vidElem[0];
                    var canvas = canvasElem[0];
                    var context = canvas.getContext('2d');
                    var localMediaStream;

                    var scan = function() {
                        if (localMediaStream) {
                            context.drawImage(video, 0, 0, 307, 250);

                            try {
                                qrcode.decode();
                            } catch (e) {
                                qrcodeError(e, localMediaStream);
                            }

                            $.data(currentElem[0], "timeout", setTimeout(scan, 500));

                        } else {
                            $.data(currentElem[0], "timeout", setTimeout(scan, 500));
                        }
                    };//end snapshot function

                    window.URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
                    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;

                    var successCallback = function(stream) {
                        video.src = (window.URL && window.URL.createObjectURL(stream)) || stream;
                        localMediaStream = stream;
                        $.data(currentElem[0], "stream", stream);

                        video.play();
                        $.data(currentElem[0], "timeout", setTimeout(scan, 1000));
                    };

                    // Call the getUserMedia method with our callback functions
                    if (navigator.getUserMedia) {
                        var config = {video: true};
                        if (typeof currentElem.data("cameraId") != 'undefined') {
                            config = {
                                video: {
                                    optional: [{
                                        sourceId: currentElem.data("cameraId")
                                    }]
                                }
                            };
                        }

                        navigator.getUserMedia(config, successCallback, function(error) {
                            if (typeof videoError == 'function') videoError(error, localMediaStream);
                            else console.log('Error callback is undefined or not a function.');
                        });
                    } else {
                        console.log('Native web camera streaming (getUserMedia) not supported in this browser.');
                        // Display a friendly "sorry" message to the user
                    }

                    qrcode.callback = function (result) {
                        if (typeof qrcodeSuccess == 'function')
                            qrcodeSuccess(result, localMediaStream);
                        else console.log('Success callback is undefined or not a function.');
                    };
                }); // end of html5_qrcode
            },
            html5_qrcode_stop: function() {
                return this.each(function() {
                    //stop the stream and cancel timeouts
                    $(this).data('stream').getVideoTracks().forEach(function(videoTrack) {
                        videoTrack.stop();
                    });

                    $(this).children('video').remove();
                    $(this).children('canvas').remove();

                    clearTimeout($(this).data('timeout'));
                });
            },
            html5_qrcode_changeCamera: function() {
                return this.each(function() {
                    //stop the stream and cancel timeouts
                    $(this).html5_qrcode_stop();
                    $(this).html5_qrcode(
                        $(this).data('qrcodeSuccess'),
                        $(this).data('qrcodeError'),
                        $(this).data('videoError'),
                        ($(this).data('sourceId') + 1) % cameraIds.length
                    );
                });
            },
            html5_qrcode_cameraCount: function() {
                return cameraIds.length;
            }
        });
    })(jQuery);
}

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise(function($injector, $location) {
            $injector.invoke(['$state', function($state) {
                $state.go('app.shops');
            }]);
        });

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            })
            // .state('login', {
            //     url: '/login',
            //     // templateUrl: 'module/partial/auth/login.html',
            //     controller: 'LoginController as vm',
            //     data: { pageTitle: 'Sign In', specialClass: 'gray-bg' }
            // })
            ;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController)
        .factory('$exceptionHandler', ['$log', '$injector', function($log, $injector) {
        return function myExceptionHandler(exception, cause) {

            var $rootScope = $injector.get("$rootScope");
            var $state = $injector.get("$state");
            var api = $injector.get("api");
            var clientSideExceptions = $injector.get("clientSideExceptions");

            var exceptionObject;
            try {
                exceptionObject = JSON.parse(exception);
            } catch (error) {
                exceptionObject = null;
            }

            if (exceptionObject !== null && typeof(exceptionObject) == 'object') {
                // app's own exception, go to error page and log it to server side
                $state.go('app.error', {exceptionObject: exceptionObject});
            } else {
                // general exception, just log it to server side
                var stringifiedException = JSON.stringify(exception, function (key, value) {
                    if (value instanceof Error) {
                        var error = {};
                        Object.getOwnPropertyNames(value).forEach(function (key) {
                            error[key] = value[key];
                        });

                        return error;
                    }
                    return value;
                });
                exceptionObject = clientSideExceptions.generalException(new Error(), stringifiedException);
                api.sendExceptionLog.save({}, {exceptionObject: exceptionObject})
            }
        };
    }]);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        //////////
    }
})();

(function ()
{
    'use strict';


    GAEnabled = true;

    angular
        .module('fuse')
        .constant('config', {
            "apiRootUrl": "https://api.shoplocalclubcard.com/api/v1",
	     "socketURL": "https://api.shoplocalclubcard.com:8080"
        })
    ;

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($httpProvider)
    {
        // Put your custom configurations here

        // Log out user on client side if user is logged out on server side
        $httpProvider.interceptors.push(function($q, $injector) {
            return {
                responseError: function(response) {
                    if (response.status == 401) {
                        var authService = $injector.get('$auth');
                        if (authService.isAuthenticated()) {
                            var stateService = $injector.get('$state');
                            toastr.warning('You have been logged out, please login again.', 'Warning!');
                            authService.removeToken();
                            stateService.go('app.auth_login');
                        }
                        console.log('error interceptor', response, authService.isAuthenticated());
                    }
                    return $q.reject(response);
                }
            };
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('clientSideExceptions', clientSideExceptionsService);

    /** @ngInject */
    function clientSideExceptionsService(config)
    {
        var clientSideExceptions = {};

        clientSideExceptions.generalException           = function(err, debug, msg) {return {code: '0000', severity: 'normal', msg: msg ? msg : 'Error: General exception happened.', persistent: false, debug: debug};};

        clientSideExceptions.cantGetLocationsNearby     = function(err, debug, msg) {return {code: '0104', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get locations nearby.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetSubscriptionToken   = function(err, debug, msg) {return {code: '0002', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get subscription token.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetUserProfile         = function(err, debug, msg) {return {code: '0003', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get user profile.', persistent: false, debug: debug};};
        clientSideExceptions.cantCreateMembershipCard   = function(err, debug, msg) {return {code: '0123', severity: 'critical', msg: msg ? msg : 'Error: Can\'t create membership card.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetLocationToOperate   = function(err, debug, msg) {return {code: '0135', severity: 'critical', msg: msg ? msg : 'Error: Can\'t operate location.', persistent: false, debug: debug};};
        clientSideExceptions.cantOperateLocation        = function(err, debug, msg) {return {code: '0004', severity: 'critical', msg: msg ? msg : 'Error: Can\'t operate location.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetVoucherInfo         = function(err, debug, msg) {return {code: '0005', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get voucher info.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetClientsAround       = function(err, debug, msg) {return {code: '0010', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get clients around.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetShopInfo            = function(err, debug, msg) {return {code: '0006', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get shop info.', persistent: false, debug: debug};};
        clientSideExceptions.cantSearchByCard           = function(err, debug, msg) {return {code: '0008', severity: 'normal', msg: msg ? msg : 'Error: Can\'t search by membership card.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveAdhocVoucherDef    = function(err, debug, msg) {return {code: '0009', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save ad-hoc voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantIssueAdhocVouchers     = function(err, debug, msg) {return {code: '0007', severity: 'critical', msg: msg ? msg : 'Error: Can\'t issue vouchers.', persistent: false, debug: debug};};
        clientSideExceptions.cantSavePointVoucherDef    = function(err, debug, msg) {return {code: '0014', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save point voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantIssueReengageVouchers  = function(err, debug, msg) {return {code: '0018', severity: 'critical', msg: msg ? msg : 'Error: Can\'t issue vouchers.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveReengageVoucherDef = function(err, debug, msg) {return {code: '0019', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save re-engage voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetCountryList         = function(err, debug, msg) {return {code: '0032', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get country list.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetCategoryList        = function(err, debug, msg) {return {code: '0033', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get category list.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveShopData           = function(err, debug, msg) {return {code: '0034', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save shop data.', persistent: false, debug: debug};};
        clientSideExceptions.cantUploadShopData         = function(err, debug, msg) {return {code: '0035', severity: 'normal', msg: msg ? msg : 'Error: Can\'t upload shop data.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveShopConfig         = function(err, debug, msg) {return {code: '0036', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save shop data.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveWelcomeVoucherDef  = function(err, debug, msg) {return {code: '0023', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save welcome voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantIssueWelcomeVouchers   = function(err, debug, msg) {return {code: '0024', severity: 'critical', msg: msg ? msg : 'Error: Can\'t issue welcome vouchers.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetOperatorInfo        = function(err, debug, msg) {return {code: '0049', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get operator info.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveOperatorData       = function(err, debug, msg) {return {code: '0051', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save operator info.', persistent: false, debug: debug};};
        clientSideExceptions.cantDeleteOperator         = function(err, debug, msg) {return {code: '0052', severity: 'critical', msg: msg ? msg : 'Error: Can\'t delete operator.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetShopLocation        = function(err, debug, msg) {return {code: '0053', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get shop location.', persistent: false, debug: debug};};
        clientSideExceptions.googleMapError             = function(err, debug, msg) {return {code: '0054', severity: 'normal', msg: msg ? msg : 'Error: Google map error.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveLocation           = function(err, debug, msg) {return {code: '0056', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save shop location.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetOperatorShops       = function(err, debug, msg) {return {code: '0059', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get operator possible shops.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetShopDetails         = function(err, debug, msg) {return {code: '0060', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get shop details.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveStampCard          = function(err, debug, msg) {return {code: '0062', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save stamp card.', persistent: false, debug: debug};};
        clientSideExceptions.cantChangeStampCard        = function(err, debug, msg) {return {code: '0063', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save stamp card.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetNotifications       = function(err, debug, msg) {return {code: '0126', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get notifications.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetVouchers            = function(err, debug, msg) {return {code: '0066', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get vouchers.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetArchiveVouchers     = function(err, debug, msg) {return {code: '0067', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get archive vouchers.', persistent: false, debug: debug};};
        clientSideExceptions.cantCheckOutUser           = function(err, debug, msg) {return {code: '0069', severity: 'normal', msg: msg ? msg : 'Error: Can\'t check out user of location.', persistent: false, debug: debug};};
        clientSideExceptions.cantCheckInUser            = function(err, debug, msg) {return {code: '0070', severity: 'normal', msg: msg ? msg : 'Error: Can\'t check in user to location.', persistent: false, debug: debug};};
        clientSideExceptions.cantSetNotificationToSeen  = function(err, debug, msg) {return {code: '0072', severity: 'normal', msg: msg ? msg : 'Error: Can\'t set notification to seen.', persistent: false, debug: debug};};
        clientSideExceptions.cantIssueMembershipCard    = function(err, debug, msg) {return {code: '0077', severity: 'critical', msg: msg ? msg : 'Error: Can\'t set notification to seen.', persistent: false, debug: debug};};
        clientSideExceptions.cantInitialiseQrReader     = function(err, debug, msg) {return {code: '0079', severity: 'normal', msg: msg ? msg : 'Error: Can\'t initialise QR reader.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetTransactions        = function(err, debug, msg) {return {code: '0082', severity: 'noraml', msg: msg ? msg : 'Error: Can\'t get transactions.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetMembershipCardData  = function(err, debug, msg) {return {code: '0084', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get membership card data.', persistent: false, debug: debug};};
        clientSideExceptions.cantPayOffVoucher          = function(err, debug, msg) {return {code: '0086', severity: 'normal', msg: msg ? msg : 'Error: Can\'t pay off voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantAddSaleValue           = function(err, debug, msg) {return {code: '0087', severity: 'normal', msg: msg ? msg : 'Error: Can\'t add sale value.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetOperatorList        = function(err, debug, msg) {return {code: '0090', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get operator list.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveOperator           = function(err, debug, msg) {return {code: '0090', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save operator.', persistent: false, debug: debug};};
        clientSideExceptions.cantAddOperator            = function(err, debug, msg) {return {code: '0092', severity: 'normal', msg: msg ? msg : 'Error: Can\'t add operator.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetProducts            = function(err, debug, msg) {return {code: '0096', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get products.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveRegistrationData   = function(err, debug, msg) {return {code: '0128', severity: 'critical', msg: msg ? msg : 'Error: Can\'t save registration data.', persistent: false, debug: debug};};
        clientSideExceptions.cantResetPassword          = function(err, debug, msg) {return {code: '0129', severity: 'critical', msg: msg ? msg : 'Error: Can\'t reset password.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetLocations           = function(err, debug, msg) {return {code: '0098', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get location list.', persistent: false, debug: debug};};
        clientSideExceptions.cantDeleteLocation         = function(err, debug, msg) {return {code: '0099', severity: 'critical', msg: msg ? msg : 'Error: Can\'t delete shop location.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetStampCards          = function(err, debug, msg) {return {code: '0106', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get stamp cards.', persistent: false, debug: debug};};
        clientSideExceptions.cantFavoriteShop           = function(err, debug, msg) {return {code: '0108', severity: 'normal', msg: msg ? msg : 'Error: Can\'t favorite / unfavorite shop.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetShopStats           = function(err, debug, msg) {return {code: '0111', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get shop stats.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetPlanList            = function(err, debug, msg) {return {code: '0112', severity: 'critical', msg: msg ? msg : 'Error: Can\'t get plan list.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetQrCode              = function(err, debug, msg) {return {code: '0112', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get membership card QR code.', persistent: false, debug: debug};};
        clientSideExceptions.cantUploadUserProfile      = function(err, debug, msg) {return {code: '0114', severity: 'normal', msg: msg ? msg : 'Error: Can\'t upload user profile.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveUserProfile        = function(err, debug, msg) {return {code: '0116', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save user profile.', persistent: false, debug: debug};};
        clientSideExceptions.cantSendPwResetLink        = function(err, debug, msg) {return {code: '0118', severity: 'critical', msg: msg ? msg : 'Error: Can\'t send password reset link.', persistent: false, debug: debug};};
        clientSideExceptions.cantDismissDialog          = function(err, debug, msg) {return {code: '0119', severity: 'normal', msg: msg ? msg : 'Error: Can\'t dismiss password reset dialog.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetCheckIns            = function(err, debug, msg) {return {code: '0120', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get check ins.', persistent: false, debug: debug};};
        clientSideExceptions.cantVerifyEmail            = function(err, debug, msg) {return {code: '0130', severity: 'normal', msg: msg ? msg : 'Error: Can\'t verify e-mail.', persistent: false, debug: debug};};
        clientSideExceptions.notAllowed                 = function(err, debug, msg) {return {code: '0131', severity: 'critical', msg: msg ? msg : 'Error: Operation not allowed.', persistent: false, debug: debug};};
        clientSideExceptions.cantGetVoucherInfo         = function(err, debug, msg) {return {code: '0026', severity: 'normal', msg: msg ? msg : 'Error: Can\'t get voucher info.', persistent: false, debug: debug};};
        clientSideExceptions.cantRevokeVoucher          = function(err, debug, msg) {return {code: '0028', severity: 'normal', msg: msg ? msg : 'Error: Can\'t revoke voucher.', persistent: false, debug: debug};};
        clientSideExceptions.cantSaveVoucher            = function(err, debug, msg) {return {code: '0031', severity: 'normal', msg: msg ? msg : 'Error: Can\'t save voucher.', persistent: false, debug: debug};};

        return clientSideExceptions;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, config)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = config.apiRootUrl;

        api.getCountryList = $resource(api.baseUrl + '/ref/countries');
        api.getCategoryList = $resource(api.baseUrl + '/ref/shop_categories');

        api.login = $resource(api.baseUrl + '/user/login');
        api.logout = $resource(api.baseUrl + '/user/logout');

        api.register = $resource(api.baseUrl + '/user/register');
        api.checkEmail = $resource(api.baseUrl + '/user/check_email');

        api.verifyEmail = $resource(api.baseUrl + '/user/email_verify/:user');

        api.resendVerificationEmail = $resource(api.baseUrl + '/user/email_verify_resend');
        api.sendPasswordResetEmail = $resource(api.baseUrl + '/user/password_restore_send');

        api.getUserProfile = $resource(api.baseUrl + '/user/profile');
        api.saveUserProfile = $resource(api.baseUrl + '/user/profile_save');
        api.getUserCheckins = $resource(api.baseUrl+ '/user/check_in_locations');

        api.getUserCard = $resource(api.baseUrl + '/member/card');
        api.claimCard = $resource(api.baseUrl + '/member/claim_card');
        api.makeCard = $resource(api.baseUrl + '/member/make_card');

        api.getShop = $resource(api.baseUrl + '/shop');
        api.getShopDetails = $resource(api.baseUrl + '/shop/show/:shop');
        api.storeShopConfig = $resource(api.baseUrl + '/shop/store');
        api.getShopLocation = $resource(api.baseUrl + '/location/show/:location');
        api.updateShopLocation = $resource(api.baseUrl + '/location/update/:location');
        api.addShopLocation = $resource(api.baseUrl + '/location/store/:shop');
        api.deleteShopLocation = $resource(api.baseUrl + '/location/destroy/:location');
        api.getShopStats = $resource(api.baseUrl + '/shop/stats/:shopId')

        api.getOperators = $resource(api.baseUrl + '/shop/operators/:shop');
        api.getOperator = $resource(api.baseUrl + '/operator/show/:shop/:operator');
        api.updateOperator = $resource(api.baseUrl + '/operator/update/:operator');
        api.addOperator = $resource(api.baseUrl + '/operator/store/:shop');
        api.kickOperator = $resource(api.baseUrl + '/operator/kick/:operator');
        api.destroyOperator = $resource(api.baseUrl + '/operator/destroy/:operator');

        api.getSubscriptionPlans = $resource(api.baseUrl + '/subscription/all_plans');
        api.getSubscriptionToken = $resource(api.baseUrl + '/subscription/token');
        api.storeSubscription = $resource(api.baseUrl + '/subscription/store');
        api.updateSubscription = $resource(api.baseUrl + '/subscription/update');
        api.showSubscription = $resource(api.baseUrl + '/subscription/show');
        api.destroySubscription = $resource(api.baseUrl + '/subscription/destroy');

        api.storeStampcard = $resource(api.baseUrl + '/stampcard/store/:shop');
        api.updateStampcard = $resource(api.baseUrl + '/stampcard/update/:stampcard');

        api.getStampcardIcons = $resource(api.baseUrl + '/ref/stamp_icons');

        api.getShopsNearby = $resource(api.baseUrl + '/location/nearby');
        api.checkInToLocation = $resource(api.baseUrl + '/location/check_in/:location');
        api.checkOutOfLocation = $resource(api.baseUrl + '/location/check_out/:location');

        api.resetPassword = $resource(api.baseUrl + '/user/password_restore_reset');

        api.getOperatorIndex = $resource(api.baseUrl + '/operator');

        api.getLocationClientsCheckIn = $resource(api.baseUrl + '/location/clients_check_ins/:location');

        api.addStamp = $resource(api.baseUrl + '/stampcard/stamp/:stampcardUser');
        api.removeStamp = $resource(api.baseUrl + '/stampcard/destroy/stamp/:stamp');
        api.payOffStampcard = $resource(api.baseUrl + '/stampcard/pay_off/:stampcardUser');

        api.issueStampCardForUser = $resource(api.baseUrl + '/stampcard/claim/:stampcard/:membershipcard');
        api.issueCard = $resource(api.baseUrl + '/member/issue_card/:shop');
        api.issueCardForUser = $resource(api.baseUrl + '/member/issue_card_for_user/:shop/:client');

        api.searchByCard = $resource(api.baseUrl + '/member/user');
        api.finishStampcard = $resource(api.baseUrl + '/stampcard/finish/:stampcardUser');

        api.getStampcards = $resource(api.baseUrl + '/stampcard');
        api.getArchiveStampcards = $resource(api.baseUrl + '/stampcard/archive');

        api.addSale = $resource(api.baseUrl + '/sale/store/:shop');
        api.getMyVouchers = $resource(api.baseUrl + '/voucher/mine');
        api.getMyArchiveVouchers = $resource(api.baseUrl + '/voucher/mine/archive');

        api.getVoucherQRCode =  $resource(api.baseUrl + '/voucher/qr_code/:voucher');
        api.getMembershipQRCode =  $resource(api.baseUrl + '/member/qr_code/:voucher');

        api.payOffVoucher =  $resource(api.baseUrl + '/voucher/pay_off/:membershipcardVoucher');

        api.operatorOperate =  $resource(api.baseUrl + '/operator/operate/:location');
        api.operatorUnoperate =  $resource(api.baseUrl + '/operator/unoperate');

        api.setFavorite =  $resource(api.baseUrl + '/favorite/store/:shop');
        api.clearFavorite =  $resource(api.baseUrl + '/favorite/unlike/:shop');

        api.getVouchersByShop =  $resource(api.baseUrl + '/voucher/list/:shop');
        api.getClientsByVoucher =  $resource(api.baseUrl + '/voucher/issued/:voucher');
        api.getValidClientsByVoucher =  $resource(api.baseUrl + '/voucher/clients/:voucher');

        api.revokeVoucher =  $resource(api.baseUrl + '/voucher/revoke');
        api.issueMultipleVouchers =  $resource(api.baseUrl + '/voucher/issue/:voucher');
        api.revokeMultipleVouchers =  $resource(api.baseUrl + '/voucher/revoke');

        api.updateVoucherDef = $resource(api.baseUrl + '/voucher/update/:voucher');
        api.storeVoucherDef = $resource(api.baseUrl + '/voucher/store/:shop');

        api.getTransactions = $resource(api.baseUrl + '/member/transactions/:card');

        api.getNotifications = $resource(api.baseUrl + '/notification');
        api.setNotificationSeen = $resource(api.baseUrl + '/notification/seen/:notification');

        api.getProducts = $resource(api.baseUrl + '/product');
        api.placeOrder = $resource(api.baseUrl + '/product/sale/:product');
        api.calculateProductDiscount = $resource(api.baseUrl + '/product/discount/:product');
        api.calculateSubscriptionDiscount = $resource(api.baseUrl + '/subscription/discount');

        api.getLocationByIp = $resource('//freegeoip.net/json/', { callback: "JSON_CALLBACK" }, {getIp: {method: 'JSONP'}});
        api.getLocationList = $resource(api.baseUrl + '/shop/locations/:shop');

        api.sendExceptionLog = $resource(api.baseUrl + '/exception/');

        return api;
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.TODAY\">TODAY</md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label \ntranslate=\"QUICKPANEL.CHAT\">CHAT</md-tab-label><md-tab-body><md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" ng-controller=\"ChatTabController as vm\"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label translate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</md-tab-label><md-tab-body>\n<md-content class=\"activity-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div class=\"error-banner pulse\" ng-class=\"{\'drop-down\': globalError}\" ng-if=\"globalError\"><p>{{globalError}}</p></div>\n<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" class=\"md-whiteframe-1dp\" \nui-view=\"navigation\"></div><div id=\"content-container\" flex layout=\"column\"><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-background md-hue-1\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav \nid=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll \nui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-panel\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"ms-theme-options-panel-button md-primary-bg\" ng-click=\"toggleOptionsPanel()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div \nclass=\"option-title\">Layout Style:</div><md-radio-group layout=\"column\" ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button value=\"verticalNavigation\">Vertical Navigation</md-radio-button>\n<md-radio-button value=\"horizontalNavigation\">Horizontal Navigation</md-radio-button><md-radio-button \nvalue=\"contentOnly\">Content Only</md-radio-button><md-radio-button value=\"contentWithToolbar\">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button value=\"boxed\">Boxed</md-radio-button><md-radio-button value=\"wide\">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option\"><div \nclass=\"option-title\">Color Palette:</div><md-menu-item ng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"theme\">\n<md-button class=\"md-raised theme-button\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"themeName\"><span><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" md-font-icon=\"icon-palette\">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>");
$templateCache.put("app/main/cart/cart.html","<div id=\"cart\" class=\"right-sidenav\"><div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nng-click=\"vm.goToPreviousState()\"><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1 \ntranslate=\"CART.YOUR_ORDER\"></h1></div><md-card><md-card-content><div class=\"order\"><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"icon-cart\"></span> <span class=\"description\" flex=\"grow\">\n{{ vm.order.description }}</span><h2 class=\"price\" flex=\"noshrink\">£ {{ vm.order.price }}</h2></div><form \nng-if=\"vm.order.showCoupon\" id=\"vm.couponForm\" name=\"vm.couponForm\" novalidate><div layout=\"row\" \nlayout-align=\"start center\"><h3 flex=\"grow\" ng-if=\"!vm.hasCoupon\"><a ng-click=\"vm.enableCoupon()\" \ntranslate=\"CART.CLICK_HERE\"></a> <span translate=\"CART.REDEEM_VOUCHER\"></span></h3><h3 flex=\"grow\" \nng-if=\"vm.hasCoupon\" translate=\"CART.INSERT_VOUCHER\"></h3><md-input-container flex=\"grow\" ng-if=\"vm.hasCoupon\" \nmd-no-float><input name=\"coupon\" ng-model=\"vm.order.coupon\" placeholder=\"Coupon code\" translate \ntranslate-attr-placeholder=\"CART.COUPON_PLACEHOLDER\" \nng-change=\"resetServerSideValidation(couponForm); vm.calculateDiscount();\"><div \nng-messages=\"vm.couponForm.coupon.$error\" role=\"alert\"><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.coupon }}</span></div></div></md-input-container></div></form><hr><div layout=\"row\" \nlayout-align=\"start center\"><h2 flex=\"grow\">Total</h2><h1 flex=\"noshrink\">£ {{ vm.totalPrice }}</h1></div></div><hr>\n<div><form id=\"vm.orderForm\" name=\"vm.orderForm\" novalidate><div layout=\"row\" layout-align=\"center\"><h3 \nng-if=\"!vm.paymentConfigured\" translate=\"CART.PLEASE_WAIT\"></h3><a ng-if=\"vm.paymentConfigured\" \nhref=\"https://www.braintreegateway.com/merchants/8wxv47jxfkq7wdtt/verified\" target=\"_blank\"><img \nsrc=\"https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-dark.png\" width=\"280px\" height=\"44px\" border=\"0\">\n</a></div><div id=\"payment-form\"></div><script src=\"https://js.braintreegateway.com/js/braintree-2.21.0.min.js\">\n</script><div layout=\"row\" layout-align=\"center\"><md-button type=\"submit\" class=\"md-button-wide\" \naria-label=\"SUBMIT PURCHASE\" ng-disabled=\"vm.orderForm.$invalid || subscriptionRequestSent\" translate=\"CART.PURCHASE\" \ntranslate-attr-aria-label=\"SUBSCRIPTION.SUBSCRIBE\" ng-if=\"!vm.paymentInProcess\"></md-button><md-progress-circular \nng-if=\"vm.paymentInProcess\" md-mode=\"indeterminate\"></md-progress-circular></div></form></div></md-card-content>\n</md-card></div>");
$templateCache.put("app/main/claimcard/claimcard.html","<div id=\"claim-card\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"claim-card-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><md-card><md-card-content><div class=\"card\"><div class=\"front\"><div \nclass=\"instructions\"><p>\nIf you have been given your unique Membership Number then enter it here and click \'Claim Your Card\'. If you do not have a membership number yet then click \'Create a New Membership Number\' button below to be allocated one.\n</p></div><div id=\"claim-card-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img \nsrc=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" translate=\"CLAIM_CARD.TITLE\">Membership Card\n</div><div class=\"subtitle\">{{ vm.user.name }}</div><form id=\"claimCardForm\" name=\"claimCardForm\" novalidate \nng-submit=\"vm.claimCard(claimCardForm, vm.claimCardFormData)\" ng-if=\"!vm.claimSuccess\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" class=\"Cardnumber\" name=\"membership_number\" \nng-model=\"vm.claimCardFormData.code\" placeholder=\"Enter membership number\" translate \ntranslate-attr-placeholder=\"CLAIM_CARD.MEMBERSHIP_NUMBER\" ng-change=\"resetServerSideValidation(claimCardForm)\" \nms-membershipcard><div ng-messages=\"claimCardForm.membership_number.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"CLAIM_CARD.ERRORS.MEMBERSHIP_NUMBER_MUST_VALID\">Must be a valid card number\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg }}</span></div></div>\n</md-input-container><table width=\"100%\" border=\"0\" cellspacing=\"0\" cellpadding=\"0\"><tr><td><md-button \nid=\"submit-claim-form\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"SUBMIT CLAIM\" \ntranslate=\"CLAIM_CARD.SUBMIT_CLAIM\" translate-attr-aria-label=\"CLAIM_CARD.SUBMIT_CLAIM\" \nng-click=\"claimCardForm.submitType=\'claim\'\" style=\"display:none\">SUBMIT</md-button><md-button id=\"submit-create-form\" \ntype=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"claimCardForm.submitType=\'create\'\" \nstyle=\"display:none\">SUBMIT</md-button></td></tr></table></form></div><div layout=\"column\" \nlayout-align=\"center center\" flex><md-button type=\"button\" class=\"md-button-auto-width\" aria-label=\"SUBMIT CLAIM\" \nng-if=\"!vm.claimSuccess && !vm.makeSuccess\" translate=\"CLAIM_CARD.SUBMIT_CLAIM\" \ntranslate-attr-aria-label=\"CLAIM_CARD.SUBMIT_CLAIM\" ng-click=\"vm.triggerClaimCard()\">SUBMIT</md-button><span>Or</span>\n<md-button ng-if=\"!vm.claimSuccess && !vm.makeSuccess\" class=\"md-button-auto-width\" ng-click=\"vm.createCard()\">\nCreate a new number</md-button></div></div><div ng-if=\"vm.claimSuccess\" class=\"login\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><span class=\"text\">{{ vm.successMsg }} </span><a class=\"link\" ui-sref=\"app.dashboard\" \ntranslate=\"CLAIM_CARD.CONTINUE\">Continue to dashboard</a></div><div ng-if=\"vm.makeSuccess\" class=\"login\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\"><span class=\"text\">{{ vm.successMsg }} </span><a class=\"link\" \nui-sref=\"app.dashboard\" translate=\"CLAIM_CARD.CONTINUE\">Continue to dashboard</a></div><div class=\"back\"><div \nclass=\"subtitleouter\">Here is your new membership card</div><div id=\"claim-card-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span><img src=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" \ntranslate=\"CLAIM_CARD.TITLE\">Membership Cards</div><div class=\"subtitle\">{{ vm.user.name }}</div><form \nname=\"createCardForm\" novalidate ng-submit=\"vm.claimCard(createCardForm, vm.createCardForm)\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" class=\"Cardnumber\" name=\"membership_number\" \nng-model=\"vm.claimCardFormData.code\" placeholder=\"Membership number\" translate \ntranslate-attr-placeholder=\"CLAIM_CARD.MEMBERSHIP_NUMBER\" ng-change=\"resetServerSideValidation(createCardForm)\" \nms-membershipcard><div ng-messages=\"createCardForm.membership_number.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span translate=\"CLAIM_CARD.ERRORS.MEMBERSHIP_NUMBER_MUST_VALID\">Must be a valid card number\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg }}</span></div></div>\n</md-input-container></form></div><div layout=\"row\"><span flex></span><md-button class=\"md-button-auto-width\" \nstyle=\"color:white\" ng-if=\"vm.claimSuccess || vm.makeSuccess\" ui-sref=\"app.dashboard\" translate=\"CLAIM_CARD.CONTINUE\">\nContinue to app</md-button><span flex></span></div></div></div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/createadhocvoucher/createadhocvoucher.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nui-sref=\"app.vouchersconfig({category: \'ad-hoc\'})\"><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>\nCreate ad-hoc voucher</h1></div><div id=\"create-adhoc-voucher\" class=\"right-sidenav\"><md-card><md-card-content \nlayout=\"row\" layout-wrap layout-align=\"start center\" id=\"card-parent\"><div class=\"vouchers padding\" flex=\"grow\" \nflex-gt-xs=\"50\"><md-card class=\"voucher-card\" id=\"voucher-card\" layout=\"column\"><md-card-content><div layout=\"row\" \nclass=\"sub-header\" flex=\"grow\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" \nng-if=\"vm.shop.logo_full_url\" ng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!vm.shop.logo_full_url\" src=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" \nlayout=\"column\" flex=\"grow\" layout-align=\"center\"><h1>{{ vm.shop.name }}</h1><span>{{ vm.shop.category.title }}</span>\n</div><div layout=\"column\" layout-align=\"center end\" flex=\"noshrink\"><md-switch aria-label=\"check-in\" \nng-click=\"vm.toggleCheckin(voucher)\" ng-model=\"voucher.is_checked_in\"></md-switch><span class=\"checkin-text\">Check in\n</span></div></div></div><hr><div class=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"ticket\" layout=\"row\" flex=\"grow\"><div class=\"message-box\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h3 class=\"voucher-type\">Ad-hoc voucher</h3><div \nng-bind-html=\"vm.voucherDef.message || \'Please insert a voucher description\'\"></div></div><div class=\"value-box\" \nlayout=\"column\" flex=\"noshrink\" layout-align=\"center center\"><span><b>Expires {{ vm.expires_at }}</b></span><h1 \nid=\"voucher-value\" ng-bind-html=\"vm.formatAsCurrency(vm.voucherDef.value, voucher.shop.country_id)\">\n${{ vm.voucherDef.value || \'0\'}}</h1><span>{{ voucher.code | voucherNumber}}</span></div></div></div><div \nclass=\"additional-info\"><div layout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div \nlayout=\"column\"><span class=\"info-line\">{{vm.shop.locations[0].address}}</span> <span class=\"info-line\">\n800 m away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\"></span> <span class=\"info-line\">\n{{ vm.shop.phone }}</span></div><div layout=\"row\"><span class=\"icon-web icon\"></span> <span class=\"info-line\">\n{{ vm.shop.website }}</span></div></div><hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" \nlayout-align=\"end center\"></div></md-card-content></md-card></div><div class=\"fields\" flex=\"grow\" flex-gt-xs=\"50\"><form\n name=\"vm.voucherDefForm\"><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">\nAdhoc voucher value</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter the monetary value for this voucher.</md-tooltip></md-button></div><div layout=\"row\"><span \nstyle=\"padding-top: 2px\" ng-bind-html=\"getCurrencyByCountry(vm.shop.country_id)\"></span><md-input-container \nclass=\"md-block\" md-no-float><input name=\"value\" type=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" \nng-model=\"vm.voucherDef.value\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEADHOCVOUCHER.VALUE_FIELD\" required \nng-change=\"resetServerSideValidation(vm.voucherDefForm); vm.adjustValueSize()\"><div \nng-messages=\"vm.voucherDefForm.value.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"EDITSTAMPCARD.ERRORS.VALUE_REQUIRED\">Field is required</span></div><div ng-message=\"serverSideValidation\">\n<span>{{ vm.serverSideValidationMsg.value }}</span></div></div></md-input-container></div></div><div class=\"field\" \nlayout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Days to expiration</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Days to expiration from the moment this voucher is issued.\n</md-tooltip></md-button></div><md-input-container class=\"md-block\" md-no-float><input name=\"expire_days\" \ntype=\"number\" pattern=\"\\d*\" ng-model=\"vm.voucherDef.expire_days\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEADHOCVOUCHER.EXPIRE_DAYS_FIELD\" required \nng-change=\"resetServerSideValidation(vm.voucherDefForm)\"><div ng-messages=\"vm.voucherDefForm.expire_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EDITSTAMPCARD.ERRORS.EXPIRE_DAYS_REQUIRED\">Field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.expire_days }}</span></div>\n</div></md-input-container></div><div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\"><span \nclass=\"field-name\">Description</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher description, it will be displayed on the front of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.message\" \naria-label=\"voucher-description\" name=\"message\" translate-attr-placeholder=\"CREATEADHOCVOUCHER.MESSAGE_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(vm.voucherDefForm)\"></text-angular></md-input-container><div layout=\"row\"><span \nflex=\"grow\"></span> <span flex=\"noshrink\" style=\"font-size: 12px\">\n{{vm.voucherDef.message.length}}/255 Available characters</span></div><div \nng-messages=\"vm.voucherDefForm.message.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"SHOPCONFIG.ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span>\n</div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.message }}</span></div></div></div>\n<div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Conditions</span>\n<md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher conditions, it will be displayed on the back of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.conditions\" \naria-label=\"voucher-conditions\" name=\"conditions\" translate-attr-placeholder=\"CREATEADHOCVOUCHER.CONDITIONS_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(vm.voucherDefForm)\"></text-angular></md-input-container><div layout=\"row\"><span \nflex=\"grow\"></span> <span flex=\"noshrink\" style=\"font-size: 12px\">\n{{vm.voucherDef.conditions.length}}/255 Available characters</span></div><div \nng-messages=\"vm.voucherDefForm.conditions.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"SHOPCONFIG.ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span>\n</div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.conditions }}</span></div></div><div \nflex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap><md-button class=\"md-button-auto-width\" \nng-click=\"vm.saveVoucherDef(voucherDefForm, vm.voucherDef)\" ng-disabled=\"voucherDefForm.$invalid\">Save</md-button>\n</div></div></form></div></md-card-content></md-card><md-card><md-card-header class=\"search-bar\" layout=\"row\"><form \nname=\"searchForm\" novalidate ng-submit=\"vm.search(vm.voucherDefForm, vm.voucherDef)\" flex=\"grow\"><div \nclass=\"search-box-container\" flex=\"grow\" layout=\"row\"><md-input-container class=\"search-box\" md-no-float flex=\"grow\">\n<input name=\"membercard\" ng-pattern=\"/^[0-9 ]*$/\" ng-model=\"vm.searchQuery\" placeholder=\"Enter membership number\" \nrequired ng-change=\"resetServerSideValidation(searchForm)\" ms-membershipcard><div \nng-messages=\"searchForm.membercard.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nMembership card number is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.membercard }}</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"search-qr\" aria-label=\"Search\"><span class=\"icon-qrcode\" \nng-if=\"(vm.searchQuery.length == 0 || !vm.searchQuery) && !vm.isIOS\"></span> <span id=\"goSearch\" \nng-if=\"(vm.searchQuery && vm.searchQuery.length != 0) || vm.isIOS\">Go</span></md-button></div></form></md-card-header>\n<md-card-content layout=\"row\" layout-align=\"center\" layout-wrap><h3 \nng-if=\"!vm.usersAround || vm.usersAround.length == 0\">No checked in users in store</h3><md-list \nng-if=\"vm.usersAround.length > 0\" flex=\"grow\"><md-list-item class=\"md-2-line\" ng-repeat=\"userAround in vm.usersAround\">\n<img class=\"md-avatar\" ng-if=\"!userAround.avatar_full_url\" src=\"/assets/images/avatars/empty_avatar.jpeg\"> <img \nclass=\"md-avatar\" ng-if=\"userAround.avatar_full_url\" ng-src=\"{{ userAround.avatar_full_url }}\"><div \nclass=\"md-list-item-text\"><h3>{{userAround.user.name}}</h3><p>{{userAround.membershipcard.code | membershipcardNumber}}\n</p></div><div class=\"md-list-item-text\" hide show-gt-sm><p>\n{{userAround.active_vouchers ? userAround.active_vouchers.length : 0 }} Vouchers</p></div><div \nclass=\"md-list-item-text\" hide show-gt-sm><p>\n{{ userAround.total_stamps }} of {{ userAround.stampcard_user.stamps_total }} Stamps</p></div><md-button \nng-click=\"vm.createVoucher()\">SELECT</md-button></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/main/createpointvoucher/createpointvoucher.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nui-sref=\"app.vouchersconfig({category: \'point\'})\"><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>\nCreate point vouchers</h1></div><div id=\"create-point-voucher\" class=\"simple right-sidenav\"><md-card><md-card-content \nlayout=\"row\" layout-wrap layout-align=\"start center\" id=\"card-parent\"><div class=\"vouchers padding\" flex=\"grow\" \nflex-gt-xs=\"50\"><md-card class=\"voucher-card\" id=\"voucher-card\" layout=\"column\"><md-card-content><div layout=\"row\" \nclass=\"sub-header\" flex=\"grow\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" \nng-if=\"vm.shop.logo_full_url\" ng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!vm.shop.logo_full_url\" src=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" \nlayout=\"column\" flex=\"grow\" layout-align=\"center\"><h1>{{ vm.shop.name }}</h1><span>{{ vm.shop.category.title }}</span>\n</div><div layout=\"column\" layout-align=\"center end\" flex=\"noshrink\"><md-switch aria-label=\"check-in\" \nng-click=\"vm.toggleCheckin(voucher)\" ng-model=\"voucher.is_checked_in\"></md-switch><span class=\"checkin-text\">Check in\n</span></div></div></div><hr><div class=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"ticket\" layout=\"row\" flex=\"grow\"><div class=\"message-box\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h3 class=\"voucher-type\">Point voucher</h3><div \nng-bind-html=\"vm.voucherDef.message || \'Please insert a voucher description\'\"></div></div><div class=\"value-box\" \nlayout=\"column\" flex=\"noshrink\" layout-align=\"center center\"><span><b>Expires {{ vm.expires_at || \'never\'}}</b></span>\n<h1 id=\"voucher-value\" \nng-bind-html=\"vm.formatAsCurrency(vm.voucherDef.points_to_value_currency, voucher.shop.country_id)\">\n${{ vm.voucherDef.value || \'0\'}}</h1><span>{{ vm.voucherDef.code | voucherNumber}}</span></div></div></div><div \nclass=\"additional-info\"><div layout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div \nlayout=\"column\"><span class=\"info-line\">{{vm.shop.locations[0].address}}</span> <span class=\"info-line\">\n800 m away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\"></span> <span class=\"info-line\">\n{{ vm.shop.phone }}</span></div><div layout=\"row\"><span class=\"icon-web icon\"></span> <span class=\"info-line\">\n{{ vm.shop.website }}</span></div></div><hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" \nlayout-align=\"end center\"></div></md-card-content></md-card></div><form name=\"voucherDefForm\" flex=\"grow\" \nflex-gt-xs=\"50\" class=\"padding\"><div class=\"fields\"><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span\n class=\"field-name\">Points gathered per unit of currency spent</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nHow many points will user get per unit of currency spent in your shop.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><span ng-bind-html=\"vm.getCurrencyByCountry(vm.shop.country_id)\">\n</span> <input name=\"value_to_points_currency\" type=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" \nng-model=\"vm.voucherDef.value_to_points_currency\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEPOINTSVOUCHER.VALUE_TO_POINTS_CURRENCY\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div \nng-messages=\"voucherDefForm.value_to_points_currency.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATEPOINTSVOUCHER.ERRORS.VALUE_TO_POINTS_CURRENCY_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.value_to_points_currency }}</span></div></div>\n</md-input-container><span style=\"padding-top: 20px\">=</span><md-input-container class=\"md-block\" md-no-float><span>\npoints</span> <input name=\"value_to_points_points\" type=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" \nng-model=\"vm.voucherDef.value_to_points_points\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEPOINTSVOUCHER.VALUE_TO_POINTS_POINTS\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.value_to_points_points.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEPOINTSVOUCHER.ERRORS.VALUE_TO_POINTS_POINTS_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.value_to_points_points }}</span></div></div></md-input-container></div><div \nclass=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Points per unit of currency</span>\n<md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nHow many points must a user obtain to get a unit of your local currency.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><span>points</span> <input name=\"points_to_value_points\" \ntype=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" ng-model=\"vm.voucherDef.points_to_value_points\" placeholder=\"Number\" \ntranslate translate-attr-placeholder=\"CREATEPOINTSVOUCHER.POINTS_TO_VALUE_POINTS\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.points_to_value_points.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEPOINTSVOUCHER.ERRORS.POINTS_TO_VALUE_POINTS_REQUIRED\">\nMinimum days of activity field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.points_to_value_points }}</span></div></div></md-input-container><span \nstyle=\"padding-top: 20px\">=</span><md-input-container class=\"md-block\" md-no-float><span \nng-bind-html=\"vm.getCurrencyByCountry(vm.shop.country_id)\"></span> <input name=\"points_to_value_currency\" \ntype=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" ng-model=\"vm.voucherDef.points_to_value_currency\" placeholder=\"Number\" \ntranslate translate-attr-placeholder=\"CREATEPOINTSVOUCHER.POINTS_TO_VALUE_CURRENCY\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div \nng-messages=\"voucherDefForm.points_to_value_currency.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATEPOINTSVOUCHER.ERRORS.POINTS_TO_VALUE_CURRENCY_REQUIRED\">Minimum days of activity field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.points_to_value_currency }}\n</span></div></div></md-input-container></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span \nclass=\"field-name\">Days to expiration</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nDays to expiration from the moment this voucher is issued.</md-tooltip></md-button></div><md-input-container \nclass=\"md-block\" md-no-float><input name=\"expire_days\" type=\"number\" min=\"0\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.expire_days\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEPOINTSVOUCHER.EXPIRE_DAYS\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.expire_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEPOINTSVOUCHER.ERRORS.EXPIRE_DAYS_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.expire_days }}\n</span></div></div></md-input-container></div><div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\">\n<span class=\"field-name\">Description</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher description, it will be displayed on the front of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.message\" \nname=\"message\" translate-attr-placeholder=\"CREATEPOINTSVOUCHER.DESCRIPTION_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(voucherDefForm)\" aria-label=\"Message\"></text-angular></md-input-container><div \nlayout=\"row\"><span flex></span> <span style=\"font-size: 12px\">{{vm.voucherDef.message.length}}/255 Available characters\n</span></div><div ng-messages=\"voucherDefForm.message.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"CREATEPOINTSVOUCHER.ERRORS.DESCRIPTION_REQUIRED\">Description field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.message }}</span></div></div>\n</div><div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Conditions</span>\n<md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher conditions, it will be displayed on the back of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.conditions\" \nname=\"conditions\" translate-attr-placeholder=\"CREATEPOINTSVOUCHER.CONDITIONS_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(voucherDefForm)\"></text-angular></md-input-container><div layout=\"row\"><span flex>\n</span> <span style=\"font-size: 12px\">{{vm.voucherDef.conditions.length}}/255 Available characters</span></div><div \nng-messages=\"voucherDefForm.conditions.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"CREATEPOINTSVOUCHER.ERRORS.CONDITIONS_REQUIRED\">Description field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.conditions }}</span></div>\n</div></div></div><div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap><md-button \nclass=\"md-button-auto-width\" ng-click=\"vm.saveVoucherDef(voucherDefForm, vm.voucherDef)\" \nng-disabled=\"voucherDefForm.$invalid\">Save & Search Users</md-button></div></form></md-card-content></md-card><md-card>\n<md-card-header><md-card-header-text><span class=\"md-title\">Valid users</span></md-card-header-text></md-card-header>\n<md-card-content layout=\"column\" layout-align=\"center\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"membershipcard in vm.validUsers\" layout=\"row\" layout-align=\"start center\"><img \nsrc=\"/assets/images/avatars/empty_avatar.jpeg\" alt=\"\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3>\n{{membershipcard.user.name}}</h3><p>{{membershipcard.code | membershipcardNumber}}</p></div><div \nclass=\"md-list-item-text\" hide show-gt-xs><p>{{membershipcard.total_points}} Total points</p></div><div \nclass=\"md-list-item-text\" hide show-gt-xs><p \nng-bind-html=\"vm.formatAsCurrency(membershipcard.voucher_value, vm.shop.country_id) + \' Current voucher value\'\"></p>\n</div><div class=\"md-list-item-text\" hide show-gt-xs><p>{{ membershipcard.stats.remaining_points }} Remaining points\n</p></div><md-checkbox ng-model=\"membershipcard.selected\" ng-change=\"vm.updateTotalValue()\"></md-checkbox>\n</md-list-item><md-list-item class=\"md-2-line\" ng-if=\"vm.validUsers.length == 0\"><div class=\"md-list-item-text\"><h2>\nNo valid users match the search criteria</h2></div></md-list-item></md-list><div flex=\"grow\" layout=\"row\" \nlayout-align=\"end\" class=\"card-buttons\" ng-if=\"vm.validUsers.length\"><span class=\"explain-text\"><b \nng-bind-html=\"vm.formatAsCurrency(vm.totalValue, vm.shop.country_id) + \' worth of vouchers will be created\'\"></b>\n</span></div><div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap class=\"card-buttons\" \nng-if=\"vm.validUsers.length\"><md-button class=\"md-button-auto-width\" aria-label=\"Select all\" \nng-click=\"vm.selectAllValidUsers()\" ng-if=\"vm.numberOfSelectedUsers!=vm.validUsers.length\">Select all</md-button>\n<md-button class=\"md-button-auto-width\" aria-label=\"Deselect all\" ng-click=\"vm.deselectAllValidUsers()\" \nng-if=\"vm.numberOfSelectedUsers==vm.validUsers.length\">Deselect all</md-button><md-button class=\"md-button-auto-width\" \naria-label=\"Create & send\" ng-click=\"vm.createVouchers()\" ng-disabled=\"!vm.numberOfSelectedUsers\">Create & send\n</md-button></div></md-card-content></md-card></div>");
$templateCache.put("app/main/createreengagevoucher/createreengagevoucher.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nui-sref=\"app.vouchersconfig({category: \'re-engage\'})\"><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a>\n<h1>Create Re-engage vouchers</h1></div><div id=\"create-welcome-voucher\" class=\"simple right-sidenav\"><md-card>\n<md-card-content layout=\"row\" layout-wrap layout-align=\"start center\"><div class=\"vouchers padding\" flex=\"grow\" \nflex-gt-xs=\"50\"><md-card class=\"voucher-card\" layout=\"column\"><md-card-content><div layout=\"row\" class=\"sub-header\" \nflex=\"grow\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"vm.shop.logo_full_url\" \nng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!vm.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ vm.shop.name }}</h1><span>{{ vm.shop.category.title }}</span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"noshrink\"><md-switch aria-label=\"check-in\" ng-click=\"vm.toggleCheckin(voucher)\" \nng-model=\"voucher.is_checked_in\"></md-switch><span class=\"checkin-text\">Check in</span></div></div></div><hr><div \nclass=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"ticket\" layout=\"row\" \nflex=\"grow\"><div class=\"message-box\" layout=\"column\" flex=\"grow\" layout-align=\"center\"><h3 class=\"voucher-type\">\nRe-engage voucher</h3><div ng-bind-html=\"vm.voucherDef.message || \'Please insert a voucher description\'\"></div></div>\n<div class=\"value-box\" layout=\"column\" flex=\"noshrink\" layout-align=\"center center\"><span><b>Expires {{ vm.expires_at}}\n</b></span><h1 id=\"voucher-value\"><span ng-bind-html=\"getCurrencyByCountry(vm.shop.country_id)\"></span>\n{{ vm.voucherDef.value || \'0\'}}</h1><span>{{ vm.voucherDef.code | voucherNumber}}</span></div></div></div><div \nclass=\"additional-info\"><div layout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div \nlayout=\"column\"><span class=\"info-line\">{{vm.shop.locations[0].address}}</span> <span class=\"info-line\">\n800 m away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\"></span> <span class=\"info-line\">\n{{ vm.shop.phone }}</span></div><div layout=\"row\"><span class=\"icon-web icon\"></span> <span class=\"info-line\">\n{{ vm.shop.website }}</span></div></div><hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" \nlayout-align=\"end center\"></div></md-card-content></md-card></div><form name=\"voucherDefForm\" flex=\"grow\" \nflex-gt-xs=\"50\" class=\"padding\"><div class=\"fields\"><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span\n class=\"field-name\">User minimum days of absence</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter the minimum number of days user must be absent to receive voucher.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><input name=\"min_absence\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.min_absence\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEREENGAGEVOUCHER.MIN_ABSENCE_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.min_absence.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEREENGAGEVOUCHER.ERRORS.MIN_ABSENCE_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.min_absence }}\n</span></div></div></md-input-container></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span \nclass=\"field-name\">Re-engage voucher value</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter the monetary value for this voucher.</md-tooltip></md-button></div><div layout=\"row\"><span \nng-bind-html=\"getCurrencyByCountry(vm.shop.country_id)\"></span><md-input-container class=\"md-block\" md-no-float><input \nname=\"value\" type=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" ng-model=\"vm.voucherDef.value\" placeholder=\"Number\" \ntranslate translate-attr-placeholder=\"CREATEREENGAGEVOUCHER.VALUE_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm); vm.adjustValueSize()\"><div \nng-messages=\"voucherDefForm.value.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATEREENGAGEVOUCHER.ERRORS.VALUE_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.value }}</span></div></div></md-input-container>\n</div></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Days to expiration\n</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nDays to expiration from the moment this voucher is issued.</md-tooltip></md-button></div><md-input-container \nclass=\"md-block\" md-no-float><input name=\"expire_days\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.expire_days\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEREENGAGEVOUCHER.EXPIRE_DAYS_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.expire_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEREENGAGEVOUCHER.ERRORS.EXPIRE_DAYS_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.expire_days }}\n</span></div></div></md-input-container></div><div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\">\n<span class=\"field-name\">Description</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher description, it will be displayed on the front of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.message\" \nname=\"description\" translate-attr-placeholder=\"CREATEREENGAGEVOUCHER.MESSAGE_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(shopConfigForm)\"></text-angular></md-input-container><div layout=\"row\" \nng-if=\"vm.editMode\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.voucherDef.message.length}}/255 Available characters</span></div><div ng-messages=\"voucherDefForm.message.$error\" \nrole=\"alert\" style=\"color: red; font-size: 12px\"><div ng-message=\"required\"><span \ntranslate=\"SHOPCONFIG.ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.description }}</span></div></div></div><div \nclass=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Conditions</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher conditions, it will be displayed on the back of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.conditions\" \nname=\"conditions\" translate-attr-placeholder=\"CREATEREENGAGEVOUCHER.CONDITIONS_FIELD\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(shopConfigForm)\"></text-angular><div \nng-messages=\"voucherDefForm.conditions.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATEREENGAGEVOUCHER.ERRORS.CONDITIONS_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.conditions }}</span></div></div>\n</md-input-container></div></div><div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap><md-button \nclass=\"md-button-auto-width\" ng-click=\"vm.saveVoucherDef(voucherDefForm, vm.voucherDef)\" \nng-disabled=\"voucherDefForm.$invalid\">Save & Search Users</md-button></div></form></md-card-content></md-card><md-card>\n<md-card-header><md-card-header-text><span class=\"md-title\">Valid users</span></md-card-header-text></md-card-header>\n<md-card-content layout=\"column\" layout-align=\"center\" class=\"padding\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"membershipcard in vm.validUsers\" layout=\"row\" layout-align=\"start center\"><img \nsrc=\"/assets/images/avatars/empty_avatar.jpeg\" alt=\"\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3>\n{{membershipcard.user.name}}</h3><p>{{membershipcard.code | membershipcardNumber}}</p></div><div \nclass=\"md-list-item-text\" hide show-gt-xs><p>{{ membershipcard.stats.stamp_last_period }}</p></div><md-checkbox \nng-model=\"membershipcard.selected\" ng-change=\"vm.updateTotalValue()\"></md-checkbox></md-list-item><md-list-item \nclass=\"md-2-line\" ng-if=\"vm.validUsers.length == 0\"><div class=\"md-list-item-text\"><h2>\nNo valid users match the search criteria</h2></div></md-list-item></md-list><div flex=\"grow\" layout=\"row\" \nlayout-align=\"end\" class=\"card-buttons\" ng-if=\"vm.validUsers.length\"><span class=\"explain-text\"><b \nng-bind-html=\"vm.formatAsCurrency(vm.totalValue, vm.shop.country_id) + \' worth of vouchers will be created\'\"></b>\n</span></div><div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap class=\"card-buttons\" \nng-if=\"vm.validUsers.length\"><md-button class=\"md-button-auto-width\" aria-label=\"Select all\" \nng-click=\"vm.selectAllValidUsers()\" ng-if=\"vm.numberOfSelectedUsers!=vm.validUsers.length\">Select all</md-button>\n<md-button class=\"md-button-auto-width\" aria-label=\"Deselect all\" ng-click=\"vm.deselectAllValidUsers()\" \nng-if=\"vm.numberOfSelectedUsers==vm.validUsers.length\">Deselect all</md-button><md-button class=\"md-button-auto-width\" \naria-label=\"Create & send\" ng-click=\"vm.createVouchers()\" ng-disabled=\"!vm.numberOfSelectedUsers\">Create & send\n</md-button></div></md-card-content></md-card></div>");
$templateCache.put("app/main/createshop/createshop.html","<div id=\"shop-config\" class=\"right-sidenav\"><md-card><md-card-header><md-card-header-text><span class=\"md-title\">\nShop information</span></md-card-header-text></md-card-header><md-card-content><form name=\"createShopForm\" novalidate \nng-submit=\"vm.saveShopConfiguration(createShopForm, vm.form)\" layout=\"row\" layout-wrap layout-align=\"center\"><div \nlayout=\"row\" flex=\"grow\" flex-gt-xs=\"50\" layout-align=\"center center\"><div layout=\"column\" flex=\"noshrink\" \nlayout-align=\"center\"><div class=\"info ng-binding\"><img class=\"shop-logo\" ng-if=\"!vm.logoChanged\" \nng-src=\"/assets/images/logos/default-shop-logo.png\"> <img class=\"shop-logo\" ng-if=\"vm.logoChanged\" \nngf-src=\"vm.form.logo\"></div><div ng-if=\"!vm.logoChanged\" class=\"info ng-binding\"><md-button \nclass=\"md-raised md-accent submit-button md-button-auto-width\" aria-label=\"UPLOAD LOGO\" \ntranslate=\"SHOPCONFIG.UPLOAD_LOGO\" translate-attr-aria-label=\"SHOPCONFIG.UPLOAD_LOGO\" ngf-select \nng-model=\"vm.form.logo\" name=\"logo\" ng-change=\"vm.setLogoChanged()\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-max-size=\"20MB\" ngf-min-height=\"100\" ngf-resize=\"{width: 100, height: 100, centerCrop: true}\"></md-button></div>\n<div ng-if=\"vm.logoChanged\" class=\"info ng-binding\"><md-button \nclass=\"md-raised md-accent submit-button md-button-auto-width\" aria-label=\"CHOOSE ANOTHER LOGO\" \ntranslate=\"SHOPCONFIG.UPLOAD_ANOTHER_LOGO\" translate-attr-aria-label=\"SHOPCONFIG.UPLOAD_ANOTHER_LOGO\" ngf-select \nng-model=\"vm.form.logo\" name=\"logo\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"20MB\" \nngf-min-height=\"100\" ngf-resize=\"{width: 100, height: 100, centerCrop: true}\"></md-button></div></div><div flex=\"grow\" \nlayout=\"row\" layout-align=\"center\"><md-input-container class=\"md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.form.name\" placeholder=\"Name\" translate translate-attr-placeholder=\"CREATE_SHOP.NAME\" required \nng-change=\"resetServerSideValidation(createShopForm)\"><div ng-messages=\"createShopForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CREATE_SHOP.ERRORS.NAME_REQUIRED\">Name field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.name }}</span></div></div></md-input-container>\n</div></div><div class=\"fields\" flex=\"grow\" flex-gt-xs=\"55\"><div class=\"field\" layout=\"row\" layout-xs=\"column\" \nflex=\"grow\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Category</span>\n<md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease select the category that is more closely related to your shop.</md-tooltip></md-button></div><md-input-container\n class=\"md-block\" md-no-float><md-select name=\"category_id\" ng-model=\"vm.form.category_id\" required><md-option \nng-repeat=\"category in vm.categories\" value=\"{{category.id}}\">{{category.title}}</md-option></md-select><div \nng-messages=\"createShopForm.category_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATE_SHOP.ERRORS.CATEGORY_REQUIRED\">Category is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.category_id }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Phone number</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter a valid phone number so your customers can call your shop.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><input name=\"phone\" ng-model=\"vm.form.phone\" placeholder=\"Phone\" \ntranslate translate-attr-placeholder=\"CREATE_SHOP.PHONE\" required \nng-change=\"resetServerSideValidation(createShopForm)\"><div ng-messages=\"createShopForm.phone.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CREATE_SHOP.ERRORS.PHONE_REQUIRED\">Phone field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.phone }}</span></div></div></md-input-container>\n</div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" flex=\"noshrink\" \nlayout-align=\"start center\"><span class=\"field-name\">Website</span><md-button class=\"icon-help-circle tooltip-button\">\n<md-tooltip>Please enter your shops website address.</md-tooltip></md-button></div><md-input-container \nclass=\"md-block\" md-no-float><input name=\"website\" ng-model=\"vm.form.website\" placeholder=\"Website\" translate \ntranslate-attr-placeholder=\"CREATE_SHOP.WEBSITE\" required ng-change=\"resetServerSideValidation(createShopForm)\"><div \nng-messages=\"createShopForm.website.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATE_SHOP.ERRORS.WEBSITE_REQUIRED\">Website field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.website }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Country</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Please select your shops country.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><md-select name=\"country_id\" ng-model=\"vm.form.country_id\" required>\n<md-option ng-repeat=\"country in vm.countries\" value=\"{{country.id}}\">{{country.name}}</md-option></md-select><div \nng-messages=\"createShopForm.country_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATE_SHOP.ERRORS.COUNTRY_REQUIRED\">Country is required</span></div><div ng-message=\"serverSideValidation\">\n<span>{{ vm.serverSideValidationMsg.country_id }}</span></div></div></md-input-container></div><div class=\"field\" \nlayout=\"column\" flex=\"noshrink\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">\nDescription</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter a short description for your shop, this description will be presented to your customers across the app.\n</md-tooltip></md-button></div><md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.form.description\" \nname=\"message\" translate-attr-placeholder=\"CREATE_SHOP.DESCRIPTION\" ta-toolbar-class=\"textangular-btn-toolbar\" \nta-toolbar-button-class=\"textangular-btn\" ng-change=\"resetServerSideValidation(createShopForm)\" \naria-label=\"Description\"></text-angular></md-input-container><div layout=\"row\"><span flex></span> <span \nstyle=\"font-size: 12px\">{{vm.form.description.length || 0}}/255 Character limit</span></div><div \nng-messages=\"voucherDefForm.message.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"CREATE_SHOP.ERRORS.DESCRIPTION_REQUIRED\">Name field is required</span></div><div\n ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.description }}</span></div></div></div></div>\n<div class=\"card-buttons\" layout=\"row\" layout-align=\"end\"><md-button type=\"submit\" class=\"md-button-auto-width\" \naria-label=\"SAVE SHOP CONFIGURATION\" ng-disabled=\"createShopForm.$invalid || createShopForm.$pristine\" \ntranslate=\"CREATE_SHOP.SAVE_CONFIGURATION\" translate-attr-aria-label=\"CREATE_SHOP.SAVE_CONFIGURATION\"></md-button>\n</div></form></md-card-content></md-card></div>");
$templateCache.put("app/main/createwelcomevoucher/createwelcomevoucher.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nui-sref=\"app.vouchersconfig({category: \'welcome\'})\"><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>\nCreate welcome vouchers</h1></div><div id=\"create-welcome-voucher\" class=\"simple right-sidenav\"><md-card>\n<md-card-content layout=\"row\" layout-wrap layout-align=\"start center\"><div class=\"vouchers padding\" flex=\"grow\" \nflex-gt-xs=\"50\"><md-card class=\"voucher-card\" layout=\"column\"><md-card-content><div layout=\"row\" class=\"sub-header\" \nflex=\"grow\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"vm.shop.logo_full_url\" \nng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!vm.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ vm.shop.name }}</h1><span>{{ vm.shop.category.title }}</span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"noshrink\"><md-switch aria-label=\"check-in\" ng-click=\"vm.toggleCheckin(voucher)\" \nng-model=\"voucher.is_checked_in\"></md-switch><span class=\"checkin-text\">Check in</span></div></div></div><hr><div \nclass=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"ticket\" layout=\"row\" \nflex=\"grow\"><div class=\"message-box\" layout=\"column\" flex=\"grow\" layout-align=\"center\"><h3 class=\"voucher-type\">\nWelcome voucher</h3><div ng-bind-html=\"vm.voucherDef.message || \'Please insert a voucher description\'\"></div></div><div\n class=\"value-box\" layout=\"column\" flex=\"noshrink\" layout-align=\"center center\"><span><b>Expires {{vm.expires_at}}</b>\n</span><h1 id=\"voucher-value\" ng-bind-html=\"vm.formatAsCurrency(vm.voucherDef.value, vm.shop.country_id)\"></h1><span>\n{{ vm.voucherDef.code | voucherNumber}}</span></div></div></div><div class=\"additional-info\"><div layout=\"row\"><span \nclass=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><span class=\"info-line\">\n{{vm.shop.locations[0].address}}</span> <span class=\"info-line\">800 m away from you</span></div></div><div \nlayout=\"row\"><span class=\"icon-phone icon\"></span> <span class=\"info-line\">{{ vm.shop.phone }}</span></div><div \nlayout=\"row\"><span class=\"icon-web icon\"></span> <span class=\"info-line\">{{ vm.shop.website }}</span></div></div><hr>\n<div class=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"></div></md-card-content>\n</md-card></div><form name=\"voucherDefForm\" flex=\"grow\" flex-gt-xs=\"50\" class=\"padding\"><div class=\"fields\"><div \nclass=\"field\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">\nUser minimum number of transactions</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter the minimum number of transactions a user must have to receive this voucher.</md-tooltip></md-button>\n</div><md-input-container class=\"md-block\" md-no-float><input name=\"min_transactions\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.min_transactions\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTIONS_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.min_transactions.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEWELCOMEVOUCHER.ERRORS.MIN_TRANSACTIONS_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.min_transactions }}</span></div></div></md-input-container></div><div class=\"field\" \nlayout=\"row\" layout-align=\"start center\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">\nUser minimum number of days active</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter the minimum number of days a user must have to receive this voucher.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><input name=\"min_active_days\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.min_active_days\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTION_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.min_active_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEWELCOMEVOUCHER.ERRORS.MIN_ACTIVE_DAYS_REQUIRED\">\nMinimum days of activity field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.min_active_days }}</span></div></div></md-input-container></div><div class=\"field\" \nlayout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Include current costumers</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Should current active costumers be included in the search?\n</md-tooltip></md-button></div><md-input-container class=\"md-block\" md-no-float><md-checkbox \nname=\"include_active_users\" type=\"number\" ng-model=\"vm.voucherDef.include_active_users\" placeholder=\"Number\" \naria-label=\"costumers_checkbox\" translate translate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTION_FIELD\" \nng-change=\"resetServerSideValidation(voucherDefForm)\"></md-checkbox><div \nng-messages=\"voucherDefForm.include_active_users.$error\" role=\"alert\"><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.include_active_users }}</span></div></div></md-input-container></div><div class=\"field\" \nlayout=\"row\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Welcome voucher value</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Please enter the monetary value for this voucher.</md-tooltip>\n</md-button></div><div layout=\"row\"><md-input-container class=\"md-block\" md-no-float><input name=\"value\" type=\"number\" \npattern=\"[0-9]+([\\,|\\.][0-9]*)?\" ng-model=\"vm.voucherDef.value\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTION_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm); vm.adjustValueSize()\"><div \nng-messages=\"voucherDefForm.value.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CREATEWELCOMEVOUCHER.ERRORS.VALUE_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.value }}</span></div></div></md-input-container>\n<span ng-bind-html=\"vm.getCurrencyByCountry(vm.shop.country_id)\"></span></div></div><div class=\"field\" layout=\"row\">\n<div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Days to expiration</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Days to expiration from the moment this voucher is issued.\n</md-tooltip></md-button></div><md-input-container class=\"md-block\" md-no-float><input name=\"expire_days\" \ntype=\"number\" pattern=\"\\d*\" ng-model=\"vm.voucherDef.expire_days\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTION_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.expire_days.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"CREATEWELCOMEVOUCHER.ERRORS.EXPIRE_DAYS_REQUIRED\">\nField is required</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.expire_days }}\n</span></div></div></md-input-container></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"grow\"><span \nclass=\"field-name\">Eligible user search radius</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nOnly valid users in the search radius will be returned in the search.</md-tooltip></md-button></div><div layout=\"row\">\n<md-input-container class=\"md-block\" md-no-float><input name=\"min_radius\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.voucherDef.min_radius\" placeholder=\"Number\" translate \ntranslate-attr-placeholder=\"CREATEWELCOMEVOUCHER.MIN_TRANSACTION_FIELD\" required \nng-change=\"resetServerSideValidation(voucherDefForm)\"><div ng-messages=\"voucherDefForm.min_radius.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"CREATEWELCOMEVOUCHER.ERRORS.MIN_RADIUS_REQUIRED\">Field is required</span>\n</div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.min_radius }}</span></div></div>\n</md-input-container><span>Km</span></div></div><div class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\">\n<span class=\"field-name\">Description</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher description, it will be displayed on the front of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.message\" \nname=\"message\" translate-attr-placeholder=\"SHOPCONFIG.DESCRIPTION\" ta-toolbar-class=\"textangular-btn-toolbar\" \nta-toolbar-button-class=\"textangular-btn\" ng-change=\"resetServerSideValidation(voucherDefForm)\"></text-angular>\n</md-input-container><div layout=\"row\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.voucherDef.message.length}}/255 Available characters</span></div><div ng-messages=\"voucherDefForm.message.$error\" \nrole=\"alert\" style=\"color: red; font-size: 12px\"><div ng-message=\"required\"><span \ntranslate=\"CREATEWELCOMEVOUCHER.ERRORS.DESCRIPTION_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.message }}</span></div></div></div><div \nclass=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"grow\"><span class=\"field-name\">Conditions</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter your voucher conditions, it will be displayed on the back of the card.</md-tooltip></md-button></div>\n<md-input-container class=\"md-block\" md-no-float><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.voucherDef.conditions\" \nname=\"conditions\" translate-attr-placeholder=\"SHOPCONFIG.DESCRIPTION\" ta-toolbar-class=\"textangular-btn-toolbar\" \nta-toolbar-button-class=\"textangular-btn\" ng-change=\"resetServerSideValidation(voucherDefForm)\"></text-angular>\n</md-input-container><div layout=\"row\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.voucherDef.conditions.length}}/255 Available characters</span></div><div \nng-messages=\"voucherDefForm.conditions.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"CREATEWELCOMEVOUCHER.ERRORS.CONDITIONS_REQUIRED\">Field is required</span></div>\n<div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.conditions }}</span></div></div></div></div>\n<div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap><md-button class=\"md-button-auto-width\" \nng-click=\"vm.saveVoucherDef(voucherDefForm, vm.voucherDef)\" ng-disabled=\"voucherDefForm.$invalid\">Save & Search Users\n</md-button></div></form></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span \nclass=\"md-title\">Valid users</span></md-card-header-text></md-card-header><md-card-content layout-align=\"center\">\n<md-list><md-list-item class=\"md-2-line\" ng-repeat=\"membershipcard in vm.validUsers\" layout=\"row\" \nlayout-align=\"start center\"><img src=\"/assets/images/avatars/empty_avatar.jpeg\" alt=\"\" class=\"md-avatar\"><div \nclass=\"md-list-item-text\"><h3>{{membershipcard.user.name}}</h3><p>{{membershipcard.code | membershipcardNumber}}</p>\n</div><div class=\"md-list-item-text\" hide show-gt-xs><p>{{ membershipcard.stats.user_active_period }}</p></div><div \nclass=\"md-list-item-text\" hide show-gt-xs><p ng-if=\"membershipcard.stats.is_active_user\">Current costumer</p></div>\n<md-checkbox ng-model=\"membershipcard.selected\" ng-change=\"vm.updateTotalValue()\"></md-checkbox></md-list-item>\n<md-list-item class=\"md-2-line\" ng-if=\"vm.validUsers.length == 0\"><div class=\"md-list-item-text\"><h2>\nNo valid users match the search criteria</h2></div></md-list-item></md-list><div flex=\"grow\" layout=\"row\" \nlayout-align=\"end\" class=\"card-buttons\" ng-if=\"vm.validUsers.length\"><span class=\"explain-text\"><b \nng-bind-html=\"vm.formatAsCurrency(vm.totalValue, vm.shop.country_id) + \' worth of vouchers will be created\'\"></b>\n</span></div><div flex=\"grow\" layout=\"row\" layout-align=\"end center\" layout-wrap class=\"card-buttons\" \nng-if=\"vm.validUsers.length\"><md-button class=\"md-button-auto-width\" aria-label=\"Select all\" \nng-click=\"vm.selectAllValidUsers()\" ng-if=\"vm.numberOfSelectedUsers!=vm.validUsers.length\">Select all</md-button>\n<md-button class=\"md-button-auto-width\" aria-label=\"Deselect all\" ng-click=\"vm.deselectAllValidUsers()\" \nng-if=\"vm.numberOfSelectedUsers==vm.validUsers.length\">Deselect all</md-button><md-button class=\"md-button-auto-width\" \naria-label=\"Create & send\" ng-click=\"vm.createVouchers()\" ng-disabled=\"!vm.numberOfSelectedUsers\">Create & send\n</md-button></div></md-card-content></md-card></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\">\n<ms-widget-front class=\"padding-16 md-white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"shoplocal-colors-fg font-size-72 line-height-72\">{{vm.widget1.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div></ms-widget-front></ms-widget><ms-widget\n flippable=\"false\"><ms-widget-front class=\"padding-16 md-white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"shoplocal-colors-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}\n</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\"><ms-widget-front class=\"padding-16 md-white-bg\"><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"shoplocal-colors-fg font-size-72 line-height-72\">\n{{vm.widget3.data.count}}</div><div class=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\"><ms-widget-front class=\"padding-16 md-white-bg\"><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"shoplocal-colors-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div></ms-widget-front></ms-widget></div><div\n class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><h1>Favourite Shop:</h1></div></div></div></div>");
$templateCache.put("app/main/editoperator/editoperator.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a ui-sref=\"app.shopconfig\"><span \nmd-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>{{vm.operator.shop.name}} operator</h1></div><div \nid=\"edit-operator\" class=\"right-sidenav\"><md-card><md-card-content><form name=\"editOperatorForm\" novalidate \nng-submit=\"vm.saveOperator(editOperatorForm, vm.operator)\"><div class=\"fields\"><div class=\"field\" layout=\"row\" \nlayout-xs=\"column\"><span flex=\"50\" class=\"field-name\" translate=\"EDITOPERATOR.EMAIL\">Email</span><md-input-container \nclass=\"md-block\" md-no-float flex=\"grow\" flex-gt-xs=\"50\"><input name=\"email\" ng-disabled=\"vm.cannotEdit\" \nng-model=\"vm.operator.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"EDITOPERATOR.EMAIL\" required \nng-change=\"resetServerSideValidation(editOperatorForm)\"><div ng-messages=\"editOperatorForm.email.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"EDITOPERATOR.ERRORS.EMAIL_REQUIRED\"></span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container>\n</div><div class=\"field-blockless\" layout=\"row\" layout-align=\"start center\" flex=\"grow\"><span flex=\"grow\" \nclass=\"field-name\" translate=\"EDITOPERATOR.IS_ACTIVE\">Is active</span><div flex=\"grow\" layout=\"row\" layout-align=\"end\">\n<md-switch ng-disabled=\"vm.operatorIsOwner\" name=\"is_active\" ng-model=\"vm.operator.is_active\" aria-label=\"is-active\">\n</md-switch></div></div><div class=\"field-blockless\" layout=\"row\" layout-align=\"start center\"><span flex=\"grow\" \nclass=\"field-name\" translate=\"EDITOPERATOR.CAN_EDIT_SHOP\">Can edit shop information</span><div flex=\"grow\" \nlayout=\"row\" layout-align=\"end\"><md-switch ng-disabled=\"vm.operatorIsOwner\" name=\"has_edit_rights\" \nng-model=\"vm.operator.has_edit_rights\" aria-label=\"has-edit-rights\"></md-switch></div></div><div class=\"\" layout=\"row\" \nlayout-align=\"end\"><md-button ng-if=\"vm.operator.id\" ng-click=\"vm.deleteOperator(vm.operator)\" \nng-disabled=\"vm.operatorIsOwner\" translate=\"EDITOPERATOR.DELETE_OPERATOR\" \ntranslate-attr-aria-label=\"EDITOPERATOR.DELETE_OPERATOR\">Delete</md-button><md-button type=\"submit\" class=\"\" \naria-label=\"SAVE SHOP CONFIGURATION\" ng-disabled=\"editOperatorForm.$invalid || editOperatorForm.$pristine\" \ntranslate=\"EDITOPERATOR.SAVE_OPERATOR\" translate-attr-aria-label=\"EDITOPERATOR.SAVE_OPERATOR\">Save</md-button></div>\n</div></form></md-card-content></md-card></div>");
$templateCache.put("app/main/editshoplocation/editshoplocation.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a ui-sref=\"app.shopconfig\"><span \nmd-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>{{vm.shop.name}} location</h1></div><div \nid=\"edit-shop-location\" class=\"page-layout simple right-sidenav\" layout=\"column\"><md-card><md-card-content><form \nname=\"shopLocationForm\" novalidate ng-submit=\"vm.saveLocation(shopLocationForm, vm.location)\"><div layout=\"row\" \nlayout-xs=\"column\"><div class=\"fields\" flex=\"grow\" layout=\"column\"><div class=\"field\" layout=\"row\" layout-xs=\"column\" \nflex=\"grow\" layout-align=\"start center\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><span \nclass=\"field-name\" translate=\"EDITSHOPLOCATION.TOWN_BRANCH_NAME\">Town/Branch Name</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>{{ \'EDITSHOPLOCATION.TOWN_BRANCH_NAME_MSG\' | translate}}\n</md-tooltip></md-button></div><md-input-container class=\"md-block\" md-no-float flex=\"grow\" flex-gt-xs=\"50\"><input \nname=\"name\" ng-model=\"vm.location.name\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"EDITSHOPLOCATION.TOWN_BRANCH_NAME\" required \nng-change=\"resetServerSideValidation(shopLocationForm)\"><div ng-messages=\"shopLocationForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"EDITSHOPLOCATION.ERRORS.NAME_REQUIRED\">Name field is required</span></div>\n<div ng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.name }}</span></div></div></md-input-container>\n</div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" flex=\"50\" \nlayout-align=\"start center\"><span class=\"field-name\" translate=\"EDITSHOPLOCATION.ZIPCODE\">Post code</span><md-button \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>{{ \'EDITSHOPLOCATION.ZIPCODE_MSG\' | translate}}</md-tooltip>\n</md-button></div><md-input-container class=\"md-block\" md-no-float flex=\"grow\" flex-gt-xs=\"50\"><input name=\"zipcode\" \nng-model=\"vm.location.zipcode\" placeholder=\"Post code\" translate translate-attr-placeholder=\"EDITSHOPLOCATION.ZIPCODE\" \nrequired ng-change=\"resetServerSideValidation(shopLocationForm)\"><div ng-messages=\"shopLocationForm.zipcode.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EDITSHOPLOCATION.ERRORS.ZIPCODE_REQUIRED\">\nPost code field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ serverSideValidationMsg.zipcode }}</span></div></div></md-input-container></div><div class=\"field\" layout=\"row\" \nlayout-xs=\"column\" flex=\"grow\"><div layout=\"row\" flex=\"50\" layout-align=\"start center\"><span class=\"field-name\" \ntranslate=\"EDITSHOPLOCATION.ADDRESS\">Address</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\n{{ \'EDITSHOPLOCATION.ADDRESS_MSG\' | translate}}</md-tooltip></md-button></div><md-input-container class=\"md-block\" \nmd-no-float flex=\"grow\" flex-gt-xs=\"50\"><textarea name=\"address\" ng-model=\"vm.location.address\" placeholder=\"Address\" \ntranslate translate-attr-placeholder=\"EDITSHOPLOCATION.ADDRESS\" required \nng-change=\"resetServerSideValidation(shopLocationForm)\"></textarea><div ng-messages=\"shopLocationForm.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"EDITSHOPLOCATION.ERRORS.ADDRESS_REQUIRED\">\nAddress field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ serverSideValidationMsg.address }}</span></div></div></md-input-container></div><div class=\"field\" layout=\"row\" \nlayout-xs=\"column\" flex=\"grow\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\" \ntranslate=\"EDITSHOPLOCATION.LOCATION\">Location</span><md-button class=\"icon-help-circle tooltip-button\"><md-tooltip>\n{{ \'EDITSHOPLOCATION.LOCATION_MSG\' | translate}}</md-tooltip></md-button></div><div flex=\"grow\" layout=\"row\" \nlayout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span class=\"field-value\" \nng-if=\"vm.location.latitude && vm.location.longitude\">{{ vm.location.latitude }}, {{vm.location.longitude}}</span>\n</div></div></div><div class=\"locationMap-container\" flex=\"grow\"><div id=\"locationMap\"></div></div></div><div class=\"\" \nlayout=\"row\" layout-align=\"end\"><md-button ng-if=\"!vm.isNewLocation\" ng-click=\"vm.removeLocation()\">Delete</md-button>\n<md-button type=\"submit\" class=\"md-button-auto-width\" aria-label=\"SAVE SHOP CONFIGURATION\" \nng-disabled=\"shopLocationForm.$invalid\" translate=\"EDITSHOPLOCATION.SAVE_SHOP_LOCATION\" \ntranslate-attr-aria-label=\"EDITSHOPLOCATION.SAVE_SHOP_LOCATION\">Save shop configuration</md-button></div></form>\n</md-card-content></md-card></div>");
$templateCache.put("app/main/editstampcard/editstampcard.html","<div id=\"edit-stampcard\" class=\"right-sidenav\"><md-card ng-if=\"vm.loading\"><md-card-content layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3 \ntranslate=\"SHOPS.LOADING\">Loading</h3></md-card-content></md-card><md-card \nng-if=\"vm.shops.length > 1 || !vm.hasOwnShop\"><md-card-header><md-card-header-text><span class=\"md-title\">\nStore selection</span></md-card-header-text></md-card-header><md-card-content><div ng-if=\"vm.shops.length > 1\"><span \nclass=\"explain-text\" translate=\"EDITSTAMPCARD.SELECT_STORE_MESSAGE\">\nSince you have edit rights in more than one shop, you must select a store first to view its properties</span><div \nlayout=\"row\" layout-wrap><div flex=\"grow\" flex-gt-xs=\"50\"><h3>Select a store</h3><md-select name=\"shop\" \nclass=\"shop-name-select no-margin\" ng-model=\"vm.currentShop\" flex=\"grow\" ng-change=\"vm.updateShopData()\" \naria-label=\"Select shop\"><md-option ng-repeat=\"shop in vm.shops\" ng-value=\"shop\">{{ shop.name }}</md-option>\n</md-select></div></div></div><br><div ng-if=\"!vm.hasOwnShop\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><span class=\"explain-text\" flex=\"grow\">It seems you don\'t have your own Shop configured\n</span><div flex=\"noshrink\"><md-button class=\"md-button-auto-width no-margin\" aria-label=\"Create your own shop\" \nng-click=\"state.go(\'app.createshop\', {enableOnStateChangeStartHandler: false})\">Create your own shop</md-button></div>\n</div></md-card-content></md-card><div ng-if=\"vm.shop\"><md-card><md-card-header><md-card-header-text><span \nclass=\"md-title\">Stampcard information</span></md-card-header-text></md-card-header><md-card-content layout=\"row\" \nlayout-xs=\"column\" id=\"card-parent\"><div class=\"stampcards\" flex=\"grow\" flex-gt-xs=\"50\"><md-card class=\"stamp-card\" \nid=\"stamp-card\" layout=\"column\"><md-card-content><div layout=\"row\" class=\"sub-header\" flex=\"grow\"><div \nclass=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"vm.shop.logo_full_url\" \nng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!vm.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ vm.shop.name }}</h1><span>{{ stampcard.shop.category.title }}</span></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"noshrink\"><md-switch aria-label=\"check-in\" \nng-click=\"vm.toggleCheckin(stampcard)\" ng-model=\"stampcard.shop.closest_location.is_checked_in\"></md-switch><span \nclass=\"checkin-text\">Check in</span></div></div></div><div class=\"content\" flex=\"grow\" layout=\"row\" layout-wrap \nlayout-align=\"center\"><span class=\"description\" flex=\"grow\" \nng-bind-html=\"vm.shop.stampcard.description || \'No description\'\"></span><div class=\"stamp\" \nng-repeat=\"stamp in vm.totalStamps\" layout-align=\"center center\"><img src=\"assets/images/icons/stamp_empty.png\" alt=\"\">\n</div><div class=\"stamp\" layout=\"column\" layout-align=\"center center\"><img src=\"assets/images/icons/stamp_final.png\" \nalt=\"\"> <span>{{ vm.shop.stampcard.reward_text || \'No reward text\'}}</span></div></div><div class=\"additional-info\">\n<div layout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><span \nclass=\"info-line\">{{vm.shop.locations[0].address}}</span> <span class=\"info-line\">800 m away from you</span></div>\n</div><div layout=\"row\"><span class=\"icon-phone icon\"></span> <span class=\"info-line\">{{ vm.shop.phone }}</span></div>\n<div layout=\"row\"><span class=\"icon-web icon\"></span> <span class=\"info-line\">{{ vm.shop.website }}</span></div></div>\n<hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.flipCard(stampcard, $index, true)\">Terms</md-button><md-button class=\"map-button\" \nng-click=\"vm.flipCard(stampcard, $index, false)\">Map <span class=\"icon-map-marker\"></span></md-button></div>\n</md-card-content></md-card></div><form name=\"stampCardForm\" class=\"form\" novalidate \nng-submit=\"vm.saveStampCardForm(stampCardForm, vm.shop.stampcard)\" flex=\"grow\" flex-gt-xs=\"50\"><div class=\"fields\"><div\n class=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span \nclass=\"field-name\">Stamp card offer</span><md-button ng-if=\"vm.editMode\" class=\"icon-help-circle tooltip-button\">\n<md-tooltip>Enter your offer text for the stamp card e.g. Buy 5 Coffees and get the 6th Free</md-tooltip></md-button>\n</div><div flex=\"grow\" layout=\"row\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span \nng-bind-html=\"vm.shop.stampcard.description || \'No description\'\"></span></div><md-input-container ng-if=\"vm.editMode\" \nclass=\"md-block\" md-no-float><text-angular ta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" \nrequired ng-model=\"vm.shop.stampcard.description\" name=\"description\" \ntranslate-attr-placeholder=\"SHOPCONFIG.DESCRIPTION\" ta-toolbar-class=\"textangular-btn-toolbar\" \nta-toolbar-button-class=\"textangular-btn\" ng-change=\"resetServerSideValidation(stampCardForm)\"></text-angular>\n</md-input-container><div layout=\"row\" ng-if=\"vm.editMode\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.shop.stampcard.description.length}}/255 Available characters</span></div><div \nng-messages=\"stampCardForm.description.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"EDITSTAMPCARD.ERRORS.DESCRIPTION_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.description }}</span></div></div></div><div \nclass=\"field-block\" layout=\"column\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span \nclass=\"field-name\">Conditions</span><md-button ng-if=\"vm.editMode\" class=\"icon-help-circle tooltip-button\"><md-tooltip>\nEnter the conditions for the use of this card e.g. Cannot be stamped stamped more than twice a day</md-tooltip>\n</md-button></div><div flex=\"grow\" layout=\"row\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span \nng-bind-html=\"vm.shop.stampcard.conditions || \'No conditions\'\"></span></div><md-input-container ng-if=\"vm.editMode\" \nclass=\"md-block\" md-no-float><text-angular ta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" \nrequired ng-model=\"vm.shop.stampcard.conditions\" name=\"conditions\" translate-attr-placeholder=\"SHOPCONFIG.DESCRIPTION\" \nta-toolbar-class=\"textangular-btn-toolbar\" ta-toolbar-button-class=\"textangular-btn\" \nng-change=\"resetServerSideValidation(stampCardForm)\"></text-angular></md-input-container><div layout=\"row\" \nng-if=\"vm.editMode\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.shop.stampcard.conditions.length}}/255 Available characters</span></div><div \nng-messages=\"stampCardForm.conditions.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"EDITSTAMPCARD.ERRORS.DESCRIPTION_REQUIRED\">Field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.conditions }}</span></div></div></div><div \nclass=\"field\" layout=\"row\"><div layout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">\nReward text</span><md-button ng-if=\"vm.editMode\" class=\"icon-help-circle tooltip-button\"><md-tooltip>\nText meant to appear below the last stamp in your card.</md-tooltip></md-button></div><div flex=\"grow\" layout=\"row\" \nlayout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span>\n{{ vm.shop.stampcard.reward_text || \'No reward text\'}}</span></div><md-input-container ng-if=\"vm.editMode\" \nclass=\"md-block\" md-no-float><input name=\"reward_text\" ng-model=\"vm.shop.stampcard.reward_text\" \nplaceholder=\"Reward text\" translate translate-attr-placeholder=\"EDITSTAMPCARD.REWARD_TEXT\" required \nng-change=\"resetServerSideValidation(stampCardForm)\"><div ng-messages=\"stampCardForm.reward_text.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"EDITSTAMPCARD.ERRORS.REWARD_TEXT_REQUIRED\">Reward text field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.reward_text }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"noshrink\" \nlayout-align=\"start center\"><span class=\"field-name\">Total stamps</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Total stamp count, afterwards you must reward your customer.\n</md-tooltip></md-button></div><div flex=\"grow\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" \nng-if=\"!vm.editMode\"><span>{{ vm.shop.stampcard.stamps_total || \'0\'}}</span></div><md-input-container \nng-if=\"vm.editMode\" class=\"md-block\" md-no-float><input name=\"stamps_total\" type=\"number\" pattern=\"\\d*\" \nng-model=\"vm.shop.stampcard.stamps_total\" placeholder=\"Stamps total\" translate \ntranslate-attr-placeholder=\"EDITSTAMPCARD.STAMPS_TOTAL\" required \nng-change=\"resetServerSideValidation(stampCardForm); vm.createStampTotalArray()\"><div \nng-messages=\"stampCardForm.stamps_total.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"EDITSTAMPCARD.ERRORS.STAMPS_TOTAL_REQUIRED\">Stamps total field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.stamp_total }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\"><div layout=\"row\" flex=\"noshrink\" \nlayout-align=\"start center\"><span class=\"field-name\">Days to expiration</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nDays until stampcard expires, starting the moment customer receives their stampcard.</md-tooltip></md-button></div><div\n flex=\"grow\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span>\n{{ vm.shop.stampcard.expire_days || \'0\'}}</span></div><md-input-container ng-if=\"vm.editMode\" class=\"md-block\" \nmd-no-float><input name=\"expire_days\" type=\"number\" pattern=\"\\d*\" ng-model=\"vm.shop.stampcard.expire_days\" \nplaceholder=\"Stamps total\" translate translate-attr-placeholder=\"EDITSTAMPCARD.EXPIRE_DAYS\" required \nng-change=\"resetServerSideValidation(stampCardForm)\"><div ng-messages=\"stampCardForm.expire_days.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"EDITSTAMPCARD.ERRORS.EXPIRE_DAYS_REQUIRED\">Stamps total field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ serverSideValidationMsg.expire_days }}</span></div></div>\n</md-input-container></div><div class=\"card-buttons\" layout=\"row\" layout-align=\"end\"><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"SAVE STAMPCARD\" ng-disabled=\"stampCardForm.$invalid\" \ntranslate=\"EDITSTAMPCARD.SAVE_STAMPCARD\" translate-attr-aria-label=\"EDITSTAMPCARD.SAVE_STAMPCARD\" ng-if=\"vm.editMode\">\n</md-button><md-button md-no-ink md-no-focus-style aria-label=\"Cancel\" translate=\"EDITSTAMPCARD.CANCEL\" \ntranslate-attr-aria-label=\"EDITSTAMPCARD.CANCEL\" ng-click=\"vm.cancelEditMode()\" ng-if=\"vm.editMode\"></md-button>\n<md-button md-no-ink md-no-focus-style aria-label=\"Edit\" translate=\"EDITSTAMPCARD.EDIT\" \ntranslate-attr-aria-label=\"EDITSTAMPCARD.EDIT\" ng-click=\"vm.enableEditMode()\" ng-if=\"!vm.editMode\"></md-button></div>\n</div></form></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">\nStampcard configuration</span></md-card-header-text></md-card-header><md-card-content><div class=\"fields\" flex=\"grow\">\n<div class=\"field-blockless\" layout=\"row\" layout-align=\"start center\" flex=\"grow\"><span flex=\"grow\">Enable stamp cards\n</span><div flex=\"grow\" layout=\"row\" layout-align=\"end\"><md-switch ng-disabled=\"!vm.shop.stampcard\" \nng-model=\"vm.shop.stampcard.is_active\" aria-label=\"shop-is-active\" \nng-click=\"vm.changeStampcardConfiguration(vm.shop.stampcard, true);\"></md-switch></div></div></div></md-card-content>\n</md-card></div></div>");
$templateCache.put("app/main/error/error.html","<md-card><md-card-content layout=\"column\" layout-align=\"start center\"><h2>\nIt appears there has been some error on our part. Sorry!</h2><img style=\"height: 300px\" \nsrc=\"assets/images/etc/error.jpg\" alt=\"\"><h3>{{ vm.exceptionObject.msg }}</h3><p><a href=\"#\" \nng-click=\"vm.goToPreviousState()\">Click here</a> to go back</p></md-card-content></md-card>");
$templateCache.put("app/main/forgotpassword/forgotpassword.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span><img src=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" \ntranslate=\"FORGOTPASSWORD.TITLE\">Recover your password</div><form name=\"forgotPasswordForm\" ng-if=\"!vm.resendSuccess\" \nnovalidate ng-submit=\"vm.resend(forgotPasswordForm, vm.form)\"><md-input-container class=\"md-block\" md-no-float><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-change=\"vm.checkEmail(forgotPasswordForm, vm.form)\"><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div \nng-if=\"vm.resendSuccess\" class=\"title\" translate=\"FORGOTPASSWORD.SUCCESS\">E-mail successfully sent</div><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img \nsrc=\"/assets/images/logos/MainLogo.png\"></span></div><form name=\"loginForm\" novalidate \nng-submit=\"vm.login(loginForm, vm.form)\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-change=\"resetServerSideValidation(loginForm)\"><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \nclass=\"email-required\" translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span class=\"email-valid\" translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"serverSideValidation\"><span \nclass=\"server-side-validation-message\">{{ vm.serverSideValidationMsg }}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required \nng-change=\"resetServerSideValidation(loginForm)\"><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"column\" layout-align=\"space-between center\">\n<md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">\nRemember Me</span></md-checkbox></div><div layout=\"row\"><span flex></span><md-progress-circular ng-if=\"vm.loading\" \nmd-mode=\"indeterminate\"></md-progress-circular><span flex></span></div><md-button ng-if=\"!vm.loading\" type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button><br><div \nclass=\"remember-forgot-password\" layout=\"column\" layout-align=\"space-between center\"></div></form><div \nclass=\"register\" layout=\"column\" layout-sm=\"column\" layout-align=\"center center\"><a ui-sref=\"app.auth_forgotpassword\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password</a> <a \nclass=\"resend-verification md-accent-color\" ui-sref=\"app.auth_resend_verification\" \ntranslate=\"LOGIN.RESEND_VERIFICATION\">Resend verification </a><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"create-account link\" ui-sref=\"app.auth_register\" \ntranslate=\"LOGIN.CREATE_ACCOUNT\">Create an account</a></div></div></div></div>");
$templateCache.put("app/main/myvouchers/myvouchers.html","<md-tabs><md-tab label=\"Nearest\" ng-click=\"vm.setOrdering(\'active\', \'distance\')\"></md-tab><md-tab label=\"Date\" \nng-click=\"vm.setOrdering(\'active\', \'created_at\')\"></md-tab><md-tab label=\"Categories\" \nng-click=\"vm.setOrdering(\'active\', \'shop.category.title\')\"></md-tab><md-tab label=\"A-Z\" \nng-click=\"vm.setOrdering(\'active\', \'shop.name\')\"></md-tab><md-tab label=\"Archive\" \nng-click=\"vm.setOrdering(\'archive\', \'created_at\')\"></md-tab></md-tabs><div id=\"vouchers\" class=\"simple right-sidenav\">\n<md-card ng-if=\"vm.vouchers.length == 0 && !vm.loading\"><md-card-content layout=\"row\" layout-align=\"center\"><h3 \nng-if=\"!vm.archived\">You have no Vouchers</h3><h3 ng-if=\"vm.archived\">You have no Archived Vouchers</h3>\n</md-card-content></md-card><md-card ng-if=\"vm.loading\"><md-card-content layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3 translate=\"SHOPS.LOADING\">Loading</h3>\n</md-card-content></md-card><div class=\"vouchers small-padding\" layout=\"row\" layout-wrap ng-if=\"vm.showCards\" \nms-scroll><div class=\"card\" ng-repeat=\"voucher in vm.vouchers | orderBy: vm.sortOrder\" flex=\"grow\" flex-gt-xs=\"50\" \nng-class=\"{flipped: voucher.flipped, \'no-padding\': voucher.flipped}\"><div class=\"front\"><md-card class=\"voucher-card\" \nlayout=\"column\"><md-card-content><div layout=\"row\" class=\"sub-header\" flex=\"grow\" layout-xs=\"column\"><div \nclass=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"voucher.shop.logo_full_url\" \nng-src=\"{{ voucher.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!voucher.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ voucher.shop.name }}</h1><span>{{ voucher.shop.category_id }}</span></div></div><div \nlayout=\"row\" flex=\"noshrink\" layout-align=\"space-around\" class=\"options\"><div layout=\"column\" \nlayout-align=\"center end\" style=\"padding: 6px 10px 0 0\"><img class=\"favorite-icon\" ng-if=\"!voucher.is_favorite\" \nsrc=\"assets/images/icons/favorite_empty.png\" ng-click=\"vm.setFavorite(voucher, true)\"> <img class=\"favorite-icon\" \nng-if=\"voucher.is_favorite\" src=\"assets/images/icons/favorite_filled.png\" ng-click=\"vm.setFavorite(voucher, false)\"> \n<span class=\"label\">Favorite</span></div><div layout=\"column\" layout-align=\"center end\"><md-switch \naria-label=\"check-in\" ng-click=\"vm.toggleCheckin(voucher)\" ng-model=\"voucher.is_checked_in\"></md-switch><span \nclass=\"label\" translate=\"SHOPS.CHECK_IN\">Check in</span></div></div></div><hr><div ng-if=\"voucher.active_points > 0\" \nflex=\"grow\" layout=\"row\" layout-align=\"end\"><div><b>{{voucher.active_points}} Points collected</b></div></div><div \nclass=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"ticket\" layout=\"row\" \nflex=\"grow\"><div class=\"message-box\" layout=\"column\" flex=\"grow\" layout-align=\"center\"><h3 class=\"voucher-type\">\n{{ voucher.type }} voucher</h3><div ng-bind-html=\"voucher.message\"></div></div><div class=\"value-box\" layout=\"column\" \nflex=\"noshrink\" layout-align=\"center center\"><span><b>Expires {{voucher.expires_at.split(\' \')[0]}}</b></span><h1 \nng-bind-html=\"vm.formatAsCurrency(voucher.value, voucher.shop.country_id)\">${{ voucher.value }}</h1><span>\n{{ voucher.code | voucherNumber }}</span></div></div></div><hr><div class=\"additional-info\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-around\"><div layout=\"row\"><span \nclass=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><a \nng-click=\"vm.flipCard(voucher, $index, false)\">{{ voucher.shop.closest_location.address }}</a> <span class=\"info-line\">\n{{ voucher.rounded_distance }} away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\"></span> \n<a ng-href=\"tel: {{voucher.shop.phone}}\" target=\"_blank\">{{ voucher.shop.phone }}</a></div><div layout=\"row\"><span \nclass=\"icon-web icon\"></span> <a ng-href=\"{{voucher.shop.website}}\" target=\"_blank\">{{ voucher.shop.website }}</a>\n</div></div><div class=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.flipCard(voucher, $index, true)\">Terms</md-button></div></md-card-content><div \nng-if=\"voucher.paid_off_at\" class=\"banner blue-banner\"><div layout=\"row\"><span flex></span> <span>REDEEMED</span> <span\n flex></span></div><div layout=\"row\" layout-align=\"center\"><span style=\"font-size: 10px\">\n{{voucher.paid_off_at.substr(0, 10) | date:\'mediumDate\'}} - {{voucher.paid_off_location.name}} - {{voucher.operator_user.name}}\n</span></div></div><div ng-if=\"voucher.expired && !voucher.paid_off_at\" class=\"banner red-banner\" layout=\"row\" \nlayout-align=\"start center\"><span flex></span> <span>EXPIRED</span> <span flex></span></div></md-card></div><div \nclass=\"back\"><md-card class=\"voucher-card small-padding\" layout=\"column\" ng-if=\"!voucher.showConditions\"><div \nid=\"{{ $index }}-map\" class=\"content map-container no-padding\" flex=\"grow\"></div><div class=\"additional-info\"><div \nlayout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><span \nclass=\"info-line\">{{ voucher.shop.closest_location.address }}</span> <span class=\"info-line\">\n{{ voucher.rounded_distance }} away from you</span></div></div></div><hr><div \nclass=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.unflipCard(voucher)\"><a href=\"tel:{{ voucher.shop.phone }}\">Call</a></md-button><md-button \nng-click=\"vm.unflipCard(voucher)\"><a href=\"{{ voucher.shop.website }}\" target=\"_blank\">Web</a></md-button><md-button \nng-click=\"vm.unflipCard(voucher)\">Back</md-button></div></md-card><md-card class=\"voucher-card\" layout=\"column\" \nng-if=\"voucher.showConditions\"><md-card-content><div layout=\"row\" class=\"sub-header\"><div class=\"shop-info-small\" \nlayout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"voucher.shop.logo_full_url\" \nng-src=\"{{ voucher.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!voucher.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ voucher.shop.name }}</h1><span>Shop category</span></div><div layout=\"column\" \nlayout-align=\"center end\" flex=\"noshrink\"><img class=\"favorite-icon\" ng-if=\"!voucher.is_favorite\" \nsrc=\"assets/images/icons/favorite_empty.png\" ng-click=\"vm.setFavorite(voucher, true)\"> <img class=\"favorite-icon\" \nng-if=\"voucher.is_favorite\" src=\"assets/images/icons/favorite_empty.png\" ng-click=\"vm.setFavorite(voucher, false)\"> \n<span class=\"checkin-text\">Favorite</span></div></div></div><hr><div class=\"content\" flex=\"grow\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"ticket\" layout=\"row\" flex=\"grow\"><div \nclass=\"message-box condition-box\" layout=\"column\" flex=\"grow\" layout-align=\"center\"><h3 class=\"voucher-type\">\n{{ voucher.type }} voucher conditions</h3><div ng-bind-html=\"voucher.conditions\"></div></div></div></div><div \nclass=\"additional-info\"><div layout=\"row\"><span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div \nlayout=\"column\"><span class=\"info-line\">{{ voucher.shop.closest_location.address }}</span> <span class=\"info-line\">\n{{ voucher.rounded_distance }} away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\"></span> \n<span class=\"info-line\">{{ voucher.shop.phone }}</span></div><div layout=\"row\"><span class=\"icon-web icon\"></span> \n<span class=\"info-line\">{{ voucher.shop.website }}</span></div></div><hr><div \nclass=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.unflipCard()\">\nCall</md-button><md-button ng-click=\"vm.unflipCard()\">Web</md-button><md-button ng-click=\"vm.unflipCard(voucher)\">Back\n</md-button></div></md-card-content></md-card></div></div><div id=\"fixedMapDiv\" class=\"map\" data-tap-disabled=\"true\">\n</div></div></div>");
$templateCache.put("app/main/notfound/notfound.html","<md-card><md-card-content layout=\"column\" layout-align=\"start center\"><h2>\nOops, it seems we cannot serve the page you are looking for!</h2><img style=\"height: 300px\" \nsrc=\"assets/images/etc/notfound.jpg\" alt=\"\"><p><a ui-sref=\"vm.goToPreviousState()\">Click here</a> to go back</p>\n</md-card-content></md-card>");
$templateCache.put("app/main/notifications/notifications.html","<div id=\"notifications\" class=\"simple right-sidenav\"><md-card ng-if=\"vm.notifications.length == 0 && !vm.loading\">\n<md-card-content layout=\"row\" layout-align=\"center\"><h3>You have no new notifications</h3></md-card-content></md-card>\n<md-card ng-if=\"vm.loading\"><md-card-content layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular><h3 translate=\"NOTIFICATIONS.LOADING\">Loading</h3></md-card-content>\n</md-card><md-card><md-card-content><md-list><md-list-item ng-repeat=\"notification in vm.notifications\" layout=\"row\">\n<span flex><b ng-bind-html=\"notification.message\"></b></span><p hide show-gt-xs style=\"color: gray\">\n{{notification.created_at}}</p><md-button ng-if=\"notification.user_id == vm.user.id\" class=\"\" aria-label=\"SetToSeen\">\n<span ng-click=\"vm.setToSeen(notification)\">Got it</span></md-button></md-list-item></md-list><div layout=\"row\"><span \nflex></span><md-button ng-if=\"vm.notifications.length > 0 && !vm.loading\" class=\"\" aria-label=\"SetAllToSeen\"><span \nng-click=\"vm.setAllToSeen(notification)\">Dismiss all</span></md-button></div></md-card-content></md-card></div>");
$templateCache.put("app/main/operatelocation/operatelocation.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"operate-location\" \nui-sref=\"app.operatorindex\"><a><span md-ink-ripple=\"#FFF\" class=\"icon-arrow-left\"></span></a><h1>{{ vm.location.name }}\n</h1></div><div class=\"operate-location\" ng-click=\"refresh()\"><a><span md-ink-ripple=\"#FFF\" class=\"icon-refresh\">\n</span></a><h1>Refresh</h1></div></div><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.refreshing\">\n</md-progress-linear><div id=\"operate-location\" class=\"simple right-sidenav\"><md-card><md-card-header \nclass=\"search-bar\" layout=\"column\"><span style=\"margin-bottom: 10px\" ng-if=\"vm.shopDoesNotHaveSubscription\" \nclass=\"subscription-info\">\nYou don\'t have a valid Subscription to use the service, please choose a subscription. Remember you get 60 days FREE before you are charged. \n<a ui-sref=\"app.subscription\">Go to Subscription page.</a></span><form name=\"searchForm\" novalidate \nng-submit=\"vm.search(searchForm)\" flex=\"grow\" layout=\"row\" layout-xs=\"column\"><div class=\"search-box-container\" \nflex=\"grow\" layout=\"row\"><md-input-container class=\"search-box\" md-no-float flex=\"grow\"><input name=\"membercard\" \nng-pattern=\"/^[0-9 ]*$/\" ng-model=\"vm.searchQuery\" placeholder=\"Enter membership number...\" required \nng-change=\"resetServerSideValidation(searchForm)\" ms-membershipcard ng-disabled=\"vm.shopDoesNotHaveSubscription\"><div \nng-messages=\"searchForm.membercard.$error\" role=\"alert\"><div ng-message=\"required\"><span>Membership Number is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.membercard }}</span></div>\n</div></md-input-container><md-button type=\"submit\" class=\"search-qr\" aria-label=\"Search\" \nng-disabled=\"vm.shopDoesNotHaveSubscription\"><span class=\"icon-qrcode\" \nng-if=\"(vm.searchQuery.length == 0 || !vm.searchQuery) && !vm.isIOS\"></span> <span id=\"goSearch\" \nng-if=\"(vm.searchQuery && vm.searchQuery.length != 0) || vm.isIOS\">Go</span></md-button></div><md-button \nclass=\"md-button-auto-width\" ng-disabled=\"vm.shopDoesNotHaveSubscription\" ng-click=\"vm.issueCard()\">CREATE MEMBERSHIP\n</md-button></form></md-card-header><md-card-content layout=\"row\" layout-align=\"center\" layout-wrap><h3 \nng-if=\"!vm.usersAround || vm.usersAround.length == 0\">No checked in users in store</h3><md-list \nng-if=\"vm.usersAround.length > 0\" flex=\"grow\"><md-list-item class=\"md-2-line\" ng-repeat=\"userAround in vm.usersAround\">\n<img class=\"md-avatar\" ng-if=\"!userAround.avatar_full_url\" src=\"/assets/images/avatars/empty_avatar.jpeg\"> <img \nclass=\"md-avatar\" ng-if=\"userAround.avatar_full_url\" ng-src=\"{{ userAround.avatar_full_url }}\"><div \nclass=\"md-list-item-text\"><h3>{{userAround.user.name}}</h3><p>{{userAround.membershipcard.code | membershipcardNumber}}\n</p></div><div class=\"md-list-item-text\" hide show-gt-sm><p>\n{{userAround.active_vouchers ? userAround.active_vouchers.length : 0 }} Vouchers</p></div><div \nclass=\"md-list-item-text\" hide show-gt-sm><p>\n{{ userAround.total_stamps }} of {{ userAround.stampcard_user.stamps_total }} Stamps</p></div><md-button \nng-disabled=\"vm.shopDoesNotHaveSubscription\" \nng-click=\"state.go(\'app.operateuser\', {location:vm.location.id, user: userAround.user.id})\">SELECT</md-button>\n</md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/main/operatelocation/scandialog.html","<md-dialog id=\"scan-dialog\" aria-label=\"Scan dialog\"><md-dialog-content><h2>\nPlease place the QR code into the camera\'s view</h2><div id=\"reader\" style=\"\"></div></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">Cancel</md-button></md-dialog-actions>\n</md-dialog><script type=\"text/javascript\"></script>");
$templateCache.put("app/main/operateuser/operateuser.html","<div class=\"navigation-header\" layout=\"row\" layout-align=\"start center\"><a \nng-click=\"state.go(\'app.operatelocation\', {location: vm.location.id})\"><span md-ink-ripple=\"#FFF\" \nclass=\"icon-arrow-left\"></span></a> <img class=\"user-pic\" ng-if=\"vm.membershipcard.user.avatar_full_url\" \nng-src=\"{{vm.membershipcard.user.avatar_full_url}}\"> <img class=\"user-pic\" \nng-if=\"!vm.membershipcard.user.avatar_full_url\" src=\"/assets/images/avatars/empty_avatar.jpeg\"><div layout=\"column\" \nclass=\"user-info\"><h1>{{ vm.membershipcard.user.name }}</h1><span>{{ vm.membershipcard.code | membershipcardNumber}}\n</span></div></div><div id=\"operate-user\" class=\"simple right-sidenav\"><md-card><md-card-header><md-card-header-text>\n<span class=\"md-title\">Manage Stamp Card</span></md-card-header-text></md-card-header><md-card-content \nng-if=\"!vm.location.shop.stampcard || !vm.location.shop.stampcard.is_active\" layout=\"row\" layout-align=\"center\" \nlayout-xs=\"column\"><div class=\"info\" layout=\"column\" flex=\"grow\" layout-align=\"center\"><h2>No available stampcards</h2>\n</div></md-card-content><md-card-content ng-if=\"vm.location.shop.stampcard && vm.location.shop.stampcard.is_active\" \nlayout=\"row\" layout-align=\"center\" layout-wrap><div class=\"\" layout=\"column\" flex=\"grow\" flex-gt-xs=\"80\" \nlayout-align=\"center center\"><div style=\"width: 100%; padding: 10px; padding-left: 16px\"><p>\nClick/Tap on an empty empty circle to issue a stamp</p></div><md-card class=\"stamp-card padding\" layout=\"column\"><div \nlayout=\"row\" class=\"sub-header\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" \nng-if=\"vm.location.shop.logo_full_url\" ng-src=\"{{ vm.location.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!vm.location.shop.logo_full_url\" src=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" \nlayout=\"column\" flex=\"grow\" layout-align=\"center\"><h1>{{ vm.location.shop.name }}</h1><span>\n{{ vm.categoryMap[vm.location.shop.category_id].title }}</span></div><div layout=\"column\" layout-align=\"center end\" \nflex=\"noshrink\"><md-switch aria-label=\"check-in\" ng-model=\"stampcard.is_checked_in\"></md-switch><span \nclass=\"checkin-text\">Check in</span></div></div></div><div class=\"content\" flex=\"grow\" layout=\"row\" layout-wrap \nlayout-align=\"center\"><span class=\"description\" flex=\"grow\" \nng-bind-html=\"vm.membershipcard.stampcardUserShop.description\"></span><div class=\"stamp\" \nng-repeat=\"(index, stamp) in vm.stamps | orderBy: \'created_at\'\" layout=\"column\" layout-align=\"start center\"><img \nng-if=\"stamp.id && !stamp.new\" ng-src=\"{{\'assets/images/icons/stamp_filled.png\'}}\" alt=\"\"> <img \nng-if=\"stamp.id && stamp.new\" ng-src=\"{{\'assets/images/icons/stamp_filled_new.png\'}}\" alt=\"\"> <img class=\"empty-stamp\" \nng-if=\"!stamp.id && (index < vm.stamps.length-1)\" src=\"assets/images/icons/stamp_empty.png\" alt=\"\" \nng-click=\"vm.addStamp()\"> <img class=\"empty-stamp\" ng-if=\"!stamp.id && (index == vm.stamps.length-1)\" \nsrc=\"assets/images/icons/stamp_final.png\" alt=\"\" ng-click=\"vm.addStamp()\"> <span ng-if=\"stamp.id\">\n{{ stamp.created_at.substr(0,10) | date:\'dd/MM\' }}</span> <span ng-if=\"index == vm.stamps.length-1\" \nid=\"{{ $index }}-voucher-value\" ng-click=\"vm.addStamp()\">{{ vm.membershipcard.stampcardUserShop.reward_text }}</span>\n</div></div><hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"start center\"><div \nflex=\"grow\" layout=\"column\" class=\"address-footer\"><span class=\"address\">{{ vm.location.address }}</span></div>\n<md-button class=\"map-button\">Map <span class=\"icon-map-marker\"></span></md-button><md-button>TERMS</md-button></div>\n</md-card><div style=\"width: 100%; padding: 16px\"><a class=\"md-button-auto-width\" \nng-click=\"vm.removeLastStamp(vm.membershipcard.stampcardUserShop)\" ng-disabled=\"vm.membershipcard.total_stamps==0\">\nREMOVE STAMP</a></div></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span \nclass=\"md-title\">Calculate sale value with vouchers</span></md-card-header-text></md-card-header><md-card-content \nlayout=\"row\" layout-wrap layout-align=\"center\"><div layout=\"column\" flex=\"grow\" flex-gt-xs=\"50\"><h3><b>\nPlease select which vouchers to use</b></h3><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"voucher in vm.membershipcard.active_vouchers | orderBy: \'expires_at\': \'reverse\'\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-list-item-text\" flex=\"grow\"><h3 \nng-bind-html=\"vm.formatAsCurrency(voucher.value) + \' Voucher (\' + voucher.type + \')\'\"></h3></div><md-checkbox \nng-model=\"voucher.selected\" ng-change=\"vm.updateTotalVoucherValue()\" aria-label=\"Select voucher\"></md-checkbox>\n</md-list-item><md-list-item class=\"md-2-line\" ng-if=\"!vm.membershipcard.active_vouchers.length\"><div \nclass=\"md-list-item-text\"><h2>No available vouchers</h2></div></md-list-item></md-list></div><div class=\"\" \nlayout=\"column\" layout-align=\"center\" flex=\"grow\" flex-gt-xs=\"50\"><h3><b>Please insert sale information</b></h3><div \nlayout=\"row\"><h3 flex=\"noshrink\">Original sale value</h3><h2 ng-bind-html=\"vm.currencySymbol\"></h2><md-input-container \nclass=\"md-block\" md-no-float flex=\"noshrink\"><input type=\"number\" pattern=\"[0-9]+([\\,|\\.][0-9]*)?\" \nname=\"original-sales-value\" ng-model=\"vm.originalSalesValue\" placeholder=\"Value\" required \nng-change=\"resetServerSideValidation(profileForm)\"></md-input-container></div><div layout=\"row\"><h3 flex=\"noshrink\"><b>\nTotal voucher value</b></h3><h2 ng-bind-html=\"vm.formatAsCurrency(vm.totalVoucherValue)\"></h2></div><div layout=\"row\">\n<h3 flex=\"noshrink\"><b>New sale value</b></h3><h1 class=\"new-sale-value\" \nng-bind-html=\"vm.formatAsCurrency(vm.getRoundedNewSalesValue())\"></h1></div></div><div class=\"\" layout=\"row\" \nflex=\"grow\" layout-align=\"center\"><md-button class=\"md-button-auto-width\" \nng-disabled=\"vm.getRoundedNewSalesValue() < 0 || vm.loading\" ng-click=\"vm.processAndCheckout()\">process & checkout\n</md-button></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">\nLast transactions</span></md-card-header-text></md-card-header><md-card-content layout=\"row\" layout-align=\"center\" \nlayout-wrap><md-list ng-if=\"vm.transactions.length > 0\" flex=\"grow\"><md-list-item class=\"md-2-line\" \nng-repeat=\"transaction in vm.transactions\" layout=\"row\" layout-wrap><div class=\"md-list-item-text\" flex><h3 \nng-if=\"transaction.type == \'voucher\'\">Voucher reedemed</h3><h3 ng-if=\"transaction.type == \'stamp\'\">Stamp added</h3><h3 \nng-if=\"transaction.type == \'sale\'\">Sale</h3><p>{{ transaction.location }}</p><p hide-gt-xs>{{transaction.created_at}}\n</p><p hide-gt-xs>{{transaction.operator.name}}</p><p ng-if=\"transaction.type == \'stamp\'\">\nStamp card ID: {{transaction.stampcard_id}}</p></div><div class=\"md-list-item-text\" layout=\"row\" layout-align=\"center\" \nhide show-gt-xs><p>{{transaction.operator.name}}</p></div><div class=\"md-list-item-text\" layout=\"row\" \nlayout-align=\"center\" hide show-gt-xs><p>{{transaction.created_at}}</p></div><div class=\"md-list-item-text\" \nlayout=\"row\" layout-align=\"end\"><p ng-if=\"transaction.type == \'voucher\' || transaction.type == \'sale\'\" \nng-bind-html=\"vm.formatAsCurrency(transaction.value)\"></p></div></md-list-item></md-list></md-card-content></md-card>\n</div>");
$templateCache.put("app/main/operatorindex/operatorindex.html","<div id=\"operator-index\" class=\"simple right-sidenav\"><md-card><md-card-header><md-card-header-text><span \nclass=\"md-title\">Select store</span></md-card-header-text></md-card-header><md-card-content><span class=\"explain-text\">\nProcessing screen allows you to process stamp cards and vouchers for your shop, please start by selecting a store and selecting a location you wish to administrate\n</span><div layout=\"row\" layout-xs=\"column\"><div class=\"shop-select padding\" layout=\"column\" flex=\"grow\" \nflex-gt-xs=\"50\"><h3>Select a store</h3><div layout=\"row\"><md-select name=\"shop\" class=\"shop-name-select no-margin\" \nng-model=\"vm.currentShop\" flex=\"grow\" ng-change=\"vm.onShopSelect()\" aria-label=\"Select shop\"><md-option \nng-repeat=\"shop in vm.shops\" ng-value=\"shop\">{{ shop.name }}</md-option></md-select></div></div><div \nclass=\"shop-info-small padding\" layout=\"row\" flex=\"grow\" flex-gt-xs=\"50\" layout-align=\"center center\"><img \nclass=\"icon\" ng-if=\"vm.currentShop.logo_full_url\" ng-src=\"{{ vm.currentShop.logo_full_url }}\" alt=\"\"> <img \nclass=\"icon\" ng-if=\"!vm.currentShop.logo_full_url && vm.currentShop\" src=\"assets/images/logos/mainLogo.png\" alt=\"\"><div\n class=\"info\" layout=\"column\" layout-align=\"center\"><h1>{{ vm.currentShop.name }}</h1></div></div></div>\n</md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Locations</span>\n</md-card-header-text></md-card-header><md-card-content layout=\"row\" layout-align=\"center\" layout-wrap><h3 \nng-if=\"!vm.currentShop\">Please select a store</h3><md-list ng-if=\"vm.currentShop\" flex=\"grow\"><md-list-item \nclass=\"md-2-line\" ng-repeat=\"location in vm.currentShop.locations\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"md-list-item-text\"><h3>{{location.name}}</h3><p>{{location.address}}</p></div><div class=\"md-list-item-text\" \nhide show-gt-xs><p>{{location.zipcode}}</p></div><md-button style=\"color: white\" \nui-sref=\"app.operatelocation({location: location.id})\" translate=\"OPERATORINDEX.OPERATE_BUTTON\" aria-label=\"Operate\">\n</md-button></md-list-item></md-list></md-card-content></md-card></div>");
$templateCache.put("app/main/operators/operators.html","<div id=\"operators\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div><div \nclass=\"profile-box info-box general md-whiteframe-1dp layout-column\" layout=\"column\"><div class=\"content\"><div \nlayout=\"row\"><div flex class=\"table-header\"></div><div flex class=\"table-header\"></div><div flex class=\"table-header\">\nActive</div><div flex class=\"table-header\">Configure shop</div><div flex class=\"table-header\"></div></div><div \nlayout=\"row\" ng-repeat=\"operator in vm.operators\"><div flex class=\"\" layout-align=\"center end\"><md-input-container \nclass=\"md-block\" md-no-float><p>{{ operator.user.email }}</p></md-input-container></div><div flex class=\"\" \nlayout-align=\"center end\"><md-input-container class=\"md-block\" md-no-float><p>{{ operator.user.name }}</p>\n</md-input-container></div><div flex class=\"\" layout-align=\"center end\"><md-input-container class=\"md-block\" \nmd-no-float><md-switch name=\"is_active\" ng-model=\"operator.is_active\" \nng-change=\"vm.saveOperator(operatorForm, operator)\" aria-label=\"active\"></md-switch></md-input-container></div><div \nflex class=\"\" layout-align=\"center end\"><md-input-container class=\"md-block\" md-no-float><md-switch \nname=\"has_edit_rights\" ng-model=\"operator.has_edit_rights\" aria-label=\"has_edit_rights\" \nng-change=\"vm.saveOperator(operatorForm, operator)\"></md-switch></md-input-container></div><div flex class=\"\" \nlayout-align=\"center end\"><md-input-container class=\"md-block\" md-no-float><md-button \nng-click=\"vm.deleteoperator(operator.id)\" class=\"md-raised md-warn\">delete</md-button></md-input-container></div></div>\n<div layout=\"row\" ng-if=\"vm.showAddOperatorForm()\"><form layout=\"row\" name=\"addOperatorForm\" novalidate \nng-submit=\"vm.addOperator(addOperatorForm, vm.newOperator)\"><div flex class=\"\" layout-align=\"center end\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.newOperator.email\" \nplaceholder=\"E-mail\" translate translate-attr-placeholder=\"SHOPOPERATORS.EMAIL_PLACEHOLDER\" required \nng-change=\"resetServerSideValidation(operatorForm)\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"addOperatorForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SHOPOPERATORS.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"SHOPOPERATORS.ERRORS.EMAIL_INVALID\">Provide a valid e-mail address</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container>\n</div><div flex class=\"\" layout-align=\"center end\"><md-input-container class=\"md-block\" md-no-float>\n{{ vm.newOperator.user.name }}</md-input-container></div><div flex class=\"\" layout-align=\"center end\">\n<md-input-container class=\"md-block\" md-no-float><md-switch name=\"is_active\" ng-model=\"vm.newOperator.is_active\" \naria-label=\"active\"></md-switch></md-input-container></div><div flex class=\"\" layout-align=\"center end\">\n<md-input-container class=\"md-block\" md-no-float><md-switch name=\"has_edit_rights\" \nng-model=\"vm.newOperator.has_edit_rights\" aria-label=\"has_edit_rights\"></md-switch></md-input-container></div><div \nflex class=\"\" layout-align=\"center end\"><md-input-container class=\"md-block\" md-no-float><md-button type=\"submit\" \nclass=\"md-raised md-primary submit-button\">save</md-button></md-input-container></div></form></div><md-button \nng-click=\"vm.showAddOperatorForm(true)\" class=\"md-raised md-primary\" translate=\"SHOPOPERATORS.ADD_OPERATOR\">\nAdd operator</md-button></div></div></div></div></div>");
$templateCache.put("app/main/product/product.html","<div id=\"product\" class=\"simple right-sidenav\" layout=\"column\"><md-card ng-if=\"vm.loading\"><md-card-content \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3 \ntranslate=\"PRODUCT.LOADING\">Loading</h3></md-card-content></md-card><md-card ng-if=\"!vm.order.product\"><md-card-content\n layout=\"row\" layout-wrap layout-align=\"space-around center\"><h3 style=\"font-weight: bold\" flex=\"grow\" \ntranslate=\"PRODUCT.SELECT_PRODUCT_MESSAGE\">\nBesides the subscription packages we offer different products for you to purchase, take a look at what we have to offer\n</h3><br><h3 flex=\"grow\" translate=\"PRODUCT.OFFER_MESSAGE\">OFFER_MESSAGE</h3><div flex=\"grow\" layout=\"row\" \nlayout-align=\"center\"><img class=\"sample-card\" src=\"assets/images/etc/sample_card.png\"></div><md-card \nng-repeat=\"product in vm.products\" class=\"purchase-card\" md-ink-ripple ng-click=\"vm.buyProduct(product)\" \nlayout=\"column\" layout-align=\"center center\"><h2>{{product.name}}</h2><p>{{product.description}}</p><p \nng-bind-html=\"vm.formatAsCurrency(product.price, 1)\"></p><span>CLICK TO PURCHASE</span></md-card><h3 flex=\"grow\" \ntranslate=\"PRODUCT.DOWNLOAD_PRINTABLE_CARDS\">PRINTABLE CARDS MESSAGE</h3><div layout=\"column\" \nlayout-align=\"start center\"><img style=\"height: 400px; width: 320px\" \nsrc=\"assets/images/etc/printable_cards_preview.png\" alt=\"\"><md-button type=\"submit\" \nonclick=\"window.open(\'assets/pdf/printable-cards.pdf\')\" class=\"md-button-auto-width\">DOWNLOAD PDF</md-button></div>\n</md-card-content></md-card><md-card ng-if=\"vm.order.product\"><md-card-content layout=\"column\" \nlayout-align=\"start center\"><form name=\"buyProductForm\" flex=\"grow\" style=\"width: 100%\"><div class=\"field\" \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float><span flex=\"grow\" class=\"field-name\">Quantity</span> \n<input name=\"quantity\" type=\"number\" pattern=\"\\d*\" ng-model=\"vm.order.quantity\" placeholder=\"Quantity\" translate \ntranslate-attr-placeholder=\"PRODUCT.QUANTITY\" required ng-change=\"resetServerSideValidation(buyProductForm)\"><div \nng-messages=\"buyProductForm.quantity.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PRODUCT.ERRORS.QUANTITY_REQUIRED\">Field is required</span></div><div ng-message=\"serverSideValidation\">\n<span>{{ vm.serverSideValidationMsg.quantity }}</span></div></div></md-input-container></div><div class=\"field\" \nlayout=\"row\"><md-input-container class=\"md-block\" md-no-float><span flex=\"grow\" class=\"field-name\" \ntranslate=\"PRODUCT.SHIPPING_ADDRESS\">Shipping address</span><textarea name=\"address\" ng-model=\"vm.order.address\" \nplaceholder=\"Shipping address\" translate translate-attr-placeholder=\"PRODUCT.SHIPPING_ADDRESS\" required \nng-change=\"resetServerSideValidation(buyProductForm)\"></textarea><div ng-messages=\"buyProductForm.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"PRODUCT.ERRORS.SHIPPING_ADDRESS_REQUIRED\">Field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.address }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\"><md-input-container class=\"md-block\" md-no-float><span \nflex=\"grow\" class=\"field-name\" translate=\"PRODUCT.COMMENTS\">Comments</span><textarea name=\"comments\" \nng-model=\"vm.order.comments\" placeholder=\"Comments\" translate translate-attr-placeholder=\"PRODUCT.COMMENTS\" \nng-change=\"resetServerSideValidation(buyProductForm)\"></textarea><div ng-messages=\"buyProductForm.comments.$error\" \nrole=\"alert\"><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.comments }}</span></div></div>\n</md-input-container></div><div layout=\"row\"><span flex></span><md-button class=\"md-button-auto-width\" \naria-label=\"Buy\" ng-click=\"vm.placeOrder(buyProductForm)\" ng-disabled=\"buyProductForm.$invalid\">GO TO CART</md-button>\n</div></form></md-card-content></md-card></div>");
$templateCache.put("app/main/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>\n<img src=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" translate=\"REGISTER.TITLE\" \nng-if=\"!vm.registrationSuccess\">Create an account</div><form name=\"registerForm\" ng-if=\"!vm.registrationSuccess\" \nnovalidate ng-submit=\"vm.register(registerForm, vm.form)\"><md-input-container class=\"md-block\" md-no-float><input \nname=\"name\" ng-model=\"vm.form.name\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER.NAME\" required \nng-change=\"resetServerSideValidation(registerForm)\"><div ng-messages=\"registerForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span class=\"name-required\" translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">\nUsername field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.name }}</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-change=\"vm.checkEmail(registerForm, vm.form)\"><div ng-messages=\"registerForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span class=\"email-required\" translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div><div ng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div><div ng-message=\"serverSideValidation\"><span \nclass=\"server-side-validation-message\">{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" required \nng-change=\"resetServerSideValidation(registerForm)\"><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span class=\"password-required\" translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.password }}</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password_confirmation\" ng-model=\"vm.form.password_confirmation\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required \nng-change=\"resetServerSideValidation(registerForm)\"><div ng-messages=\"registerForm.password_confirmation.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span class=\"password_confirmation-required\" \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label>Country</label><md-select \nng-model=\"vm.form.country_id\"><md-option ng-repeat=\"country in vm.countries\" value=\"{{country.id}}\">{{country.name}}\n</md-option></md-select><div ng-messages=\"registerForm.country_id.$error\" role=\"alert\"><div ng-message=\"required\"><span\n class=\"country-required\" translate=\"REGISTER.ERRORS.COUNTRY_REQUIRED\">Country field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.country_id }}</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input name=\"zipcode\" ng-model=\"vm.form.zipcode\" \nplaceholder=\"Postal / Zip code\" translate translate-attr-placeholder=\"REGISTER.ZIPCODE\" required \nng-change=\"resetServerSideValidation(registerForm)\"><div ng-messages=\"registerForm.zipcode.$error\" role=\"alert\"><div \nng-message=\"required\"><span class=\"zipcode-required\" translate=\"REGISTER.ERRORS.ZIPCODE_REQUIRED\">\nPostal / Zip code field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.zipcode }}</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n</md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">\nI read and accept</span> <a href=\"http://shoplocalclubcard.com/terms-conditions/\" class=\"md-accent-color terms-href\" \ntranslate=\"REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form></div></div></div>");
$templateCache.put("app/main/resendverification/resendverification.html","<div id=\"resend-verification\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"resend-verification-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"resend-verification-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img src=\"/assets/images/logos/MainLogo.png\"></span>\n</div><div class=\"title\" translate=\"RESEND_VERIFICATION.TITLE\">Recover your password</div><form \nname=\"resendVerificationForm\" ng-if=\"!resendSuccess\" novalidate ng-submit=\"vm.resend(resendVerificationForm, vm.form)\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email address\" translate translate-attr-placeholder=\"RESEND_VERIFICATION.EMAIL_ADRESS\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-change=\"vm.checkEmail(resendVerificationForm, vm.form)\"><div \nng-messages=\"resendVerificationForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESEND_VERIFICATION.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\">\n<span translate=\"RESEND_VERIFICATION.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"resendVerificationForm.$invalid || resendVerificationForm.$pristine\" \ntranslate=\"RESEND_VERIFICATION.SEND_RESET_LINK\" translate-attr-aria-label=\"RESEND_VERIFICATION.SEND_RESET_LINK\">\nSEND RESET LINK</md-button></form><div ng-if=\"resendSuccess\" class=\"title\" translate=\"RESEND_VERIFICATION.SUCCESS\">\nE-mail successfully sent</div><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.auth_login\" translate=\"RESEND_VERIFICATION.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/resetpassword/resetpassword.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img \nsrc=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" translate=\"RESET_PASSWORD.TITLE\">\nReset your password</div><form name=\"resetPasswordForm\" novalidate ng-submit=\"vm.reset(resetPasswordForm, vm.form)\" \nng-if=\"!vm.resetSuccess\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"RESET_PASSWORD.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required ng-change=\"resetServerSideValidation(resetPasswordForm)\"><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.email }}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"RESET_PASSWORD.PASSWORD\" required \nng-change=\"resetServerSideValidation(resetPasswordForm)\"><div ng-messages=\"resetPasswordForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"RESET_PASSWORD.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div><div ng-message=\"serverSideValidation\"><span>\n{{ vm.serverSideValidationMsg.password }}</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password_confirmation\" ng-model=\"vm.form.password_confirmation\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"RESET_PASSWORD.PASSWORD_CONFIRM\" required \nng-change=\"resetServerSideValidation(resetPasswordForm)\"><div \nng-messages=\"resetPasswordForm.password_confirmation.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"resetPasswordForm.$invalid || registerForm.$pristine\" translate=\"RESET_PASSWORD.RESET_PASSWORD\" \ntranslate-attr-aria-label=\"RESET_PASSWORD.RESET_PASSWORD\">CREATE MY ACCOUNT</md-button></form><div class=\"col-xs-12\" \nng-if=\"vm.resetSuccess!=null\"><div class=\"form-group panel-success mtop-15\" ng-if=\"vm.resetSuccess\"><div \nclass=\"panel-heading description-block\">Password Reset Success<br>{{verifySuccessMessage}}</div></div></div></div>\n</div></div>");
$templateCache.put("app/main/shopconfig/shopconfig.html","<div id=\"shop-config\" class=\"simple right-sidenav\" layout=\"column\"><md-card ng-if=\"vm.loading\"><md-card-content \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3 \ntranslate=\"SHOPS.LOADING\">Loading</h3></md-card-content></md-card><md-card \nng-if=\"vm.shops.length > 1 || !vm.hasOwnShop\"><md-card-header><md-card-header-text><span class=\"md-title\">\nStore selection</span></md-card-header-text></md-card-header><md-card-content><div ng-if=\"vm.shops.length > 1\"><span \nclass=\"explain-text\" translate=\"SHOPCONFIG.SELECT_STORE_MESSAGE\">\nYou have edit rights in more than one shop, you must select a store to view its properties</span><div layout=\"row\" \nlayout-wrap><div flex=\"grow\" flex-gt-xs=\"50\"><h3>Select a store</h3><md-select name=\"shop\" \nclass=\"shop-name-select no-margin\" ng-model=\"vm.currentShop\" flex=\"grow\" ng-change=\"vm.updateShopData()\" \naria-label=\"Select shop\"><md-option ng-repeat=\"shop in vm.shops\" ng-value=\"shop\">{{ shop.name }}</md-option>\n</md-select></div></div><br></div><div ng-if=\"!vm.hasOwnShop\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><span class=\"explain-text\" flex=\"grow\" translate=\"SHOPCONFIG.CREATE_SHOP\">\nIt seems you don\'t have your own Shop configured</span><div flex=\"noshrink\"><md-button \nclass=\"md-button-auto-width no-margin\" aria-label=\"Create your own shop\" ng-click=\"vm.startWizard()\">\nCreate your own shop</md-button></div></div></md-card-content></md-card><div ng-if=\"vm.shop\"><md-card><md-card-header>\n<md-card-header-text><span class=\"md-title\">Shop information</span></md-card-header-text></md-card-header>\n<md-card-content><form name=\"shopConfigForm\" novalidate ng-submit=\"vm.saveShopConfiguration(shopConfigForm, vm.shop)\" \nlayout=\"row\" layout-wrap layout-align=\"center\"><div flex=\"grow\" flex-gt-xs=\"80\" layout-align=\"end\" layout=\"row\"><span \nng-if=\"!vm.shop.is_active\" class=\"not-active\"><span class=\"icon-alert-octagon\"></span>\n This shop needs to be verified by our team</span> <span ng-if=\"vm.shop.is_active\" class=\"active\"><span \nclass=\"icon-checkbox-marked-circle\"></span> Verified shop</span></div><div flex=\"grow\" flex-gt-xs=\"80\" \nstyle=\"margin-bottom: 10px\" layout-align=\"end\" layout=\"row\"><span ng-if=\"vm.shop.subscription\" \nclass=\"subscription-info\"><span ng-if=\"vm.shop.subscriptionStatus==\'trial\'\">Trial</span>\n {{ vm.shop.subscription }} subscription</span> <span ng-if=\"!vm.shop.subscription\" class=\"subscription-info\">\nYou don\'t have a valid Subscription to use the service, please choose a subscription. Remember you get 60 days FREE before you are charged.\n<br><a ui-sref=\"app.subscription\">Go to Subscription page.</a></span></div><div layout=\"row\" flex=\"grow\" \nflex-gt-xs=\"50\" layout-align=\"center center\"><div layout=\"column\" flex=\"noshrink\" layout-align=\"center\"><div \nclass=\"info ng-binding\"><img class=\"shop-logo\" ng-if=\"!vm.logoChanged && vm.shop.logo_full_url\" \nng-src=\"{{vm.shop.logo_full_url}}\"> <img class=\"shop-logo\" ng-if=\"!vm.logoChanged && !vm.shop.logo_full_url\" \nng-src=\"/assets/images/logos/default-shop-logo.png\"> <img class=\"shop-logo\" ng-if=\"vm.editMode && vm.logoChanged\" \nngf-src=\"vm.shop.logo\"></div><div ng-if=\"vm.editMode\" class=\"info ng-binding\"><md-button \nclass=\"md-raised md-accent submit-button md-button-auto-width\" aria-label=\"UPLOAD LOGO\" \ntranslate=\"SHOPCONFIG.UPLOAD_LOGO\" translate-attr-aria-label=\"SHOPCONFIG.UPLOAD_LOGO\" ngf-select \nng-model=\"vm.shop.logo\" name=\"logo\" ng-change=\"vm.setLogoChanged()\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-max-size=\"3MB\" ngf-min-height=\"100\" ngf-resize=\"{width: 100, height: 100, centerCrop: true}\"></md-button></div><p \nng-if=\"shopConfigForm.logo.$invalid\">Image error, image must be at least 100px tall and less than 3mb in size.</p>\n</div><div flex=\"grow\" layout=\"row\" layout-align=\"center\"><h1 ng-if=\"!vm.editMode\"><b>{{vm.shop.name}}</b></h1>\n<md-input-container class=\"md-block\" md-no-float ng-if=\"vm.editMode\"><input name=\"name\" ng-model=\"vm.shop.name\" \ntranslate translate-attr-placeholder=\"SHOPCONFIG.NAME\" required ng-change=\"resetServerSideValidation(shopConfigForm)\">\n<div ng-messages=\"shopConfigForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SHOPCONFIG.ERRORS.NAME_REQUIRED\">Name field is required</span></div><div ng-message=\"serverSideValidation\">\n<span>{{ vm.serverSideValidationMsg.name }}</span></div></div></md-input-container></div></div><div class=\"fields\" \nflex=\"grow\" flex-gt-xs=\"55\"><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Category</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease select the category that is more closely related to your shop.</md-tooltip></md-button></div><div flex=\"grow\" \nlayout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span class=\"field-value\">\n{{ vm.shop.category_title }}</span></div><md-input-container ng-if=\"vm.editMode\" class=\"md-block\" md-no-float>\n<md-select name=\"category_id\" ng-model=\"vm.shop.category_id\" required><md-option ng-repeat=\"category in vm.categories\" \nvalue=\"{{category.id}}\">{{category.title}}</md-option></md-select><div ng-messages=\"shopConfigForm.category_id.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"SHOPCONFIG.ERRORS.CATEGORY_REQUIRED\">Category is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.category_id }}</span></div>\n</div></md-input-container></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Phone number</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter a valid phone number so your customers can call your shop.</md-tooltip></md-button></div><div flex=\"grow\" \nlayout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span class=\"field-value\">\n{{ vm.shop.phone }}</span></div><md-input-container ng-if=\"vm.editMode\" class=\"md-block\" md-no-float><input \nname=\"phone\" ng-model=\"vm.shop.phone\" placeholder=\"Phone\" translate translate-attr-placeholder=\"SHOPCONFIG.PHONE\" \nrequired ng-change=\"resetServerSideValidation(shopConfigForm)\"><div ng-messages=\"shopConfigForm.phone.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"SHOPCONFIG.ERRORS.PHONE_REQUIRED\">Phone field is required\n</span></div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.phone }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Website</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Please enter your shops website address.</md-tooltip></md-button>\n</div><div flex=\"grow\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span \nclass=\"field-value\">{{ vm.shop.website }}</span></div><md-input-container ng-if=\"vm.editMode\" class=\"md-block\" \nmd-no-float><input name=\"website\" ng-model=\"vm.shop.website\" placeholder=\"Website\" translate \ntranslate-attr-placeholder=\"SHOPCONFIG.WEBSITE\" required ng-change=\"resetServerSideValidation(shopConfigForm)\"><div \nng-messages=\"shopConfigForm.website.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SHOPCONFIG.ERRORS.WEBSITE_REQUIRED\">Website field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.website }}</span></div></div>\n</md-input-container></div><div class=\"field\" layout=\"row\" layout-xs=\"column\" flex=\"grow\"><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Country</span><md-button ng-if=\"vm.editMode\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Please select your shops country.</md-tooltip></md-button></div>\n<div flex=\"grow\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\" ng-if=\"!vm.editMode\"><span \nclass=\"field-value\">{{ vm.shop.country_name }}</span></div><md-input-container class=\"md-block\" md-no-float \nng-if=\"vm.editMode \"><md-select name=\"country_id\" ng-model=\"vm.shop.country_id\" required><md-option \nng-repeat=\"country in vm.countryList\" value=\"{{country.id}}\">{{country.name}}</md-option></md-select><div \nng-messages=\"shopConfigForm.country_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"SHOPCONFIG.ERRORS.COUNTRY_REQUIRED\">Country is required</span></div><div ng-message=\"serverSideValidation\">\n<span>{{ vm.serverSideValidationMsg.country_id }}</span></div></div></md-input-container></div><div class=\"field\"><div \nlayout=\"row\" flex=\"noshrink\" layout-align=\"start center\"><span class=\"field-name\">Description</span><md-button \nng-if=\"vm.editMode\" class=\"icon-help-circle tooltip-button\"><md-tooltip>\nPlease enter a short description for your shop. This description will be presented to your customers across the app.\n</md-tooltip></md-button></div><div ng-if=\"!vm.editMode\"><div ng-bind-html=\"vm.shop.description\"></div></div>\n<md-input-container ng-if=\"vm.editMode\" class=\"md-block\"><text-angular \nta-toolbar=\"[[\'bold\', \'italics\', \'underline\', \'ul\', \'ol\', \'quote\']]\" required ng-model=\"vm.shop.description\" \nname=\"description\" translate-attr-placeholder=\"SHOPCONFIG.DESCRIPTION\" ta-toolbar-class=\"textangular-btn-toolbar\" \nta-toolbar-button-class=\"textangular-btn\" ng-change=\"resetServerSideValidation(shopConfigForm)\"></text-angular>\n</md-input-container><div layout=\"row\" ng-if=\"vm.editMode\"><span flex></span> <span style=\"font-size: 12px\">\n{{vm.shop.description.length}}/255 Available characters</span></div><div \nng-messages=\"shopConfigForm.description.$error\" role=\"alert\" style=\"color: red; font-size: 12px\"><div \nng-message=\"required\"><span translate=\"SHOPCONFIG.ERRORS.DESCRIPTION_REQUIRED\">Description field is required</span>\n</div><div ng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.description }}</span></div></div>\n</div></div><div class=\"card-buttons\" layout=\"row\" layout-align=\"end\"><md-button md-no-ink md-no-focus-style \ntype=\"submit\" aria-label=\"SAVE MY PROFILE\" translate=\"PROFILE.SAVE_PROFILE\" \ntranslate-attr-aria-label=\"PROFILE.SAVE_PROFILE\" ng-if=\"vm.editMode\" ng-disabled=\"shopConfigForm.$invalid\"></md-button>\n<md-button md-no-ink md-no-focus-style aria-label=\"Cancel\" translate=\"PROFILE.CANCEL_EDIT_PROFILE\" \ntranslate-attr-aria-label=\"PROFILE.CANCEL_EDIT_PROFILE\" ng-click=\"vm.cancelEditMode()\" ng-if=\"vm.editMode\"></md-button>\n<md-button md-no-ink md-no-focus-style aria-label=\"Edit\" translate=\"PROFILE.EDIT_PROFILE\" \ntranslate-attr-aria-label=\"PROFILE.EDIT_PROFILE\" ng-click=\"vm.enableEditMode()\" ng-if=\"!vm.editMode\"></md-button></div>\n</form></md-card-content></md-card><md-card hide><md-card-header><md-card-header-text><span class=\"md-title\">\nOther configuration</span></md-card-header-text></md-card-header><md-card-content><div class=\"fields\" flex=\"grow\"><div \nclass=\"field-blockless\" layout=\"row\" layout-align=\"start center\" flex=\"grow\"><span flex=\"grow\">\nClients can cancel payoff during 1 hour?</span><div flex=\"grow\" layout=\"row\" layout-align=\"end\"><md-switch \nname=\"is_payoff_cancelable_boolean\" ng-model=\"vm.shop.is_payoff_cancelable\" aria-label=\"cancel-payoff\" \nng-click=\"vm.changeShopConfiguration()\"></md-switch></div></div></div></md-card-content></md-card><md-card>\n<md-card-header><md-card-header-text><span class=\"md-title\">Locations</span></md-card-header-text></md-card-header>\n<md-card-content><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"location in vm.shop.locations\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"md-list-item-text\"><h3>{{location.name}}</h3><p>{{location.address}}</p></div>\n<div class=\"md-list-item-text\" hide show-gt-xs><p>{{location.zipcode}}</p></div><md-button \nng-click=\"state.go(\'app.editshoplocation\', {location: location.id})\">edit</md-button></md-list-item><md-list-item \nclass=\"md-2-line\" ng-if=\"vm.shop.locations.length == 0\"><div class=\"md-list-item-text\"><h3>\nNo locations are available, please add a location</h3></div></md-list-item></md-list><div layout=\"row\" \nlayout-align=\"end center\"><span class=\"explain-text\" \nng-if=\"vm.currentSubscription == \'Free\' && vm.shop.locations.length >= 1\">\nFree subscription shops can only have 1 location</span><md-button \nng-click=\"state.go(\'app.editshoplocation\', {shop: null})\" class=\"md-button-auto-width\" \nng-disabled=\"vm.currentSubscription == \'Free\' && vm.shop.locations.length >= 1\">Add new location</md-button></div>\n</md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\">Operators</span>\n</md-card-header-text></md-card-header><md-card-content><div layout=\"row\" layout-align=\"center\" \nng-if=\"vm.operators.length == 0\"><h3>No operators are available, please add an operator</h3></div><md-list>\n<md-list-item class=\"md-2-line\" ng-repeat=\"operator in vm.operators\"><div class=\"md-list-item-text\"><h3>\n{{operator.user.name}}</h3><p>{{operator.user.email}}</p></div><div class=\"md-list-item-text\" hide show-gt-xs \nlayout=\"row\" layout-align=\"center\"><div layout=\"column\"><md-switch ng-disabled=\"operator.is_owner\" \nng-model=\"operator.is_active\" ng-change=\"vm.updateOperator(operator)\"></md-switch><p ng-if=\"operator.is_active\">Active\n</p><p ng-if=\"!operator.is_active\">Not active</p></div></div><div class=\"md-list-item-text\" hide show-gt-xs \nlayout=\"row\" layout-align=\"center\"><p ng-if=\"operator.has_edit_rights\">Can edit shop</p><p \nng-if=\"!operator.has_edit_rights\">Cannot edit shop</p></div><md-button \nng-click=\"state.go(\'app.editoperator\', {shopId: vm.shop.id, operatorId: operator.id})\">edit</md-button></md-list-item>\n</md-list><div layout=\"row\" layout-align=\"end\"><md-button class=\"md-button-auto-width\" \nng-click=\"state.go(\'app.editoperator\', {shopId: vm.shop.id, operatorId: null})\">Add new operator</md-button></div>\n</md-card-content></md-card></div></div>");
$templateCache.put("app/main/shoplocation/shoplocation.html","<div id=\"shop-location\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div>\n<div class=\"profile-box info-box general md-whiteframe-1dp layout-column\" layout=\"column\"><div class=\"content\"><div \nng-repeat=\"location in vm.locations\"><p>{{ location.name }}</p><p>{{ location.address }}</p><p>{{ location.zipcode }}\n</p><p>{{ location.latitude }}</p><p>{{ location.longitude }}</p><md-button \nui-sref=\"app.editshoplocation({location: location.id})\" class=\"md-raised md-primary\">edit</md-button><md-button \nui-sref=\"#\" ng-click=\"vm.deleteLocation($event, location.id)\" class=\"md-raised md-warn\">delete</md-button><hr></div>\n<md-button ui-sref=\"app.editshoplocation({shop: null})\" class=\"md-raised md-primary\" \ntranslate=\"SHOPLOCATION.ADD_LOCATION\">Add shop</md-button></div></div></div></div></div>");
$templateCache.put("app/main/shops/shops.html","<md-tabs><md-tab label=\"{{ \'SHOPS.ORDERING_LABELS.NEAREST\' | translate }}\" \nng-click=\"vm.setOrdering(\'distance\', false)\"></md-tab><md-tab \nlabel=\"{{ \'SHOPS.ORDERING_LABELS.CATEGORY\' | translate }}\" ng-click=\"vm.setOrdering(\'category\', false)\"></md-tab>\n<md-tab label=\"{{ \'SHOPS.ORDERING_LABELS.ATOZ\' | translate }}\" ng-click=\"vm.setOrdering(\'name\', false)\"></md-tab>\n<md-tab label=\"{{ \'SHOPS.ORDERING_LABELS.FAVORITES\' | translate }}\" ng-click=\"vm.setOrdering(\'name\', true)\"></md-tab>\n</md-tabs><div id=\"shops\" class=\"right-sidenav\" infinite-scroll=\"vm.myPagingFunction()\" \ninfinitescroll=\"vm.myPagingFunction()\" infinite-scroll-distance=\"0\" infinite-scroll-parent><md-card \nclass=\"message-card\" ng-if=\"!vm.loading && (vm.locations.length == 0 || vm.error)\"><md-card-content layout=\"row\" \nlayout-align=\"center\" ng-if=\"vm.locations.length == 0 && !vm.loading && !vm.error\"><h3 \nng-if=\"!vm.searchCriteria.favorite\" translate=\"SHOPS.NO_NEARBY_SHOPS\">No nearby shops</h3><h3 \nng-if=\"vm.searchCriteria.favorite\" translate=\"SHOPS.NO_FAVORITE_SHOPS\">No favorite shops</h3></md-card-content>\n<md-card-content layout=\"column\" layout-align=\"center center\" ng-if=\"vm.error==\'locationError\' && !vm.loading\"><h3 \ntranslate=\"SHOPS.LOCATION_ERROR\">vm.error</h3></md-card-content></md-card><div class=\"shops\" layout=\"row\" flex=\"grow\" \nlayout-wrap layout-align=\"center\" ng-if=\"vm.showCards\" ms-scroll>{{ vm.currentCategory = null }}<div class=\"card\" \nng-repeat=\"location in vm.locations\" flex=\"grow\" \nng-class=\"{flipped: location.flipped, \'no-padding\': location.flipped}\"><div class=\"md-primary-bg category-header\" \nng-if=\"vm.searchCriteria.order==\'category\' && vm.currentCategory!=location.shop.category.title\"><h1>\n{{ vm.currentCategory=location.shop.category.title }}</h1></div><div class=\"front\"><md-card class=\"location-card\" \nlayout=\"column\" flex=\"noshrink\"><md-card-content class=\"\"><div layout=\"row\" class=\"sub-header\" flex=\"grow\" \nlayout-xs=\"column\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" \nng-if=\"location.shop.logo_full_url\" ng-src=\"{{ location.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!location.shop.logo_full_url\" src=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" \nlayout=\"column\" flex=\"grow\" layout-align=\"center\"><h1 style=\"display: block\">{{ location.shop.name }}</h1><span>\n{{ location.name }}</span> <span>{{ location.shop.category.title }}</span></div></div><div layout=\"row\" \nflex=\"noshrink\" layout-align=\"space-around\" class=\"options\"><div ng-if=\"location.total_vouchers > 0\" \nclass=\"voucher-value-container\" layout=\"column\" layout-align=\"start center\"><div class=\"voucher-value\" layout=\"row\" \nlayout-align=\"center center\"><span ng-bind-html=\"vm.formatAsCurrency(location.total_vouchers, location)\" \nid=\"{{ $index }}-voucher-value\"></span></div><span class=\"label\">Voucher value</span></div><div layout=\"column\" \nlayout-align=\"center end\" style=\"padding: 6px 10px 0 0\"><img class=\"favorite-icon\" ng-if=\"!location.is_favorite\" \nsrc=\"assets/images/icons/favorite_empty.png\" ng-click=\"vm.setFavorite(location, true)\"> <img class=\"favorite-icon\" \nng-if=\"location.is_favorite\" src=\"assets/images/icons/favorite_filled.png\" ng-click=\"vm.setFavorite(location, false)\"> \n<span class=\"label\">Favorite</span></div><div layout=\"column\" layout-align=\"center end\"><md-switch \naria-label=\"check-in\" ng-click=\"vm.toggleCheckin(location)\" ng-model=\"location.is_checked_in\"></md-switch><span \nclass=\"label\" translate=\"SHOPS.CHECK_IN\">Check in</span></div></div></div><hr><div ng-if=\"location.active_points > 0\" \nflex=\"grow\" layout=\"row\" layout-align=\"end\"><div><b>{{location.active_points}} Points collected</b></div></div><div \nclass=\"content\" flex=\"grow\"><div ng-bind-html=\"location.shop.description\"></div></div><div layout=\"row\" class=\"offer\" \nflex=\"grow\"><div flex=\"grow\" ng-class=\"{\'left-padding\': (location.vouchers > 0)}\" layout=\"column\"><span \nclass=\"offer-title\" translate=\"SHOPS.OFFER\">Shop\'s offer</span> <span class=\"offer-text\">\n{{ vm.striptags(location.shop.stampcard.description) }}</span></div></div><hr><div class=\"additional-info\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-around\"><div layout=\"row\"><span \nclass=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><a \nng-click=\"vm.openMap(location, $index)\">{{ location.address }}</a> <span class=\"info-line\">\n{{ location.rounded_distance }} {{ \'SHOPS.AWAY_FROM_YOU\' | translate}}</span></div></div><div layout=\"row\"><span \nclass=\"icon-phone icon\"></span> <a ng-href=\"tel:{{ location.shop.phone }}\" target=\"_blank\">{{ location.shop.phone }}\n</a></div><div layout=\"row\"><span class=\"icon-web icon\"></span> <a ng-href=\"{{ location.shop.website }}\" \ntarget=\"_blank\">{{ location.shop.website }}</a></div></div></md-card-content></md-card></div><div class=\"back\"><md-card\n class=\"location-card small-padding\" layout=\"column\"><div id=\"{{ $index }}-map\" \nclass=\"content map-container no-padding\" flex=\"grow\"></div><div class=\"additional-info\"><div layout=\"row\"><span \nclass=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><span class=\"info-line\">\n{{ location.address }}</span> <span class=\"info-line\">\n{{ location.rounded_distance }} {{ \'SHOPS.AWAY_FROM_YOU\' | translate}}</span></div></div></div><hr><div \nclass=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeMap()\" \ntranslate=\"SHOPS.CARD_BUTTONS.BACK\">Back</md-button></div></md-card></div></div><md-card-content layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.loading && !vm.error\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular><h3 translate=\"SHOPS.LOADING\">Loading</h3></md-card-content><div id=\"fixedMapDiv\" class=\"map\" \ndata-tap-disabled=\"true\"></div></div></div>");
$templateCache.put("app/main/stampcards/stampcards.html","<md-tabs><md-tab label=\"{{ \'STAMPCARDS.ORDERING_LABELS.NEAREST\' | translate }}\" \nng-click=\"vm.setOrdering(\'active\', \'shop.closest_location.distance_km\')\">Nearest</md-tab><md-tab \nlabel=\"{{ \'STAMPCARDS.ORDERING_LABELS.DATE\' | translate }}\" ng-click=\"vm.setOrdering(\'active\', \'created_at\')\"></md-tab>\n<md-tab label=\"{{ \'STAMPCARDS.ORDERING_LABELS.CATEGORY\' | translate }}\" \nng-click=\"vm.setOrdering(\'active\', \'shop.category.title\')\"></md-tab><md-tab \nlabel=\"{{ \'STAMPCARDS.ORDERING_LABELS.ATOZ\' | translate }}\" ng-click=\"vm.setOrdering(\'active\', \'shop.name\')\"></md-tab>\n<md-tab label=\"{{ \'STAMPCARDS.ORDERING_LABELS.ARCHIVE\' | translate }}\" \nng-click=\"vm.setOrdering(\'archive\', \'created_at\')\"></md-tab></md-tabs><div id=\"stampcards\" class=\"right-sidenav\">\n<md-card ng-if=\"vm.stampcards.length == 0 && !vm.loading\"><md-card-content layout=\"row\" layout-align=\"center\"><h3>\nYou have no stampcards</h3></md-card-content></md-card><div class=\"stampcards\" layout=\"row\" layout-wrap flex=\"grow\" \nlayout-align=\"center\" ng-if=\"vm.showCards\" ms-scroll><div class=\"card\" \nng-repeat=\"stampcard in vm.stampcards | orderBy: vm.sortOrder \" flex=\"grow\" \nng-class=\"{flipped: stampcard.flipped, \'no-padding\': stampcard.flipped}\"><div class=\"front\"><md-card \nclass=\"stamp-card\" flex=\"noshrink\" layout=\"column\"><md-card-content><div layout=\"row\" class=\"sub-header\" flex=\"grow\" \nlayout-xs=\"column\"><div class=\"shop-info-small\" layout=\"row\" flex=\"grow\"><img class=\"icon\" \nng-if=\"stampcard.shop.logo_full_url\" ng-src=\"{{ stampcard.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!stampcard.shop.logo_full_url\" src=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" \nlayout=\"column\" flex=\"grow\" layout-align=\"center\"><h1>{{ stampcard.shop.name }}</h1><span>\n{{ stampcard.shop.category_id }}</span></div></div><div layout=\"row\" flex=\"noshrink\" layout-align=\"space-around\" \nclass=\"options\"><div layout=\"column\" layout-align=\"center end\" style=\"padding: 6px 10px 0 0\"><img \nclass=\"favorite-icon\" ng-if=\"!stampcard.shop.is_favorite\" src=\"assets/images/icons/favorite_empty.png\" \nng-click=\"vm.setFavorite(stampcard, true)\"> <img class=\"favorite-icon\" ng-if=\"stampcard.shop.is_favorite\" \nsrc=\"assets/images/icons/favorite_filled.png\" ng-click=\"vm.setFavorite(stampcard, false)\"> <span class=\"label\">Favorite\n</span></div><div layout=\"column\" layout-align=\"center end\"><md-switch aria-label=\"check-in\" \nng-click=\"vm.toggleCheckin(stampcard)\" ng-model=\"stampcard.shop.closest_location.is_checked_in\"></md-switch><span \nclass=\"label\" translate=\"SHOPS.CHECK_IN\">Check in</span></div></div></div><hr><div ng-if=\"stampcard.active_points > 0\" \nflex=\"grow\" layout=\"row\" layout-align=\"end\"><div><b>{{stampcard.active_points}} Points collected</b></div></div><div \nclass=\"content\" flex=\"grow\" layout=\"row\" layout-wrap layout-align=\"center\"><span class=\"description\" \nng-bind-html=\"stampcard.description\" flex=\"grow\"></span><div class=\"stamp\" \nng-repeat=\"(index, stamp) in stampcard.stamps | orderBy: \'created_at\'\" layout=\"column\" layout-align=\"start center\"><img\n ng-if=\"stamp.id && !stamp.new\" ng-src=\"{{\'assets/images/icons/stamp_filled.png\'}}\" alt=\"\"> <img \nng-if=\"stamp.id && stamp.new && index < stampcard.stamps.length-1\" \nng-src=\"{{\'assets/images/icons/stamp_filled_new.png\'}}\" alt=\"\"> <img \nng-if=\"!stamp.id && index < stampcard.stamps.length-1\" ng-src=\"{{\'assets/images/icons/stamp_empty.png\'}}\" alt=\"\"> <img \nng-if=\"!stamp.id && index == stampcard.stamps.length-1\" ng-src=\"{{\'assets/images/icons/stamp_final.png\'}}\" alt=\"\"> \n<span ng-if=\"stamp.id\">{{ stamp.created_at.substr(0,10) | date:\'dd/MM\' }}</span> <span \nng-if=\"index == stampcard.stamps.length-1\" id=\"{{ $index }}-voucher-value\">{{ stampcard.reward_text }}</span></div>\n</div><hr><div class=\"additional-info\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-around\"><div layout=\"row\">\n<span class=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><a \nng-click=\"vm.flipCard(stampcard, $index, false)\">{{ stampcard.shop.closest_location.address }}</a> <span \nclass=\"info-line\">{{ stampcard.rounded_distance }} away from you</span></div></div><div layout=\"row\"><span \nclass=\"icon-phone icon\"></span> <a ng-href=\"tel:{{ stampcard.shop.phone }}\" target=\"_blank\">{{ stampcard.shop.phone }}\n</a></div><div layout=\"row\"><span class=\"icon-web icon\"></span> <a ng-href=\"{{ stampcard.shop.website }}\" \ntarget=\"_blank\">{{ stampcard.shop.website }}</a></div><div layout=\"row\"><span class=\"icon-alarm icon\"></span><div \nlayout=\"column\"><span class=\"info-line\">Expires on {{ stampcard.expires_at.substr(0,10) | date:\'dd/MM\' }}</span></div>\n</div><div layout=\"row\"><span class=\"icon-tag icon\"></span><div layout=\"column\"><span class=\"info-line\">\nID: {{ stampcard.id }}</span></div></div></div><div class=\"card-buttons small-buttons footer\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.flipCard(stampcard, $index, true)\">Terms</md-button></div>\n</md-card-content><div ng-if=\"stampcard.stampcard_paid_id\" class=\"banner blue-banner\" layout=\"row\" \nlayout-align=\"start center\"><span flex></span> <span>COMPLETED</span> <span flex></span></div><div \nng-if=\"stampcard.expired && !stampcard.stampcard_paid_id\" class=\"banner red-banner\" layout=\"row\" \nlayout-align=\"start center\"><span flex></span> <span>EXPIRED</span> <span flex></span></div></md-card></div><div \nclass=\"back\"><md-card class=\"stamp-card small-padding\" layout=\"column\" ng-if=\"!stampcard.showConditions\"><div \nid=\"{{ $index }}-map\" class=\"content map-container no-padding\" flex=\"grow\"></div><div flex=\"noshrink\" layout=\"column\">\n<span class=\"address\">{{ stampcard.shop.closest_location.address }}, {{ stampcard.rounded_distance }} away</span></div>\n<hr><div class=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.unflipCard(stampcard)\"><a href=\"tel:{{stampcard.shop.phone}}\">Call</a></md-button><md-button \nng-click=\"vm.unflipCard(stampcard)\"><a href=\"{{stampcard.shop.website}}\" target=\"_blank\">Web</a></md-button><md-button \nng-click=\"vm.unflipCard(stampcard)\">Back</md-button></div></md-card><md-card class=\"stamp-card\" layout=\"column\" \nng-if=\"stampcard.showConditions\"><md-card-content><div layout=\"row\" class=\"sub-header\"><div class=\"shop-info-small\" \nlayout=\"row\" flex=\"grow\"><img class=\"icon\" ng-if=\"stampcard.shop.logo_full_url\" \nng-src=\"{{ stampcard.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" ng-if=\"!stampcard.shop.logo_full_url\" \nsrc=\"assets/images/logos/default-shop-logo.png\" alt=\"\"><div class=\"info\" layout=\"column\" flex=\"grow\" \nlayout-align=\"center\"><h1>{{ stampcard.shop.name }}</h1><span>{{ stampcard.shop.category_id }}</span></div><div \nlayout=\"column\" layout-align=\"center end\" flex=\"noshrink\"><img class=\"favorite-icon\" \nng-if=\"!stampcard.shop.is_favorite\" src=\"assets/images/icons/favorite_empty.png\" \nng-click=\"vm.setFavorite(stampcard, true)\"> <img class=\"favorite-icon\" ng-if=\"stampcard.shop.is_favorite\" \nsrc=\"assets/images/icons/favorite_filled.png\" ng-click=\"vm.setFavorite(stampcard, false)\"> <span class=\"checkin-text\">\nFavorite</span></div></div></div><hr><div class=\"content\" flex=\"grow\" layout=\"column\" layout-wrap><span \nclass=\"condition\" ng-bind-html=\"stampcard.conditions\"></span></div><div class=\"additional-info\"><div layout=\"row\"><span\n class=\"icon-arrow-right-bold-circle-outline icon\"></span><div layout=\"column\"><span class=\"info-line\">\n{{ stampcard.shop.closest_location.address }}</span> <span class=\"info-line\">\n{{ stampcard.rounded_distance }} away from you</span></div></div><div layout=\"row\"><span class=\"icon-phone icon\">\n</span> <span class=\"info-line\">{{ stampcard.shop.phone }}</span></div><div layout=\"row\"><span class=\"icon-web icon\">\n</span> <span class=\"info-line\">{{ stampcard.shop.website }}</span></div><div layout=\"row\"><span \nclass=\"icon-alarm icon\"></span> <span class=\"info-line\">\nExpires on {{ stampcard.expires_at.substr(0,10) | date:\'dd/MM\' }}</span></div></div><hr><div \nclass=\"card-buttons small-buttons footer\" layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.unflipCard(stampcard)\">Back</md-button></div></md-card-content></md-card></div></div><md-card-content \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.loading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular><h3 translate=\"SHOPS.LOADING\">Loading</h3></md-card-content><div id=\"fixedMapDiv\" class=\"map\" \ndata-tap-disabled=\"true\"></div></div></div>");
$templateCache.put("app/main/subscription/subscription.html","<div id=\"shop-subscription\" class=\"simple ng-scope right-sidenav\"><md-card flex=\"grow\"><md-card-content><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center\"><div class=\"shop-info-big\" layout=\"row\" flex=\"grow\"><img \nclass=\"icon\" ng-if=\"vm.shop.logo_full_url\" ng-src=\"{{ vm.shop.logo_full_url }}\" alt=\"\"> <img class=\"icon\" \nng-if=\"!vm.shop.logo_full_url\" ng-src=\"/assets/images/logos/default-shop-logo.png\"><div class=\"info\" layout=\"column\" \nlayout-align=\"center\"><h1>{{ vm.shop.name }}</h1></div></div><div layout=\"column\" layout-align=\"center center\" \nflex=\"no-shrink\" flex-xs=\"grow\" id=\"plan-header\"><div class=\"\"><span class=\"name\"><span \nng-if=\"vm.currentSubscription.status == \'trial\'\">Trial</span> {{ vm.currentSubscription.plan }}</span><span \nclass=\"subscription\"> subscription</span></div><span ng-if=\"vm.currentSubscription.plan != \'Free\'\" class=\"expiration\">\nExpires on {{ vm.currentSubscription.expires_at }}</span> <span ng-if=\"vm.currentSubscription.plan != \'Free\'\"><a \nng-click=\"vm.cancelSubscription()\" class=\"cancel-subscription\">Cancel subscription</a></span></div></div><div \nclass=\"padding cards\" layout=\"row\" layout-align=\"center\"><md-card class=\"subscription-card\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"main-content\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\">\n<span class=\"value\">{{ vm.stats.active_customers }}</span> <span class=\"sub-value\" \nng-if=\"vm.currentSubscription.plan == \'Basic\'\">/100</span></div><span class=\"description\">Active customers</span></div>\n</md-card><md-card class=\"subscription-card\" layout=\"column\" layout-align=\"center center\"><div class=\"main-content\" \nlayout=\"column\" layout-align=\"center center\"><div layout=\"row\"><span class=\"value\">{{ vm.stats.stampcards }}</span>\n</div><span class=\"description\">Stamp cards</span></div></md-card><md-card class=\"subscription-card\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"main-content\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\">\n<span class=\"value\">{{ vm.stats.active_customers_in_area.length || 0}}</span></div><span class=\"description\">\nCustomers in your area</span></div></md-card><md-card class=\"subscription-card\" \nng-class=\"vm.currentSubscription.plan != \'Premium\' ? \'disabled\' : \'\'\" layout=\"column\" layout-align=\"center center\"><div\n class=\"main-content\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><span class=\"value\">\n{{ vm.stats.vouchers_point }}</span></div><span class=\"description\">Points rewarded</span> <span class=\"footer\">\nPremium only</span></div></md-card><md-card class=\"subscription-card\" \nng-class=\"vm.currentSubscription.plan != \'Premium\' ? \'disabled\' : \'\'\" layout=\"column\" layout-align=\"center center\"><div\n class=\"main-content\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\"><span class=\"value\">\n{{ vm.stats.vouchers_welcome }}</span></div><span class=\"description\">Welcome vouchers</span> <span class=\"footer\">\nPremium only</span></div></md-card><md-card class=\"subscription-card\" \nng-class=\"vm.currentSubscription.plan != \'Premium\' ? \'disabled\' : \'\'\" layout=\"column\" layout-align=\"center center\"><div\n class=\"main-content\" layout=\"column\" layout-align=\"center center\" flex=\"100\"><div layout=\"row\"><span class=\"value\">\n{{ vm.stats.vouchers_re-engage }}</span></div><span class=\"description\">Re-engage vouchers</span> <span class=\"footer\">\nPremium only</span></div></md-card></div></md-card-content></md-card></div>");
$templateCache.put("app/main/thankyou/thankyou.html","<md-card><md-card-content layout=\"column\" layout-align=\"start center\"><h2>\nThank you for purchasing a {{vm.params.braintree_plan}} subscription!</h2><img style=\"height: 300px\" \nsrc=\"assets/images/etc/thankyou1.jpg\" alt=\"\"><h5>\nYour order ID is {{vm.params.id}}, valid until {{vm.params.trial_ends_at}}</h5><h4>\nYour support allows us to continue to develop a great product!</h4><p>\nYou will be redirected in a few seconds, if not please <a ui-sref=\"app.shopconfig\">click here</a></p></md-card-content>\n</md-card>");
$templateCache.put("app/main/userprofile/userprofile.html","<div id=\"profile\" class=\"page-layout simple tabbed ng-scope\"><div layout=\"column\"><md-card flex><md-card-header>\n<md-card-header-text><span class=\"md-title\">My club card</span></md-card-header-text></md-card-header><md-card-content \nlayout=\"row\" layout-wrap layout-align=\"center\"><div class=\"club-card\" layout=\"column\"><div class=\"background\"></div>\n<div layout=\"row\"><img class=\"main-logo\" src=\"assets/images/logos/MainLogo.png\" alt=\"\"><div class=\"card-header\" \nlayout=\"column\" layout-align=\"center center\"><span class=\"name\">Shop Local Club Card</span> <span class=\"subname\">\nMember Card</span></div></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><img class=\"qr-code\" \nng-src=\"{{vm.qrCode}}\"><div class=\"card-footer\" layout=\"column\" layout-align=\"center center\"><span class=\"name\">\n{{ vm.form.name }}</span> <span class=\"card-number\">{{ vm.form.membershipcard.code | membershipcardNumber}}</span>\n</div></div></div></md-card-content></md-card><md-card flex><md-card-header><md-card-header-text><span \nclass=\"md-title\">Account information</span></md-card-header-text></md-card-header><md-card-content layout=\"row\" \nlayout-wrap layout-align=\"center\"><div flex=\"grow\" flex-gt-xs=\"60\" class=\"profile-card\"><form name=\"profileForm\" \nnovalidate ng-submit=\"vm.saveUserProfile(profileForm, vm.form)\"><div layout=\"row\" class=\"profile-card-header\"><div \nlayout=\"column\"><img class=\"user-pic\" ng-if=\"!vm.avatarChanged && vm.form.avatar_full_url\" \nng-src=\"{{vm.form.avatar_full_url}}\"> <img class=\"user-pic\" ng-if=\"!vm.avatarChanged && !vm.form.avatar_full_url\" \nsrc=\"/assets/images/avatars/empty_avatar.jpeg\"> <img class=\"user-pic\" ng-if=\"vm.editMode && vm.avatarChanged\" \nngf-src=\"vm.form.avatar\"><div ng-if=\"vm.editMode\" class=\"info ng-binding\"><md-button class=\"md-button-auto-width\" \naria-label=\"UPLOAD AVATAR\" translate=\"PROFILE.UPLOAD_AVATAR\" translate-attr-aria-label=\"PROFILE.UPLOAD_AVATAR\" \nngf-select ng-model=\"vm.form.avatar\" name=\"avatar\" ng-change=\"vm.setAvatarChanged()\" ngf-pattern=\"\'image/*\'\" \nngf-accept=\"\'image/*\'\" ngf-max-size=\"3MB\" ngf-min-height=\"100\" ngf-resize=\"{width: 100, height: 100}\">AVATAR\n</md-button></div><p ng-if=\"profileForm.avatar.$invalid\">\nImage error, image must be at least 100px tall and less than 3mb in size.</p></div><div layout=\"row\" \nlayout-align=\"center\" flex=\"80\"><div class=\"name\" layout=\"row\" layout-align=\"center\" ng-if=\"!vm.editMode\"><h1>\n{{ vm.form.name }}</h1></div><md-input-container ng-if=\"vm.editMode\" class=\"md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.form.name\" placeholder=\"Name\" translate translate-attr-placeholder=\"PROFILE.NAME\" required \nng-change=\"resetServerSideValidation(profileForm)\"><div ng-messages=\"profileForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"PROFILE.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.name }}</span></div></div></md-input-container>\n</div></div><div class=\"fields\" layout=\"column\" flex=\"100\"><div class=\"field\" layout=\"row\" layout-xs=\"column\"><span \nflex=\"20\" class=\"field-name\">Email</span><div flex=\"80\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\"><span \nclass=\"field-value\">{{ vm.form.email }}</span></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\"><span \nflex=\"20\" class=\"field-name\">Country</span><div flex=\"80\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\"><span\n class=\"field-value\" ng-if=\"!vm.editMode\">{{ vm.countryList[vm.form.country_id].name }}</span><md-input-container \nng-if=\"vm.editMode\" class=\"md-block\" md-no-float><md-select name=\"country_id\" ng-model=\"vm.form.country_id\"><md-option \nng-repeat=\"country in vm.countryList\" value=\"{{country.id}}\">{{country.name}}</md-option></md-select><div \nng-messages=\"profileForm.country_id.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.COUNTRY_REQUIRED\">Zip code field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.country_id }}</span></div></div>\n</md-input-container></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\"><span flex=\"30\" class=\"field-name\">\nPostal / Zip Code</span><div flex=\"70\" layout=\"row\" layout-align=\"end\" layout-align-xs=\"start\"><span \nclass=\"field-value\" ng-if=\"!vm.editMode\">{{ vm.form.zipcode }}</span><md-input-container ng-if=\"vm.editMode\" \nclass=\"md-block\" md-no-float><input name=\"zipcode\" ng-model=\"vm.form.zipcode\" placeholder=\"Zip code\" translate \ntranslate-attr-placeholder=\"PROFILE.ZIP_CODE\" required ng-change=\"resetServerSideValidation(profileForm)\"><div \nng-messages=\"profileForm.zipcode.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"PROFILE.ERRORS.ZIPCODE_REQUIRED\">Zip code field is required</span></div><div \nng-message=\"serverSideValidation\"><span>{{ vm.serverSideValidationMsg.zipcode }}</span></div></div>\n</md-input-container></div></div><div class=\"field\" layout=\"row\" layout-xs=\"column\"><span flex=\"noshrink\" \nclass=\"field-name\">Password</span><div class=\"\"><span flex=\"grow\" class=\"field-value\" ng-if=\"!vm.editMode\"><a \naria-label=\"Change password\" translate=\"PROFILE.CHANGE_PASSWORD\" translate-attr-aria-label=\"PROFILE.CHANGE_PASSWORD\" \nng-click=\"vm.changePassword()\"></a></span></div></div></div><md-divider></md-divider><div class=\"card-buttons\" \nlayout=\"row\" layout-align=\"end\"><md-button md-no-ink md-no-focus-style type=\"submit\" aria-label=\"SAVE MY PROFILE\" \ntranslate=\"PROFILE.SAVE_PROFILE\" translate-attr-aria-label=\"PROFILE.SAVE_PROFILE\" ng-if=\"vm.editMode\"></md-button>\n<md-button md-no-ink md-no-focus-style aria-label=\"Cancel\" translate=\"PROFILE.CANCEL_EDIT_PROFILE\" \ntranslate-attr-aria-label=\"PROFILE.CANCEL_EDIT_PROFILE\" ng-click=\"vm.cancelEditMode()\" ng-if=\"vm.editMode\"></md-button>\n<md-button md-no-ink md-no-focus-style aria-label=\"Edit\" translate=\"PROFILE.EDIT_PROFILE\" \ntranslate-attr-aria-label=\"PROFILE.EDIT_PROFILE\" ng-click=\"vm.enableEditMode()\" ng-if=\"!vm.editMode\"></md-button></div>\n</form></div></md-card-content></md-card></div><div><md-card flex=\"100\"><md-card-header><md-card-header-text><span \nclass=\"md-title\">Check-ins</span></md-card-header-text></md-card-header><md-card-content class=\"padding\" layout=\"row\" \nlayout-align=\"center\"><h3 ng-if=\"vm.checkins.length == 0\">You haven\'t checked in at any store yet!</h3><md-list \nclass=\"checkin-list\" flex=\"grow\" ng-if=\"vm.checkins.length > 0\"><md-list-item class=\"checkin\" \nng-repeat=\"checkin in vm.checkins\" layout=\"row\" flex=\"100\"><div layout=\"row\" flex=\"80\" flex-gt-xs=\"60\"><img \nng-if=\"!checkin.shop.logo_full_url\" class=\"shop-icon-small\" ng-src=\"assets/images/logos/default-shop-logo.png\"> <img \nng-if=\"checkin.shop.logo_full_url\" class=\"shop-icon-small\" ng-src=\"{{checkin.shop.logo_full_url}}\"><div \nclass=\"shop-info\"><h2>{{ checkin.shop.name }}</h2><span class=\"category\">{{ vm.striptags(checkin.shop.description) }}\n</span></div></div><div flex=\"20\" hide show-gt-xs layout=\"row\" layout-align=\"center center\"><span class=\"last-checkin\">\nChecked in at {{checkin.checkinTime}}</span></div><div flex layout=\"row\" layout-align=\"end\"><div layout=\"column\" \nlayout-align=\"center center\"><md-switch ng-click=\"vm.toggleCheckinStatus(checkin)\" ng-model=\"checkin.checked\">\n</md-switch>Check-in</div></div><md-divider md-inset></md-divider></md-list-item></md-list></md-card-content></md-card>\n</div><div ng-if=\"updateSuccess && showSuccessMessage\" class=\"login\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><span class=\"text\">{{ successMsg }}</span></div></div>");
$templateCache.put("app/main/verifyemail/verifyemail.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span><img \nsrc=\"/assets/images/logos/MainLogo.png\"></span></div><div class=\"title\" translate=\"VERIFICATION.TITLE\">\nActivating your account</div><div class=\"col-xs-12\" ng-if=\"vm.verificationSuccess!=null\"><div \nclass=\"form-group panel-danger mtop-15\" ng-if=\"!vm.verificationSuccess\"><div class=\"panel-heading description-block\">\nPlease correct errors.<br>{{ verifyErrorMessage }}</div></div><div class=\"form-group panel-success mtop-15\" \nng-if=\"vm.verificationSuccess\"><div class=\"panel-heading description-block\">Verification Success<br>\n{{verifySuccessMessage}}<br>Thank you<br><div layout=\"column\"><md-button class=\"md-button-auto-width\" \nstyle=\"color: white\" ui-sref=\"app.shops\">Continue to App</md-button><a ng-if=\"vm.isMobile\" style=\"margin-top:10px\" \nng-click=\"vm.openMobileApp()\">Or tap here to open mobile app</a></div></div></div></div></div></div></div>");
$templateCache.put("app/main/vouchersconfig/vouchersconfig.html","<div id=\"voucher-config\" class=\"simple right-sidenav\"><md-card ng-if=\"vm.loading\"><md-card-content layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular><h3 \ntranslate=\"SHOPS.LOADING\">Loading</h3></md-card-content></md-card><md-card \nng-if=\"vm.shops.length > 1 || !vm.hasOwnShop\"><md-card-header><md-card-header-text><span class=\"md-title\">Select store\n</span></md-card-header-text></md-card-header><md-card-content><div ng-if=\"vm.shops.length > 1\" \nclass=\"shop-select padding\" layout=\"column\" flex=\"grow\" flex-gt-xs=\"50\"><h3>Select a store</h3><div layout=\"row\">\n<md-select name=\"shop\" class=\"shop-name-select no-margin\" ng-model=\"vm.currentShop\" flex=\"grow\" \nng-change=\"vm.onShopSelect()\" aria-label=\"Select shop\"><md-option ng-repeat=\"shop in vm.shops\" ng-value=\"shop\">\n{{ shop.name }}</md-option></md-select></div></div><div ng-if=\"!vm.hasOwnShop\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"start center\"><span class=\"explain-text\" flex=\"grow\">It seems you don\'t have your own Shop configured\n</span><div flex=\"noshrink\"><md-button class=\"md-button-auto-width no-margin\" aria-label=\"Create your own shop\" \nng-click=\"state.go(\'app.createshop\', {enableOnStateChangeStartHandler: false})\">Create your own shop</md-button></div>\n</div></md-card-content></md-card><div ng-if=\"vm.shop && vm.hasOwnShop\"><md-card><md-card-header><md-card-header-text>\n<span class=\"md-title\" ng-if=\"vm.category == \'welcome\'\">Welcome voucher configuration</span> <span class=\"md-title\" \nng-if=\"vm.category == \'re-engage\'\">Re-engage voucher configuration</span> <span class=\"md-title\" \nng-if=\"vm.category == \'point\'\">Points voucher configuration</span> <span class=\"md-title\" \nng-if=\"vm.category == \'ad-hoc\'\">Adhoc voucher configuration</span></md-card-header-text></md-card-header>\n<md-card-content layout=\"column\" layout-align=\"start\"><div class=\"fields\"><div class=\"field-blockless\" layout=\"row\" \nlayout-align=\"start center\" flex=\"grow\"><span flex=\"noshrink\" ng-if=\"vm.category == \'welcome\'\">Enable Welcome vouchers\n</span> <span flex=\"noshrink\" ng-if=\"vm.category == \'re-engage\'\">Enable Re-engage vouchers</span> <span \nflex=\"noshrink\" ng-if=\"vm.category == \'point\'\">Enable Points vouchers</span> <span flex=\"noshrink\" \nng-if=\"vm.category == \'ad-hoc\'\">Enable Adhoc vouchers</span><md-button flex=\"noshrink\" \nclass=\"icon-help-circle tooltip-button\"><md-tooltip>Premium only.</md-tooltip></md-button><div flex=\"grow\" \nlayout=\"row\" layout-align=\"end\"><md-switch ng-disabled=\"vm.shop.is_active == 0\" ng-model=\"vm.voucherDef.is_active\" \naria-label=\"shop-is-active\" ng-disabled=\"!vm.statusChangeEnabled\" ng-change=\"vm.changeVoucherStatus()\"></md-switch>\n</div></div></div></md-card-content></md-card><md-card><md-card-header><md-card-header-text><span class=\"md-title\" \nng-if=\"vm.category == \'welcome\'\">Active Welcome vouchers</span> <span class=\"md-title\" \nng-if=\"vm.category == \'re-engage\'\">Active Re-engage vouchers</span> <span class=\"md-title\" \nng-if=\"vm.category == \'point\'\">Active Points vouchers</span> <span class=\"md-title\" ng-if=\"vm.category == \'ad-hoc\'\">\nActive Adhoc vouchers</span></md-card-header-text></md-card-header><md-card-content layout=\"column\" \nlayout-align=\"center\"><div flex=\"grow\" layout=\"row\" layout-align=\"center\" ng-if=\"vm.activeVouchers.length == 0\"><h3>\nNo valid user match the search criteria</h3></div><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"voucher in vm.activeVouchers\" layout=\"row\" layout-align=\"start center\"><img \nsrc=\"/assets/images/avatars/empty_avatar.jpeg\" alt=\"\" class=\"md-avatar\"><div class=\"md-list-item-text\"><h3>\n{{voucher.membershipcard.user.name}}</h3><p>{{voucher.code | voucherNumber}}</p></div><div class=\"md-list-item-text\" \nhide show-gt-xs layout=\"row\" layout-align=\"center\"><p \nng-bind-html=\"vm.formatAsCurrency(voucher.value, vm.shop.country_id) + \' voucher value\'\">\n${{voucher.value}} voucher value</p></div><div class=\"md-list-item-text\" hide show-gt-xs layout=\"row\" \nlayout-align=\"center\"><p>Expires {{voucher.expires_at.split(\' \')[0] | date:\'dd/MM/yy\'}}</p></div><div \nclass=\"md-list-item-text\" layout=\"row\" layout-align=\"end\"><a style=\"padding-right: 20px\" \nng-if=\"vm.category != \'point\'\" translate=\"VOUCHERSCONFIG.REVOKE\" ng-click=\"vm.revokeVoucher(voucher)\" \naria-label=\"Revoke\"></a></div></md-list-item></md-list><div flex=\"grow\" layout=\"row\" layout-align=\"end\" \nclass=\"card-buttons\"><md-button ng-if=\"vm.category == \'welcome\'\" class=\"md-button-auto-width\" \naria-label=\"Create vouchers\" ng-disabled=\"!vm.voucherDef.is_active || !vm.statusChangeEnabled\" \nng-click=\"state.go(\'app.createwelcomevoucher\')\">Create vouchers</md-button><md-button \nng-if=\"vm.category == \'re-engage\'\" class=\"md-button-auto-width\" aria-label=\"Create vouchers\" \nng-disabled=\"!vm.voucherDef.is_active || !vm.statusChangeEnabled\" ng-click=\"state.go(\'app.createreengagevoucher\')\">\nCreate vouchers</md-button><md-button ng-if=\"vm.category == \'point\'\" class=\"md-button-auto-width\" \naria-label=\"Create vouchers\" ng-disabled=\"!vm.voucherDef.is_active || !vm.statusChangeEnabled\" \nng-click=\"state.go(\'app.createpointvoucher\')\">Create vouchers</md-button><md-button ng-if=\"vm.category == \'ad-hoc\'\" \nclass=\"md-button-auto-width\" aria-label=\"Create vouchers\" \nng-disabled=\"!vm.voucherDef.is_active || !vm.statusChangeEnabled\" ng-click=\"state.go(\'app.createadhocvoucher\')\">\nCreate vouchers</md-button></div></md-card-content></md-card></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Row Color\" md-menu-origin \nng-click=\"$mdOpenMenu($event)\" ng-class=\"selectedColor.class\"><span ng-show=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-show=\"!selectedColor.palette\">Select Color</span>\n</md-button><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"selectedColor.palette\">\n{{selectedColor.palette}} {{selectedColor.hue}} </span><span ng-if=\"!selectedColor.palette\">Select Color</span>\n<md-button class=\"remove-color-button md-icon-button\" ng-click=\"removeColor()\" aria-label=\"Remove Color\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-if=\"!selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in palettes\" ng-click=\"activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-if=\"selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+selectedPalette+\'-\'+hue+\'-bg\'\" \nng-repeat=\"(hue, values) in selectedHues\" ng-click=\"selectColor(selectedPalette,hue)\" layout=\"row\" \nlayout-align=\"start end\" md-ink-ripple><span class=\"label\">{{hue}} </span><i \nng-if=\"selectedPalette == selectedColor.palette && hue == selectedColor.hue\" class=\"s16 icon-check\"></i></div></div>\n</div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-icon \nid=\"ms-search-bar-expander\" md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><md-icon \nid=\"ms-search-bar-collapser\" md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></label><input \nid=\"ms-search-bar-input\" type=\"text\" ng-model=\"global.search\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"TOOLBAR.SEARCH\" flex></div>");
$templateCache.put("app/main/subscription/card-templates/subscription-template.html","<h1>{{ card.name }}</h1><h2 ng-if=\"card.id!=\'Free\'\"><span ng-if=\"card.currencyIsoCode==\'GBP\'\">£</span>{{ card.price }} \n<span ng-if=\"card.currencyIsoCode!=\'GBP\'\">{{card.currencyIsoCode}}</span> per year</h2><h2 ng-if=\"card.id==\'Free\'\">\n&nbsp;</h2><h3 ng-if=\"card.id==\'Free\'\">25 Active Customers</h3><h3 ng-if=\"card.id!=\'Free\'\">Unlimited Customers</h3><ul \nclass=\"list-icon\"><li>Stamp cards</li><li>Email marketing</li><li ng-if=\"card.id==\'Premium\'\">Points collection<span \nng-if=\"card.id==\'Premium\'\"></span></li><li ng-if=\"card.id==\'Premium\'\">Welcome vouchers<span ng-if=\"card.id==\'Premium\'\">\n</span></li><li ng-if=\"card.id==\'Premium\'\">Re-engage vouchers<span ng-if=\"card.id==\'Premium\'\"></span></li></ul>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>\n<md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span>\n</md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div \nclass=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader>\n<md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\">\n<h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list>\n<md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader>\n<md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"><img class=\"menu logo\" \nsrc=\"assets/images/logos/MainLogo.png\"></span><span class=\"logo-text\">SHOPLOCAL</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><ms-search-bar></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\"><ms-search-bar>\n</ms-search-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div class=\"error-banner pulse\" ng-class=\"{\'drop-down\': globalError}\" ng-if=\"globalError\"><p>{{globalError}}</p></div>\n<div layout=\"row\" layout-align=\"start center\" class=\"md-accent-bg\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\">\n</md-progress-circular></div><div layout=\"row\" layout-align=\"start center\">{{ stateTitle }}</div><div layout=\"row\" \nlayout-align=\"start center\" style=\"width: 30%\"></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target \nng-if=\"!vm.user.avatar_full_url\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"> <img md-menu-align-target \nng-if=\"vm.user.avatar_full_url\" class=\"avatar\" ng-src=\"{{ vm.user.avatar_full_url }}\"><div \nng-if=\"notifications.length > 0\"><span class=\"badge white-fg\" ng-if=\"notifications.length > 9\"></span> <span \nclass=\"badge white-fg\" ng-if=\"notifications.length <= 9\"></span> <span class=\"badge-text white-fg\" \nng-if=\"notifications.length > 9\">9+</span> <span class=\"badge-text-small white-fg\" ng-if=\"notifications.length <= 9\">\n{{ notifications.length.toString() }}&nbsp;</span></div></div><span class=\"username\" hide-xs>{{ vm.user.name }}</span>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\" ng-repeat=\"notification in vm.latestNotifications\"><md-icon \nmd-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button ui-sref=\"app.notifications\" \nng-bind-html=\"notification.message.substr(0,33) + \'...\'\"></md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-button ui-sref=\"app.notifications\"><span class=\"link\">See all notifications</span></md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent user-menu-logout\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\"><span class=\"link\">Logout</span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps\" layout=\"row\" layout-align=\"start center\"><div class=\"step md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{step.stepNumber}} \n</span><span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\">\n</span></div><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");}]);